import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import { print } from 'graphql'
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A type representing a clickstream payload as a JSON string */
  AnalyticsPayload: any;
  /** Built-in java.math.BigDecimal */
  BigDecimal: any;
  /** A type representing a Locale such as en_US or fr_FR */
  Locale: any;
  /** A type representing a full protocol, host and path */
  URL: any;
  /** A type representing a formatted java.util.UUID */
  UUID: any;
}

/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  /** Action to pop auth window */
  AUTHWINDOW = 'AUTHWINDOW',
  /** Action to close a dropdown option */
  CLOSE = 'CLOSE',
  /** Action to copy contents to clipboard */
  COPY = 'COPY',
  /** Action to open the date picker */
  DATEPICKER = 'DATEPICKER',
  /** Action to open an external link off */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Action to display free lx message */
  FREE_LX = 'FREE_LX',
  /** Action to open a link off */
  OPEN = 'OPEN',
  /** Action to display term and conditions */
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}

export enum ActionType {
  Open = 'Open',
  OpenPriceChangeAlert = 'OpenPriceChangeAlert',
  DownloadDPReport = 'DownloadDPReport'
}

/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED'
}

/** Provide criteria needed to perform an activities search */
export interface ActivitiySearchCriteriaInput {
  primary: PrimaryActivitySearchCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum ActivityAvailabilityPriceTextTheme {
  POSITIVE = 'POSITIVE'
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}

/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION'
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES'
}

export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION'
}

export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: InputMaybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: InputMaybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: InputMaybe<Scalars['String']>;
}

/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS'
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MIP = 'MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT'
}

export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  SWP_SORT_SECTION = 'SWP_SORT_SECTION',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  TRIPS_ACTIVITY_LIST = 'TRIPS_ACTIVITY_LIST',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS'
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT'
}

export enum ActivityMapGroupType {
  POI = 'POI'
}

/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: InputMaybe<Scalars['Int']>;
  /** field which identifies sem channel */
  sem?: InputMaybe<Scalars['String']>;
  /** field which identifies semdtl value */
  semdtl?: InputMaybe<Scalars['String']>;
}

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY'
}

/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars['String'];
  productToken: Scalars['String'];
}

export interface ActivityOfferFilterInput {
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
  tickets?: InputMaybe<Array<ActivityTicketInput>>;
}

/** Data used to retrieve details about an activity product */
export interface ActivityOfferNaturalKeyInput {
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars['String'];
}

export enum ActivityOfferUDSToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}

/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY'
}

/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO'
}

/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED'
}

export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS'
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST'
}

/** Allow to define a period of time to search for activities */
export interface ActivitySearchCriteriaDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}

/** Region information for an activity search */
export interface ActivitySearchCriteriaLocationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: InputMaybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: InputMaybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: InputMaybe<Scalars['String']>;
}

/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: InputMaybe<Scalars['String']>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: InputMaybe<Scalars['String']>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: InputMaybe<Array<ActivitySelectedValueInput>>;
}

/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER'
}

/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL'
}

export interface ActivitySelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}

/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum ActivityTextAlignment {
  CENTRE = 'CENTRE',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export interface ActivityTicketInput {
  code: Scalars['String'];
  count: Scalars['Int'];
}

/** Details of traveler with a specific age. Age will be used to derive the traveler type in package bookings */
export interface ActivityTravelerDetailsInput {
  /** Age of the traveler. Traveler type(adult/infant/youth) can be derived from age */
  age: Scalars['Int'];
  /** Number of travelers with specified age */
  count: Scalars['Int'];
}

/** Container of traveler information */
export interface ActivityTravelerInfoInput {
  /** number of adults from Hotel PDP */
  numberOfAdults: Scalars['Int'];
  /** number of children from Hotel PDP */
  numberOfChildren: Scalars['Int'];
  /** number of infants from Hotel PDP */
  numberOfInfants: Scalars['Int'];
}

export enum ActivityUDSToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT'
}

/** Input to update the activity in the session */
export interface ActivityUpdateInput {
  newActivity: ActivityNaturalKeyInput;
  oldActivity: ActivityNaturalKeyInput;
}

export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: InputMaybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** RegionCode from residency selection of user */
  regionCode?: InputMaybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  removeInsuranceProductIds?: InputMaybe<Array<Scalars['String']>>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId: Scalars['Int'];
}

/** Represents values for add ons */
export enum AddOnRequested {
  CB1 = 'CB1',
  COB = 'COB',
  SC = 'SC'
}

/** Represents the additional change query params */
export interface AdditionalChangeQueryParamsInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** Represents the virtual agent token which is used for exchange of information */
  opaqueToken?: InputMaybe<Scalars['String']>;
}

export interface AdditionalOnboardingContextInput {
  cmsToken?: InputMaybe<Scalars['String']>;
  isFirstAppLaunch?: InputMaybe<Scalars['Boolean']>;
  originUrl?: InputMaybe<Scalars['String']>;
  scenario?: InputMaybe<Scalars['String']>;
}

export interface AdditionalOnboardingOperationContextInput {
  cmsToken?: InputMaybe<Scalars['String']>;
  originUrl?: InputMaybe<Scalars['String']>;
}

export enum AdditionalShoppedAncillaries {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG'
}

export enum AdditionalShopping {
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG'
}

/** Represents client input to decide if and how the stripe toolbar will be displayed on the traveller sites */
export interface AffiliatesClientContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageId?: InputMaybe<Scalars['String']>;
  pageLocation: PageLocation;
}

/** Represents the createAffiliateLink mutation request and response types */
export interface AffiliatesCreateLinkRequestInput {
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
}

/** Represents the createAffiliateVanityLink mutation request */
export interface AffiliatesCreateVanityLinkRequestInput {
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
  targetUrl: Scalars['String'];
  userText: Scalars['String'];
}

/** Represents information used to identify contextual property */
export interface AffiliatesPropertyContextInput {
  /** Represents eg property Id */
  egPropertyId?: InputMaybe<Scalars['String']>;
  /** Represents hotels property Id */
  hotelsPropertyId?: InputMaybe<Scalars['String']>;
}

/** Represents the affiliatesStats query request */
export interface AffiliatesStatsRequestInput {
  propertyContext?: InputMaybe<AffiliatesPropertyContextInput>;
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}

export interface AgencyDestinationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  pinnedPropertyId?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
}

export interface AgencyPropertySearchFiltersInput {
  guest_rating?: InputMaybe<Scalars['String']>;
  payment_and_cancellation?: InputMaybe<Array<Scalars['String']>>;
  point_of_interest?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<PriceFilterInput>;
  property_type?: InputMaybe<Array<Scalars['String']>>;
  star_rating?: InputMaybe<Array<Scalars['String']>>;
}

export interface AgencyQuoteBuilderPropertyRateCardInput {
  businessModelType?: InputMaybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  inventoryType: InventoryType;
  packageRate: Scalars['Boolean'];
  pricePerNight: Scalars['String'];
  priceTotal: Scalars['String'];
  propertyDestination: Scalars['String'];
  propertyId: Scalars['String'];
  propertyName: Scalars['String'];
  propertyType: Scalars['String'];
  ratePlanId: Scalars['String'];
  roomTypeDescription: Scalars['String'];
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  starRating?: InputMaybe<Scalars['Float']>;
}

export interface AgencyQuoteBuilderRateCardInput {
  propertyInput: AgencyQuoteBuilderPropertyRateCardInput;
}

export interface AgencyQuoteBuilderRemoveInput {
  all: Scalars['Boolean'];
  index?: InputMaybe<Scalars['Int']>;
}

/** Input for deleting quotes */
export interface AgencyQuoteDeleteInput {
  /** List of quote ids to delete */
  quoteIds: Array<Scalars['String']>;
}

/** Status of quotes delete */
export interface AgencyQuoteDeleteStatusInput {
  deletedCount: Scalars['Int'];
  isSuccessful: Scalars['Boolean'];
}

export interface AgencyQuoteListInput {
  /** Status and number of quotes deleted. */
  deleteStatus?: InputMaybe<AgencyQuoteDeleteStatusInput>;
  /** Page index */
  paginationIndex?: InputMaybe<Scalars['Int']>;
  /** Search string if we want to filter the agency quote list records */
  searchCriteria?: InputMaybe<Scalars['String']>;
  /** Information of the tab */
  selectedTab?: InputMaybe<Scalars['String']>;
  /** Field Id for sort */
  sortContentId?: InputMaybe<Scalars['String']>;
  /** Sort direction (ascending, descending) */
  sortType?: InputMaybe<AgencyQuoteListSortType>;
}

/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export enum AgencyQuoteListSortType {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
  NOT_SORTED = 'NOT_SORTED'
}

export interface AgencyQuoteNaturalKeyInput {
  lodgingType: Scalars['String'];
  packageRates?: InputMaybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

export interface AgencyQuoteSaveAgencyDetailInput {
  /** Address of the agency, line 1 */
  address1?: InputMaybe<Scalars['String']>;
  /** Address of the agency line 2 */
  address2?: InputMaybe<Scalars['String']>;
  /** Email of the agent */
  email: Scalars['String'];
  /** Name of the Agency */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number associated with the agency */
  phone: Scalars['String'];
}

export interface AgencyQuoteSaveCardInput {
  /** Destination of the travel */
  destination: Scalars['String'];
  /** Indicates state for hiding cancellation policy */
  hideCancellationState: Scalars['Boolean'];
  /** Indicates state for hiding price details */
  hidePriceState: Scalars['Boolean'];
  /** Expedia's line of businesses */
  lob: ExpLineOfBusiness;
  /** Natural key for input validation */
  naturalKey: AgencyQuoteNaturalKeyInput;
  /** Total price for the quote */
  totalPrice?: InputMaybe<Scalars['String']>;
}

export interface AgencyQuoteSaveInput {
  /** Agency details pulled from database */
  agencyInfo: AgencyQuoteSaveAgencyDetailInput;
  /** Message from the agent, to be added by the agent */
  agentMessage?: InputMaybe<Scalars['String']>;
  /** Details of the trip on quote, pulled from database */
  quoteCards: Array<AgencyQuoteSaveCardInput>;
  /** Autogenerated Unique Identifier for each quote. Could be Null for saving a quote after Update */
  quoteId?: InputMaybe<Scalars['String']>;
  /** Name of the quote, to be added by the agent */
  quoteName: Scalars['String'];
  /** Name of the Traveler, to be added by the agent */
  travelerName: Scalars['String'];
}

export interface AgencyShoppingContextInput {
  bookingDate: Scalars['String'];
  checkin: Scalars['String'];
  checkout: Scalars['String'];
  countryCode: Scalars['String'];
  currency: Scalars['String'];
  language: Scalars['String'];
  occupancy: Array<Scalars['String']>;
}

export interface AgentQuoteNaturalKeyInput {
  packageRates?: InputMaybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

export interface AgentStateInput {
  agentPresenceUri: Scalars['String'];
  localizedText?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: AgentStateType;
}

export enum AgentStateType {
  NotReady = 'NotReady',
  Offline = 'Offline',
  Ready = 'Ready'
}

/** Airport location type chosen in flight search. */
export enum AirportLocationType {
  AIRPORT = 'AIRPORT',
  METROCODE = 'METROCODE',
  UNSPECIFIED = 'UNSPECIFIED'
}

export enum Alignment {
  CENTER = 'CENTER',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = 'DEBUG',
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = 'NONE',
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = 'PREVIEW',
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = 'RELEASED'
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BARBECUE = 'BARBECUE',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FIRE_PLACE = 'FIRE_PLACE',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WASHER = 'WASHER',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE'
}

export enum AmenityFilter {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  INVALID = 'INVALID',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}

/** represents the bag template analytics keys */
export enum AnalyticsKey {
  /** Represents the analytics key for number of bags per traveller */
  NUMBER_OF_BAGS = 'NUMBER_OF_BAGS',
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  PIECE_OR_WEIGHT_CONCEPT = 'PIECE_OR_WEIGHT_CONCEPT',
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  QUANTITY_OF_BAGS = 'QUANTITY_OF_BAGS'
}

/** Represents per journey ancillary selection */
export interface AncillaryJourneySelectionsInput {
  /** Represents the journey index for which the selection is applicable */
  journeyIndex: Scalars['Int'];
  /** Represents flight journey status */
  journeyStatus?: InputMaybe<FlightJourneyStatus>;
  /** Represents the list of per traveller selection */
  travellerAncillarySelections: Array<TravellerAncillarySelectionInput>;
}

/** Represents path plus page for where ancillaries will be shopped. */
export enum AncillaryShoppingPath {
  PACKAGE_INFOSITE = 'PACKAGE_INFOSITE',
  PACKAGE_TRIPS = 'PACKAGE_TRIPS',
  STANDALONE_INFOSITE = 'STANDALONE_INFOSITE',
  STANDALONE_TRIPS = 'STANDALONE_TRIPS'
}

export interface ArithmeticOperationsCriteriaInput {
  /** Represents the input numbers to be operated upon */
  inputNumbers: Array<Scalars['Float']>;
  /** The operation to be performed */
  operation: Operation;
}

/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:1 */
  FOUR_ONE = 'FOUR_ONE',
  /** Aspect ratio 4:3 */
  FOUR_THREE = 'FOUR_THREE',
  /** Aspect ratio 1:1 */
  ONE_ONE = 'ONE_ONE',
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  /** Aspect ratio 3:4 */
  THREE_FOUR = 'THREE_FOUR',
  /** Aspect ratio 3:2 */
  THREE_TWO = 'THREE_TWO',
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE'
}

/** Represents authentication configuration */
export interface AuthenticationConfigInput {
  /** Represents a JWT token retrieved from the IAM Token API */
  authToken?: InputMaybe<Scalars['String']>;
  /** Represents a unique channel origin id per chat experience */
  channelOriginId?: InputMaybe<Scalars['String']>;
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}

export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  LOCAL_OFFER = 'LOCAL_OFFER',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE'
}

/** Represents the quantity of bags to be sent in analytics none/some/all */
export enum BagsSelectionType {
  ALL = 'ALL',
  NONE = 'NONE',
  SOME = 'SOME'
}

export enum BannerDisplayType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARN = 'WARN'
}

export enum BannerTheme {
  BRAND_PROMO_PRIMARY = 'BRAND_PROMO_PRIMARY',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export interface BookingChangeFlightInput {
  /** Represents the air record locator for the flight that needs to be changed */
  airRecordLocator?: InputMaybe<Scalars['String']>;
  /** Represents the virtual agent domain or Web domain */
  client?: InputMaybe<BookingServicingClient>;
  /** ConversationId for virtual agent */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Represents the new flight search criteria */
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  /** opaqueId for virtual agent */
  opaqueId?: InputMaybe<Scalars['String']>;
  /** Represents the old flight and traveler selection that needs to be changed */
  selectedChanges?: InputMaybe<Array<BookingServicingChangeSelectionInput>>;
  /** Represents the tripId for the flight that needs to be changed */
  tripId: Scalars['String'];
  /** Represents the trip item id for the flight that needs to be changed */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the trip view id for the flight that needs to be changed */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents criteria input containing info about trip for cancel query */
export interface BookingServicingCancelCriteriaInput {
  /** Represents the cancel query input */
  flightsCriteriaInput: BookingServicingCancelFlightInput;
}

/** Represents info about trip for cancel query input */
export interface BookingServicingCancelFlightInput {
  /** Represents the air record locator for the cancel query input */
  airRecordLocator: Scalars['String'];
  /** Represents the type of cancellation being performed by the traveler */
  cancelType: BookingServicingCancelType;
  /** Represents the tripId for the cancel query input */
  tripId: Scalars['String'];
  /** Represents the tripItemId for the cancel query input */
  tripItemId?: InputMaybe<Scalars['String']>;
  /** Represents the tripViewId for the cancel query input */
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** The path for cancellation that will be performed by the traveler */
export enum BookingServicingCancelType {
  /** Represents the type for Involuntary/ASC Cancel */
  INVOLUNTARY = 'INVOLUNTARY',
  /** Represents the type for Voluntary Cancel */
  VOLUNTARY = 'VOLUNTARY'
}

/** Represents the information about the flight and traveler selections that need to be changed  */
export interface BookingServicingChangeCriteriaInput {
  /** Represents the information about the flight  and traveler selections that need to be changed  */
  flightsInput?: InputMaybe<BookingChangeFlightInput>;
}

export interface BookingServicingChangeLodgingInput {
  orderLineGuid: Scalars['String'];
  orderNumber: Scalars['String'];
  tripId: Scalars['String'];
}

export interface BookingServicingChangeSelectionInput {
  /** Represents the name of the change flight(eg old flight/traveler) */
  name: Scalars['String'];
  /** Represents the value of the change flight(eg old flight/traveler) */
  value: Scalars['String'];
}

export enum BookingServicingClient {
  /** Represents virtual agent domain */
  VIRTUAL_AGENT = 'VIRTUAL_AGENT',
  /** Represents web domain */
  WEB = 'WEB'
}

/** Target of the Link when clicked */
export enum BookingServicingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}

export enum BookingServicingQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}

/** Booking servicing toolbar navigation type */
export enum BookingServicingToolbarNavigationType {
  /** Represents the toolbar with a back button */
  BACK = 'BACK',
  /** Represents the toolbar with a close button */
  CLOSE = 'CLOSE',
  /** Represents the toolbar with a expand less button */
  EXPAND_LESS = 'EXPAND_LESS',
  /** Represents the toolbar with a expand up button */
  EXPAND_UP = 'EXPAND_UP'
}

/** Booking servicing toolbar type */
export enum BookingServicingToolbarType {
  /** Represents the standard type */
  STANDARD = 'STANDARD',
  /** Represents the transparent type */
  TRANSPARENT = 'TRANSPARENT'
}

/** Represents the traveler details input */
export interface BookingServicingTravelerDetailsInput {
  accessibility: Array<Scalars['String']>;
  bedTypeId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  smoking?: InputMaybe<Scalars['String']>;
}

export enum BookingServicingTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}

/** The type of input validation that will be performed on the traveler input */
export enum BookingServicingTravelerValidationType {
  /** Represents the type of validation when a child is traveling alone without an adult */
  CHILD_TRAVELING_ALONE = 'CHILD_TRAVELING_ALONE'
}

export enum BooleanEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE'
}

/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars['String'];
  value: Scalars['Boolean'];
}

/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}

export enum BulletStyle {
  DEFAULT = 'DEFAULT',
  ICON_ALTERNATE = 'ICON_ALTERNATE',
  ICON_STANDARD = 'ICON_STANDARD',
  NO_BULLET = 'NO_BULLET',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Indicate the business model type of a given offer */
export enum BusinessModelType {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}

export interface CDFFeedbackInput {
  context: Array<GraphQLPairInput>;
  formValues: Array<GraphQLPairInput>;
}

export enum CDFPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}

export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT'
}

export interface CampaignParametersInput {
  campaignId: Scalars['String'];
  contentPagination?: InputMaybe<ContentPaginationInput>;
  propertyParameters?: InputMaybe<CampaignPropertyParametersInput>;
}

export enum CampaignProductType {
  ACTIVITY = 'ACTIVITY',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE'
}

export interface CampaignPropertyParametersInput {
  guestRating?: InputMaybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  starRating?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<PropertyDetailsPropertyType>;
}

export interface CancellationWaiverDeclineRequestContext {
  bookingItemId: Scalars['String'];
  serviceRequestId: Scalars['String'];
  reason: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
}

export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED'
}

export enum CarActionType {
  /** Apply loyalty points to offer */
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  /** Click map marker */
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  /** Change Search */
  CHANGE_SEARCH = 'CHANGE_SEARCH',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Click to filter car sales */
  FILTER_SALE_OFFER = 'FILTER_SALE_OFFER',
  /** Submit content to server */
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  /** Go back to search page to see all cars */
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  /** Open cancellation policy link */
  GO_TO_CANCELLATION_POLICY = 'GO_TO_CANCELLATION_POLICY',
  /** Continues to the standalone details page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Open dialog to see cleaning and safety practices */
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  /** Open Delta Campaign page */
  GO_TO_DELTA_CAMPAIGN_LINK = 'GO_TO_DELTA_CAMPAIGN_LINK',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Open recommended sort FAQ page */
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  /** Continues to the user sign in page */
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  /** Continues to the user sign up page */
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  /** Click to sign in and unlock car sales */
  GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES = 'GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES',
  /** Open Walmart plus member trial page */
  GO_TO_WPLUS_MEMBER_TRIAL_LINK = 'GO_TO_WPLUS_MEMBER_TRIAL_LINK',
  /** Load more results to search page */
  LOAD_MORE = 'LOAD_MORE',
  /** Change Search */
  OFF_AIRPORT_CHANGE_SEARCH = 'OFF_AIRPORT_CHANGE_SEARCH',
  /** Opens a dialog */
  OPEN_DIALOG = 'OPEN_DIALOG',
  /** Open merchant rules in iframe */
  OPEN_DOC = 'OPEN_DOC',
  /** Open ground transfers page */
  OPEN_GROUND_TRANSFERS = 'OPEN_GROUND_TRANSFERS',
  /** Opens the inline time wizard */
  OPEN_INLINE_TIME_WIZARD = 'OPEN_INLINE_TIME_WIZARD',
  /** Opens the inline search wizard */
  OPEN_INLINE_WIZARD = 'OPEN_INLINE_WIZARD',
  /** Opens a new tab */
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  /** Opens on current tab */
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  /** Open vendor rules from domain rules */
  OPEN_RULE = 'OPEN_RULE',
  /** Used to open Telephone Link */
  OPEN_TEL = 'OPEN_TEL',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Remove loyalty points to offer */
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  /** Click see cars on map marker item card */
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  /** Open share feedback form */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Show offers with AARP Exclusive benefits */
  SHOW_AARP_EXCLUSIVE_OFFERS = 'SHOW_AARP_EXCLUSIVE_OFFERS',
  /** Show offers with free cancellations */
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  /** Click to unlock car sales */
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES'
}

export interface CarDetailContextInput {
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: InputMaybe<Scalars['String']>;
  optionAction?: InputMaybe<CarAccessorySelectionState>;
  optionToken?: InputMaybe<Scalars['String']>;
  principalToken?: InputMaybe<Scalars['String']>;
  rewardPointsSelection?: InputMaybe<RewardsPointSelectionEnum>;
  selectedAccessories?: InputMaybe<Array<Scalars['String']>>;
}

export enum CarFormatStyle {
  IFRAME = 'IFRAME',
  LIST = 'LIST'
}

export enum CarMapMarkerType {
  CarMarker = 'CarMarker',
  PlaceMarker = 'PlaceMarker'
}

/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars['String'];
  specialEquipments?: InputMaybe<Array<SpecialEquipment>>;
}

/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  isExactLocationSearch?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
}

export enum CarRouteType {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP'
}

export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  useEgtpPath?: InputMaybe<Scalars['Boolean']>;
}

/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Represents name and code for each car brand. */
export enum CarSearchFormPreferredBrand {
  AC = 'AC',
  AD = 'AD',
  AL = 'AL',
  EP = 'EP',
  ET = 'ET',
  EY = 'EY',
  FX = 'FX',
  GI = 'GI',
  MW = 'MW',
  NU = 'NU',
  RO = 'RO',
  SC = 'SC',
  SV = 'SV',
  SX = 'SX',
  ZA = 'ZA',
  ZD = 'ZD',
  ZE = 'ZE',
  ZI = 'ZI',
  ZL = 'ZL',
  ZR = 'ZR',
  ZT = 'ZT'
}

export enum CardActions {
  DISMISS = 'DISMISS'
}

export enum CardSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export enum CardTheme {
  GLOBAL_LOYALTY_EXTRAHIGH = 'GLOBAL_LOYALTY_EXTRAHIGH',
  GLOBAL_LOYALTY_HIGH = 'GLOBAL_LOYALTY_HIGH',
  GLOBAL_LOYALTY_LOW = 'GLOBAL_LOYALTY_LOW',
  GLOBAL_LOYALTY_MIDDLE = 'GLOBAL_LOYALTY_MIDDLE',
  GLOBAL_LOYALTY_STANDARD = 'GLOBAL_LOYALTY_STANDARD',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Enum class to represent the type of carry on bag */
export enum CarryOnBagType {
  CARRY_ON_BAG = 'CARRY_ON_BAG'
}

export enum CarsDialogType {
  LIMITED_RESULTS = 'LIMITED_RESULTS',
  LIMITED_RESULTS_WITHOUT_TURO = 'LIMITED_RESULTS_WITHOUT_TURO',
  LIMITED_RESULTS_WITH_TURO = 'LIMITED_RESULTS_WITH_TURO'
}

export interface CarsDomainRequestContextInput {
  partnerContext: PartnerContextInput;
  principalJWT: Scalars['String'];
}

export enum CarsRichTextStyle {
  BOLD = 'BOLD',
  BULLET = 'BULLET',
  ITALICIZE = 'ITALICIZE'
}

/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars['String'];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}

export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS'
}

export enum ChannelType {
  VIRTUAL_AGENT = 'VIRTUAL_AGENT'
}

/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING'
}

/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT'
}

/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION'
}

/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = 'CLICKSTREAM',
  GLASSBOX = 'GLASSBOX'
}

/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars['String'];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars['String'];
}

/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2'
}

export enum CheckinValidityWithReason {
  /** the associated date is not valid for checkin due to an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkin due to being in the past */
  INVALID_DUE_TO_BEING_IN_PAST = 'INVALID_DUE_TO_BEING_IN_PAST',
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkin because it is too far in the future */
  INVALID_DUE_TO_MAX_FUTURE_BOOKING = 'INVALID_DUE_TO_MAX_FUTURE_BOOKING',
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION = 'INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION',
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE = 'INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE',
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  INVALID_DUE_TO_NOT_AVAILABLE = 'INVALID_DUE_TO_NOT_AVAILABLE',
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS = 'INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS',
  /** the associated date is valid for checkin */
  VALID = 'VALID'
}

export interface CheckoutDomainInfoInput {
  name: Scalars['String'];
  refId: Scalars['String'];
}

/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars['String'];
}

/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  HOTEL_BUSINESS_MODEL = 'HOTEL_BUSINESS_MODEL',
  HOTEL_MARKETING_CHANNEL = 'HOTEL_MARKETING_CHANNEL',
  META_DEEPLINK = 'META_DEEPLINK',
  PROPERTY_UPSELL_AMOUNT = 'PROPERTY_UPSELL_AMOUNT',
  RATE_UPGRADE_ELIGIBLE = 'RATE_UPGRADE_ELIGIBLE',
  RATE_UPSELL = 'RATE_UPSELL',
  RATE_UPSELL_AMOUNT = 'RATE_UPSELL_AMOUNT',
  ROOM_UPGRADE_ELIGIBLE = 'ROOM_UPGRADE_ELIGIBLE',
  ROOM_UPSELL = 'ROOM_UPSELL',
  SHOPPING_DEAL_BADGE_PERCENTAGE = 'SHOPPING_DEAL_BADGE_PERCENTAGE',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  TAAP_PACKAGE_RATES = 'TAAP_PACKAGE_RATES'
}

export interface CheckoutRedirectInput {
  /** Cabin number which will be populated for users redirecting from the Checkout page */
  cabinNumber: Scalars['String'];
  /** Deck number which will be populated for users redirecting from the Checkout page */
  deck: Scalars['String'];
  /** Optional Offer token which will be used to select the previous rate for users redirecting from the Checkout page */
  offerToken?: InputMaybe<Scalars['String']>;
}

export interface CheckoutSessionInfoInput {
  sessionId: Scalars['UUID'];
  sessionToken: Scalars['UUID'];
}

export enum CheckoutValidityWithReason {
  /** the associated date's is not valid for checkout for an unknown reason */
  INVALID = 'INVALID',
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  INVALID_DUE_TO_CHANGEOVER_EXCLUSION = 'INVALID_DUE_TO_CHANGEOVER_EXCLUSION',
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK = 'INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK',
  /** the associated date is valid for checkout */
  VALID = 'VALID'
}

/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING'
}

/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars['String'];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: InputMaybe<Scalars['String']>;
}

/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars['String'];
  /** URL of HTTP Request */
  url: Scalars['String'];
}

/** The closed bounding type of the date period. (Boundaries are always included) */
export enum ClosedPeriodBounding {
  LOWER = 'LOWER',
  UPPER = 'UPPER'
}

export enum CoachingTipsView {
  STANDALONE_MINIMAL = 'STANDALONE_MINIMAL',
  STANDALONE_SUGGESTED = 'STANDALONE_SUGGESTED',
  OPPY_HUB = 'OPPY_HUB'
}

/** Context of pagination and max number of elements. If not defined, the default set of elements are provided. */
export interface CollectionPaginationContextInput {
  /** Indicates the maximum number of items to be shown in the module. */
  maxPageSize?: InputMaybe<Scalars['Int']>;
  /** Indicates the pagination offset. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Indicates the initial number of items to be shown in the module and how many more items will be fetched by pagination. */
  pageSize?: InputMaybe<Scalars['Int']>;
}

/** The type of the collection */
export enum CollectionType {
  FLIGHT = 'FLIGHT',
  GEOGRAPHY = 'GEOGRAPHY',
  LODGING = 'LODGING'
}

export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS'
}

/** Represents left or right alignment of a specific messages in the conversation View */
export enum CommunicationCenterMessageAlignment {
  /** Represents left Alignment */
  LEFT = 'LEFT',
  /** Represents Right Alignment */
  RIGHT = 'RIGHT'
}

/** Represents the state of message preview */
export enum CommunicationCenterMessagePreviewState {
  /** Represents read state */
  READ = 'READ',
  /** Represents unread state */
  UNREAD = 'UNREAD'
}

/** The display type of the Customer notification message */
export enum CommunicationCenterNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CommunicationCenterNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

/** Represents the state of notification or message */
export enum CommunicationCenterNotificationState {
  /** Represents read state */
  READ = 'READ',
  /** Represents seen state - equivalents as unread */
  SEEN = 'SEEN',
  /** Represents invalid state */
  UNKNOWN = 'UNKNOWN',
  /** Represents unseen state - initial state of notification */
  UNSEEN = 'UNSEEN'
}

/** Represents the type of the notification */
export enum CommunicationCenterNotificationType {
  /** Represents coupon notification */
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  /** Represents default type of notification */
  DEFAULT = 'DEFAULT'
}

/** Represents the type of user actions of the notification. */
export enum CommunicationCenterNotificationUserActionType {
  /** Represents the action of deleting a notification */
  DELETE = 'DELETE',
  /** Represents the action of marking a notification as read */
  MARK_AS_READ = 'MARK_AS_READ',
  /** Represents the action of marking a notification as unread */
  MARK_AS_UNREAD = 'MARK_AS_UNREAD'
}

/** Represents the status of query/mutation response */
export enum CommunicationCenterOperationStatus {
  /** Represents the status of failure response for generic or unknown reasons */
  GENERIC_FAILURE = 'GENERIC_FAILURE',
  /** Represents the status of failure response for invalid input */
  INVALID_INPUT = 'INVALID_INPUT',
  /** Represents the status of failure response for service errors */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** Represents the status of successful response */
  SUCCESS = 'SUCCESS'
}

export enum CommunicationChannel {
  EMAIL = 'EMAIL',
  PUSH = 'PUSH',
  SMS = 'SMS'
}

export enum CommunicationPreferencesOptionsType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  DEFAULT = 'DEFAULT',
  MANAGE_EMAIL_PREFERENCE = 'MANAGE_EMAIL_PREFERENCE',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  PRIVACY_STATEMENT = 'PRIVACY_STATEMENT',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE',
  UNSUB_ALL = 'UNSUB_ALL',
  UNSUB_OTHER_EMAILS = 'UNSUB_OTHER_EMAILS'
}

export enum CompetitiveSetProductType {
  LODGING = 'LODGING'
}

/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA'
}

export interface ContactUsFormContentInput {
  /** Customer Selected category from dropdown */
  category: Scalars['String'];
  /** Customer selected intent from dropdown */
  intent: Scalars['String'];
  /** Customer Entered Itinerary Number */
  itineraryNumber: Scalars['String'];
  /** Customer Entered Phone Number */
  phoneNumber: Scalars['String'];
}

export enum ContactUsOptionType {
  CALL_BACK_WITH_AGENT = 'CALL_BACK_WITH_AGENT',
  CALL_TO_AGENT = 'CALL_TO_AGENT',
  CHAT_BACK_WITH_AGENT = 'CHAT_BACK_WITH_AGENT',
  CHAT_WITH_AGENT = 'CHAT_WITH_AGENT',
  SEND_EMAIL_AGENT = 'SEND_EMAIL_AGENT'
}

/** Represents ContactUs Email Form */
export interface ContactUsSendEmailFormRequestInput {
  /** Email of customer */
  customerEmail: Scalars['String'];
  /** Name of customer */
  customerName: Scalars['String'];
  /** details of the email */
  details: Scalars['String'];
  /** intent */
  intent: Scalars['String'];
  /** product */
  product: Scalars['String'];
}

/** Represents Email Us Sheet Request */
export interface ContactUsSendEmailRequestInput {
  /** Email of customer */
  customerEmail: Scalars['String'];
  /** Name of customer */
  customerName: Scalars['String'];
  /** Message of email */
  message: Scalars['String'];
  /** subject of email */
  subject: Scalars['String'];
}

/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT'
}

export interface ContentPaginationInput {
  pageNumber: Scalars['Int'];
  pageSize?: InputMaybe<Scalars['Int']>;
}

/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: InputMaybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: InputMaybe<Scalars['String']>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: InputMaybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: InputMaybe<Scalars['Int']>;
  /**
   * DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: InputMaybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars['Locale'];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars['Int'];
  /** The legacy TravelProductID */
  tpid?: InputMaybe<Scalars['Int']>;
}

/** Represents any relevant attributes of a conversation */
export interface ConversationAttributesInput {
  /** Represents the URL of the page where the current conversation is taking place */
  currentPageUrl?: InputMaybe<Scalars['String']>;
}

/** Represents the context of a conversation */
export interface ConversationContextInput {
  /** Represents any relevant attributes of a conversation, such as the current pages's URL */
  attributes?: InputMaybe<ConversationAttributesInput>;
  /** Represents the conversation ID, used to route messages */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Represents the participant ID, used to identify the author of a message or the actor of an event */
  participantId?: InputMaybe<Scalars['String']>;
}

/** Represents any relevant configs of a conversation */
export interface ConversationInitializationConfigsInput {
  /** Represents any relevant attributes of a conversation, such as the current page URL */
  attributes?: InputMaybe<ConversationAttributesInput>;
  /** Represents config to create a new conversation */
  forceNewConversation?: InputMaybe<Scalars['Boolean']>;
  /** Represents mode of conversation - create, join, resume, etc. */
  mode: ConversationMode;
  /** Represents input data related to a participant */
  participant?: InputMaybe<ParticipantInput>;
}

export enum ConversationMode {
  CREATE_CONVERSATION = 'CREATE_CONVERSATION'
}

/** A latitude/longitude pair */
export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars['Float'];
  /** The longitude of the point in degrees */
  longitude: Scalars['Float'];
}

export interface CouponIdentifierInput {
  type: CouponIdentifierType;
  value: Scalars['String'];
}

export enum CouponIdentifierType {
  CODE = 'CODE',
  INSTANCE_ID = 'INSTANCE_ID'
}

export enum CreditCardApplicationFormOperation {
  EQ = 'EQ',
  GE = 'GE',
  GT = 'GT',
  LE = 'LE',
  LT = 'LT',
  NE = 'NE'
}

export interface CreditCardApplicationFormQueryInput {
  /** The deeplink that potentially triggered the Application Form opening. */
  deeplinkUrl?: InputMaybe<Scalars['String']>;
  /** The page the traveler is instantiating the Application Form from. */
  sourcePage: CreditCardSourcePage;
}

export interface CreditCardApplicationThankYouInput {
  /** First name of the applicant for the Credit Card */
  applicantFirstName: Scalars['String'];
  /** Application ID of the Credit Card application process */
  applicationID: Scalars['String'];
  /** Application token of the Credit Card application process */
  applicationToken: Scalars['String'];
  /** Enum to request either the Thank you pending or approved screen */
  screenType: CreditCardThankYouScreenType;
}

export enum CreditCardApplyButtonActionType {
  EMBEDDED = 'EMBEDDED',
  EXTERNAL = 'EXTERNAL'
}

export enum CreditCardEncodingType {
  Base64 = 'Base64'
}

export enum CreditCardSourcePage {
  /** The traveler initiated the application journey from the Application (A.K.A. Pillar) Page. */
  APPLICATION = 'APPLICATION',
  /** The traveler initiated the application journey from a Checkout Page. */
  CHECKOUT = 'CHECKOUT',
  /** The traveler initiated the application journey from a page external to EG websites, such as a marketing email. */
  EXTERNAL = 'EXTERNAL'
}

export enum CreditCardThankYouScreenType {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

/** Enum class to represent the type of credit eligible filter */
export enum CreditEligibleFilterType {
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE'
}

export interface CrossLinksParameterInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}

/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars['String'];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars['String'];
  /** The country code of User's current location. ex: US */
  country: Scalars['String'];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars['String'];
}

/** Amenities on a sailing */
export interface CruiseAmenitiesListInput {
  /** Amenities items to display. */
  amenities: Array<CruiseAmenityInfoInput>;
}

/** Amenity on a sailing */
export interface CruiseAmenityInfoInput {
  /** Category of amenity */
  a11yCategory?: InputMaybe<Scalars['String']>;
  /** Amenity description */
  a11yDescription: Scalars['String'];
  /** Category of amenity */
  category?: InputMaybe<Scalars['String']>;
  /** Amenity description */
  description: Scalars['String'];
  /** Icon of amenity */
  icon: CruiseOrderSummaryRatesPromotionIconInfoInput;
}

export enum CruiseBadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  VIP = 'VIP'
}

/** A guest over the age of 2 */
export interface CruiseChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

/** Duration of cruise to perform a cruise search */
export interface CruiseDurationRangeInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}

export enum CruiseFeature {
  LIVE_SHOPPING_USING_MSC_ADAPTER = 'LIVE_SHOPPING_USING_MSC_ADAPTER',
  MEMBER_DEALS = 'MEMBER_DEALS',
  MEMBER_DEALS_FOR_NON_MEMBERS = 'MEMBER_DEALS_FOR_NON_MEMBERS'
}

export enum CruiseFilterType {
  /** cabin experience - eg. Suite  */
  CABIN = 'CABIN',
  /** departure port */
  DEPARTURE = 'DEPARTURE',
  /** use for filtering by the destination */
  DESTINATION = 'DESTINATION',
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  LENGTH = 'LENGTH',
  /** use for filtering by the cruise line name */
  NAME = 'NAME',
  /** default not set value */
  NOT_SET = 'NOT_SET',
  /** ship type */
  SHIP = 'SHIP',
  /** use for ocean cruise */
  THEME_OCEAN = 'THEME_OCEAN',
  /** use for river cruise */
  THEME_RIVER = 'THEME_RIVER'
}

/** Cruise line policy */
export interface CruiseLinePolicyInput {
  /** Link to the policy page */
  link?: InputMaybe<Scalars['String']>;
}

/** Represents the promotion details */
export interface CruiseOrderSummaryPromotionDetailsInput {
  /** Amenity associated with a promotion */
  amenityInfo: CruiseAmenityInfoInput;
  /** Cruise line cancellation policy */
  cancellationPolicy?: InputMaybe<CruiseLinePolicyInput>;
  /** Instructions with a promotion */
  cruiseOrderSummaryPromotionInstruction?: InputMaybe<CruiseOrderSummaryPromotionInstructionInput>;
  /** Policies with a promotion */
  cruiseOrderSummaryPromotionPolicy?: InputMaybe<CruiseOrderSummaryPromotionPolicyInput>;
}

/** Expando showing already included amenities */
export interface CruiseOrderSummaryPromotionExpandoInput {
  /** Represents the amenities in the sailing */
  amenitiesList?: InputMaybe<CruiseAmenitiesListInput>;
}

/** Represents the promotion instruction */
export interface CruiseOrderSummaryPromotionInstructionInput {
  /** Code of the promotion */
  promotionCode: Scalars['String'];
  /** Name of the promotion */
  promotionName: Scalars['String'];
  /** Details about the promotion instruction */
  text: Scalars['String'];
  /** Title of the promotion instruction */
  title: Scalars['String'];
}

/** Represents the promotion policy */
export interface CruiseOrderSummaryPromotionPolicyInput {
  /** Description of the promotion policy */
  text: Scalars['String'];
  /** Title of the promotion policy */
  title: Scalars['String'];
}

/** Promotion details side sheet in the Order Summary page */
export interface CruiseOrderSummaryPromotionSideSheetInput {
  /** List of promotion details */
  cruiseOrderSummaryPromotionDetails: Array<CruiseOrderSummaryPromotionDetailsInput>;
  /** Already included amenities expando */
  expando: CruiseOrderSummaryPromotionExpandoInput;
  /** Terms and conditions link */
  termsAndConditions?: InputMaybe<CruiseOrderSummaryPromotionTermsAndConditionsInput>;
  /** Description of the promotions */
  text?: InputMaybe<Array<Scalars['String']>>;
}

/** Promotion details side sheet in the Order Summary page */
export interface CruiseOrderSummaryPromotionTermsAndConditionsInput {
  /** Terms and conditions link */
  link?: InputMaybe<CruiseOrderSummaryRatesUILinkActionInfoInput>;
}

export interface CruiseOrderSummaryRatesInfoInput {
  /** Offer token */
  offerToken: Scalars['String'];
  /** Price Info */
  price: CruiseOrderSummaryRatesPriceInput;
  /** Promotion details side sheet */
  promotionDetails?: InputMaybe<CruiseOrderSummaryPromotionSideSheetInput>;
  /** Promotions Info */
  promotions: Array<CruiseOrderSummaryRatesPromotionInfoInput>;
  /** Update info */
  updateInfo?: InputMaybe<CruiseOrderSummaryRatesUpdateInfoInput>;
}

export interface CruiseOrderSummaryRatesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** Cabin type */
  cabinType: Scalars['String'];
  /** Optional information populated for users redirecting from the Checkout page */
  checkoutRedirectInput?: InputMaybe<CheckoutRedirectInput>;
  /** children ages */
  childAges?: InputMaybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Lead in price shown to the user in infosite sidesheet */
  leadInPrice?: InputMaybe<Scalars['Float']>;
  /** Sailing token */
  sailingToken: Scalars['String'];
}

export interface CruiseOrderSummaryRatesPageDataInput {
  /** Info about rates displayed on the page. */
  ratesInfo: Array<CruiseOrderSummaryRatesInfoInput>;
  /** Index of the rate selected by the user */
  selectedRateIndex: Scalars['Int'];
}

export interface CruiseOrderSummaryRatesPriceChangeMessageInput {
  /** New price */
  newPrice: Scalars['String'];
  /** Old price */
  oldPrice: Scalars['String'];
  /** Type of change, increase/decrease */
  type: Scalars['String'];
}

export interface CruiseOrderSummaryRatesPriceInput {
  /** Base fare Info */
  baseFare?: InputMaybe<CurrencyTypeInput>;
  /** Cabin category title */
  cabinCategoryTitle: Scalars['String'];
  /** Cruise line code */
  cruiseLineCode?: InputMaybe<Scalars['String']>;
  /** Sold out rate flag */
  isSoldOut: Scalars['Boolean'];
  /** Member pricing Info */
  memberPricing: MemberPricingInput;
  /** Price Info */
  price?: InputMaybe<CurrencyAmountTypeInput>;
}

export interface CruiseOrderSummaryRatesPromotionIconInfoInput {
  /** Description of the Icon */
  description: Scalars['String'];
  /** Id of the Icon */
  id: Scalars['String'];
  /** Token of the Icon */
  token: Scalars['String'];
}

export interface CruiseOrderSummaryRatesPromotionInfoInput {
  /** Full Name of the promotion */
  fullName: Scalars['String'];
  /** Icon of the promotion */
  icon: CruiseOrderSummaryRatesPromotionIconInfoInput;
}

export interface CruiseOrderSummaryRatesUILinkActionInfoInput {
  /** Url link */
  url: Scalars['String'];
}

export interface CruiseOrderSummaryRatesUpdateInfoInput {
  /** Price change message to display on the rate */
  priceChangeMessage?: InputMaybe<CruiseOrderSummaryRatesPriceChangeMessageInput>;
}

export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: InputMaybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: InputMaybe<Scalars['String']>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: InputMaybe<Scalars['String']>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: InputMaybe<Scalars['Boolean']>;
}

export interface CruiseSailingCabinCategoriesInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Cabin experience */
  cabinExperience: Scalars['String'];
  /** children ages */
  childAges?: InputMaybe<Array<CruiseChildInput>>;
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
}

/** Property criteria needed to perform a cruise search */
export interface CruiseSearchCriteriaInput {
  primary: PrimaryCruiseCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export interface CruiseSearchFiltersInput {
  /** 1 or more cruise line codes separated by ',' delimiter  */
  cruiseLines?: InputMaybe<Scalars['String']>;
  /** 1 or more port codes separated by ',' delimiter  */
  departureLocations?: InputMaybe<Scalars['String']>;
  /** 1 or more deeplink destination names separated by ',' delimiter  */
  destinationNames?: InputMaybe<Scalars['String']>;
  /** Earliest departure date */
  earliestDeptDate?: InputMaybe<Scalars['String']>;
  /** CruiseFilterType enum name to describe the primary function of the SearchFilter */
  filterType: CruiseFilterType;
  /** Latest departure date */
  latestDeptDate?: InputMaybe<Scalars['String']>;
  /** Max length of sailing */
  maxLength?: InputMaybe<Scalars['String']>;
  /** Return sailings with member only offer */
  memberOnlyOffer?: InputMaybe<Scalars['Boolean']>;
  /** Min length of sailing */
  minLength?: InputMaybe<Scalars['String']>;
  /** 1 or more promotion codes separated by ',' delimiter  */
  promotionCode?: InputMaybe<Scalars['String']>;
  /** ocean or river */
  sailingVarieties?: InputMaybe<Scalars['String']>;
  /** 1 or more ship codes separated by ',' delimiter  */
  ships?: InputMaybe<Scalars['String']>;
  /** Cabin type filter. One of the ANY, INSIDE, OCEAN_VIEW, BALCONY or SUITE */
  superCategoryCode?: InputMaybe<Scalars['String']>;
}

/**
 * Values : popularity - sorts by Popularity
 * price - sorts by the offer price within all sailings returned
 * length - sorts by the sailing itinerary length, in days
 * departureDate - sorts by sailing departure/embarkation date
 * cruiseLine - sorts by cruise line name
 */
export interface CruiseSearchOptionsInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Limit of how many results will be returned. - Default is 20 */
  limit: Scalars['Int'];
  /** Limit of how many results will be skipped. - Default is 0 */
  offset?: InputMaybe<Scalars['Int']>;
  /** Field to sort results by - Default is departure-date */
  sortBy?: InputMaybe<Scalars['String']>;
}

export interface CurrencyAmountTypeInput {
  /** Amount in the currency. */
  amount?: InputMaybe<Scalars['Float']>;
  /** Currency code. */
  currencyCode?: InputMaybe<Scalars['String']>;
}

export interface CurrencyTypeInput {
  /** Default currency amount info */
  defaultCurrencyAmount?: InputMaybe<CurrencyAmountTypeInput>;
  /** Supply currency amount info */
  supplyCurrencyAmount?: InputMaybe<CurrencyAmountTypeInput>;
}

/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}

/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum CustomerNotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}

/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: InputMaybe<Scalars['Boolean']>;
  /** Notification id */
  id?: InputMaybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: InputMaybe<Scalars['Boolean']>;
  /** Set to true when notification is starred */
  star?: InputMaybe<Scalars['Boolean']>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: InputMaybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: InputMaybe<Scalars['URL']>;
  /** regionId number */
  regionId?: InputMaybe<Scalars['String']>;
  /** list of GAIA regionIds */
  regionIds?: InputMaybe<Array<Scalars['String']>>;
  /** trip folder id */
  tripFolderId?: InputMaybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: InputMaybe<DateRangeInput>;
  /** destination information */
  destination?: InputMaybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: InputMaybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: InputMaybe<Scalars['String']>;
  /** property id */
  propertyId?: InputMaybe<Scalars['String']>;
  /** regionId number */
  regionId?: InputMaybe<Scalars['String']>;
}

/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  GDPR = 'GDPR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  OSANO = 'OSANO',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

export enum DamageLiability {
  COF = 'COF',
  RDD = 'RDD'
}

export enum DashboardType {
  DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',
  PERFORMANCE = 'PERFORMANCE'
}

/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 * CHECKOUT: Core Checkout Identifying Service
 */
export enum DataSourceType {
  CART = 'CART',
  CHECKOUT = 'CHECKOUT',
  ENTITY = 'ENTITY',
  OFFER = 'OFFER',
  ORDER = 'ORDER'
}

/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars['Int'];
  /** The numeric month, e.g. `1` for January */
  month: Scalars['Int'];
  /** The four-digit year e.g. `1999` */
  year: Scalars['Int'];
}

/** A generic period of date, not tied to a checkin/out status. */
export interface DatePeriodInput {
  /** The bounding type of period, if defined, otherwise interpreted as a degenerate interval */
  bound?: InputMaybe<ClosedPeriodBounding>;
  /** The length of period */
  length: Scalars['Int'];
  /** The unit of period */
  unit: DatePeriodUnit;
}

/** The unit of date period */
export enum DatePeriodUnit {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND'
}

/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}

/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars['Int'];
  /** The hour of the datetime */
  hour: Scalars['Int'];
  /** The minute of the hour */
  minute: Scalars['Int'];
  /** The numeric month of the date */
  month: Scalars['Int'];
  /** The second of the minute */
  second: Scalars['Int'];
  /** The four-digit year of the date */
  year: Scalars['Int'];
}

/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars['String'];
  value: DateInput;
}

export enum DealType {
  AARP = 'AARP',
  POINTS_PROMOTION = 'POINTS_PROMOTION'
}

/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: InputMaybe<AlterMode>;
}

export enum DeeplinkType {
  HSR = 'HSR',
  PDP = 'PDP'
}

export interface DestinationHeadingCriteriaInput {
  /** Max number of images for the given destination. */
  imageLimit?: InputMaybe<Scalars['Int']>;
  /** Id of the destination. */
  placeId: Scalars['String'];
}

export interface DestinationImageDimensionsInput {
  height: Scalars['Int'];
  width: Scalars['Int'];
}

/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: InputMaybe<CoordinatesInput>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: InputMaybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: InputMaybe<Scalars['String']>;
  /** List of property IDs to return search information for. */
  propertyIds?: InputMaybe<Array<Scalars['String']>>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: InputMaybe<Scalars['String']>;
}

/** Inputs for the destinationGroup query */
export interface DestinationRecommendationCriteriaInput {
  /** Max amount of cards to show */
  maxCards?: InputMaybe<Scalars['Int']>;
  /** Min amount of cards to show */
  minCards?: InputMaybe<Scalars['Int']>;
  /** Id of the origin destination */
  referencePlaceId: Scalars['String'];
  /** Strategy for place relationship */
  strategy: DestinationRecommendationStrategy;
  /** Type of destinations in the output */
  type: DestinationRecommendationPlaceType;
}

export enum DestinationRecommendationPlaceType {
  CITY = 'CITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI = 'POI'
}

/** Strategy to select the relationship of the output destinations and the origin */
export enum DestinationRecommendationStrategy {
  NEARBY = 'NEARBY',
  SIMILAR = 'SIMILAR',
  TOP = 'TOP'
}

/** Input for travelGuideRecommendation query */
export enum DestinationTravelGuidePolicy {
  PERSONALIZED = 'PERSONALIZED',
  USER_LOCATION = 'USER_LOCATION'
}

/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}

export enum DialogButtonActionType {
  CLOSE_DIALOG = 'CLOSE_DIALOG',
  CREATE_TRACKING_MUTATION = 'CREATE_TRACKING_MUTATION',
  DISABLE_TRACKING_MUTATION = 'DISABLE_TRACKING_MUTATION',
  UPDATE_TRACKING_MUTATION = 'UPDATE_TRACKING_MUTATION'
}

/** Dimensions for a presentation object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
}

export enum DirectFeedbackPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}

export interface DirectFeedbackValuesInput {
  context: Array<GraphQLPairInput>;
  formValues: Array<GraphQLPairInput>;
}

/** A reference place or property for which to show directions to */
export interface DirectionsReferenceInput {
  /** The id of the reference place or property. */
  id: Scalars['String'];
  /** The type of reference, e.g. place, property, etc. */
  type: EGDSMapFeatureType;
}

/** Used as input value to let the server knows what data needs to be populated in a card. */
export enum DiscoveryCardContentSize {
  ABBREVIATED = 'ABBREVIATED',
  FOUNDATION = 'FOUNDATION',
  LONG_FORM = 'LONG_FORM',
  SHORT_FORM = 'SHORT_FORM',
  UBER_ABBREVIATED = 'UBER_ABBREVIATED',
  UBER_ABBREVIATED_PRICE = 'UBER_ABBREVIATED_PRICE',
  UBER_ABBREVIATED_RATING = 'UBER_ABBREVIATED_RATING'
}

export enum DiscoveryContainerType {
  CAROUSEL = 'CAROUSEL',
  EXPANDO = 'EXPANDO'
}

/** Represent the context for a destination (eg. information in a landing page). */
export interface DiscoveryDestinationContextInput {
  placeId?: InputMaybe<DiscoveryPlaceIdInput>;
}

/** Represent the context for lodging (eg. information in a PDP) */
export interface DiscoveryLodgingContextInput {
  checkin?: InputMaybe<DateInput>;
  checkout?: InputMaybe<DateInput>;
  propertyId?: InputMaybe<Scalars['String']>;
  rooms?: InputMaybe<Array<DiscoveryRoomInput>>;
  searchCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** List of all the managed offering types. */
export enum DiscoveryOfferingType {
  DESTINATION = 'DESTINATION',
  PRODUCT = 'PRODUCT'
}

/** Identifier for a destination, it can contains also the type of a destination (neighborhood, city, airport, etc...) */
export interface DiscoveryPlaceIdInput {
  id: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
}

export interface DiscoveryRecentActivityContextInput {
  lodging?: InputMaybe<DiscoveryLodgingContextInput>;
  marketingChannelTypeCode?: InputMaybe<Scalars['Int']>;
  outputLineOfBusiness: LineOfBusinessDomain;
}

/** Context values a client can/should fill as input of the recommendations. */
export interface DiscoveryRecommendationContextInput {
  destination?: InputMaybe<DiscoveryDestinationContextInput>;
  lodging?: InputMaybe<DiscoveryLodgingContextInput>;
  orderId?: InputMaybe<Scalars['String']>;
  outputLineOfBusiness?: InputMaybe<LineOfBusinessDomain>;
}

/** Used to select which parameters should be used to run the inference. */
export enum DiscoveryRecommendationInputContext {
  /** Uses the 'destination' section from the context object. */
  DESTINATION = 'DESTINATION',
  /** Uses the 'orderId' section from the context object. */
  ORDER = 'ORDER',
  /** Uses the 'product' section from the context object. */
  PRODUCT = 'PRODUCT',
  /** Personalize the recommendations using the latest products a user saw. */
  RECENTLY_VIEWED_PRODUCT = 'RECENTLY_VIEWED_PRODUCT',
  /** Personalize the recommendations using the recent searches of the user. */
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  /** Base the recommendations on the user location. */
  USER_LOCATION = 'USER_LOCATION'
}

/** List of all the managed recommendations strategies. */
export enum DiscoveryRecommendationStrategy {
  ALTERNATIVE = 'ALTERNATIVE',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  SIMILAR = 'SIMILAR'
}

/** Represent a room for lodging. */
export interface DiscoveryRoomInput {
  adults: Scalars['Int'];
  children?: InputMaybe<Array<Scalars['Int']>>;
}

/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE'
}

/** Different types of duration span input validations. */
export enum DurationSpanValidationType {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  MAXIMUM_GREATER_THAN_MINIMUM = 'MAXIMUM_GREATER_THAN_MINIMUM',
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  MAXIMUM_VALUE = 'MAXIMUM_VALUE',
  /** Used to validate that a minimum input value is less than a maximum input value. */
  MINIMUM_LESS_THAN_MAXIMUM = 'MINIMUM_LESS_THAN_MAXIMUM',
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  MINIMUM_VALUE = 'MINIMUM_VALUE',
  /** Used to validate that the user input has a value. */
  REQUIRED_VALUE = 'REQUIRED_VALUE'
}

/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export enum EGDSButtonStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}

/**
 * Represents the variations of a card. Can be used with EGDSCard union members.
 * https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 */
export enum EGDSCardThemes {
  BORDERED = 'BORDERED',
  PADDED = 'PADDED'
}

/** Defines how checkbox state should be displayed on client. */
export enum EGDSCheckBoxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED'
}

/** Represents the label theme for the date range result. */
export enum EGDSDateRangeResultTheme {
  LINK = 'LINK',
  POSITIVE = 'POSITIVE'
}

/** Represents short day name. */
export enum EGDSDayName {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

/** Represents the type of decorative in the text element. e.g. superscript */
export enum EGDSDecorativeText {
  /** Renders with a line through the text */
  LINE_THROUGH = 'LINE_THROUGH',
  /** Renders as a subscript at the bottom of the text line */
  SUBSCRIPT = 'SUBSCRIPT',
  /** Renders as a superscript at the top of the text line */
  SUPERSCRIPT = 'SUPERSCRIPT',
  /** Renders with a line under the text */
  UNDERLINE = 'UNDERLINE'
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EGDSHeadingStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  H7 = 'H7',
  H8 = 'H8'
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EGDSIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}

/** Option for selecting an infant seat on a plane. */
export enum EGDSInfantSeat {
  IN_SEAT = 'IN_SEAT',
  ON_LAP = 'ON_LAP'
}

/** Represents the size of the text in a EGDS Standard Link */
export enum EGDSLinkSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

/** The type of feature - PLACE OR PROPERTY */
export enum EGDSMapFeatureType {
  PLACE = 'PLACE',
  PROPERTY = 'PROPERTY'
}

/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export enum EGDSMapInitialViewport {
  /** To use bounds value as initial viewport */
  BOUNDS = 'BOUNDS',
  /** To compute a bound from a set of options with a specified center */
  CENTERED_COMPUTED_BOUNDS = 'CENTERED_COMPUTED_BOUNDS',
  /** To use zoom and center values as initial viewport */
  CENTER_AND_ZOOM = 'CENTER_AND_ZOOM',
  /** To compute a bound from a set of options */
  COMPUTED_BOUNDS = 'COMPUTED_BOUNDS',
  /** Will center the map to show all markers pushed to the map */
  FIT_MARKERS = 'FIT_MARKERS'
}

/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export enum EGDSMapMarkerStatus {
  AVAILABLE = 'AVAILABLE',
  FILTERED = 'FILTERED',
  SOLD_OUT = 'SOLD_OUT',
  UNKNOWN = 'UNKNOWN'
}

/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export enum EGDSMapPositionMode {
  FIT_BOUNDS = 'FIT_BOUNDS',
  ZOOM_AND_CENTER = 'ZOOM_AND_CENTER'
}

/** type of maps that can be used */
export enum EGDSMapProvider {
  GOOGLE = 'GOOGLE',
  MAPBOX = 'MAPBOX',
  MAPKIT = 'MAPKIT'
}

export enum EGDSMark {
  AARP = 'AARP',
  AARP_MEMBER_BENEFITS = 'AARP_MEMBER_BENEFITS',
  ADDON = 'ADDON',
  AIR_NEW_ZEALAND = 'AIR_NEW_ZEALAND',
  APPLE = 'APPLE',
  APPLE_MAPS = 'APPLE_MAPS',
  APP_CTX = 'APP_CTX',
  APP_EBOOK = 'APP_EBOOK',
  APP_EXP = 'APP_EXP',
  APP_HOTWIRE = 'APP_HOTWIRE',
  APP_ORB = 'APP_ORB',
  APP_TVLY = 'APP_TVLY',
  APP_WOTIF = 'APP_WOTIF',
  BONUS_EBOOK = 'BONUS_EBOOK',
  COMMISSION_TIER_FOUR = 'COMMISSION_TIER_FOUR',
  COMMISSION_TIER_ONE = 'COMMISSION_TIER_ONE',
  COMMISSION_TIER_THREE = 'COMMISSION_TIER_THREE',
  COMMISSION_TIER_TWO = 'COMMISSION_TIER_TWO',
  FACEBOOK = 'FACEBOOK',
  FLAGS__AR = 'FLAGS__AR',
  FLAGS__AS = 'FLAGS__AS',
  FLAGS__AT = 'FLAGS__AT',
  FLAGS__AU = 'FLAGS__AU',
  FLAGS__BE = 'FLAGS__BE',
  FLAGS__BO = 'FLAGS__BO',
  FLAGS__BR = 'FLAGS__BR',
  FLAGS__BZ = 'FLAGS__BZ',
  FLAGS__CA = 'FLAGS__CA',
  FLAGS__CH = 'FLAGS__CH',
  FLAGS__CL = 'FLAGS__CL',
  FLAGS__CN = 'FLAGS__CN',
  FLAGS__CO = 'FLAGS__CO',
  FLAGS__CR = 'FLAGS__CR',
  FLAGS__CZ = 'FLAGS__CZ',
  FLAGS__DE = 'FLAGS__DE',
  FLAGS__DK = 'FLAGS__DK',
  FLAGS__EC = 'FLAGS__EC',
  FLAGS__EE = 'FLAGS__EE',
  FLAGS__EG = 'FLAGS__EG',
  FLAGS__ES = 'FLAGS__ES',
  FLAGS__EU = 'FLAGS__EU',
  FLAGS__FI = 'FLAGS__FI',
  FLAGS__FR = 'FLAGS__FR',
  FLAGS__GR = 'FLAGS__GR',
  FLAGS__GT = 'FLAGS__GT',
  FLAGS__GY = 'FLAGS__GY',
  FLAGS__HK = 'FLAGS__HK',
  FLAGS__HN = 'FLAGS__HN',
  FLAGS__HR = 'FLAGS__HR',
  FLAGS__HU = 'FLAGS__HU',
  FLAGS__ID = 'FLAGS__ID',
  FLAGS__IE = 'FLAGS__IE',
  FLAGS__IL = 'FLAGS__IL',
  FLAGS__IN = 'FLAGS__IN',
  FLAGS__IS = 'FLAGS__IS',
  FLAGS__IT = 'FLAGS__IT',
  FLAGS__JP = 'FLAGS__JP',
  FLAGS__KR = 'FLAGS__KR',
  FLAGS__L1 = 'FLAGS__L1',
  FLAGS__LT = 'FLAGS__LT',
  FLAGS__LV = 'FLAGS__LV',
  FLAGS__MX = 'FLAGS__MX',
  FLAGS__MY = 'FLAGS__MY',
  FLAGS__NI = 'FLAGS__NI',
  FLAGS__NL = 'FLAGS__NL',
  FLAGS__NO = 'FLAGS__NO',
  FLAGS__NZ = 'FLAGS__NZ',
  FLAGS__PA = 'FLAGS__PA',
  FLAGS__PE = 'FLAGS__PE',
  FLAGS__PH = 'FLAGS__PH',
  FLAGS__PL = 'FLAGS__PL',
  FLAGS__PT = 'FLAGS__PT',
  FLAGS__PY = 'FLAGS__PY',
  FLAGS__RU = 'FLAGS__RU',
  FLAGS__SA = 'FLAGS__SA',
  FLAGS__SE = 'FLAGS__SE',
  FLAGS__SG = 'FLAGS__SG',
  FLAGS__SK = 'FLAGS__SK',
  FLAGS__SR = 'FLAGS__SR',
  FLAGS__SV = 'FLAGS__SV',
  FLAGS__TH = 'FLAGS__TH',
  FLAGS__TR = 'FLAGS__TR',
  FLAGS__TW = 'FLAGS__TW',
  FLAGS__UA = 'FLAGS__UA',
  FLAGS__UAE = 'FLAGS__UAE',
  FLAGS__UK = 'FLAGS__UK',
  FLAGS__US = 'FLAGS__US',
  FLAGS__UY = 'FLAGS__UY',
  FLAGS__VE = 'FLAGS__VE',
  FLAGS__VN = 'FLAGS__VN',
  FLAGS__WW = 'FLAGS__WW',
  FLAGS__ZA = 'FLAGS__ZA',
  GOOGLE = 'GOOGLE',
  GOOGLE_LOGO = 'GOOGLE_LOGO',
  GOOGLE_MAP = 'GOOGLE_MAP',
  GOOGLE_TRANSLATED = 'GOOGLE_TRANSLATED',
  HAWAIIAN = 'HAWAIIAN',
  HOTWIRE_HOTRATE_CIRCLE = 'HOTWIRE_HOTRATE_CIRCLE',
  LINE = 'LINE',
  LOYALTY_HOTELS__HIGH_TIER = 'LOYALTY_HOTELS__HIGH_TIER',
  LOYALTY_HOTELS__LOW_TIER = 'LOYALTY_HOTELS__LOW_TIER',
  LOYALTY_HOTELS__MIDDLE_TIER = 'LOYALTY_HOTELS__MIDDLE_TIER',
  LOYALTY_HOTELS__REWARDS = 'LOYALTY_HOTELS__REWARDS',
  LOYALTY_HOTELS__STAMP_EMPTY = 'LOYALTY_HOTELS__STAMP_EMPTY',
  LOYALTY_HOTELS__STAMP_PENDING = 'LOYALTY_HOTELS__STAMP_PENDING',
  LOYALTY_HOTELS__STAMP_SEARCHED = 'LOYALTY_HOTELS__STAMP_SEARCHED',
  LOYALTY_TVLY = 'LOYALTY_TVLY',
  MAPBOX = 'MAPBOX',
  MIP_PRIMARY = 'MIP_PRIMARY',
  MIP_REVERSE = 'MIP_REVERSE',
  MIP_SECONDARY = 'MIP_SECONDARY',
  MOD_CTX = 'MOD_CTX',
  MOD_EBOOK = 'MOD_EBOOK',
  MOD_EXP = 'MOD_EXP',
  MOD_HOTELS = 'MOD_HOTELS',
  MOD_ORB = 'MOD_ORB',
  MOD_TVLY = 'MOD_TVLY',
  MOD_WOTIF = 'MOD_WOTIF',
  NAVER = 'NAVER',
  ONEKEY__ABRITEL = 'ONEKEY__ABRITEL',
  ONEKEY__BLUE = 'ONEKEY__BLUE',
  ONEKEY__BOOKABACH = 'ONEKEY__BOOKABACH',
  ONEKEY__CASH = 'ONEKEY__CASH',
  ONEKEY__EXPEDIA = 'ONEKEY__EXPEDIA',
  ONEKEY__FEWODIREKT = 'ONEKEY__FEWODIREKT',
  ONEKEY__GOLD = 'ONEKEY__GOLD',
  ONEKEY__HOTELS__CHINESE = 'ONEKEY__HOTELS__CHINESE',
  ONEKEY__HOTELS__ENGLISH = 'ONEKEY__HOTELS__ENGLISH',
  ONEKEY__HOTELS__PORTUGUESE = 'ONEKEY__HOTELS__PORTUGUESE',
  ONEKEY__HOTELS__SPANISH = 'ONEKEY__HOTELS__SPANISH',
  ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT = 'ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT',
  ONEKEY__PLATINUM = 'ONEKEY__PLATINUM',
  ONEKEY__SILVER = 'ONEKEY__SILVER',
  ONEKEY__STANDARD = 'ONEKEY__STANDARD',
  ONEKEY__STANDARD__ALWAYS_LIGHT = 'ONEKEY__STANDARD__ALWAYS_LIGHT',
  ONEKEY__STAYZ = 'ONEKEY__STAYZ',
  ONEKEY__VRBO = 'ONEKEY__VRBO',
  ONEKEY__WORDMARK = 'ONEKEY__WORDMARK',
  ONEKEY__WORDMARK__ALWAYS_LIGHT = 'ONEKEY__WORDMARK__ALWAYS_LIGHT',
  PAYMENT__7_ELEVEN = 'PAYMENT__7_ELEVEN',
  PAYMENT__AFFIRM = 'PAYMENT__AFFIRM',
  PAYMENT__AIRPLUS = 'PAYMENT__AIRPLUS',
  PAYMENT__ALIPAY = 'PAYMENT__ALIPAY',
  PAYMENT__AMEX = 'PAYMENT__AMEX',
  PAYMENT__APPLEPAY = 'PAYMENT__APPLEPAY',
  PAYMENT__CHASE = 'PAYMENT__CHASE',
  PAYMENT__CLICKTOPAY = 'PAYMENT__CLICKTOPAY',
  PAYMENT__DINERS_CLUB_INTERNATIONAL = 'PAYMENT__DINERS_CLUB_INTERNATIONAL',
  PAYMENT__DISCOVER = 'PAYMENT__DISCOVER',
  PAYMENT__GOOGLE_PAY = 'PAYMENT__GOOGLE_PAY',
  PAYMENT__IDEAL = 'PAYMENT__IDEAL',
  PAYMENT__JAPAN_CREDIT_BUREAU = 'PAYMENT__JAPAN_CREDIT_BUREAU',
  PAYMENT__KLARNA = 'PAYMENT__KLARNA',
  PAYMENT__MAESTRO = 'PAYMENT__MAESTRO',
  PAYMENT__MASTERCARD = 'PAYMENT__MASTERCARD',
  PAYMENT__MASTERPASS = 'PAYMENT__MASTERPASS',
  PAYMENT__PAYPAL = 'PAYMENT__PAYPAL',
  PAYMENT__SAMSUNG_CARD = 'PAYMENT__SAMSUNG_CARD',
  PAYMENT__UATP = 'PAYMENT__UATP',
  PAYMENT__UNION_PAY = 'PAYMENT__UNION_PAY',
  PAYMENT__VISA = 'PAYMENT__VISA',
  PLUS_CIRCLE = 'PLUS_CIRCLE',
  PLUS_CIRCLE_CTX = 'PLUS_CIRCLE_CTX',
  PLUS_CIRCLE_EBOOK = 'PLUS_CIRCLE_EBOOK',
  PLUS_CIRCLE_ORB = 'PLUS_CIRCLE_ORB',
  PLUS_CIRCLE_TVLY = 'PLUS_CIRCLE_TVLY',
  PLUS_CIRCLE_WOTIF = 'PLUS_CIRCLE_WOTIF',
  PREMIUM_TVLY = 'PREMIUM_TVLY',
  REWARDS_ORB = 'REWARDS_ORB',
  TRIPADVISOR = 'TRIPADVISOR',
  TRIVAGO = 'TRIVAGO',
  VAP_HOTELS__HIGH_TIER = 'VAP_HOTELS__HIGH_TIER',
  VAP_HOTELS__LOW_TIER = 'VAP_HOTELS__LOW_TIER',
  VAP_HOTELS__MIDDLE_TIER = 'VAP_HOTELS__MIDDLE_TIER',
  VIP_BEX = 'VIP_BEX',
  VIP_CIRCLE_BEX = 'VIP_CIRCLE_BEX',
  VIP_CIRCLE_EBOOKERS = 'VIP_CIRCLE_EBOOKERS',
  VIP_CIRCLE_HOTELS = 'VIP_CIRCLE_HOTELS',
  VIP_CIRCLE_ORBITZ = 'VIP_CIRCLE_ORBITZ',
  VIP_EBOOKERS = 'VIP_EBOOKERS',
  VIP_ORBITZ = 'VIP_ORBITZ',
  VIRGIN_AU = 'VIRGIN_AU',
  VRBO = 'VRBO'
}

/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EGDSParagraphStyle {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}

/** The type of path for directions */
export enum EGDSPathType {
  CYCLING = 'CYCLING',
  DRIVING = 'DRIVING',
  FLYING = 'FLYING',
  TRANSIT = 'TRANSIT',
  WALKING = 'WALKING'
}

/** Possible camera movement for the photosphere image */
export enum EGDSPhotosphereCameraMovement {
  AUTO_PAN = 'AUTO_PAN',
  DISABLED = 'DISABLED',
  FULL_MOVE = 'FULL_MOVE'
}

/** Type of EGDSSheet */
export enum EGDSSheetType {
  BOTTOM = 'BOTTOM',
  CENTERED = 'CENTERED',
  FULLSCREEN = 'FULLSCREEN',
  POPOVER = 'POPOVER',
  SIDE = 'SIDE'
}

export enum EGDSTextListItemStyle {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EGDSTextListSize {
  LIST_1 = 'LIST_1',
  LIST_2 = 'LIST_2',
  LIST_3 = 'LIST_3'
}

/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export enum EGDSTextListType {
  BULLET = 'BULLET',
  ICON = 'ICON',
  NO_BULLET = 'NO_BULLET',
  NUMBER = 'NUMBER'
}

/** Represents different type of travelers validation. */
export enum EGDSTravelersValidationType {
  /** Used to validate child age required. */
  CHILD_AGE_REQUIRED = 'CHILD_AGE_REQUIRED',
  /** Used to validate maximum number of allowed infants in seat. */
  MANY_INFANT_IN_SEAT = 'MANY_INFANT_IN_SEAT',
  /** Used to validate maximum number of allowed infants on lap. */
  MANY_INFANT_ON_LAP = 'MANY_INFANT_ON_LAP',
  /** Used to validate maximum allowed travelers for search. */
  MAX_TRAVELERS = 'MAX_TRAVELERS'
}

/** Defines how typeahead results should be displayed on client. */
export enum EGDSTypeaheadRenderType {
  ADAPTIVE = 'ADAPTIVE',
  DIALOG = 'DIALOG',
  MENU = 'MENU'
}

/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export enum EGReferrerEventType {
  /** Used to track a click on a UI component. */
  CLICK = 'CLICK',
  /** Used to track an impression of a UI component. */
  IMPRESSION = 'IMPRESSION'
}

export enum EmptyStateType {
  ENABLE_PUSH = 'ENABLE_PUSH',
  EXPLORE_TRIPS = 'EXPLORE_TRIPS',
  SIGN_IN = 'SIGN_IN'
}

/**
 * "The `EssentialInfoItemInput` contains essentialInfoItemId along with bookingItemID separated by -. eg. 1-4020303
 * essentialInfoItemId identifies which essential info to render and bookingItemID is used as an parameter to lodgingDemandReservationService's getVrStayEssentialInfo API
 */
export interface EssentialInfoItemInput {
  itemId: Scalars['String'];
}

export enum EventType {
  DeleteTripAlertPresented = 'DeleteTripAlertPresented',
  DeleteTripDialogPresented = 'DeleteTripDialogPresented',
  DeleteTripErrorToastPresented = 'DeleteTripErrorToastPresented',
  DeleteTripFailed = 'DeleteTripFailed',
  DeleteTripSucceeded = 'DeleteTripSucceeded',
  DeleteTripSuccessToastPresented = 'DeleteTripSuccessToastPresented',
  HeroModuleCampaign = 'HeroModuleCampaign',
  HeroModuleColdStart = 'HeroModuleColdStart',
  ItinActiveCar = 'ItinActiveCar',
  ItinActiveCruise = 'ItinActiveCruise',
  ItinActiveFlight = 'ItinActiveFlight',
  ItinActiveGT = 'ItinActiveGT',
  ItinActiveHotel = 'ItinActiveHotel',
  ItinActiveLX = 'ItinActiveLX',
  ItinActivePackageFH = 'ItinActivePackageFH',
  ItinActiveRail = 'ItinActiveRail',
  ItinCancellation = 'ItinCancellation',
  MoveItemDrawerPresented = 'MoveItemDrawerPresented',
  MoveItemErrorToastPresented = 'MoveItemErrorToastPresented',
  MoveItemSubmitted = 'MoveItemSubmitted',
  MoveItemSuccessToastPresented = 'MoveItemSuccessToastPresented',
  MoveItemSuceeded = 'MoveItemSuceeded',
  MoveLinkedItemsDialogPresented = 'MoveLinkedItemsDialogPresented',
  RemoveItemDialogPresented = 'RemoveItemDialogPresented',
  TripItemMenuPresented = 'TripItemMenuPresented',
  TripSignInDialogPresented = 'TripSignInDialogPresented',
  TripsCollabInviteConfirmationViewed = 'TripsCollabInviteConfirmationViewed',
  TripsCollabInviteFailureViewed = 'TripsCollabInviteFailureViewed',
  TripsCollabInviteSucceeded = 'TripsCollabInviteSucceeded',
  TripsCollabJoinGroupFailed = 'TripsCollabJoinGroupFailed',
  TripsCollabJoinGroupSucceeded = 'TripsCollabJoinGroupSucceeded',
  TripsCollabJoinTripConfirmationViewed = 'TripsCollabJoinTripConfirmationViewed',
  TripsCollabJoinTripErrorToastPresented = 'TripsCollabJoinTripErrorToastPresented',
  TripsCollabLandingScreenRedirectToTripOverView = 'TripsCollabLandingScreenRedirectToTripOverView',
  TripsCollabLandingScreenViewed = 'TripsCollabLandingScreenViewed',
  TripsCollabManageGroupViewed = 'TripsCollabManageGroupViewed',
  TripsCollabViewPresentedActivities = 'TripsCollabViewPresentedActivities',
  TripsCollabViewPresentedCars = 'TripsCollabViewPresentedCars',
  TripsCollabViewPresentedCruise = 'TripsCollabViewPresentedCruise',
  TripsCollabViewPresentedFlight = 'TripsCollabViewPresentedFlight',
  TripsCollabViewPresentedHotel = 'TripsCollabViewPresentedHotel',
  TripsCollabViewPresentedVacationRental = 'TripsCollabViewPresentedVacationRental',
  TripsEditItemSucceeded = 'TripsEditItemSucceeded',
  TripsEditTripErrorToastPresented = 'TripsEditTripErrorToastPresented',
  TripsEditTripPresented = 'TripsEditTripPresented',
  TripsEditTripSubmitted = 'TripsEditTripSubmitted',
  TripsEditTripSuccessToastPresented = 'TripsEditTripSuccessToastPresented',
  TripsFlightScheduleChangeBannerDisplayed = 'TripsFlightScheduleChangeBannerDisplayed',
  TripsHeroModuleCurrentTrip = 'TripsHeroModuleCurrentTrip',
  TripsHeroModulePossibleActivityTrip = 'TripsHeroModulePossibleActivityTrip',
  TripsHeroModulePossibleAirTrip = 'TripsHeroModulePossibleAirTrip',
  TripsHeroModulePossibleCarTrip = 'TripsHeroModulePossibleCarTrip',
  TripsHeroModulePossibleHotelTrip = 'TripsHeroModulePossibleHotelTrip',
  TripsHeroModulePossiblePackageHFTrip = 'TripsHeroModulePossiblePackageHFTrip',
  TripsHeroModulePossibleTrip = 'TripsHeroModulePossibleTrip',
  TripsHeroModulePotentialTrip = 'TripsHeroModulePotentialTrip',
  TripsHeroModuleUpcomingTrip = 'TripsHeroModuleUpcomingTrip',
  TripsItemDetailViewed = 'TripsItemDetailViewed',
  TripsListViewed = 'TripsListViewed',
  TripsModuleDestinationGuide = 'TripsModuleDestinationGuide',
  TripsModuleRecommendedActivity = 'TripsModuleRecommendedActivity',
  TripsModuleRecommendedCar = 'TripsModuleRecommendedCar',
  TripsModuleRecommendedHotel = 'TripsModuleRecommendedHotel',
  TripsOverviewViewed = 'TripsOverviewViewed',
  TripsTravelPlannerItinNumberPresent = 'TripsTravelPlannerItinNumberPresent',
  Unknown = 'Unknown'
}

export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

/** Specifies the position of the trigger icon  */
export enum ExpandoTriggerPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}

/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars['Int'];
  /** The numeric Abacus ID for an experiment */
  id: Scalars['String'];
}

export interface FOPItemInput {
  id: Scalars['String'];
  paymentContextualInfo?: InputMaybe<PaymentContextualInfoInput>;
  paymentMethod: PaymentMethodType;
  state: Scalars['String'];
}

export enum FacetType {
  BUTTON = 'BUTTON',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  SLIDER = 'SLIDER'
}

/** Represents the state of the fare */
export enum FareState {
  /** Fare is selected on meta search, but it has unselected visual state */
  META_UNSELECTED = 'META_UNSELECTED',
  /** Fare is selected */
  SELECTED = 'SELECTED',
  /** Fare is selected with PMP */
  SELECTED_PMP_SELECTED = 'SELECTED_PMP_SELECTED',
  /** Fare is unselected */
  UNSELECTED = 'UNSELECTED',
  /** Fare is unselected with PMP */
  UNSELECTED_PMP_SELECTED = 'UNSELECTED_PMP_SELECTED'
}

export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = 'CARD_ON_FILE_DAMAGE_LIABILITY',
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT'
}

/** The filter placement for the map view */
export enum FilterPlacement {
  /** Display the filters on the bottom, over the map */
  OVERLAY_BOTTOM = 'OVERLAY_BOTTOM',
  /** Display the filters on the top, over the map */
  OVERLAY_TOP = 'OVERLAY_TOP',
  /** Display the filters in the toolbar */
  TOOLBAR = 'TOOLBAR'
}

/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}

/** Enum class to represent the type of travel and baggage */
export enum FilterTravelAndBaggageType {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}

export enum FlavorType {
  DEMO = 'DEMO',
  INT = 'INT',
  LAB = 'LAB',
  PROD = 'PROD',
  SANDBOX = 'SANDBOX'
}

/** Controls the alignment along the cross axis. */
export enum FlexAlignItems {
  CENTER = 'CENTER',
  END = 'END',
  START = 'START',
  STRETCH = 'STRETCH'
}

/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export enum FlexDirection {
  ROW = 'ROW'
}

/** Controls the alignment along the main axis. */
export enum FlexJustifyContent {
  CENTER = 'CENTER',
  END = 'END',
  SPACE_AROUND = 'SPACE_AROUND',
  SPACE_BETWEEN = 'SPACE_BETWEEN',
  START = 'START'
}

/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export enum FlexWrap {
  NOWRAP = 'NOWRAP'
}

/** The core criteria needed for a flex search */
export interface FlexibleSearchCriteriaInput {
  /** The raw flexibility of the search */
  flexibility?: InputMaybe<Array<DatePeriodInput>>;
  flexibleSearchMonths?: InputMaybe<Array<Scalars['Int']>>;
  flexibleSearchTripDurationType?: InputMaybe<FlexibleSearchTripDurationType>;
  numFlexibleDays?: InputMaybe<Scalars['Int']>;
  /** The search range for the flexible search */
  searchRange?: InputMaybe<Array<DateRangeInput>>;
}

/** The trip duration type for the flex search */
export enum FlexibleSearchTripDurationType {
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  WEEKEND = 'WEEKEND'
}

export interface FlightAncillaryBagSelectionInput {
  /** Represents count of options available for corresponding bag */
  availableOptionsCount?: InputMaybe<Scalars['Int']>;
  /** Represents index of the selected bag */
  selectedBagIndex: Scalars['Int'];
  /** Represents the price of selected bag */
  selectedBagPrice?: InputMaybe<Scalars['Float']>;
}

/** Represents details of air ancillary selections for a journey */
export interface FlightAncillaryJourneySelectionInput {
  /** Represents the state of `apply same ancillaries for all travellers` checkbox */
  applySameAncillaryForAllTravellers: Scalars['Boolean'];
  /** It's contains the count of included checked bag */
  checkedBagIncluded?: InputMaybe<Scalars['Int']>;
  /** Represents list of selected ancillaries for each traveller */
  flightAncillaryTravelerSelections: Array<FlightAncillaryTravelerSelectionInput>;
  /** Represents index of the journey */
  journeyIndex: Scalars['Int'];
}

/** Represents list of selected ancillaries for a traveller */
export interface FlightAncillaryTravelerSelectionInput {
  /** Represents sequence index of the combined ancillaries in cache */
  combinedAncillaryIndex?: InputMaybe<Scalars['Int']>;
  /** Represents list of selected bags */
  flightAncillaryBagSelections: Array<FlightAncillaryBagSelectionInput>;
  /** Represents index of the traveller */
  travelerIndex: Scalars['Int'];
}

export enum FlightCabinClassInfo {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}

/** Flight cabin class */
export enum FlightClass {
  BUSINESS = 'BUSINESS',
  ECONOMY = 'ECONOMY',
  FIRST_CLASS = 'FIRST_CLASS',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}

/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL'
}

/** Represents the enum for flight journey status */
export enum FlightJourneyStatus {
  /** Represents that the segment status as failure */
  FAILURE = 'FAILURE',
  /** Represents that the segment status as success */
  SUCCESS = 'SUCCESS'
}

/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: Scalars['String'];
  productTokens: Array<Scalars['String']>;
  travelers: Array<TravelerDetailsInput>;
}

/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Represent Type for the values of FlightSelectableAncillaryOption */
export enum FlightSelectableAncillaryOptionValuesType {
  /** Represents NONE value */
  NONE = 'NONE',
  /** Represents a Valid value | eg: upto 15 kg */
  VALID = 'VALID'
}

/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  /** Checkbox. Example: To add Price Match Promise */
  CHECKBOX = 'CHECKBOX',
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  PRIMARY = 'PRIMARY',
  /** Radio Button. Example: To choose seats for a particular traveler */
  RADIO_BUTTON = 'RADIO_BUTTON',
  /** Secondary action. */
  SECONDARY = 'SECONDARY',
  /** Switch toggle action. Example: price alerts subscription toggle */
  SWITCH = 'SWITCH',
  /** Tertiary action. Example: 'No Thanks' */
  TERTIARY = 'TERTIARY',
  /** Toggle action. Example: seat button in seat map */
  TOGGLE = 'TOGGLE'
}

/** Available action types an actionable element */
export enum FlightsActionType {
  /** Add Price Match Promise to the seleted fare */
  ADD_PRICE_MATCH_PROMISE = 'ADD_PRICE_MATCH_PROMISE',
  /** User has selected seat(s) for all passengers in that leg */
  ALL_SEATS_SELECTED_FOR_A_LEG = 'ALL_SEATS_SELECTED_FOR_A_LEG',
  /** Selects the chosen fare and reloads dynamic elements */
  APPLY_FARE = 'APPLY_FARE',
  /** Highlights the fare chosen by the user */
  CHOOSE_FARE = 'CHOOSE_FARE',
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG = 'CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG',
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG = 'CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Go to coupon credit page */
  COUPON_CREDIT = 'COUPON_CREDIT',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Activates the suggested filter */
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  /** Fetch more search listings */
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  GO_TO_AUTH = 'GO_TO_AUTH',
  /** Go to Checkout page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the next set of journey results */
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Redirects to flights search page */
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  /** Redirects back to storefront */
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  /** Opens a dialog for to display cross sell information */
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  /** open amenities tray and upsell options for standard offer flight listings */
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  /** Opens a dialog to display tax breakdown information */
  LOAD_TAX_BREAKDOWN_DIALOG = 'LOAD_TAX_BREAKDOWN_DIALOG',
  /** User has not selected seat(s) for any passengers in that leg */
  NO_SEATS_SELECTED_FOR_A_LEG = 'NO_SEATS_SELECTED_FOR_A_LEG',
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Opens sidesheet for bags selection */
  OPEN_BAGS_SELECTION_SHEET = 'OPEN_BAGS_SELECTION_SHEET',
  /** Opens a dialog to to go to Airlines Site for Booking */
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = 'OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG',
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  OPEN_CREDIT_DIALOG = 'OPEN_CREDIT_DIALOG',
  /** Open Fare Seat information when clicked on required seat button */
  OPEN_FARE_SEAT_MAP_SEAT_SHEET = 'OPEN_FARE_SEAT_MAP_SEAT_SHEET',
  /** Open Fare Seat view to preview the seat map */
  OPEN_FARE_SEAT_MAP_VIEW = 'OPEN_FARE_SEAT_MAP_VIEW',
  /** Open Fare Seat view to select the seat */
  OPEN_FARE_SEAT_SELECT_VIEW = 'OPEN_FARE_SEAT_SELECT_VIEW',
  /** Open Flight leg drop down in seat map view */
  OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG = 'OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG',
  /** Open Legend info sheet in bottom in case of mobile */
  OPEN_LEGEND_INFO_SHEET_MOBILE = 'OPEN_LEGEND_INFO_SHEET_MOBILE',
  /** Open price summary */
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT = 'OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT',
  /** Redirects to Airlines Site for Booking */
  REDIRECT_TO_AIRLINES_FOR_BOOKING = 'REDIRECT_TO_AIRLINES_FOR_BOOKING',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Actionable item to add a journey */
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  /** Closes the expanded Search Form */
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  /** Actionable item to remove a journey */
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG = 'SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Continues to flight details page after selecting seats for all flights */
  SEAT_MAP_CONTINUE_BOOKING = 'SEAT_MAP_CONTINUE_BOOKING',
  /** Closes the current flight seat selection page and continues for next flight */
  SEAT_MAP_GO_TO_NEXT_FLIGHT = 'SEAT_MAP_GO_TO_NEXT_FLIGHT',
  /** Go to next flight section for selecting seats */
  SEAT_MAP_NEXT_FLIGHT = 'SEAT_MAP_NEXT_FLIGHT',
  /** Saves user's seat preferences and redirects to FIS */
  SEAT_MAP_SAVE_AND_EXIT = 'SEAT_MAP_SAVE_AND_EXIT',
  /** Stays at Page displaying Seat Map when selected by user */
  SEAT_MAP_STAY_HERE = 'SEAT_MAP_STAY_HERE',
  /** Continues to stay on the current flight seat selection page */
  SEAT_MAP_STAY_ON_THIS_PAGE = 'SEAT_MAP_STAY_ON_THIS_PAGE',
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  SEAT_SELECT_DIALOG_CONTINUE_BOOKING = 'SEAT_SELECT_DIALOG_CONTINUE_BOOKING',
  /** Displays seat map preview corresponding to each traveler */
  SEAT_SELECT_PREVIEW_FOR_TRAVELER = 'SEAT_SELECT_PREVIEW_FOR_TRAVELER',
  /** Select Flight leg in seat map drop down menu */
  SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG = 'SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG',
  /** Select the seat */
  SELECT_SEAT = 'SELECT_SEAT',
  /** Open Opinion Lab Share Feedback dialogue */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Open a modal showing details of the free Price Match Promise product */
  SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS',
  /** Open a modal showing details of the Price Match Promise product */
  SHOW_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_PRICE_MATCH_PROMISE_DETAILS',
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  SOME_SEATS_SELECTED_FOR_A_LEG = 'SOME_SEATS_SELECTED_FOR_A_LEG',
  /** Subscribe to emails */
  SUBSCRIBE_TO_EMAILS = 'SUBSCRIBE_TO_EMAILS',
  /** Subscribe/Unsubscribes from price alerts */
  TOGGLE_PRICE_ALERTS = 'TOGGLE_PRICE_ALERTS',
  /** Unselect the selected seat */
  UNSELECT_SEAT = 'UNSELECT_SEAT',
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  UPGRADE_TO_NEXT_FARE = 'UPGRADE_TO_NEXT_FARE'
}

/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE'
}

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars['Int'];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars['String'];
}

/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars['String'];
}

/** Ancillary summary criteria for the selected fare */
export interface FlightsAncillaryCriteriaInput {
  /** Represents ancillaryID to signify whether ancillaries were selected, null when no ancillaries were selected. */
  ancillaryId?: InputMaybe<Scalars['String']>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: InputMaybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents path plus page for where ancillaries will be shopped. */
  ancillaryShoppingPath?: InputMaybe<AncillaryShoppingPath>;
  /** Represents the ancillary requested in the summary */
  ancillaryType: FlightsAncillaryType;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: InputMaybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represents identifier of a journey for a traveler. For Standalone shopping path its decodable string whereas for post purchase its trip Id. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight, null for first call on page load */
  selectedOfferToken?: InputMaybe<Scalars['String']>;
}

/** Enum class to represent the ancillary display action */
export enum FlightsAncillaryDisplayAction {
  NONE = 'NONE',
  PREFETCH = 'PREFETCH'
}

/** Accessibility message types to be announced post selection */
export enum FlightsAncillarySelectionAccessibilityMsgType {
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Success */
  SELECTION_SUCCESS = 'SELECTION_SUCCESS'
}

/** Error types which can occur during ancillary selection */
export enum FlightsAncillarySelectionErrorType {
  /** Baggage Details loaded call failed */
  BAGGAGE_DETAILS_LOADED_FAILED = 'BAGGAGE_DETAILS_LOADED_FAILED',
  /** Ancillary details loading failed */
  DETAILS_LOADING_FAILED = 'DETAILS_LOADING_FAILED',
  /** Ancillary Pre-Selection Unavailable */
  PRE_SELECTION_FAILED = 'PRE_SELECTION_FAILED',
  /** Ancillary Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Ancillary Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}

/** Type of ancillaries supported */
export enum FlightsAncillaryType {
  BAGS = 'BAGS',
  BAGS_V2 = 'BAGS_V2',
  SEATS = 'SEATS'
}

/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  BRAND = 'BRAND',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP'
}

/** Represents the button width in the UI */
export enum FlightsButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH'
}

/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}

/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
  displayToast?: InputMaybe<Scalars['Boolean']>;
}

/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  displayToast?: InputMaybe<Scalars['Boolean']>;
  numOfCheckedBags: Scalars['Int'];
}

/** Represents the value credit eligible filter */
export interface FlightsCreditEligibleFilterValueInput {
  creditEligible: CreditEligibleFilterType;
}

/** Represents an individual cross sort parameter */
export interface FlightsCrossSortOptionInput {
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars['Int'];
}

/** User specified parameters for cross sort */
export interface FlightsCrossSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOptionInput>;
}

/** Enum class to represent cross sort types */
export enum FlightsCrossSortType {
  CABIN_CLASS = 'CABIN_CLASS',
  CANCELLATION = 'CANCELLATION',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHANGE_ALLOWED = 'CHANGE_ALLOWED',
  CHECKED_BAG = 'CHECKED_BAG',
  DURATION = 'DURATION',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PRICE = 'PRICE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}

/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represents the list of per segment(seats)/per product(bags) selections */
  ancillaryJourneySelections?: InputMaybe<Array<AncillaryJourneySelectionsInput>>;
  /** Represents path plus page for where ancillaries will be shopped. */
  ancillaryShoppingPath?: InputMaybe<AncillaryShoppingPath>;
  /** Represents the ancillary type for update */
  ancillaryType?: InputMaybe<FlightsAncillaryType>;
  /** Represents details of selected ancillaries for each journey */
  flightAncillaryJourneySelections?: InputMaybe<Array<FlightAncillaryJourneySelectionInput>>;
  /** Represents identifier of a journey for a traveler. For Standalone shopping path its decodable string whereas for post purchase its trip Id. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
  /** Represents Price of the selected flight */
  originalPrice?: InputMaybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: InputMaybe<Array<GraphQLPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars['String']>;
}

/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** This will contain the list of ancillaries for which auto shopping is complete. */
  additionalShoppedAncillaries?: InputMaybe<Array<AdditionalShoppedAncillaries>>;
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: InputMaybe<Scalars['String']>;
  /** Represents the type of the channel for example VirtualAgent */
  channelType?: InputMaybe<ChannelType>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars['String']>;
}

/** Represents the information of the user device */
export interface FlightsDevicePermissionsInput {
  /** Represents the array of all the notifications enabled for the user device */
  pushNotificationsEnabled: Array<NotificationsType>;
}

/** Represents flights dialog actions */
export enum FlightsDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE'
}

/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE'
}

/** Represents IDs for flights dialogs */
export enum FlightsDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /** Represents the Close button dialog for the baggage details */
  BAGGAGE_CLOSE_DIALOG = 'BAGGAGE_CLOSE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the dialog ID for seat legends dialog */
  SEAT_LEGEND_DIALOG = 'SEAT_LEGEND_DIALOG',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG'
}

/** Represents a pre action in flights dialog trigger */
export enum FlightsDialogPreAction {
  CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS'
}

/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = 'SMART_NFF_ALTERNATE_SUGGESTION'
}

/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars['Int'];
  flightsDisplayComponent: FlightsDisplayComponent;
}

/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: InputMaybe<Array<FlightsDisplayComponentCountingValueInput>>;
}

/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars['Int'];
}

/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED'
}

/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = 'BASE_AND_UPSELL',
  NONSTOP_BASE_AND_UPSELL = 'NONSTOP_BASE_AND_UPSELL',
  NONSTOP_ONLY_BASE = 'NONSTOP_ONLY_BASE',
  NONSTOP_ONLY_UPSELL = 'NONSTOP_ONLY_UPSELL',
  ONLY_BASE = 'ONLY_BASE',
  ONLY_UPSELL = 'ONLY_UPSELL'
}

/** Enum class to represent the available filter types */
export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  ARRIVAL_TIME_SLIDER = 'ARRIVAL_TIME_SLIDER',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHECKED_BAG = 'CHECKED_BAG',
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DEPARTURE_TIME_SLIDER = 'DEPARTURE_TIME_SLIDER',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE',
  SEAT_CHOICE = 'SEAT_CHOICE',
  TRAVEL_AND_BAGGAGE = 'TRAVEL_AND_BAGGAGE'
}

/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

/** Represents the flexible grid type */
export enum FlightsFlexibleGridType {
  /** Flex Search type shown for OW */
  FLEX_SEARCH = 'FLEX_SEARCH',
  /** Flex Search Grid type shown for RT Outbound */
  FLEX_SEARCH_GRID = 'FLEX_SEARCH_GRID',
  /** No Flex Search variant shown */
  FLEX_SEARCH_NOT_APPLICABLE = 'FLEX_SEARCH_NOT_APPLICABLE'
}

/** Represent flexible search header cell theme */
export enum FlightsFlexibleSearchHeaderCellTheme {
  /** Theme to represent an outbound or inbound departureDate header */
  DEFAULT = 'DEFAULT',
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER'
}

/** Represent flexible search legend cell theme */
export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT'
}

/** Represent flexible search result cell theme */
export enum FlightsFlexibleSearchResultCellTheme {
  /** Default theme */
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  /** Theme to represent highest priced cells in the matrix */
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  /** Theme to represent the lowest price displayed in the matrix */
  LOWEST_PRICE = 'LOWEST_PRICE',
  /** Theme to represent when no price is available, 'Search' */
  NO_PRICE = 'NO_PRICE',
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  SEARCHED_DATE = 'SEARCHED_DATE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS'
}

/** Represents the position of the icon */
export enum FlightsIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING'
}

/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: InputMaybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars['String'];
  /** Location type of the destination airport */
  destinationAirportLocationType?: InputMaybe<AirportLocationType>;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: InputMaybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars['String'];
  /** Location type of the origin airport */
  originAirportLocationType?: InputMaybe<AirportLocationType>;
}

/** Target of the Link when clicked */
export enum FlightsLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}

/** Represents page load type of FSR */
export enum FlightsListingsViewType {
  MIXED = 'MIXED',
  SINGLE = 'SINGLE'
}

/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = 'LISTINGS_SUPPLY_RESPONSE_TIME'
}

/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}

/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}

/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}

/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  /** Represents the placard type to be shown immediately */
  IMMEDIATE = 'IMMEDIATE',
  /** Represents the placard type to be shown during server error of sort and filter action */
  SORT_FILTERS_SERVER_ERROR = 'SORT_FILTERS_SERVER_ERROR'
}

/** Represents a type of placards the client can request for */
export enum FlightsPlacardType {
  /** Represents the placard of type free cancellation */
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  /** Represents the placard of type hotel attach */
  HOTEL_ATTACH = 'HOTEL_ATTACH',
  /** Represents the placard of type loyalty reward */
  LOYALTY_REWARD = 'LOYALTY_REWARD',
  /** Represents the placard of type no change fees */
  NO_CHANGE_FEES = 'NO_CHANGE_FEES',
  /** Represents the placard of type passport */
  PASSPORT = 'PASSPORT',
  /** Represents the placard of type price change */
  PRICE_CHANGE = 'PRICE_CHANGE',
  /** Represents the placard of type split ticket */
  SPLIT_TICKET = 'SPLIT_TICKET'
}

/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars['String'];
}

/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}

/** Enum class to represent the id associated with the rewards option */
export enum FlightsRewardsOptionId {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}

export interface FlightsSearchComponentCriteriaInput {
  /** Parameter to recognize that traffic source is meta search */
  isMetaTraffic?: InputMaybe<Scalars['Boolean']>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier?: InputMaybe<Scalars['String']>;
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: InputMaybe<Array<GraphQLPairInput>>;
}

/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represents that the user is intending to redeem credits (i.e. coming from My Coupons and Credits or Virtual Agent) */
  hasCreditRedemptionIntent?: InputMaybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: InputMaybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: InputMaybe<Array<JourneyFlightSelectionInput>>;
  /** Represents the previously selected credit's originalBookingId to correctly render the toast when credits are changed */
  previousOriginalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the mismatched search criteria between the current search and servicing need */
  searchCriteriaMismatch?: InputMaybe<Array<FlightsSearchCriteriaMismatch>>;
  /** Trip type in search */
  tripType: FlightsTripType;
}

/** Represents the mismatched criterion between the current search and servicing need */
export enum FlightsSearchCriteriaMismatch {
  TRAVELER = 'TRAVELER'
}

/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: InputMaybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time Slider filter. */
  arrivalTimeSliderFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: InputMaybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: InputMaybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: InputMaybe<FlightsCreditEligibleFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: InputMaybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: InputMaybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time Slider filter. */
  departureTimeSliderFilterValue?: InputMaybe<FlightsSliderFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: InputMaybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: InputMaybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: InputMaybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: InputMaybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: InputMaybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: InputMaybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: InputMaybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: InputMaybe<FlightsTravelAndBaggageBasedFilterValueInput>;
}

export enum FlightsSearchFormErrorType {
  /** Age of child is missing */
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  /** Date before previous date - Multi-dest */
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  /** Date must be between a range */
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  /** Dates must be greater than or equal to default date/checkin date. */
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  /** Age of infant is missing */
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  /** Date must be in the correct format */
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  /** Total traveler count must be equal or lower than max */
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  /** At least 1 traveler required in a booking */
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  /** Location must not be blank */
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  /** Origin and destination location must not be the same */
  LOCATION_SAME = 'LOCATION_SAME',
  /** Dates must be no more than 26 days apart */
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  /** Origin and Destination city cannot be same */
  SAME_CITY = 'SAME_CITY',
  /** Special characters are not allowed */
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  /** Enter at least 3 characters of the airport name */
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  /** Number of infant in lap must be equal or lower than number of adults */
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT'
}

/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: InputMaybe<Array<FlightsAdvancedFilterType>>;
  airline?: InputMaybe<Scalars['String']>;
  cabinClass: FlightsCabinClass;
}

/** Represents the enum to handle different styles for the card */
export enum FlightsSeatCardStyles {
  /** Represents that the card should have border */
  BORDER = 'BORDER',
  /** Represents that the card should not have a border */
  WITHOUT_BORDER = 'WITHOUT_BORDER'
}

/** Represents the value associated with travel and baggage filter - seat choice */
export interface FlightsSeatChoiceBasedFilterValueInput {
  displayToast?: InputMaybe<Scalars['Boolean']>;
  seatChoice: SeatChoiceType;
}

/** Represents criteria for flights seat map. */
export interface FlightsSeatMapCriteriaInput {
  /** Represents which offer seat map to be shown. This will be decoded and used to create seat map service request */
  offerIdentifier: Scalars['String'];
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: InputMaybe<Scalars['String']>;
  /** Represents list of segments for which seat map for selection is to be shown. */
  seatSegments?: InputMaybe<Array<SeatSegmentInput>>;
  /** RepreArraysents list of segments for which seat map is to be shown. This will identify the segments from the decoded offer identifier and request seat map downstream. */
  segmentIdentifiers: Array<Scalars['String']>;
}

/** Enum class to represent the seat type variant. */
export enum FlightsSeatMapSeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}

/** Error types which can occur during seat selection */
export enum FlightsSeatSelectionErrorType {
  /** Seat Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Seat Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}

/** Represents the enum for handling whether new seats experience should be enabled or not */
export enum FlightsSeatsExperienceType {
  /** Represents frontend to show old seats experience */
  CURRENT_SEATS_EXPERIENCE = 'CURRENT_SEATS_EXPERIENCE',
  /** Represents frontend to show new seats experience */
  NEW_SEATS_EXPERIENCE = 'NEW_SEATS_EXPERIENCE'
}

/** Represents criteria for flights servicing confirmation page. */
export interface FlightsServicingConfirmationCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId?: InputMaybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId: Scalars['String'];
  /** Represents the trip id */
  tripId?: InputMaybe<Scalars['String']>;
}

/** Represents criteria for flights servicing page. */
export interface FlightsServicingCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: InputMaybe<Scalars['String']>;
  /** Represents the identifier to deduce change order flow */
  isResumeChange?: InputMaybe<Scalars['Boolean']>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: InputMaybe<Scalars['String']>;
  /** Represents the trip id */
  tripId?: InputMaybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: InputMaybe<Scalars['String']>;
}

/** Represents the min and max values associated with slider filters, like DepartureTime or ArrivalTime slider filter */
export interface FlightsSliderFilterValueInput {
  max: Scalars['Int'];
  min: Scalars['Int'];
}

/** Represents the button width in the UI */
export enum FlightsSmartShoppingButtonWidth {
  /** Button will take the width it needs */
  DEFAULT = 'DEFAULT',
  /** Button will take the full width of the content */
  FULL_WIDTH = 'FULL_WIDTH'
}

/** Represents flights dialog actions */
export enum FlightsSmartShoppingDialogAction {
  CLOSE = 'CLOSE',
  OPEN = 'OPEN',
  TOGGLE = 'TOGGLE'
}

/** Represents IDs for flights dialogs */
export enum FlightsSmartShoppingDialogId {
  /** Represents the Airlines credit dialog */
  AIRLINE_CREDITS = 'AIRLINE_CREDITS',
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  BAGGAGE_CLOSE_COMPLETE_DIALOG = 'BAGGAGE_CLOSE_COMPLETE_DIALOG',
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  BAGGAGE_CLOSE_INCOMPLETE_DIALOG = 'BAGGAGE_CLOSE_INCOMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  BAGGAGE_CONTINUE_BOOKING = 'BAGGAGE_CONTINUE_BOOKING',
  /** Represents the dialog ID for Baggage details */
  BAGGAGE_DETAILS_DIALOG = 'BAGGAGE_DETAILS_DIALOG',
  /** Represents the bags popup dialog on checkout button */
  BAGS_POPUP_ON_CHECKOUT = 'BAGS_POPUP_ON_CHECKOUT',
  /** Represents the check credits dialog for users coming from MCC and VA */
  CHECK_CREDITS_DIALOG = 'CHECK_CREDITS_DIALOG',
  /** Represents the Flights Details and Fares dialog */
  FLIGHTS_DETAILS_AND_FARES = 'FLIGHTS_DETAILS_AND_FARES',
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FORCED_CHOICE_MODAL = 'FORCED_CHOICE_MODAL',
  /** Represents the How Airlines Work dialog inside Select Credits */
  HOW_CREDITS_WORK = 'HOW_CREDITS_WORK',
  /** Represents the Leave This Page dialog inside Select Credits */
  LEAVE_TO_COUPONS = 'LEAVE_TO_COUPONS',
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  PAID_BAGS_DIALOG = 'PAID_BAGS_DIALOG',
  /** Represents the Info dialog for Price Match Promise Selected Card */
  PMP_INFO_DIALOG = 'PMP_INFO_DIALOG',
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  PMP_REMOVE_DIALOG = 'PMP_REMOVE_DIALOG',
  /** Represents the seats popup dialog on checkout button */
  SEATS_POPUP_ON_CHECKOUT = 'SEATS_POPUP_ON_CHECKOUT',
  /** Represents the Close button dialog for the seat details */
  SEAT_CLOSE_COMPLETE_DIALOG = 'SEAT_CLOSE_COMPLETE_DIALOG',
  /** Represents the Continue booking dialog for the baggage details */
  SEAT_CONTINUE_BOOKING = 'SEAT_CONTINUE_BOOKING',
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  SEAT_SELECTION_DIALOG = 'SEAT_SELECTION_DIALOG',
  /** Represents the dialog on traveler mismatch for credits offer */
  TRAVELER_MISMATCH_DIALOG = 'TRAVELER_MISMATCH_DIALOG'
}

/** Represents the position of the icon */
export enum FlightsSmartShoppingIconPosition {
  /** Icon will be rendered at the beginning of the content */
  LEADING = 'LEADING',
  /** Icon will be rendered at the end of the content */
  TRAILING = 'TRAILING'
}

/** Target of the Link when clicked */
export enum FlightsSmartShoppingLinkTarget {
  /** Link will be opened in an external view e.g. new tab or browser window */
  EXTERNAL = 'EXTERNAL',
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  INTERNAL = 'INTERNAL'
}

/** Traveler details for flights search */
export interface FlightsSmartShoppingTravelerDetailsInput {
  /** Age for each traveler */
  ages?: InputMaybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: TravelerDetailsType;
}

/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: InputMaybe<Array<FlightsCrossSortOptionInput>>;
  crossSortOptionType?: InputMaybe<FlightsCrossSortOptionTypeInput>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING'
}

/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  BEST_BETS = 'BEST_BETS',
  BEST_SORT = 'BEST_SORT',
  CROSS_SORT = 'CROSS_SORT',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  NONSTOP = 'NONSTOP',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED'
}

/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL'
}

/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars['Int'];
  stopFilterOperation: FlightsStopFilterOperation;
}

/** This represents a decorator that can be applied to a section */
export enum FlightsTextSectionDecorator {
  /** This represents a separator that renders after the text section */
  BOTTOMSEPARATOR = 'BOTTOMSEPARATOR',
  /** This represents a separator that renders above the text section */
  TOPSEPARATOR = 'TOPSEPARATOR'
}

/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}

export enum FlightsTimePeriodOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}

/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}

/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: InputMaybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}

/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}

export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}

/** Represents all the common information in the journey review block on FIS  */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = 'ALL_JOURNEYS',
  CURRENT_JOUNRNEY = 'CURRENT_JOUNRNEY',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}

export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY'
}

/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN'
}

/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQLPairInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}

/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT'
}

export enum GroundTransfersGroupViewType {
  CARDS_LIST = 'CARDS_LIST'
}

/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}

/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: InputMaybe<CoordinatesInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type: GeoType;
}

export enum GroundTransfersMapTransitOption {
  BUS = 'BUS',
  NONE = 'NONE',
  TRAIN = 'TRAIN'
}

export enum GroundTransfersMapTravelMode {
  DRIVING = 'DRIVING',
  TRANSIT = 'TRANSIT'
}

/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars['String'];
}

export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum GroundTransfersSectionStyle {
  BULLETED = 'BULLETED',
  STANDARD = 'STANDARD'
}

/** Text style to apply to text */
export enum GroundTransfersStyle {
  /** Bold styling */
  EMPHASISED = 'EMPHASISED',
  /** Loyalty messages styling */
  LOYALTY = 'LOYALTY',
  /** Green text styling */
  POSITIVE = 'POSITIVE',
  /** Regular text with no styling, default Value */
  STANDARD = 'STANDARD'
}

/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars['Int'];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}

/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = 'END',
  START = 'START'
}

/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}

/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Header layout. */
export enum HeaderLayout {
  DEFAULT = 'DEFAULT',
  MINIMAL = 'MINIMAL',
  SIMPLIFIED = 'SIMPLIFIED'
}

/** Used to pass certain marketing details to the header for google ad awareness */
export interface HeaderMarketingInput {
  googleClickIdentifier?: InputMaybe<Scalars['String']>;
  metaDistributionPartnersDetails?: InputMaybe<Scalars['String']>;
}

/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}

/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING'
}

/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export enum HelpAndFeedbackHelpCenterOptionsType {
  OWNER = 'OWNER',
  PROPERTY_MANAGER = 'PROPERTY_MANAGER',
  TRAVELER = 'TRAVELER',
  TRUST_AND_SAFETY = 'TRUST_AND_SAFETY'
}

export enum HelpAndFeedbackOptionsType {
  BRAND_CALL = 'BRAND_CALL',
  CHAT_NOW = 'CHAT_NOW',
  CREDIT_CARD = 'CREDIT_CARD',
  RATE_OUR_APP = 'RATE_OUR_APP',
  SHARE_YOUR_FEEDBACK = 'SHARE_YOUR_FEEDBACK',
  VISIT_HELP_CENTER = 'VISIT_HELP_CENTER'
}

/** Browse request to get articles */
export interface HelpArticlesSearchRequestInput {
  /** Specify specific category from product to retrieve articles */
  category?: InputMaybe<Scalars['String']>;
  /** Specify article id to get article data */
  helpArticleId?: InputMaybe<Scalars['String']>;
  /** Specify search term to get articles suggestions */
  helpArticlesSearchTerm?: InputMaybe<Scalars['String']>;
  /** Specify specific product from homepage to retrieve articles */
  product?: InputMaybe<Scalars['String']>;
  /** Specify specific product id from homepage to retrieve articles */
  productId?: InputMaybe<Scalars['String']>;
}

export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH'
}

export interface HttpHeaderInput {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
}

export enum HttpStatus {
  ACCEPTED = 'ACCEPTED',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  BAD_REQUEST = 'BAD_REQUEST',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  CHECKPOINT = 'CHECKPOINT',
  CONFLICT = 'CONFLICT',
  CONTINUE = 'CONTINUE',
  CREATED = 'CREATED',
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  FORBIDDEN = 'FORBIDDEN',
  FOUND = 'FOUND',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  GONE = 'GONE',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  IM_USED = 'IM_USED',
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  LOCKED = 'LOCKED',
  LOOP_DETECTED = 'LOOP_DETECTED',
  METHOD_FAILURE = 'METHOD_FAILURE',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MULTI_STATUS = 'MULTI_STATUS',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  NOT_MODIFIED = 'NOT_MODIFIED',
  NO_CONTENT = 'NO_CONTENT',
  OK = 'OK',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  PROCESSING = 'PROCESSING',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  RESET_CONTENT = 'RESET_CONTENT',
  SEE_OTHER = 'SEE_OTHER',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  TOO_EARLY = 'TOO_EARLY',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  URI_TOO_LONG = 'URI_TOO_LONG',
  USE_PROXY = 'USE_PROXY',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES'
}

/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE'
}

/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export enum IconSpotLight {
  INFO = 'INFO',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD',
  WARNING = 'WARNING'
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  default = 'default',
  emphasis = 'emphasis',
  negative = 'negative',
  positive = 'positive'
}

/** Enum to specify the type for inputId */
export enum IdentifierType {
  CART_ID = 'CART_ID',
  ENTITY_ID = 'ENTITY_ID',
  OFFER_ID = 'OFFER_ID',
  ORDER_ID = 'ORDER_ID',
  PROPERTY_ID = 'PROPERTY_ID'
}

export enum IdentityAccountCreationState {
  INVALID = 'INVALID',
  NOT_UPGRADED = 'NOT_UPGRADED',
  UPGRADED = 'UPGRADED'
}

export enum IdentityAccountCreationType {
  INVALID = 'INVALID',
  REGISTERED = 'REGISTERED',
  UNREGISTERED = 'UNREGISTERED'
}

export interface IdentityAccountTakeOverDeviceInput {
  payload: Scalars['String'];
  type: IdentityAccountTakeOverDeviceType;
}

export enum IdentityAccountTakeOverDeviceType {
  TRUST_WIDGET = 'TRUST_WIDGET'
}

/** EG Universal Login AccountTakeOver input from client */
export interface IdentityAccountTakeOverInput {
  inputs: Array<GraphQLPairInput>;
  type: Scalars['String'];
}

export interface IdentityAccountTakeOverShieldInput {
  accountTakeOverTokens?: InputMaybe<Array<IdentityAccountTakeOverTokenInput>>;
  crossSiteRequestForgeryData: IdentityCrossSiteRequestForgeryInput;
  devices?: InputMaybe<Array<IdentityAccountTakeOverDeviceInput>>;
  placement?: InputMaybe<Scalars['String']>;
}

export interface IdentityAccountTakeOverTokenInput {
  name: Scalars['String'];
  value: Scalars['String'];
}

export enum IdentityAccountTakeOverType {
  CAPTCHA_SAFETYNET_ANDROID = 'CAPTCHA_SAFETYNET_ANDROID',
  CSRF = 'CSRF',
  DEVICE_CHECK = 'DEVICE_CHECK',
  TRUST_WIDGET = 'TRUST_WIDGET'
}

export enum IdentityChannelType {
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
  IOS = 'IOS'
}

/** EG Universal Login input for IdentityClientInfo query and mutation */
export interface IdentityClientInfoInput {
  appName: Scalars['String'];
  appVersion: Scalars['String'];
  channelType: IdentityChannelType;
  deviceOS: Scalars['String'];
  deviceType: DeviceType;
}

/** EG Identity Creation Account Request */
export interface IdentityCreateAccountRequestInput {
  accountTakeOverShield: IdentityAccountTakeOverShieldInput;
  channelType?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneDetails?: InputMaybe<IdentityPhoneDetailsInput>;
  rememberMe?: InputMaybe<Scalars['Boolean']>;
}

export interface IdentityCrossSiteRequestForgeryInput {
  token: Scalars['String'];
}

/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: InputMaybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars['UUID'];
  /** The Expedia User ID */
  expUserId?: InputMaybe<Scalars['String']>;
  /** The user TUID */
  tuid?: InputMaybe<Scalars['String']>;
}

export enum IdentityLayout {
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  GET_SEND_OTP_ATO = 'GET_SEND_OTP_ATO',
  GET_SET_PASSWORD_ATO = 'GET_SET_PASSWORD_ATO',
  GET_SIGN_IN_ATO = 'GET_SIGN_IN_ATO',
  GET_SIGN_IN_VERIFY_OTP_ATO = 'GET_SIGN_IN_VERIFY_OTP_ATO',
  GET_SIGN_UP_VERIFY_OTP_ATO = 'GET_SIGN_UP_VERIFY_OTP_ATO',
  GET_USER_DETAILS_ATO = 'GET_USER_DETAILS_ATO',
  LAUNCH_ONE_IDENTITY = 'LAUNCH_ONE_IDENTITY',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SIGNIN = 'SIGNIN',
  SIGNUP = 'SIGNUP'
}

export interface IdentityPhoneDetailsInput {
  countryCode: Scalars['String'];
  locale: Scalars['String'];
  phoneNumber: Scalars['String'];
}

export enum IdentitySocialButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export interface IdentitySocialInput {
  nonce: Scalars['String'];
  socialType: IdentitySocialType;
  token: Scalars['String'];
  tokenType: IdentitySocialTokenType;
}

export enum IdentitySocialTokenType {
  Access = 'Access',
  AuthCode = 'AuthCode',
  ID = 'ID'
}

export enum IdentitySocialType {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

/** EG Universal Login spacing definition */
export enum IdentitySpaceSize {
  S0X = 'S0X',
  S0XH = 'S0XH',
  S10X = 'S10X',
  S11X = 'S11X',
  S12X = 'S12X',
  S14X = 'S14X',
  S16X = 'S16X',
  S18X = 'S18X',
  S1X = 'S1X',
  S2X = 'S2X',
  S3X = 'S3X',
  S4X = 'S4X',
  S5X = 'S5X',
  S6X = 'S6X',
  S8X = 'S8X'
}

/** EG Universal Login input for IdentityFormSubmit mutation */
export interface IdentitySubmitRequestInput {
  atoInputs: Array<IdentityAccountTakeOverInput>;
  context: Scalars['String'];
  input: Array<GraphQLPairInput>;
  socialInput?: InputMaybe<IdentitySocialInput>;
}

export enum IdentitySuccessType {
  ONE_KEY_ONBOARDING = 'ONE_KEY_ONBOARDING',
  ORIGIN = 'ORIGIN'
}

/** Input type for fetching the Inquiry form. */
export interface InquiryFormInput {
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput?: InputMaybe<PrimaryPropertyCriteriaInput>;
}

export enum InquiryProminence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

/** Input type for submitting a new Inquiry request. */
export interface InquiryRequestInput {
  inquirerPhoneCountryCode?: InputMaybe<Scalars['String']>;
  inquirerPhoneNumber?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  optInForMarketing?: InputMaybe<Scalars['Boolean']>;
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  primaryPropertyCriteriaInput: PrimaryPropertyCriteriaInput;
}

/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: InputMaybe<Scalars['String']>;
  /** Gaia region id of the location */
  regionId?: InputMaybe<Scalars['String']>;
}

/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars['String'];
  /** email src to collect analytics when it's true  */
  isEmailSrc?: InputMaybe<Scalars['Boolean']>;
  /** LOB of the booking */
  lob?: InputMaybe<Scalars['String']>;
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: InputMaybe<Scalars['String']>;
}

export interface InsuranceBookingCancellationRequestInput {
  orderId: Scalars['String'];
  orderLineId: Scalars['String'];
}

export interface InsuranceBookingOverviewRequestInput {
  /** LOB of the booking */
  lob?: InputMaybe<Scalars['String']>;
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: InputMaybe<Scalars['String']>;
}

/** GraphQL request for Insurance Claim Details */
export interface InsuranceClaimDetailsRequestInput {
  /** Order Id of the booking */
  orderNumber?: InputMaybe<Scalars['String']>;
}

/** Represents criteria for insurance. */
export interface InsuranceCriteriaInput {
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: InputMaybe<Scalars['String']>;
  /** offer token for insurance product */
  insuranceOfferToken?: InputMaybe<Scalars['String']>;
  /** Represents PMP up-funnel selection */
  selectedProductId?: InputMaybe<Scalars['String']>;
}

export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: InputMaybe<Scalars['String']>;
  /** Drop-off location for car */
  dropOffLocation?: InputMaybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: InputMaybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: InputMaybe<Array<Scalars['String']>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}

export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars['String'];
  /** email src to collect analytics when it's true  */
  isEmailSrc?: InputMaybe<Scalars['Boolean']>;
  /** LOB of the booking */
  lob?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['String']>;
}

export enum InsuranceListLayout {
  SINGLE_COLUMN = 'SINGLE_COLUMN'
}

export enum InsuranceListType {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED'
}

export enum InsuranceListTypeOld {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED'
}

export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars['String'];
  /** Search term */
  searchTerm: Scalars['String'];
}

export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}

export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE'
}

export enum InsurancePhrasePartStyle {
  /** Green */
  COLOR_GREEN = 'COLOR_GREEN',
  /** Red */
  COLOR_RED = 'COLOR_RED',
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}

export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}

export interface InsuranceSelectionDetailsInput {
  /** Insurance id of already added insurance */
  existingInsuranceProductIds?: InputMaybe<Array<Scalars['String']>>;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Details of already added insurance */
  insuranceSelectionDetails?: InputMaybe<InsuranceSelectionDetailsInput>;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: InputMaybe<Scalars['String']>;
  /** TripId */
  tripId: Scalars['UUID'];
  /** In order to ignore the caching at client level and make an actual shopping call version hash is changed in subsequent requests */
  versionHash?: InputMaybe<Scalars['String']>;
}

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;
  insuranceSearchId?: InputMaybe<Scalars['String']>;
  offerTypeId?: InputMaybe<Scalars['Int']>;
}

/** Client Id Possibilities */
export enum InsurtechClientId {
  CAR_INFO_SITE = 'CAR_INFO_SITE',
  EG_CHECKOUT = 'EG_CHECKOUT',
  FCR_CHECKOUT = 'FCR_CHECKOUT'
}

/** Status Possibilities */
export enum InsurtechMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

/** State represents teh status whether offer is already added, not added or some different offer is added */
export enum InsurtechOfferState {
  CHANGED_OFFER = 'CHANGED_OFFER',
  NOT_SELECTED = 'NOT_SELECTED',
  UNCHANGED_OFFER = 'UNCHANGED_OFFER'
}

export interface InsurtechPrimingCardRequestInput {
  /** Identifier offer for car inventory */
  offer: OfferIdentityInput;
}

/** Interaction to publish an event for */
export enum InteractionEventName {
  BOOK = 'BOOK',
  CHECKOUT_PAGE_LOAD = 'CHECKOUT_PAGE_LOAD',
  CONFIRMATION_PAGE_LOAD = 'CONFIRMATION_PAGE_LOAD'
}

/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: InputMaybe<Scalars['String']>;
  /** Name of interest */
  name?: InputMaybe<Scalars['String']>;
}

/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  THOMASCOOK_EUR = 'THOMASCOOK_EUR',
  THOMASCOOK_UK = 'THOMASCOOK_UK',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA'
}

/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars['Int'];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars['String'];
}

export enum KeyPhrasesClientType {
  DEFAULT = 'DEFAULT',
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET'
}

/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: InputMaybe<Array<Scalars['String']>>;
  /** Maps to ReviewScoreRange */
  guestRating?: InputMaybe<Scalars['String']>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: InputMaybe<Array<Scalars['String']>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: InputMaybe<Array<Scalars['Int']>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: InputMaybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: InputMaybe<Scalars['String']>;
  /** Maps to starList */
  stars?: InputMaybe<Scalars['String']>;
  /** Maps to StructureType */
  structureTypes?: InputMaybe<Array<Scalars['String']>>;
}

/** Line of business in request */
export enum LineOfBusiness {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}

/** Line of business */
export enum LineOfBusinessDomain {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

/** ADs related property search options  */
export enum Listings {
  /** Only return travelAds */
  ADS_ONLY = 'ADS_ONLY'
}

export enum LiveAnnouncePoliteness {
  ASSERTIVE = 'ASSERTIVE',
  OFF = 'OFF',
  POLITE = 'POLITE'
}

/** Data type for AdaptEx testing. Contains a list of traveler states on UI to provide consistent experience. For more info, read https://github.expedia.biz/lodging-experience/experience-api-lodging-schema-reviews/blob/master/proposals/property-comparison-tool-adaptex/PROPOSAL.md */
export interface LodgingAdaptExContextInput {
  /** Contains a list of AdaptEx states */
  state: Array<LodgingAdaptExStateInput>;
}

/** Data type for AdaptEx testing. Contains a state of a traveler on UI to provide consistent experience. For example, it can indicate if user has seen a popup. */
export interface LodgingAdaptExStateInput {
  /** Name of the state. For example, 'userSawPrompt' */
  name: Scalars['String'];
  /** Value of the state. For example, 'true' */
  value: Scalars['String'];
}

/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR'
}

export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST'
}

export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL'
}

/** Theme information for a message. */
export enum LodgingMessageTheme {
  /** To be used for warnings/errors; typically red. */
  AGGRESSIVE = 'AGGRESSIVE',
  /** To be used for success/perks; typically green. */
  HIGHLIGHT = 'HIGHLIGHT',
  /** To be used for emphasis; typically bold. */
  STRONG = 'STRONG'
}

export enum LodgingStepperState {
  COMPLETE = 'COMPLETE',
  CURRENT = 'CURRENT',
  INCOMPLETE = 'INCOMPLETE'
}

export enum LodgingTrackPosition {
  END = 'END',
  STANDARD = 'STANDARD',
  START = 'START'
}

export enum LoyaltyExperienceStrategy {
  HIDE_TRAVELER_INFO_AND_REWARDS_LINK = 'HIDE_TRAVELER_INFO_AND_REWARDS_LINK',
  SHOW_TRAVELER_INFO_AND_REWARDS_LINK = 'SHOW_TRAVELER_INFO_AND_REWARDS_LINK'
}

/** Enumeration for 2fa/mfa verification method */
export enum MFAVerificationMethod {
  SMS = 'SMS',
  CALL = 'CALL'
}

export enum MODERATION_RULE {
  BLOCK = 'BLOCK',
  ADVISE = 'ADVISE'
}

export enum MODERATION_TYPE {
  WORD = 'WORD',
  CHARACTER = 'CHARACTER'
}

/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  GROCERY = 'GROCERY',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN',
  VACATION_RENTAL = 'VACATION_RENTAL'
}

/** Toolbar action type */
export enum MapToolbarActionsType {
  /** Show filters button in the toolbar */
  FILTERS = 'FILTERS'
}

/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI'
}

/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  /** Hypertext markup language */
  HTML = 'HTML'
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD'
}

export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}

export interface MemberPricingInput {
  /** Discount percentage */
  discountPercentage?: InputMaybe<Scalars['Int']>;
  /** Is lead in offer MOD */
  leadInMemberOffer?: InputMaybe<Scalars['Boolean']>;
  /** Is any offer MOD */
  memberOfferAvailable?: InputMaybe<Scalars['Boolean']>;
}

export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER'
}

/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  BRANDED_THEME_ACCENT = 'BRANDED_THEME_ACCENT',
  BRANDED_THEME_DARK = 'BRANDED_THEME_DARK',
  BRANDED_THEME_LIGHT = 'BRANDED_THEME_LIGHT',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS'
}

/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}

/** Change Package Search Form Primer */
export interface MishopUIChangePackageFormPrimerInput {
  multiItemSessionId: Scalars['String'];
}

/** The type of button to display */
export enum MishopUIDialogButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}

/** Contains the necessary data for calling packageSummaryContent query */
export interface MishopUIPackageSummaryContentPrimerInput {
  naturalKey: PackageNaturalKeyInput;
}

/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUIPlacardNotificationInput {
  multiItemPriceToken?: InputMaybe<Scalars['String']>;
  placardType: MishopUIPlacardType;
  priceDetailsOptions?: InputMaybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export enum MishopUIPlacardType {
  PRICE_CHANGE = 'PRICE_CHANGE'
}

export enum MishopUIProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  PROPERTY = 'PROPERTY'
}

/** Contains necessary data for fetching property content */
export interface MishopUIPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  naturalKey: PropertyNaturalKeyInput;
  propertyChangeLink?: InputMaybe<Scalars['String']>;
  relativeChangePropertyLink: Scalars['String'];
  relativeChangeRoomLink: Scalars['String'];
}

export enum MobilitySearchDialogsId {
  /** This represents a dialog to display price summary details */
  PRICE_SUMMARY_DETAILS = 'PRICE_SUMMARY_DETAILS'
}

/** Pricing information */
export interface MoneyInput {
  /** DEPRECATED: Use platform formatters and return localized strings instead. Numeric portion of the price */
  amount: Scalars['Float'];
  /** DEPRECATED: The currency should be specified from the context instead. The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: InputMaybe<Scalars['String']>;
}

/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}

/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars['String'];
  /** The package type for this search */
  packageType: PackageType;
}

/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: InputMaybe<Array<ActivityNaturalKeyInput>>;
  cars?: InputMaybe<Array<CarNaturalKeyInput>>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: InputMaybe<Array<PackageNaturalKeyInput>>;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput>>;
}

/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: InputMaybe<Array<CarSearchCriteriaInput>>;
  flights?: InputMaybe<Array<FlightSearchCriteriaInput>>;
  properties?: InputMaybe<Array<PropertySearchCriteriaInput>>;
  /** Filter and sort for package level */
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Enum class to represent the type of no cancel fee */
export enum NoCancelFeeType {
  NO_CANCEL_FEE = 'NO_CANCEL_FEE'
}

/** Enum class to represent the type of no change fee */
export enum NoChangeFeeType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}

/** The button type of the Customer notification submit button */
export enum NotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

/** Represents the target of the link */
export enum NotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum NotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}

export enum NotificationLocationOnPage {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  ERROR = 'ERROR',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}

/** Enumeration of possible layout types */
export enum NotificationMessageCardLayout {
  ICON_ON_SIDE = 'ICON_ON_SIDE',
  ICON_ON_TOP = 'ICON_ON_TOP'
}

/** The display type of the Customer notification message */
export enum NotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum NotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum NotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}

/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** the optional field containing an error token, triggering the retrieval of an error message */
  errorToken?: InputMaybe<Scalars['String']>;
  /** itinerary number */
  itineraryNumber?: InputMaybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: InputMaybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: InputMaybe<Scalars['URL']>;
  /** the optional field containing the checkout session id to be able to measure key metrics */
  sessionId?: InputMaybe<Scalars['String']>;
  /** the optional field containing the token to retrieve the travel information */
  travelApiId?: InputMaybe<Scalars['String']>;
  /** trip folder id */
  tripFolderId?: InputMaybe<Scalars['String']>;
  /** trip item id */
  tripItemId?: InputMaybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaFiltersInput {
  /** airport code */
  airlinesFilter?: InputMaybe<Array<Scalars['String']>>;
  /** flight amenities */
  amenitiesFilter?: InputMaybe<Array<AmenityFilter>>;
  /** arrival time */
  arrivalTimeFilter?: InputMaybe<Array<FlightsTimePeriodOfDay>>;
  /** departure time */
  departureTimeFilter?: InputMaybe<Array<FlightsTimePeriodOfDay>>;
  /** number of stops */
  numberOfStopsFilter?: InputMaybe<Array<Scalars['Int']>>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** cabin class */
  cabinClass?: InputMaybe<FlightsCabinClass>;
  /** start date and end date of the trip */
  dateRange?: InputMaybe<DateRangeInput>;
  /** destination information */
  destination?: InputMaybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip filters */
  filter?: InputMaybe<Array<NotificationOptionalContextJourneyCriteriaFiltersInput>>;
  /** origin information */
  origin?: InputMaybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip schedule changes status */
  scheduleChangeStatus?: InputMaybe<TripScheduleChangeStatus>;
  /** traveler details */
  travelerDetail?: InputMaybe<Array<TravelerDetailsInput>>;
  /** trip type */
  tripType?: InputMaybe<FlightsTripType>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: InputMaybe<Scalars['String']>;
  /** property id */
  propertyId?: InputMaybe<Scalars['String']>;
  /** regionId number */
  regionId?: InputMaybe<Scalars['String']>;
}

/** The style to apply to phrase links */
export enum NotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

/** The theme to apply to phrase links */
export enum NotificationPhraseLinkTheme {
  DEFAULT = 'DEFAULT',
  INVERSE = 'INVERSE'
}

/** The text style to apply to strings */
export enum NotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}

/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: InputMaybe<Scalars['Boolean']>;
  /** Notification id */
  id?: InputMaybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: InputMaybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: InputMaybe<Scalars['Boolean']>;
}

export enum NotificationState {
  READ = 'READ',
  SEEN = 'SEEN',
  UNKNOWN = 'UNKNOWN',
  UNSEEN = 'UNSEEN'
}

export enum NotificationSubType {
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  DEFAULT = 'DEFAULT'
}

export enum NotificationType {
  ALERT = 'ALERT',
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  BOTTOM_SHEET = 'BOTTOM_SHEET',
  CENTERED_SHEET = 'CENTERED_SHEET',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  CLEANLINESS = 'CLEANLINESS',
  CONFIGURABLE = 'CONFIGURABLE',
  ERROR = 'ERROR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  ONETRUST = 'ONETRUST',
  ONE_KEY = 'ONE_KEY',
  OSANO = 'OSANO',
  RAF_BANNER = 'RAF_BANNER',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY',
  TRUST_MSG_BANNER = 'TRUST_MSG_BANNER',
  UNRECOVERABLE_ERROR = 'UNRECOVERABLE_ERROR'
}

export enum NotificationUserActionType {
  DELETE = 'DELETE',
  MARK_AS_READ = 'MARK_AS_READ',
  MARK_AS_UNREAD = 'MARK_AS_UNREAD',
  UNKNOWN = 'UNKNOWN'
}

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

export enum NotificationsType {
  ALL = 'ALL'
}

/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars['String'];
  value: Scalars['Int'];
}

export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP'
}

export interface OfferIdentityInput {
  /** Type of the offer details whether token or id */
  type: OfferIdentityType;
  /** The value of the identifier */
  value: Scalars['String'];
}

/** The identity to get or update insurtech offers could be both */
export enum OfferIdentityType {
  EG_OFFER_ID = 'EG_OFFER_ID',
  EG_OFFER_TOKEN = 'EG_OFFER_TOKEN'
}

/**
 * Represents EG Travel Platform API, consists of a productLine enumeration and a token.
 * https://confluence.expedia.biz/display/RPT/RFC-62-EG+-+OfferToken+-+guidelines+for+Product+Line+SPIs
 */
export interface OfferTokenInput {
  /** ProductLine associated with an Offer Token */
  lineOfBusiness: LineOfBusinessDomain;
  /** Encoded offer token string used to identify a specific product offer for purchase */
  token: Scalars['String'];
}

export interface OffersRecommendationAvailabilityFilterInput {
  dates?: InputMaybe<OptionalDateTimeRangeInput>;
  destination?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  travelMemberGroups?: InputMaybe<Array<TravelMemberGroupInput>>;
}

export enum OffersRecommendationContainerType {
  CAROUSEL = 'CAROUSEL',
  GRID = 'GRID'
}

export interface OffersRecommendationProductIdentifierInput {
  lineOfBusiness: LineOfBusinessDomain;
  productId: Scalars['String'];
}

export enum OffersRecommendationStrategy {
  ALTERNATE = 'ALTERNATE',
  ATTACH = 'ATTACH',
  CO_CLICK = 'CO_CLICK',
  NEARBY = 'NEARBY',
  POPULAR = 'POPULAR',
  TRENDING = 'TRENDING'
}

export interface OnboardingContext {
  onboardingSource: Scalars['String'];
}

export enum OneKeyOnboardingOperationStatus {
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED',
  TIMED_OUT = 'TIMED_OUT'
}

export enum Operation {
  ADDITION = 'ADDITION',
  MULTIPLICATION = 'MULTIPLICATION'
}

export enum OperationStatus {
  FAILURE = 'FAILURE',
  INVALID_INPUT = 'INVALID_INPUT',
  SUCCESS = 'SUCCESS'
}

/** In order to pass any additional parameters */
export interface OptionalContextInput {
  /** Indicates if user is on desktop dropdown view */
  dropdownView?: InputMaybe<Scalars['Boolean']>;
  /** Indicates if client is in dark mode */
  isDarkMode?: InputMaybe<Scalars['Boolean']>;
  /** If app user has enabled push notification in the device */
  pushEnabled?: InputMaybe<Scalars['Boolean']>;
}

/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: InputMaybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: InputMaybe<DateTimeInput>;
}

export interface OrderInfoInput {
  orderId: Scalars['String'];
  orderLine?: InputMaybe<Scalars['String']>;
}

/** Possible values for UITK mark's orientation prop */
export enum Orientation {
  /** Landscape orientation */
  LANDSCAPE = 'LANDSCAPE',
  /** Portrait orientation */
  PORTRAIT = 'PORTRAIT'
}

/** Package location */
export interface PackageLocationInput {
  airportCode: Scalars['String'];
  /** The Geo location of the region to search */
  coordinates?: InputMaybe<CoordinatesInput>;
  regionId?: InputMaybe<Scalars['String']>;
  /** The name of the region */
  regionName?: InputMaybe<Scalars['String']>;
}

/** Minimum set of data used to retrieve content about a package */
export interface PackageNaturalKeyInput {
  offerToken: Scalars['String'];
}

/** Represents the search criteria with which customers searched for packages */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

export enum PackageSort {
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR'
}

export interface PackageUIActivityHeaderPrimerInput {
  productType: MishopUIProductType;
}

export interface PackageUIFlightHeaderPrimerInput {
  productType: MishopUIProductType;
}

export interface PackageUIGroundTransferHeaderPrimerInput {
  productType: MishopUIProductType;
}

/** Contains the necessary data to render banner for a changed product */
export interface PackageUIProductChangedBannerPrimerInput {
  currentPackageOfferId: PackageNaturalKeyInput;
  previousOffers: MultiItemProductsInput;
  previousPackageOfferId: PackageNaturalKeyInput;
}

/** Information needed to render the prebundle package product header */
export interface PackageUIProductHeaderPrimerInput {
  activityHeaderPrimer?: InputMaybe<PackageUIActivityHeaderPrimerInput>;
  flightHeaderPrimer?: InputMaybe<PackageUIFlightHeaderPrimerInput>;
  groundTransferHeaderPrimer?: InputMaybe<PackageUIGroundTransferHeaderPrimerInput>;
  propertyHeaderPrimer?: InputMaybe<PackageUIPropertyHeaderPrimerInput>;
}

export interface PackageUIPropertyHeaderPrimerInput {
  productType: MishopUIProductType;
}

/** Optional custom context information about the page where the query results will eventually be rendered */
export interface PageContextInput {
  propertySearch?: InputMaybe<PropertySearchCriteriaInput>;
}

/** Page identity */
export enum PageLocation {
  /** All checkout related pages */
  CHECKOUT = 'CHECKOUT',
  /** Checkout error pages for all LOBs */
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = 'CONFIRMATION',
  /** All product detail pages are identified as DETAILS */
  DETAILS = 'DETAILS',
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  ENTRY = 'ENTRY',
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  FEATURES = 'FEATURES',
  /** Payment error pages for all LOBs */
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = 'POST_BOOKING',
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  SYSTEM = 'SYSTEM',
  /** User pages including sign-in, my account and rewards */
  USER = 'USER'
}

export enum PageState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}

/** Input for travelGuidePageContextInput pageType parameter */
export enum PageType {
  HOME_PAGE = 'HOME_PAGE',
  TRAVEL_GUIDE = 'TRAVEL_GUIDE'
}

export interface PaginationDetailsInput {
  next?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  previous?: InputMaybe<Scalars['Int']>;
}

/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: InputMaybe<Scalars['Int']>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: InputMaybe<Scalars['Int']>;
}

/** Represents input data related to a participant */
export interface ParticipantInput {
  /** Represents subscriptionId received from experience-api-conversation, it will be passed in conversation attributes to publish messages. */
  subscriptionId?: InputMaybe<Scalars['String']>;
}

export interface PartnerContextInput {
  detailsSiteConfiguration?: InputMaybe<TravelStoreV1CarDetailsInput>;
  partnerAccountId: Scalars['String'];
  searchSiteConfiguration?: InputMaybe<TravelStoreV1CarSearchInput>;
}

export enum PasswordWithStrengthMeterInputStrength {
  STRONG = 'STRONG',
  VERY_STRONG = 'VERY_STRONG',
  WEAK = 'WEAK'
}

export enum PasswordWithStrengthMeterProgressBarTheme {
  MUTED = 'MUTED',
  POSITIVE = 'POSITIVE'
}

export interface PaymentCheckoutIdentifierInput {
  sessionId?: InputMaybe<Scalars['String']>;
  sessionToken?: InputMaybe<Scalars['String']>;
}

export interface PaymentContextualInfoInput {
  bin?: InputMaybe<Scalars['String']>;
  etzToken?: InputMaybe<Scalars['String']>;
  providerConfirmationStatus?: InputMaybe<Scalars['String']>;
}

export enum PaymentMethodType {
  AFFIRM = 'AFFIRM',
  CREDIT_CARD = 'CREDIT_CARD',
  INVALID = 'INVALID',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export interface PaymentPrepareFOPRequestInput {
  fopItems: Array<FOPItemInput>;
  paymentSessionId: Scalars['String'];
  userInfo: PaymentUserInfoInput;
}

export interface PaymentSelectFOPRequestInput {
  checkoutIdentifier: PaymentCheckoutIdentifierInput;
  fopItems: Array<FOPItemInput>;
  paymentSessionId: Scalars['String'];
}

export enum PaymentState {
  STATE_CANCELLED = 'STATE_CANCELLED',
  STATE_DISABLED = 'STATE_DISABLED',
  STATE_INVALID = 'STATE_INVALID',
  STATE_REMOVED = 'STATE_REMOVED',
  STATE_SELECTED = 'STATE_SELECTED',
  STATE_UNSELECTED = 'STATE_UNSELECTED',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  GIFT_CARD = 'GIFT_CARD',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD'
}

/** Represents the logo size used by the client to render */
export enum PaymentTypeLogoSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL'
}

export interface PaymentUpdateFOPRequestInput {
  checkoutIdentifier: PaymentCheckoutIdentifierInput;
  fopItems: Array<FOPItemInput>;
  paymentSessionId: Scalars['String'];
}

export interface PaymentUserInfoInput {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
}

export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK'
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK'
}

export enum Placement {
  /** Horizontal Orientation of Images in the List */
  Horizontal = 'Horizontal',
  /** Vertical Orientation of Images in the List */
  Vertical = 'Vertical'
}

/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export enum PluralCategory {
  FEW = 'FEW',
  MANY = 'MANY',
  ONE = 'ONE',
  OTHER = 'OTHER',
  TWO = 'TWO',
  ZERO = 'ZERO'
}

/** Points related property search options  */
export enum Points {
  /** Don't use loyalty points to calculate the strikeout price. */
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export interface PolicyFetchParamsInput {
  cartId?: InputMaybe<Scalars['String']>;
  offerToken?: InputMaybe<OfferTokenInput>;
  orderInfo?: InputMaybe<OrderInfoInput>;
}

/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = 'ALTERNATIVE_ACTION_ON_FAILURE'
}

export interface PriceDetailsOptionsInput {
  metaDeeplink: Scalars['Boolean'];
}

export interface PriceFilterInput {
  facetValuesSize: Scalars['Int'];
  max: Scalars['Int'];
  maxIndex: Scalars['Int'];
  min: Scalars['Int'];
}

export interface PriceInsightsCreateMutationDataInput {
  lowestPredictedPrice?: InputMaybe<Scalars['Float']>;
  lowestPredictedPriceDate?: InputMaybe<Scalars['String']>;
  priceTrend?: InputMaybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

/** Represents a query parameter in the deep link. */
export interface PriceInsightsDeepLinkQueryParamInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

export interface PriceInsightsDisableMutationDataInput {
  lowestPredictedPrice?: InputMaybe<Scalars['Float']>;
  lowestPredictedPriceDate?: InputMaybe<Scalars['String']>;
  priceTrend?: InputMaybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

/** Represent search context for all product lines */
export interface PriceInsightsSearchContextInput {
  carSearchCriteria?: InputMaybe<CarSearchCriteriaInput>;
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
}

export interface PriceInsightsUpdateMutationDataInput {
  lowestPredictedPrice?: InputMaybe<Scalars['Float']>;
  lowestPredictedPriceDate?: InputMaybe<Scalars['String']>;
  priceTrend?: InputMaybe<Scalars['String']>;
  timeSeriesTierShown: Scalars['Int'];
}

export enum PriceMatchPromiseChartType {
  BAR = 'BAR',
  LINE = 'LINE'
}

export enum PriceMatchPromiseScaleType {
  DATE = 'DATE',
  LABEL = 'LABEL',
  TIME = 'TIME'
}

/** Represents the state for the PMP module */
export enum PriceMatchPromiseState {
  /** Represents when the PMP module is removable */
  REMOVABLE = 'REMOVABLE',
  /** Represents when the PMP module is selectable */
  SELECTABLE = 'SELECTABLE',
  /** Represents when the PMP module is static */
  STATIC = 'STATIC',
  /** Represents when the PMP module is toggleable */
  TOGGLEABLE = 'TOGGLEABLE'
}

/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: InputMaybe<Scalars['Float']>;
  /** The minimum price, e.g. 50.00 */
  min?: InputMaybe<Scalars['Float']>;
}

export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE'
}

/** Core criteria needed for an activities search */
export interface PrimaryActivitySearchCriteriaInput {
  dateRange?: InputMaybe<ActivitySearchCriteriaDateRangeInput>;
  destination?: InputMaybe<ActivitySearchCriteriaLocationInput>;
}

/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: InputMaybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}

/** The core criteria needed for a cruise search */
export interface PrimaryCruiseCriteriaInput {
  adultCount?: InputMaybe<Scalars['Int']>;
  childCount?: InputMaybe<Scalars['Int']>;
  children?: InputMaybe<Array<CruiseChildInput>>;
  departureDateRange?: InputMaybe<DateRangeInput>;
  destinations?: InputMaybe<Array<Scalars['String']>>;
  durationRange?: InputMaybe<CruiseDurationRangeInput>;
}

/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: InputMaybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}

/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: InputMaybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  pinnedProductIds?: InputMaybe<Array<Scalars['String']>>;
  selectedOffers?: InputMaybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}

export interface PrimaryPackageSearchCriteriaInput {
  /** Cabin class chosen for flight */
  cabinClass?: InputMaybe<FlightsCabinClass>;
  /** If not provided, packages returned will be for different duration and popular advance purchase window based on the themes */
  dateRange?: InputMaybe<DateRangeInput>;
  /** If not provided, packages returned will be for different popular destinations based on the themes */
  destination?: InputMaybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: InputMaybe<PackageLocationInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: InputMaybe<Array<TravelerOccupancyGroupInput>>;
}

/** This is a wrapper which houses all the LoB specific primary input criteria.  This is used for unified shopping. */
export interface PrimaryProductShoppingCriteriaInput {
  groundTransportation?: InputMaybe<PrimaryGroundTransfersCriteriaInput>;
  property?: InputMaybe<PrimaryPropertyCriteriaInput>;
}

/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: InputMaybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  flexSearchCriteria?: InputMaybe<FlexibleSearchCriteriaInput>;
  rooms: Array<RoomInput>;
}

/** User preference for data sharing with third parties which users may update */
export enum PrivacySellState {
  CAN_NOT_SELL = 'CAN_NOT_SELL',
  CAN_SELL = 'CAN_SELL'
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}

export enum ProductEntityAssetSelection {
  AMENITY = 'AMENITY',
  HEADLINE = 'HEADLINE',
  RELEVANT_AMENITY_DETAILS = 'RELEVANT_AMENITY_DETAILS',
  REVIEW_SUMMARY = 'REVIEW_SUMMARY'
}

/** Product Entity Input params */
export interface ProductEntityInput {
  /** product line */
  assetSelectionList: Array<ProductEntityAssetSelection>;
  /** Product Identifier */
  productIdentifier: ProductIdentifierInput;
}

/** Product Identifier wrapping type */
export interface ProductIdentifierInput {
  /** Id */
  id: Scalars['String'];
  /** product line */
  productLine?: InputMaybe<ProductLine>;
  /** search context */
  searchCriteriaSelections?: InputMaybe<Array<SearchCriteriaSelectionsInput>>;
  /** Identifier Type of Input */
  type: IdentifierType;
}

/** Enum to specify image width for product image */
export enum ProductImageWidth {
  FULL_WIDTH = 'FULL_WIDTH',
  HALF_WIDTH = 'HALF_WIDTH',
  QUARTER_WIDTH = 'QUARTER_WIDTH',
  THIRD_WIDTH = 'THIRD_WIDTH'
}

export enum ProductLine {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  INSURANCE = 'INSURANCE',
  LODGING = 'LODGING',
  PACKAGE = 'PACKAGE',
  PRODUCT_LINE_INVALID = 'PRODUCT_LINE_INVALID',
  RAIL = 'RAIL',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: InputMaybe<Scalars['String']>;
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL'
}

/** Input type for the unified shopping experience. */
export interface ProductShoppingCriteriaInput {
  primarySearchCriteria: PrimaryProductShoppingCriteriaInput;
  secondaryCriteria?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Input to productSummary Query */
export interface ProductSummaryInput {
  /** Identifier String of Input */
  id: Scalars['String'];
  /** Identifier Type of Input */
  idType: IdentifierType;
}

export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS'
}

/** Represents layout of buttons. */
export enum ProfileButtonLayout {
  /** Horizontally stacked buttons. */
  INLINE = 'INLINE',
  /** Vertically stacked buttons. */
  STACKED = 'STACKED'
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum ProfileLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}

/** Possible actions for the Activities Cross Sell links that will be shown as a sticky card on PDP  */
export enum PropertyActivitiesCrossSellActionType {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  OPEN = 'OPEN',
  REMOVE = 'REMOVE'
}

/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE'
}

export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO'
}

export enum PropertyCalendarPriceTrend {
  /** Negative price trend */
  NEGATIVE = 'NEGATIVE',
  /** Positive price trend */
  POSITIVE = 'POSITIVE'
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY'
}

export enum PropertyContentType {
  /** Detailed view that appears in expanded modal. */
  DETAILED = 'DETAILED',
  /** Simplified view that appears flat on page. */
  SUMMARY = 'SUMMARY'
}

export interface PropertyContext {
  propertyId: Scalars['String'];
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}

export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertyDetailsPropertyType {
  HOTEL = 'HOTEL',
  VACATION_RENTAL = 'VACATION_RENTAL'
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  ACCESSIBLE_PARKING = 'ACCESSIBLE_PARKING',
  ELEVATOR = 'ELEVATOR',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER',
  SERVICE_ANIMAL = 'SERVICE_ANIMAL',
  SIGN_LANGUAGE_INTERPRETER = 'SIGN_LANGUAGE_INTERPRETER',
  STAIR_FREE_PATH = 'STAIR_FREE_PATH'
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BALCONY_OR_TERRACE = 'BALCONY_OR_TERRACE',
  BAR = 'BAR',
  BEACH = 'BEACH',
  CASINO = 'CASINO',
  CRIB = 'CRIB',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  GOLF = 'GOLF',
  GYM = 'GYM',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PARKING = 'PARKING',
  PETS = 'PETS',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI'
}

/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta affcid channel code */
  affcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afflid channel code */
  afflid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta afmcid channel code */
  afmcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta brandcid channel code */
  brandcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emlcid channel code */
  emlcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta emldtl channel code */
  emldtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta gclid channel code */
  gclid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmcid channel code */
  icmcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta icmdtl channel code */
  icmdtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta k_user_id channel code */
  k_user_id?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta kword channel code */
  kword?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta lnkloc channel code */
  lnkloc?: InputMaybe<Scalars['String']>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: InputMaybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: InputMaybe<Array<PropertyMarketingTagInput>>;
  /** Deprecated: Don't get/set value from this field , ReplaceWith("marketingChannels") ,Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: InputMaybe<Scalars['Int']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta mdpcid channel code */
  mdpcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field,ReplaceWith("marketingChannels"),  Meta mdpdtl channel code */
  mdpdtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta olacid channel code */
  olacid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta oladtl channel code */
  oladtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semcid channel code */
  semcid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta semdtl channel code */
  semdtl?: InputMaybe<Scalars['String']>;
  /** Deprecated: Don't get/set value from this field, ReplaceWith("marketingChannels"), Meta seocid channel code */
  seocid?: InputMaybe<Scalars['String']>;
}

/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export interface PropertyMarketingTagInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  businessModelType?: InputMaybe<BusinessModelType>;
  checkIn: DateInput;
  checkOut: DateInput;
  id: Scalars['String'];
  inventoryType: InventoryType;
  noCreditCard?: InputMaybe<Scalars['Boolean']>;
  /** Pet permissibility & inclusion at property. Necessary when pets are used in primary search criteria */
  petsIncluded?: InputMaybe<Scalars['Boolean']>;
  ratePlanId: Scalars['String'];
  ratePlanType?: InputMaybe<Scalars['String']>;
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: InputMaybe<ShoppingPathType>;
}

/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars['Int'];
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD'
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}

/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}

export enum PropertyRecommendationStrategy {
  NEARBY_PROPERTIES = 'NEARBY_PROPERTIES',
  SIMILAR_PROPERTIES = 'SIMILAR_PROPERTIES'
}

/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS'
}

/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: InputMaybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: InputMaybe<Scalars['Boolean']>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: InputMaybe<Scalars['Boolean']>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: InputMaybe<Scalars['String']>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: InputMaybe<Scalars['Locale']>;
  /** Filter review results by a list of review ratings */
  ratings?: InputMaybe<Array<Scalars['Float']>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: InputMaybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: InputMaybe<Scalars['Int']>;
  /** Filter review results by user provided keyword */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: InputMaybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by travel companions */
  travelCompanion?: InputMaybe<Array<Scalars['String']>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: InputMaybe<Array<Scalars['String']>>;
  /** DEPRECATED - Replaced by travelerType param. Filter review results by trip reasons */
  tripReason?: InputMaybe<Array<Scalars['String']>>;
}

/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE'
}

/** [Optional] Review filter type */
export enum PropertyReviewType {
  /** filter reviews by rating <= 2 */
  CRITICAL = 'CRITICAL',
  /** filter reviews by rating >= 3 */
  POSITIVE = 'POSITIVE',
  /** filter reviews by latest date */
  RECENT = 'RECENT'
}

/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}

/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: InputMaybe<ShoppingSearchCriteriaInput>;
}

/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: InputMaybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: InputMaybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: InputMaybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: InputMaybe<Array<Scalars['Int']>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: InputMaybe<Scalars['String']>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: InputMaybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: InputMaybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: InputMaybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: InputMaybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: InputMaybe<Scalars['String']>;
  /** Filter results by the payment type. */
  paymentType?: InputMaybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: InputMaybe<Scalars['String']>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: InputMaybe<PriceRangeInput>;
  /** Deprecated: Legacy input is now combined", ReplaceWith("LegacyPropertySearchCriteria", PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: InputMaybe<Array<Scalars['Int']>>;
  /** Filter results by user provided string */
  propertyName?: InputMaybe<Scalars['String']>;
  /** Property syle filters */
  propertyStyles?: InputMaybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: InputMaybe<ReviewScoreRangeInput>;
  /** Rewards Type filters */
  rewards?: InputMaybe<Array<Scalars['String']>>;
  /** Filter results by availability */
  showAvailableOnly?: InputMaybe<Scalars['Boolean']>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: InputMaybe<Array<Scalars['Float']>>;
  /** Deprecated - ReplaceWith("starList") , Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: InputMaybe<StarRangeInput>;
  /** Deprecated: TNL 42683 - BEX_VR_STAY_FILTER, Filter results by Stay Type. Example: Hotels and Resorts, Vacation Rentals */
  stayTypes?: InputMaybe<Array<StayType>>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: InputMaybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: InputMaybe<Scalars['String']>;
  /** Filter results by the type of traveler. */
  travelerType?: InputMaybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: InputMaybe<Scalars['Boolean']>;
}

export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  ADS_ONLY = 'ADS_ONLY',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum PropertySectionRef {
  AVAILABILITY_CALENDAR_START_DATE = 'AVAILABILITY_CALENDAR_START_DATE',
  PRICE_DISPLAY_SERVICE_RESPONSE = 'PRICE_DISPLAY_SERVICE_RESPONSE',
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES'
}

/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: InputMaybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: InputMaybe<Scalars['String']>;
  /** Points related property search option */
  points?: InputMaybe<Points>;
  /** DEPRECATED. regionType only used for EG-Typeahead url params */
  typeaheadRegionType?: InputMaybe<Scalars['Int']>;
}

/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MAXIMUM_SAVINGS = 'MAXIMUM_SAVINGS',
  MAXIMUM_SAVINGS_PERCENT = 'MAXIMUM_SAVINGS_PERCENT',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PACKAGE_SAVINGS = 'PACKAGE_SAVINGS',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  REVIEW_COUNT = 'REVIEW_COUNT',
  REVIEW_RELEVANT = 'REVIEW_RELEVANT',
  VACATION_RENTAL = 'VACATION_RENTAL'
}

export enum PropertyStyle {
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE'
}

/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: InputMaybe<Scalars['String']>;
  candidateHmGuid?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['String']>;
  slots?: InputMaybe<Scalars['String']>;
  testVersionOverride?: InputMaybe<Scalars['String']>;
  trackingData: Scalars['String'];
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST'
}

/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
}

export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY'
}

export enum RecentActivityType {
  BROWSING_HISTORY = 'BROWSING_HISTORY',
  RECENT_SEARCHES = 'RECENT_SEARCHES',
  VIEWED_OFFERS = 'VIEWED_OFFERS',
  VIEWED_PRODUCTS = 'VIEWED_PRODUCTS'
}

export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS'
}

/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN'
}

export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId?: InputMaybe<Scalars['Int']>;
}

export interface ReservationContext {
  reservationId: Scalars['String'];
  conversationId?: InputMaybe<Scalars['String']>;
  reservationStatus?: InputMaybe<SupplyReservationStatusType>;
}

export interface ResidencyDetailsInput {
  /** Country code Selection */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Region code Selection */
  regionCode?: InputMaybe<Scalars['String']>;
}

export enum ResidencyState {
  APPLIED = 'APPLIED',
  AVAILABLE = 'AVAILABLE'
}

/** Tags Associated with the response */
export enum ResponseTagType {
  CACHE_SOURCE_AIRBLAZE = 'CACHE_SOURCE_AIRBLAZE',
  CACHE_SOURCE_BYOT_AIRBLAZE = 'CACHE_SOURCE_BYOT_AIRBLAZE',
  EXPERIENCE_SEARCH_CACHE_HYDRATOR = 'EXPERIENCE_SEARCH_CACHE_HYDRATOR',
  LISTINGS_PAGINATED_SLICED = 'LISTINGS_PAGINATED_SLICED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  MAIN_SEARCH_STACK = 'MAIN_SEARCH_STACK',
  RESPONSE_SUMMARY_CACHED_CONFIG = 'RESPONSE_SUMMARY_CACHED_CONFIG',
  RESPONSE_SUMMARY_CACHED_ML = 'RESPONSE_SUMMARY_CACHED_ML',
  RESPONSE_SUMMARY_HYBRID = 'RESPONSE_SUMMARY_HYBRID',
  RESPONSE_SUMMARY_LIVE = 'RESPONSE_SUMMARY_LIVE',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface ReviewAnswerInput {
  answer?: InputMaybe<ReviewsFormRatingValueInput>;
  questionUrn: Scalars['String'];
}

/** Enum of types of review interactions */
export enum ReviewInteractionType {
  HELPFUL_REVIEW = 'HELPFUL_REVIEW',
  REVIEW_REPORT_FLAG = 'REVIEW_REPORT_FLAG'
}

/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: InputMaybe<Scalars['Float']>;
  /** The minimum review score, e.g. 1.0 */
  min?: InputMaybe<Scalars['Float']>;
}

export interface ReviewsFormRatingValueInput {
  boolValue?: InputMaybe<Scalars['Boolean']>;
  numberValue?: InputMaybe<Scalars['Int']>;
  stringValue?: InputMaybe<Scalars['String']>;
  tagValue?: InputMaybe<ReviewsFormTagValueInput>;
}

export interface ReviewsFormTagValueInput {
  customValue?: InputMaybe<Scalars['String']>;
  tagUrns: Array<Scalars['String']>;
}

export enum RewardsOption {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}

/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars['Int'];
  /** The number of children in the room */
  children?: InputMaybe<Array<ChildInput>>;
}

export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

/** SearchCriteriaSelections */
export interface SearchCriteriaSelectionsInput {
  /** Id */
  id: Scalars['String'];
  /** value */
  value: Scalars['String'];
}

/** Search form product types */
export enum SearchFormProductType {
  ACTIVITIES = 'ACTIVITIES',
  CARS = 'CARS',
  CRUISES = 'CRUISES',
  FLIGHTS = 'FLIGHTS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES'
}

/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  /** Grouping using searches made 7 days from most recent search in same region */
  SEVEN_DAYS = 'SEVEN_DAYS',
  /** Grouping using searches made 3 days from most recent search in same region */
  THREE_DAYS = 'THREE_DAYS'
}

/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  /** Grouping using multi_city_vicinity destination type for searches. */
  METRO_CITY = 'METRO_CITY'
}

/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars['String'];
  /** Search item regionId. */
  regionId: Scalars['String'];
  /** Search item region type. */
  regionType?: InputMaybe<Scalars['String']>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars['String'];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: InputMaybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: InputMaybe<SearchHistoryDestinationType>;
}

/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** DEPRECATED: Customer spinner call no longer made before property search. List of interests coming from Customer Spinner */
  interests?: InputMaybe<Array<InterestInput>>;
  /** DEPRECATED. Use semdtl. SEM param, fetch from URL */
  semDtl?: InputMaybe<Scalars['String']>;
  /** SEM param, fetch from URL */
  semdtl?: InputMaybe<Scalars['String']>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: InputMaybe<Scalars['String']>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: InputMaybe<Scalars['String']>;
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** Used to pass selected offer data from SRP to PDP */
  offerDetails?: InputMaybe<Array<SelectedValueInput>>;
  /** The price of the search results offer */
  offerPrice?: InputMaybe<SearchOfferPriceInput>;
  ratePlanId?: InputMaybe<Scalars['String']>;
  roomTypeId?: InputMaybe<Scalars['String']>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: InputMaybe<Scalars['String']>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: InputMaybe<Scalars['String']>;
  /** The total price of the search offer */
  price?: InputMaybe<MoneyInput>;
}

/** Enum class to represent the type of seat choice */
export enum SeatChoiceType {
  SEAT_CHOICE = 'SEAT_CHOICE'
}

/** Represents seat segment for which seat map is to be shown. */
export interface SeatSegmentInput {
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars['String'];
  /** This will be used for unique identification of segment */
  identifier: Scalars['String'];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars['String'];
}

/** Enum class to represent the seat type variant. */
export enum SeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}

/** Type for Selected Baggage template */
export enum SelectedAncillaryTemplateType {
  MULTIPLE = 'MULTIPLE',
  NONE = 'NONE',
  ONE = 'ONE'
}

/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}

export enum ServiceAutomationToolbarElevation {
  FLAT = 'FLAT',
  FLOATING = 'FLOATING'
}

export enum ServiceAutomationToolbarNavType {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
  EXPAND_UP = 'EXPAND_UP'
}

export interface ShopInsurtechOffersRequestInput {
  /** The cart ID */
  cartId?: InputMaybe<Scalars['String']>;
  /** Optional for explicitly passing the offeritem that we possibly want to provide insurance coverage  */
  coveredOfferItemsId?: InputMaybe<Scalars['String']>;
  /** Client id that refer to the page the user reach out to the module from, e.g.: eg_checkout, car_info_site. */
  insurtechClientId: InsurtechClientId;
  /** Residency details to get details according to country and region */
  residencyDetails?: InputMaybe<ResidencyDetailsInput>;
  /** identify whether the residency already applied or available */
  residencyState?: InputMaybe<ResidencyState>;
  /** Session ID */
  sessionIdentifier?: InputMaybe<Scalars['String']>;
}

export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}

/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: InputMaybe<MultiItemContextInput>;
}

/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE'
}

/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: InputMaybe<Array<BooleanValueInput>>;
  counts?: InputMaybe<Array<NumberValueInput>>;
  dates?: InputMaybe<Array<DateValueInput>>;
  ranges?: InputMaybe<Array<RangeValueInput>>;
  selections?: InputMaybe<Array<SelectedValueInput>>;
}

/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = 'CLEAR_DATA',
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  OPEN_MODAL = 'OPEN_MODAL'
}

export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not have to match region type, but will be used to find the relevant destination type based on region type provided */
  regionId: Scalars['String'];
}

/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: Scalars['String'];
  value: Scalars['String'];
}

/** Context for Side Sheet */
export interface SideSheetQueryContextInput {
  addOnRequested: Array<AddOnRequested>;
  isFirstLoad?: InputMaybe<Scalars['Boolean']>;
  journeyContinuationId: Scalars['String'];
}

export enum SignalType {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  CONFIGURATION_ADDED = 'CONFIGURATION_ADDED',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  OFFER_ADDED = 'OFFER_ADDED',
  OFFER_REMOVED = 'OFFER_REMOVED',
  OPERATION_FAILED = 'OPERATION_FAILED',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_METHOD_UPDATED = 'PAYMENT_METHOD_UPDATED',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  SIGNAL_TYPE_INVALID = 'SIGNAL_TYPE_INVALID',
  UNRECOGNIZED = 'UNRECOGNIZED',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE'
}

export interface SimilarFlightsContextInput {
  offerIdentifier?: InputMaybe<Scalars['String']>;
}

/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars['Int']>;
}

export interface SmartFormDataInput {
  /** Timestamp at which this mutation was sent by the client. */
  timestamp: Scalars['String'];
  userInput: SmartFormUserInput;
}

export enum SmartFormHeadingSizeInput {
  EIGHT = 'EIGHT',
  FIVE = 'FIVE',
  FOUR = 'FOUR',
  ONE = 'ONE',
  SEVEN = 'SEVEN',
  SIX = 'SIX',
  THREE = 'THREE',
  TWO = 'TWO'
}

export enum SmartFormHeadingTagInput {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6'
}

/** To define which type of keystrokes will be considered by this input. */
export enum SmartFormTextInputVariant {
  EMAIL = 'EMAIL',
  NUMERIC = 'NUMERIC',
  TEL = 'TEL',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA'
}

/** Value collected corresponding to a field represented by inputId */
export interface SmartFormUserFieldInput {
  inputId: Scalars['String'];
  value: Array<Scalars['String']>;
}

/** Collection of the values collected corresponding to fields */
export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}

/**
 * "
 *     Type of operation to perform.
 */
export enum SortAndFilterBasicFilterPayloadType {
  /** Check selected filter option */
  OPTION = 'OPTION',
  /** Remove selected filter */
  REMOVE = 'REMOVE'
}

/** Specifies when a signal should be emitted */
export enum SortAndFilterSignalCondition {
  /** When a filter value changes from the default value to a non default value */
  DEFAULT_TO_NON_DEFAULT = 'DEFAULT_TO_NON_DEFAULT',
  /** When a filter value changes from a non default value to the default value */
  NON_DEFAULT_TO_DEFAULT = 'NON_DEFAULT_TO_DEFAULT',
  /** When a filter value changes from a non default value to a different non default value */
  NON_DEFAULT_TO_NON_DEFAULT = 'NON_DEFAULT_TO_NON_DEFAULT',
  /** When a filter state changes from unselected to selected */
  SELECTED = 'SELECTED',
  /** When a filter state changes from selected to unselected */
  UNSELECTED = 'UNSELECTED'
}

/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export enum SortAndFiltersViewType {
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  APPLIED_FILTERS = 'APPLIED_FILTERS',
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  FILTERS = 'FILTERS',
  /**
   * Represent a view where the list of filters are displayed as pills.
   * Used for all viewport sizes, on top of the results on a Search Results Page.
   */
  FILTERS_PILLS = 'FILTERS_PILLS',
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  FILTER_BAR = 'FILTER_BAR',
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  FILTER_DIALOG = 'FILTER_DIALOG',
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  SORT = 'SORT',
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SORT_AND_FILTERS = 'SORT_AND_FILTERS',
  /**
   * Represent a view where sort options are displayed as tabs with each tab displaying the sorted results based on the selected tab.
   * Used for all viewport sizes.
   */
  SORT_TABS = 'SORT_TABS'
}

export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS'
}

/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE'
}

/** Context needed to request sponsored content */
export interface SponsoredContentContextInput {
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars['String'];
  /** Unique identifier for sponsored content placements */
  sponsoredContentId: Scalars['String'];
  /** Model for ad targeting input */
  targeting?: InputMaybe<SponsoredContentTargetingInput>;
  /** Target variant. Eg. pwa */
  variant?: InputMaybe<Scalars['String']>;
}

/** Location resolution by type */
export enum SponsoredContentLocationResolver {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}

/** Location resolution by type */
export enum SponsoredContentLocationResolverInput {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}

/** The type of the ad placement */
export enum SponsoredContentProductType {
  BRAND_RESULT_LISTING = 'BRAND_RESULT_LISTING',
  BRAND_RESULT_LISTING_CARS = 'BRAND_RESULT_LISTING_CARS',
  BRAND_RESULT_LISTING_CRUISES = 'BRAND_RESULT_LISTING_CRUISES',
  BRAND_RESULT_LISTING_FLIGHTS = 'BRAND_RESULT_LISTING_FLIGHTS',
  BRAND_RESULT_LISTING_LODGING = 'BRAND_RESULT_LISTING_LODGING',
  BRAND_RESULT_LISTING_LX = 'BRAND_RESULT_LISTING_LX',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  MULTI_LISTING_AD = 'MULTI_LISTING_AD',
  SPONSORED_PROPERTIES_CAROUSEL = 'SPONSORED_PROPERTIES_CAROUSEL'
}

/** Input model to hold targeting params for queries. */
export interface SponsoredContentTargetingInput {
  /** number of adults included in the search */
  adults?: InputMaybe<Scalars['Int']>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: InputMaybe<DateInput>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: InputMaybe<DateInput>;
  /** Destination for the trip. */
  destination?: InputMaybe<Scalars['String']>;
  /** number of kids included in the search */
  kids?: InputMaybe<Scalars['Int']>;
  /** Type of location for origin and dest. */
  locationResolver?: InputMaybe<SponsoredContentLocationResolverInput>;
  /** Origin for the trip. */
  origin?: InputMaybe<Scalars['String']>;
}

export interface StackingOptionInput {
  promotionId: Scalars['String'];
  allowStacking?: InputMaybe<Scalars['Boolean']>;
}

export interface StarRangeInput {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
}

/** Property search filtering options */
export enum StayType {
  CONVENTIONAL = 'CONVENTIONAL',
  VACATION_RENTALS = 'VACATION_RENTALS'
}

export enum StepReviewInlineEditingSheetButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE'
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOBILE_HOME = 'MOBILE_HOME',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP'
}

export interface SupplyAmenitiesGroupInput {
  groupId: Scalars['String'];
  roomTypeId?: InputMaybe<Scalars['String']>;
  spaceId?: InputMaybe<Scalars['String']>;
}

export interface SupplyAmenitiesUpdateInput {
  groupId: Scalars['String'];
  roomTypeId?: InputMaybe<Scalars['String']>;
  amenities: Array<SupplyAmenityInput>;
}

export interface SupplyAmenityInput {
  elementId: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
}

export interface SupplyCancellationWaiverApprovalRequestContext {
  bookingItemId: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
}

export interface SupplyCancellationWaiverReservationContext {
  bookingItemId: Scalars['String'];
}

export interface SupplyContentAdditionalInfoUpdateInput {
  bathrooms?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['String']>;
  property?: InputMaybe<Scalars['String']>;
}

export interface SupplyContentAmenityInput {
  uuid: Scalars['String'];
  value: Scalars['String'];
}

export enum SupplyContentDescriptionSectionName {
  PROPERTY_NAME = 'PROPERTY_NAME',
  HEADLINE = 'HEADLINE',
  DESCRIPTION = 'DESCRIPTION',
  MANUAL_TRANSLATION = 'MANUAL_TRANSLATION',
  ABOUT_YOU = 'ABOUT_YOU',
  WHY_THIS_PROPERTY = 'WHY_THIS_PROPERTY',
  UNIQUE_BENEFITS = 'UNIQUE_BENEFITS',
  BATHROOMS_ADDITIONAL_INFO = 'BATHROOMS_ADDITIONAL_INFO',
  BEDROOMS_ADDITIONAL_INFO = 'BEDROOMS_ADDITIONAL_INFO',
  PROPERTY_ADDITIONAL_INFO = 'PROPERTY_ADDITIONAL_INFO',
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  INTERIOR_SIZE = 'INTERIOR_SIZE',
  SUITABILITY_AMENITY = 'SUITABILITY_AMENITY'
}

export interface SupplyContentHeadlineDescriptionUpdateInput {
  propertyName?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
}

export enum SupplyContentManualTranslationOperation {
  ADD = 'ADD',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE'
}

export interface SupplyContentManualTranslationUpdateInput {
  locale: Scalars['String'];
  optOutAutoTranslation: Scalars['Boolean'];
  headline?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  operation: SupplyContentManualTranslationOperation;
}

export interface SupplyContentUpdateLocationInput {
  showExactLocation: Scalars['Boolean'];
}

export interface SupplyContentYourPropertyUpdateInput {
  propertyTypeId?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  amenities?: InputMaybe<Array<SupplyContentAmenityInput>>;
}

export interface SupplyContentYourStoryUpdateInput {
  aboutYou?: InputMaybe<Scalars['String']>;
  whyThisProperty?: InputMaybe<Scalars['String']>;
  uniqueBenefits?: InputMaybe<Scalars['String']>;
}

export interface SupplyCurrentPageContext {
  /** The current relative path for the page */
  path?: InputMaybe<Scalars['String']>;
  /** specifies any query params the current page has like htid */
  search?: InputMaybe<Scalars['String']>;
  /** field for native , defining the current native view- like reservations/inbox */
  view?: InputMaybe<Scalars['String']>;
}

export enum SupplyDashboardType {
  DASHBOARD = 'DASHBOARD',
  LEGACY = 'LEGACY'
}

export interface SupplyFeeFilterInput {
  includedFees?: InputMaybe<Array<Scalars['String']>>;
}

export interface SupplyFeesInput {
  productCode: Scalars['String'];
  type: Scalars['String'];
  amount: Scalars['Float'];
}

export interface SupplyIndirectTaxInput {
  taxDetails: Array<SupplyIndirectTaxInputDetail>;
}

export interface SupplyIndirectTaxInputDetail {
  taxationCountry: Scalars['String'];
  taxJurisdictionType: Scalars['String'];
  taxJurisdictionName: Scalars['String'];
  legalName: Scalars['String'];
  registrationStatus: Scalars['String'];
  taxId: Scalars['String'];
}

export interface SupplyMarketplaceFeedInput {
  feedItemActionType: Scalars['String'];
  feedItemId: Scalars['String'];
}

/** Input for generating mfa code */
export interface SupplyMultiFactorCodeGenerationInput {
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
  /** MFA Verification type */
  verifyMethod: MFAVerificationMethod;
  /** Optional challenge ticket in case use tries to request for a new code via `send me a new code` operation */
  challengeTicket?: InputMaybe<Scalars['String']>;
}

/** Input for verifying mfa code */
export interface SupplyMultiFactorCodeVerificationInput {
  /** 6 digit Code sent to user */
  code: Scalars['String'];
  /** Challenge ticket associated with the mfa flow */
  challengeTicket: Scalars['String'];
  /** MFA verification method */
  verifyMethod: MFAVerificationMethod;
  /** Country code for the phone number */
  countryCode: Scalars['String'];
  /** Phone number of the user */
  phoneNumber: Scalars['String'];
}

export interface SupplyNavigationContext {
  showSidebarTrigger: Scalars['Boolean'];
  fallbackUrls?: InputMaybe<SupplyNavigationContextFallbackUrls>;
}

export interface SupplyNavigationContextFallbackUrls {
  signInUrl?: InputMaybe<Scalars['String']>;
  helpAndSupportUrl?: InputMaybe<Scalars['String']>;
  termsOfUseUrl?: InputMaybe<Scalars['String']>;
}

export enum SupplyNavigationHeaderMenuType {
  PROPERTY_DETAILS = 'PROPERTY_DETAILS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  PROPERTY_FILTER = 'PROPERTY_FILTER',
  SEARCH = 'SEARCH'
}

export interface SupplyNewListingOfferEnrollmentInput {
  enrolled: Scalars['Boolean'];
}

export enum SupplyOnboardingAvailabilityType {
  OPEN = 'OPEN',
  BLOCK = 'BLOCK'
}

export enum SupplyOnboardingButtonType {
  BACK = 'BACK',
  SKIP = 'SKIP',
  NEXT = 'NEXT',
  LINK = 'LINK',
  DONE = 'DONE'
}

export interface SupplyOnboardingPartnerBillingAddressInput {
  /** Flag for removing or adding address */
  isAddingAddress: Scalars['Boolean'];
  streetAddress: Scalars['String'];
  unit?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  stateProvince: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
}

export interface SupplyOnboardingPartnerBusinessNameInput {
  businessName: Scalars['String'];
}

export interface SupplyOnboardingPartnerLegalNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}

export enum SupplyOnboardingTipCardId {
  AMENITIES = 'AMENITIES',
  REGULATORY = 'REGULATORY',
  PHOTOS = 'PHOTOS',
  HEADLINE = 'HEADLINE',
  DESCRIPTION = 'DESCRIPTION'
}

export enum SupplyPartnerLifeCycleStage {
  LIFE_CYCLE_STAGE_BABY = 'LIFE_CYCLE_STAGE_BABY',
  LIFE_CYCLE_STAGE_KID = 'LIFE_CYCLE_STAGE_KID',
  LIFE_CYCLE_STAGE_TEENAGER = 'LIFE_CYCLE_STAGE_TEENAGER',
  LIFE_CYCLE_STAGE_YOUNG_ADULT = 'LIFE_CYCLE_STAGE_YOUNG_ADULT',
  LIFE_CYCLE_STAGE_ALL_GROWN_UP = 'LIFE_CYCLE_STAGE_ALL_GROWN_UP',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export interface SupplyPartnerPayoutDeferredAccountInput {
  currency: Scalars['String'];
  currencyV1?: InputMaybe<Scalars['String']>;
  bankingCountry: Scalars['String'];
}

export enum SupplyPaymentDetailsExpandoPositioning {
  TRAILING = 'TRAILING',
  LEADING = 'LEADING'
}

export enum SupplyPaymentDisplayToolbarIcon {
  CLOSE = 'CLOSE',
  BACK = 'BACK'
}

export enum SupplyPhotosActionType {
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TOOL_BAR_BUTTON = 'TOOL_BAR_BUTTON',
  LINK_BUTTON = 'LINK_BUTTON',
  LINK = 'LINK'
}

export interface SupplyPhotosAddPhotoInput {
  fileUrl: Scalars['String'];
  fileName: Scalars['String'];
  rank?: InputMaybe<Scalars['Int']>;
  roomIds: Array<Scalars['String']>;
  spaceIds: Array<Scalars['String']>;
}

/** The experience varies by the view (UFO, PE, EPC) & photo category */
export interface SupplyPhotosExperienceContext {
  view: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
}

export enum SupplyPhotosPhotoStatus {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING'
}

export interface SupplyProductCreationExperienceInputParam {
  step: Scalars['String'];
  roomTypeKey?: InputMaybe<Scalars['String']>;
  copyRoomTypeKey?: InputMaybe<Scalars['String']>;
}

export interface SupplyPromotionCreateMembersOnlyDealsTiersInput {
  name: Scalars['String'];
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  canStackToOtherPromotions?: InputMaybe<Scalars['Boolean']>;
  promotionRunDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  blockoutDates?: InputMaybe<Array<SupplyPromotionDateRangeInput>>;
  ratePlanIds?: InputMaybe<Array<Scalars['String']>>;
  bookingDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  stayDates?: InputMaybe<SupplyPromotionDateRangeInput>;
}

export interface SupplyPromotionDateRangeInput {
  startDate: DateInput;
  endDate?: InputMaybe<DateInput>;
}

export interface SupplyPromotionMemberTiersDiscountsInput {
  baseMemberDiscount: Scalars['Int'];
  middleMemberDiscount?: InputMaybe<Scalars['Int']>;
  topMemberDiscount?: InputMaybe<Scalars['Int']>;
}

export enum SupplyPromotionNotificationType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export interface SupplyPromotionPlaygroundInputs {
  reservationDate: DateInput;
  travelDates: SupplyPromotionDateRangeInput;
  roomRatePlanId: Scalars['String'];
  memberLevel: Scalars['Int'];
}

export enum SupplyPromotionReservationMode {
  ADVANCED = 'ADVANCED',
  STANDARD = 'STANDARD'
}

export enum SupplyPromotionResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}

export interface SupplyPromotionUpdateMembersOnlyDealsTiersInput {
  name: Scalars['String'];
  memberTiersDiscounts: SupplyPromotionMemberTiersDiscountsInput;
  canStackToOtherPromotions?: InputMaybe<Scalars['Boolean']>;
  ratePlanIds?: InputMaybe<Array<Scalars['String']>>;
  promotionRunDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  blockoutDates?: InputMaybe<Array<SupplyPromotionDateRangeInput>>;
  bookingDates?: InputMaybe<SupplyPromotionDateRangeInput>;
  stayDates?: InputMaybe<SupplyPromotionDateRangeInput>;
}

export interface SupplyPropertyRateInput {
  currencyCode: Scalars['String'];
  language: Scalars['String'];
  baseRate: Scalars['Float'];
}

export enum SupplyQuickActionComparisonType {
  LESSER_THAN = 'LESSER_THAN',
  GREATER_THAN = 'GREATER_THAN'
}

/** Allowed operations on subscribe event */
export enum SupplyQuickActionElementVisibility {
  HIDE_SELF = 'HIDE_SELF',
  SHOW_SELF = 'SHOW_SELF'
}

/** Allowed operations on subscribe event */
export enum SupplyQuickActionFieldProcessorOperation {
  PLAIN_REPLACE = 'PLAIN_REPLACE',
  PERCENT_CALC_AND_REPLACE = 'PERCENT_CALC_AND_REPLACE',
  SUBTRACT_AND_REPLACE = 'SUBTRACT_AND_REPLACE'
}

export enum SupplyQuickActionFieldSetDirection {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL'
}

export interface SupplyQuickActionFormContextInput {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
}

/**
 * SupplyQuickActionSpacingSize
 * Note: only 0X_HALF, 1X, 2X, 3X, 4X, 6X, 12X, 16X are supported for desktop.
 * Using other sizes may render differently different on mobile and desktop
 */
export enum SupplyQuickActionSpacingSize {
  SPACING__0X__HALF = 'SPACING__0X__HALF',
  SPACING__10X = 'SPACING__10X',
  SPACING__11X = 'SPACING__11X',
  SPACING__12X = 'SPACING__12X',
  SPACING__14X = 'SPACING__14X',
  SPACING__16X = 'SPACING__16X',
  SPACING__1X = 'SPACING__1X',
  SPACING__2X = 'SPACING__2X',
  SPACING__3X = 'SPACING__3X',
  SPACING__4X = 'SPACING__4X',
  SPACING__5X = 'SPACING__5X',
  SPACING__6X = 'SPACING__6X',
  SPACING__8X = 'SPACING__8X'
}

export enum SupplyQuickActionTableItemCellType {
  NORMAL = 'NORMAL',
  STRIKETHROUGH = 'STRIKETHROUGH'
}

export interface SupplyRegulatoryFlowThirdPartyValidationInput {
  /** The Third party validation rule */
  rule: Scalars['String'];
  /** The field to validate */
  field: Scalars['String'];
  /** The field value to validate */
  value: Scalars['String'];
  /** other possible parameters for the Third party validation */
  options: Array<SupplyRegulatoryFlowThirdPartyValidationOption>;
}

export interface SupplyRegulatoryFlowThirdPartyValidationOption {
  name: Scalars['String'];
  value: Scalars['String'];
}

export interface SupplyRegulatorySettingInput {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
}

export enum SupplyRegulatoryStatus {
  COMPLIANT = 'COMPLIANT',
  NOT_COMPLIANT = 'NOT_COMPLIANT',
  NONE = 'NONE'
}

export enum SupplyReservationDetailsComponentType {
  STAY_DETAILS = 'STAY_DETAILS',
  PARTNER_NOTES = 'PARTNER_NOTES',
  RENTAL_AGREEMENT = 'RENTAL_AGREEMENT',
  PAYMENT_SUMMARY = 'PAYMENT_SUMMARY',
  PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE',
  TRAVELER_INFO = 'TRAVELER_INFO',
  DAMAGE_DEPOSIT = 'DAMAGE_DEPOSIT',
  PAYMENT_DETAILS = 'PAYMENT_DETAILS',
  ACCESS_INSTRUCTIONS = 'ACCESS_INSTRUCTIONS',
  CANCELLATION_POLICY = 'CANCELLATION_POLICY',
  MINI_AVAILABILITY_CALENDAR = 'MINI_AVAILABILITY_CALENDAR'
}

export enum SupplyReservationStatusType {
  BOOKED = 'BOOKED',
  INQUIRY = 'INQUIRY',
  CANCELED = 'CANCELED',
  ARRIVING_TODAY = 'ARRIVING_TODAY',
  CURRENT_STAY = 'CURRENT_STAY',
  POST_STAY = 'POST_STAY',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  PRE_APPROVED = 'PRE_APPROVED',
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  BOOKING_REQUEST_EXPIRED = 'BOOKING_REQUEST_EXPIRED',
  PRE_APPROVAL_EXPIRED = 'PRE_APPROVAL_EXPIRED'
}

export interface SupplyReservationsAccessIdentifierInput {
  id: Scalars['String'];
  idType: Scalars['String'];
}

export interface SupplyReservationsAccessInstructionPhotoInput {
  imageId: Scalars['UUID'];
  photoUrl: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
}

export interface SupplyReservationsAccessInstructionsInput {
  accessType: SupplyReservationsAccessTypes;
  accessCode?: InputMaybe<Scalars['String']>;
  instructions: Scalars['String'];
  gallery?: InputMaybe<Array<InputMaybe<SupplyReservationsAccessInstructionPhotoInput>>>;
}

export enum SupplyReservationsAccessTypes {
  SMART_LOCK = 'SMART_LOCK',
  LOCKBOX = 'LOCKBOX',
  KEYPAD = 'KEYPAD',
  PICKUP = 'PICKUP',
  DOORMAN = 'DOORMAN',
  OTHER = 'OTHER'
}

export enum SupplyReservationsActionType {
  ACCESS_INSTRUCTIONS_ADD = 'ACCESS_INSTRUCTIONS_ADD',
  ACCESS_INSTRUCTIONS_EDIT = 'ACCESS_INSTRUCTIONS_EDIT',
  HEADER_MARK_AS_UNREAD = 'HEADER_MARK_AS_UNREAD',
  HEADER_MARK_AS_SPAM = 'HEADER_MARK_AS_SPAM',
  HEADER_ARCHIVE = 'HEADER_ARCHIVE',
  HEADER_UNARCHIVE = 'HEADER_UNARCHIVE',
  HEADER_PRINT = 'HEADER_PRINT',
  HEADER_SHARE = 'HEADER_SHARE',
  HEADER_FEEDBACK = 'HEADER_FEEDBACK',
  HEADER_HELP_CENTER = 'HEADER_HELP_CENTER',
  HEADER_DETAILS = 'HEADER_DETAILS',
  DAMAGE_PROTECTION_REPORT_DAMAGE = 'DAMAGE_PROTECTION_REPORT_DAMAGE',
  DAMAGE_PROTECTION_REFUND_DEPOSIT = 'DAMAGE_PROTECTION_REFUND_DEPOSIT',
  DAMAGE_PROTECTION_SEE_POLICY = 'DAMAGE_PROTECTION_SEE_POLICY',
  DAMAGE_PROTECTION_SEE_DAMAGE_REPORT = 'DAMAGE_PROTECTION_SEE_DAMAGE_REPORT',
  DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL = 'DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL',
  PAYMENT_SCHEDULE_MARK_PAID = 'PAYMENT_SCHEDULE_MARK_PAID',
  PAYMENT_SCHEDULE_RESEND_REQUEST = 'PAYMENT_SCHEDULE_RESEND_REQUEST',
  PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST = 'PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST',
  PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE = 'PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE',
  PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE = 'PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE',
  PAYMENT_SCHEDULE_SEND_A_REFUND = 'PAYMENT_SCHEDULE_SEND_A_REFUND',
  GUEST_INFO_EMAIL = 'GUEST_INFO_EMAIL',
  GUEST_INFO_PHONE = 'GUEST_INFO_PHONE',
  GUEST_INFO_VIEW_PROFILE = 'GUEST_INFO_VIEW_PROFILE',
  RENTAL_AGREEMENT_VIEW = 'RENTAL_AGREEMENT_VIEW',
  PAYMENT_SUMMARY_VIEW = 'PAYMENT_SUMMARY_VIEW',
  NOTES_EDIT = 'NOTES_EDIT',
  NOTES_ADD = 'NOTES_ADD',
  NOTES_CANCEL = 'NOTES_CANCEL',
  NOTES_SAVE = 'NOTES_SAVE',
  STAY_DETAILS_CHANGE_DATES = 'STAY_DETAILS_CHANGE_DATES',
  STAY_DETAILS_EDIT_RESERVATION = 'STAY_DETAILS_EDIT_RESERVATION',
  STAY_DETAILS_CHANGE_TIME = 'STAY_DETAILS_CHANGE_TIME',
  STAY_DETAILS_ADD_REMOVE_GUESTS = 'STAY_DETAILS_ADD_REMOVE_GUESTS',
  STAY_DETAILS_CANCEL_RESERVATION = 'STAY_DETAILS_CANCEL_RESERVATION',
  STAY_DETAILS_CONFIRM_CANCELLATION = 'STAY_DETAILS_CONFIRM_CANCELLATION',
  STAY_DETAILS_SEND_PRE_APPROVAL = 'STAY_DETAILS_SEND_PRE_APPROVAL',
  STAY_DETAILS_EDIT_QUOTE = 'STAY_DETAILS_EDIT_QUOTE',
  STAY_DETAILS_ACCEPT = 'STAY_DETAILS_ACCEPT',
  STAY_DETAILS_DECLINE = 'STAY_DETAILS_DECLINE',
  STAY_DETAILS_EDIT_DATES = 'STAY_DETAILS_EDIT_DATES',
  STAY_DETAILS_CANCEL_PRE_APPROVAL = 'STAY_DETAILS_CANCEL_PRE_APPROVAL'
}

export enum SupplyReservationsInteractionChatImageSize {
  SMALL = 'SMALL',
  LARGE = 'LARGE'
}

export enum SupplyReservationsInteractionListActionDialogFooterActionType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}

export enum SupplyReservationsInteractionListColumnHorizontalAlign {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  CENTER = 'CENTER',
  JUSTIFY = 'JUSTIFY',
  JUSTIFY_ALL = 'JUSTIFY_ALL',
  START = 'START',
  END = 'END',
  MATCH_PARENT = 'MATCH_PARENT'
}

export enum SupplyReservationsInteractionListColumnVerticalAlign {
  BASELINE = 'BASELINE',
  SUB = 'SUB',
  SUPER = 'SUPER',
  TEXT_TOP = 'TEXT_TOP',
  TEXT_BOTTOM = 'TEXT_BOTTOM',
  MIDDLE = 'MIDDLE',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM'
}

export enum SupplyReservationsInteractionListItemAction {
  UNREAD = 'UNREAD',
  READ = 'READ',
  SPAM = 'SPAM',
  ARCHIVE = 'ARCHIVE',
  UNARCHIVE = 'UNARCHIVE'
}

export enum SupplyReservationsInteractionListSwipeActionEdge {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}

export enum SupplyReservationsInteractionMessageMode {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING'
}

export interface SupplyReservationsInteractionsClientDataInput {
  timezone: Scalars['String'];
}

export interface SupplyReservationsInteractionsFilterInput {
  /**
   * List of selected filters
   * Should be the value of "options.name"
   * Examples:
   *     "message.unread"
   *     "guest.requests.inquiry"
   */
  filters?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
}

export interface SupplyReservationsInteractionsPageInput {
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}

export enum SupplyReservationsInteractionsSort {
  GUEST_ASC = 'GUEST_ASC',
  GUEST_DESC = 'GUEST_DESC',
  CHECKIN_DATE_ASC = 'CHECKIN_DATE_ASC',
  CHECKIN_DATE_DESC = 'CHECKIN_DATE_DESC',
  RECEIVED_ON_ASC = 'RECEIVED_ON_ASC',
  RECEIVED_ON_DESC = 'RECEIVED_ON_DESC'
}

export enum SupplyReservationsPaymentDetailsExpandoPositioning {
  TRAILING = 'TRAILING',
  LEADING = 'LEADING'
}

export enum SupplyReservationsPaymentDisplayToolbarIcon {
  CLOSE = 'CLOSE',
  BACK = 'BACK'
}

export enum SupplyReservationsRenderHint {
  COLLAPSED = 'COLLAPSED',
  LIST = 'LIST'
}

export enum SupplyScoreFactorBmlAuditItemObervationType {
  RATE = 'RATE',
  AVAILABILITY = 'AVAILABILITY'
}

export enum SupplyScoreFactorNotificationType {
  DOING_GREAT = 'DOING_GREAT',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION'
}

/** Description of a SupplyScoreMessaging's card */
export enum SupplyScoreMessagingTheme {
  MESSAGE = 'MESSAGE',
  INFO = 'INFO',
  WARNING = 'WARNING'
}

export interface SupplyTaxesAmountInput {
  amount: Scalars['Float'];
  age: Scalars['Int'];
}

export interface SupplyTaxesInput {
  type: SupplyTaxesType;
  taxesPercent?: InputMaybe<SupplyTaxesPercentInput>;
  taxesAmount?: InputMaybe<SupplyTaxesAmountInput>;
}

export interface SupplyTaxesPercentInput {
  percent: Scalars['Float'];
}

export enum SupplyTaxesType {
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
  NOT_INCLUDED = 'NOT_INCLUDED'
}

/** Represents the selection status of a tab */
export enum TabStatus {
  /** Represents the status of not being selected */
  NOT_SELECTED = 'NOT_SELECTED',
  /** Represents the status of being selected */
  SELECTED = 'SELECTED'
}

/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL'
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  EMPHASIS = 'EMPHASIS',
  INVERSE = 'INVERSE',
  LOYALTY = 'LOYALTY',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR'
}

export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_EXTRA_HIGH_TIER = 'LOYALTY_EXTRA_HIGH_TIER',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  PROMOTED = 'PROMOTED',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  STANDARD = 'STANDARD',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS'
}

export interface TopTaskCardAction {
  cardAction: CardActions;
  topTaskType: TopTaskTypes;
  taskId: Scalars['String'];
}

export enum TopTaskTypes {
  BOOKING_REQUEST = 'BOOKING_REQUEST',
  INQUIRY = 'INQUIRY',
  CURRENT_STAY = 'CURRENT_STAY',
  ARRIVING = 'ARRIVING',
  CANCELLATION_REQUEST = 'CANCELLATION_REQUEST',
  RATE_TRAVELER = 'RATE_TRAVELER',
  CANCELLATION = 'CANCELLATION',
  BANK_DETAILS = 'BANK_DETAILS',
  TAX_FORM = 'TAX_FORM',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  CONFIRM_IDENTITY = 'CONFIRM_IDENTITY',
  OPPORTUNITY = 'OPPORTUNITY',
  LOWER_FEES = 'LOWER_FEES',
  ADD_PHOTOS = 'ADD_PHOTOS',
  ADD_AMENITIES = 'ADD_AMENITIES',
  ADD_MINIMUM_STAY = 'ADD_MINIMUM_STAY',
  VRPAYMENTS_TIP = 'VRPAYMENTS_TIP'
}

/** Optional inputs for custom flex content */
export interface TravelContentAttributesInput {
  /** content Id */
  contentId: Scalars['String'];
  /** preview */
  preview: Scalars['Boolean'];
}

/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}

export interface TravelGuidePageContextInput {
  pageType: PageType;
  placeId?: InputMaybe<Scalars['String']>;
}

export interface TravelMemberGroupInput {
  adults: Scalars['Int'];
  childrenAges?: InputMaybe<Array<Scalars['Int']>>;
}

export interface TravelStoreV1CarDetailsInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
}

export interface TravelStoreV1CarSearchInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  defaultSortOption: Scalars['String'];
  filterOptions: Array<Scalars['String']>;
  messagingOptions: Array<Scalars['String']>;
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
  sortOptions: Array<Scalars['String']>;
}

/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: InputMaybe<Scalars['Int']>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}

/** Package traveler occupancy group */
export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}

export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  LGBT = 'LGBT',
  ROMANTIC = 'ROMANTIC'
}

/** Represents per traveller ancillary selection */
export interface TravellerAncillarySelectionInput {
  /** Represents the list of encoded AncillaryToken for each selection made */
  ancillaryTokens: Array<Scalars['String']>;
  /** Represents the traveler index for which the selection is applicable */
  travelerIndex: Scalars['Int'];
}

export enum TripCareButtonAction {
  BACK = 'BACK',
  CANCEL_POLICY = 'CANCEL_POLICY',
  DISMISS_POPUP = 'DISMISS_POPUP',
  POPUP = 'POPUP',
  RELOAD = 'RELOAD'
}

export enum TripCareButtonState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

export enum TripCareLayoutStyle {
  CARD_BORDER_TOP = 'CARD_BORDER_TOP'
}

export enum TripCareListType {
  BULLET = 'BULLET',
  NO_BULLET = 'NO_BULLET',
  NUMBERED = 'NUMBERED'
}

export enum TripCarePhraseStyle {
  BOLD = 'BOLD',
  HR_DIVIDER_BOTTOM = 'HR_DIVIDER_BOTTOM',
  HR_DIVIDER_TOP = 'HR_DIVIDER_TOP',
  SIZE_100 = 'SIZE_100',
  SIZE_200 = 'SIZE_200',
  SIZE_300 = 'SIZE_300',
  SIZE_400 = 'SIZE_400',
  SIZE_500 = 'SIZE_500',
  SIZE_600 = 'SIZE_600',
  SIZE_700 = 'SIZE_700',
  SIZE_800 = 'SIZE_800',
  SIZE_900 = 'SIZE_900',
  SMALL = 'SMALL',
  SPACING_FOUR = 'SPACING_FOUR',
  SPACING_HALF = 'SPACING_HALF',
  SPACING_ONE = 'SPACING_ONE',
  SPACING_SIX = 'SPACING_SIX',
  SPACING_THREE = 'SPACING_THREE',
  SPACING_TWO = 'SPACING_TWO',
  THEME_EMPHASIS = 'THEME_EMPHASIS',
  THEME_NEGATIVE = 'THEME_NEGATIVE',
  THEME_POSITIVE = 'THEME_POSITIVE',
  WEIGHT_BOLD = 'WEIGHT_BOLD',
  WEIGHT_MEDIUM = 'WEIGHT_MEDIUM',
  WEIGHT_REGULAR = 'WEIGHT_REGULAR'
}

export enum TripCarePhraseType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
  TEXT = 'TEXT'
}

export enum TripCreationEntryPoint {
  HOTEL_SEARCH_RESULTS = 'HOTEL_SEARCH_RESULTS',
  TRIPS_LIST = 'TRIPS_LIST',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}

/** Metadata which can be provided when creating a new trip. */
export interface TripCreationMetadataInput {
  entryPoint?: InputMaybe<TripCreationEntryPoint>;
  itemId?: InputMaybe<Scalars['String']>;
  /** An input provided when creating a new trip as part of moving an item to a trip */
  moveItemInput?: InputMaybe<TripItemInput>;
  /** Trip planning inputs provided when creating a new trip as part of saving an item to a trip */
  saveItemInput?: InputMaybe<TripsPlanInput>;
}

export interface TripDetailsSupportRequestsInput {
  buttonStyle: EGDSButtonStyle;
  itineraryNumber: Scalars['String'];
  lineOfBusiness: Scalars['String'];
  orderLineId: Scalars['String'];
}

/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export enum TripEntity {
  ACTIVITY_PRODUCT = 'ACTIVITY_PRODUCT',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LODGING_PRODUCT = 'LODGING_PRODUCT'
}

export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}

/**
 * The `TripInviteInput` complex type contains a `inviteId` known by the Trip Domain.
 * The inviteId is invitation identifier to be opened from trips overview screen or redirected to by invite deep link.
 * The server will construct all the necessary information based on invite that has back reference to trip with all needed information to populate view
 * It also provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripInviteInput {
  inviteId: Scalars['String'];
}

/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: InputMaybe<Scalars['String']>;
  tripEntity?: InputMaybe<TripEntity>;
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
}

/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  segments?: InputMaybe<Array<Scalars['String']>>;
  tripViewId: Scalars['String'];
}

export enum TripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE'
}

/** Represents different avatar sizes. */
export enum TripsAvatarSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

/** Supported Trips badge themes */
export enum TripsBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  SAVED = 'SAVED',
  STATUS_NEGATIVE = 'STATUS_NEGATIVE',
  STATUS_POSITIVE = 'STATUS_POSITIVE',
  UTILITY_STANDARD = 'UTILITY_STANDARD',
  VIP = 'VIP'
}

export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = 'MATCH_PARENT_CONTAINER',
  WRAP_CONTENT = 'WRAP_CONTENT'
}

export enum TripsCalendarSelectionType {
  SINGLE = 'SINGLE',
  START_AND_END = 'START_AND_END',
  START_AND_END_WITH_SAME_DATE = 'START_AND_END_WITH_SAME_DATE'
}

/** Contains attributes for trip cancellation */
export interface TripsCancellationAttributesInput {
  orderLineNumbers?: InputMaybe<Array<Scalars['String']>>;
  orderNumber?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute. In case of partial refund, we are passing this value to the backend. */
  penaltyAmount?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed refund amount to user. If this value set then compare between displayed amount and actual amount from backend. */
  refundAmount?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed cash refund amount to user, we are passing this value to the backend. */
  refundInCash?: InputMaybe<Scalars['String']>;
  /** Formatted string. This is optional attribute for displayed points refund amount to user, we are passing this value to the backend. */
  refundInPoints?: InputMaybe<Scalars['String']>;
}

export enum TripsCancellationType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE'
}

/** Represents a TripsCard's selection/active state */
export enum TripsCardState {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}

/** Type of the drawer/sheet we want the client to render. CENTER is for desktop where we want to show the drawer as a center sheet/dialogBOTTOM is for app and mweb where the drawer comes from the bottom of the screenSIDE is for desktop where the sheet comes from the right of the screen. eg. plan, moveFULL is equivalent to sidesheet on mweb where the sheet will cover the whole page */
export enum TripsComposableDrawerType {
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  FULL = 'FULL',
  SIDE = 'SIDE'
}

/** Display theme for trips content */
export enum TripsContentTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS',
  /** The ordered list should always be displayed with numbers */
  ORDERED = 'ORDERED',
  /** Paragraph type list */
  PARAGRAPH = 'PARAGRAPH'
}

export enum TripsContentType {
  PDF = 'PDF'
}

export enum TripsContentUnorderedListTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS'
}

export enum TripsCustomerNotificationTripScheduleChangeStatus {
  FLIGHT_SCHEDULE_CHANGE = 'FLIGHT_SCHEDULE_CHANGE',
  NO_CHANGE = 'NO_CHANGE'
}

/** Represents layout of buttons on a modal dialog */
export enum TripsDialogButtonLayout {
  /** Dialog with horizontally stacked buttons */
  INLINE = 'INLINE',
  /** Dialog with vertically stacked buttons */
  STACKED = 'STACKED'
}

export enum TripsDisplayMode {
  DEFAULT = 'DEFAULT',
  MODAL = 'MODAL'
}

/** Controls the width of the divider */
export enum TripsDivider {
  NARROW = 'NARROW',
  WIDE = 'WIDE'
}

/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars['String'];
}

export enum TripsFindItineraryNumberView {
  FIND_ITINERARY_OTHER_EMAIL = 'FIND_ITINERARY_OTHER_EMAIL',
  FIND_ITINERARY_USER_EMAIL = 'FIND_ITINERARY_USER_EMAIL',
  RESULT = 'RESULT'
}

/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export enum TripsFittedImageType {
  BARCODE = 'BARCODE',
  E_FRANKING_STAMP = 'E_FRANKING_STAMP',
  QR_CODE = 'QR_CODE'
}

/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export enum TripsFormContainerTheme {
  MATCH_PARENT = 'MATCH_PARENT',
  WRAP_CONTENT = 'WRAP_CONTENT'
}

export enum TripsFormType {
  CREATE_NEW_TRIP_FROM_ITEM = 'CREATE_NEW_TRIP_FROM_ITEM',
  FIND_ITINERARY_NUMBER = 'FIND_ITINERARY_NUMBER',
  INVITE = 'INVITE',
  SAVE_NEW_TRIP = 'SAVE_NEW_TRIP',
  SEARCH_BOOKING = 'SEARCH_BOOKING',
  SEND_ITINERARY_EMAIL = 'SEND_ITINERARY_EMAIL',
  UPDATE_TRIP = 'UPDATE_TRIP'
}

/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export enum TripsInputType {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE'
}

export interface TripsItemsGroupFilterInput {
  type: Scalars['String'];
  value: Scalars['String'];
}

/** Contains filters and sort fields to control how the items appear in groups. */
export interface TripsItemsGroupInput {
  filters: Array<TripsItemsGroupFilterInput>;
  sort?: InputMaybe<Scalars['String']>;
}

export enum TripsLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

/** The type of map marker */
export enum TripsMarkerType {
  ActivityEventMarker = 'ActivityEventMarker',
  ActivityGuestPickupMarker = 'ActivityGuestPickupMarker',
  ActivityLocationMarker = 'ActivityLocationMarker',
  ActivityRedemptionMarker = 'ActivityRedemptionMarker',
  AirportMarker = 'AirportMarker',
  CarMarker = 'CarMarker',
  CruiseMarker = 'CruiseMarker',
  HotelMarker = 'HotelMarker',
  PlaceMarker = 'PlaceMarker'
}

export interface TripsNotAuthorizedInput {
  filter?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  screen?: InputMaybe<TripsScreen>;
  tripItemId?: InputMaybe<Scalars['String']>;
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Input to the trips.plan query. */
export interface TripsPlanInput {
  /** Provides LOB specific search context */
  attributes?: InputMaybe<TripsSaveItemAttributesInput>;
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: InputMaybe<PageLocation>;
  /** Composes PropertySearch and FlightSearch inputs */
  productSearchCriteria?: InputMaybe<TripsProductSearchCriteriaInput>;
  source?: InputMaybe<TripsPlanSourceType>;
  /** Attributes needed to create or update trip items subscription data */
  subscriptionAttributes?: InputMaybe<TripsSubscriptionAttributesInput>;
  /** A handle to one of the domain tripItems that stores the item identified by the domain */
  tripItem?: InputMaybe<TripItemInput>;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export enum TripsPlanSourceType {
  ACTIVITY_DETAILS = 'ACTIVITY_DETAILS',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  HOTEL_SEARCH = 'HOTEL_SEARCH',
  LODGING_DETAILS = 'LODGING_DETAILS',
  LODGING_SEARCH = 'LODGING_SEARCH',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}

/** Input to the trips.screenshot query. */
export interface TripsProductSearchCriteriaInput {
  flightSearchCriteria?: InputMaybe<FlightSearchCriteriaInput>;
  propertySearchCriteria?: InputMaybe<PropertySearchCriteriaInput>;
  tripsFlightSearchCriteria?: InputMaybe<TripsSaveFlightSearchCriteriaInput>;
}

export enum TripsResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}

/** Save activity input details */
export interface TripsSaveActivityAttributesInput {
  /** Date range representing activity search, if absent the default [today, today+14d] is used */
  dateRange?: InputMaybe<DateRangeInput>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
}

/** Input type representing primary and filters flight search criteria */
export interface TripsSaveFlightSearchCriteriaInput {
  flightSearchFilters: Array<FlightsSearchFilterValuesInput>;
  primary: PrimaryFlightCriteriaInput;
}

/** Type grouping all the optional additional information that's required when saving an item. */
export interface TripsSaveItemAttributesInput {
  /** Activity input details */
  activityAttributes?: InputMaybe<TripsSaveActivityAttributesInput>;
  /** Flight input details */
  flightAttributes?: InputMaybe<FlightSearchCriteriaInput>;
  /** Stay input details */
  stayAttributes?: InputMaybe<TripsSaveStayAttributesInput>;
}

export interface TripsSaveItemInput {
  anchorPrice?: InputMaybe<Scalars['String']>;
  productSearchCriteria: TripsProductSearchCriteriaInput;
}

/** Save stay input details */
export interface TripsSaveStayAttributesInput {
  /** The check-in date for the property */
  checkInDate?: InputMaybe<DateInput>;
  /** The check-out date for the property */
  checkoutDate?: InputMaybe<DateInput>;
  /** The Gaia region ID of the search */
  regionId?: InputMaybe<Scalars['String']>;
  /** Provides Stay traveler information */
  roomConfiguration?: InputMaybe<Array<PropertyRoomInput>>;
}

/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: InputMaybe<DateTimeInput>;
  checkoutDate?: InputMaybe<DateTimeInput>;
  propertyId: Scalars['String'];
  regionId?: InputMaybe<Scalars['String']>;
  roomConfiguration?: InputMaybe<Array<TripsStayRoomTravelerInfoInput>>;
  sourceType?: InputMaybe<TripsPlanSourceType>;
}

export enum TripsScreen {
  INVITE_LANDING_PAGE = 'INVITE_LANDING_PAGE',
  TRIP_ITEM_ITINERARY = 'TRIP_ITEM_ITINERARY',
  TRIP_ITEM_MANAGE_BOOKING = 'TRIP_ITEM_MANAGE_BOOKING',
  TRIP_ITEM_PRICING_REWARDS = 'TRIP_ITEM_PRICING_REWARDS',
  TRIP_ITEM_RECEIPT = 'TRIP_ITEM_RECEIPT',
  TRIP_MANAGE_GUESTS = 'TRIP_MANAGE_GUESTS',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW',
  TRIP_OVERVIEW_ITINERARY = 'TRIP_OVERVIEW_ITINERARY'
}

/** Input to the trips.screenshot query. */
export interface TripsScreenshotInput {
  /** The id of the item being saved, e.g property id */
  itemId: Scalars['String'];
  /** Provides an entrypoint location from which an item can be saved to a trip */
  pageLocation?: InputMaybe<PageLocation>;
  /** Provides LOB specific search context */
  saveItemAttributes: TripsSaveItemAttributesInput;
}

export enum TripsSearchBookingView {
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  SEARCH_RESULT = 'SEARCH_RESULT'
}

/** This enum represents the different fields that a TripsSignalPair relates to. */
export enum TripsSignalPairKey {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  STATUS = 'STATUS'
}

/** This enum represents the different category types of signals registered within the platform. */
export enum TripsSignalType {
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}

/** Attributes needed to create or update trip items subscription data */
export interface TripsSubscriptionAttributesInput {
  anchorPrice?: InputMaybe<Scalars['String']>;
  subscriptionInputs?: InputMaybe<Array<GraphQLPairInput>>;
}

/** Represents a toggle's state. */
export enum TripsToggleStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

/** Alignment for the buttons in a dialog's footer */
export enum TripsUIDialogFooterButtonLayout {
  INLINE = 'INLINE',
  STACKED = 'STACKED'
}

export enum TripsUIMessagingBannerCardTheme {
  CRITICAL = 'CRITICAL',
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR'
}

export enum TripsUIResponseStatus {
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS'
}

export enum TripsViewType {
  ACTIVITIES_SEARCH_RESULTS = 'ACTIVITIES_SEARCH_RESULTS',
  CAMPAIGNS = 'CAMPAIGNS',
  CARS_SEARCH_RESULTS = 'CARS_SEARCH_RESULTS',
  FILTERED = 'FILTERED',
  FIND_ITINERARY_BY_OTHER_EMAIL = 'FIND_ITINERARY_BY_OTHER_EMAIL',
  FIND_ITINERARY_BY_USER_EMAIL = 'FIND_ITINERARY_BY_USER_EMAIL',
  FLIGHTS_SEARCH_RESULTS = 'FLIGHTS_SEARCH_RESULTS',
  ITEM_DETAILS = 'ITEM_DETAILS',
  ITEM_ESSENTIAL_INFO = 'ITEM_ESSENTIAL_INFO',
  ITEM_PRICING_AND_REWARDS = 'ITEM_PRICING_AND_REWARDS',
  ITEM_VOUCHER = 'ITEM_VOUCHER',
  LOB_SELECTION_VIEW = 'LOB_SELECTION_VIEW',
  LODGING_SEARCH_RESULTS = 'LODGING_SEARCH_RESULTS',
  LOGIN_PROMPT = 'LOGIN_PROMPT',
  MANAGE_BOOKING = 'MANAGE_BOOKING',
  MANAGE_GUESTS = 'MANAGE_GUESTS',
  OVERVIEW = 'OVERVIEW',
  PACKAGES_FC_SEARCH_RESULTS = 'PACKAGES_FC_SEARCH_RESULTS',
  PACKAGES_FHC_SEARCH_RESULTS = 'PACKAGES_FHC_SEARCH_RESULTS',
  PACKAGES_HC_SEARCH_RESULTS = 'PACKAGES_HC_SEARCH_RESULTS',
  PACKAGES_HF_SEARCH_RESULTS = 'PACKAGES_HF_SEARCH_RESULTS',
  PENDING_INVITE = 'PENDING_INVITE',
  SEARCH_BY_ITINERARY_NUMBER = 'SEARCH_BY_ITINERARY_NUMBER',
  SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL = 'SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL',
  TRIPS_LIST = 'TRIPS_LIST'
}

/**
 * Contains fields that will be used to build the correct trips view URL. For the most accurate result,
 *     supply as many of the fields as possible. If input is not supplied, the Url will navigate to /trips"
 */
export interface TripsWebViewInput {
  filter?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  screen?: InputMaybe<TripsScreen>;
  tripItemId?: InputMaybe<Scalars['String']>;
  tripViewId?: InputMaybe<Scalars['String']>;
}

/** Represents a typing indicator event's content */
export interface TypingIndicatorEventContentInput {
  /** Represents if the user is typing or not - isTyping: true equals start: true */
  isTyping?: InputMaybe<Scalars['Boolean']>;
}

/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UILinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export enum UISignal {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  DUPLICATE_REQUEST = 'DUPLICATE_REQUEST',
  GENERIC_DOWNSTREAM_ERROR = 'GENERIC_DOWNSTREAM_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  UNKNOWN = 'UNKNOWN',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE'
}

/** Type to select a category of action for an UnescoPledge */
export enum UnescoPledgeCategory {
  /** Category to support local communities */
  COMMUNITY_ENGAGEMENT = 'COMMUNITY_ENGAGEMENT',
  /** Category to save energy consumption */
  CONSERVE_ENERGY = 'CONSERVE_ENERGY',
  /** Category to save water consumption */
  CONSERVE_WATER = 'CONSERVE_WATER',
  /** Category to add additional information about sustainability */
  OTHER = 'OTHER',
  /** Category to reduce plastic usage */
  REDUCE_PLASTIC = 'REDUCE_PLASTIC',
  /** Category to reduce waste */
  REDUCE_WASTE = 'REDUCE_WASTE'
}

/** Type to specify a filter related UnescoPledges */
export interface UnescoPledgeFilterInput {
  /** Categories to filter */
  category?: InputMaybe<Array<InputMaybe<UnescoPledgeCategory>>>;
  /** Number of UnescoPledge to visualize */
  pledgesNumber?: InputMaybe<Scalars['Int']>;
  /** Number of the starting index of UnescoPledge list */
  startingIndex?: InputMaybe<Scalars['Int']>;
}

export enum UniversalProfileAccountManagementOptionType {
  TRAVELER_ARRANGER = 'TRAVELER_ARRANGER'
}

export interface UniversalProfileAccountTakeOverWidgetRequestInput {
  content?: InputMaybe<Scalars['String']>;
  type: UniversalProfileAccountTakeOverWidgetTypeRequest;
}

export enum UniversalProfileAccountTakeOverWidgetTypeRequest {
  CAPTCHA = 'CAPTCHA',
  CSRF = 'CSRF'
}

export interface UniversalProfileAddressInput {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}

export enum UniversalProfileAnalyticsEventSubType {
  BLURRED = 'BLURRED',
  FOCUSED = 'FOCUSED',
  INPUTTED = 'INPUTTED',
  SUCCEEDED = 'SUCCEEDED'
}

export interface UniversalProfileBasicInformationDateOfBirthInput {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
}

export interface UniversalProfileBasicInformationNameInput {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileBasicInformationRequestInput {
  accessibilityNeeds?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  dateOfBirth: UniversalProfileBasicInformationDateOfBirthInput;
  gender?: InputMaybe<Scalars['String']>;
  name: UniversalProfileBasicInformationNameInput;
}

export enum UniversalProfileCategorySwitchOperator {
  OFF = 'OFF',
  ON = 'ON'
}

export interface UniversalProfileChangeEmailRequestInput {
  cmsToken: Scalars['String'];
  email: Scalars['String'];
}

/** EG Universal profile input for accessing client type */
export interface UniversalProfileClientInfoInput {
  appVersion?: InputMaybe<Scalars['String']>;
  channelType: UniversalProfileClientType;
}

export enum UniversalProfileClientType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB'
}

export interface UniversalProfileCommunicationPreferenceEmailRequestInput {
  categoryConsent: Array<UniversalProfileEmailCommunicationPreferenceUpdateInput>;
  unsubscribeFromAll: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceRequestInput {
  updates: Array<UniversalProfileCommunicationPreferenceUpdateInput>;
}

export interface UniversalProfileCommunicationPreferenceUnsubRequestInput {
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: InputMaybe<Scalars['String']>;
  emlDtl?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceUnsubscribeCategoriesRequestInput {
  categoryTypes: Array<UniversalProfileCommunicationPreferencesCategoryType>;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: InputMaybe<Scalars['String']>;
  emlDtl?: InputMaybe<Scalars['String']>;
  isStrict: Scalars['Boolean'];
}

export interface UniversalProfileCommunicationPreferenceUnsubscribePreferenceRequestInput {
  categoryType: UniversalProfileCommunicationPreferencesCategoryType;
  channel: CommunicationChannel;
  checksum: Scalars['String'];
  egAccountId: Scalars['String'];
  emlCid?: InputMaybe<Scalars['String']>;
  emlDtl?: InputMaybe<Scalars['String']>;
}

export interface UniversalProfileCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  selectedChannels?: InputMaybe<Array<CommunicationChannel>>;
}

export enum UniversalProfileCommunicationPreferencesCategoryType {
  ACCOUNT_SUPPORT = 'ACCOUNT_SUPPORT',
  CONFIRMATION_AND_CRITICAL_UPDATES = 'CONFIRMATION_AND_CRITICAL_UPDATES',
  OFFERS_AND_INSPIRATION = 'OFFERS_AND_INSPIRATION',
  ONE_KEY = 'ONE_KEY',
  ONE_KEY_MONTHLY_STATEMENTS = 'ONE_KEY_MONTHLY_STATEMENTS',
  ONE_KEY_REWARD_ACCOUNT_UPDATES = 'ONE_KEY_REWARD_ACCOUNT_UPDATES',
  PARTNERS_OFFERS_WITH_US = 'PARTNERS_OFFERS_WITH_US',
  PERSONALIZED_TRIP_RECOMMENDATIONS = 'PERSONALIZED_TRIP_RECOMMENDATIONS',
  REVIEWS = 'REVIEWS',
  SURVEYS = 'SURVEYS',
  THE_TRAVEL_EDIT = 'THE_TRAVEL_EDIT',
  TRIP_BOARD_ACTIVITY = 'TRIP_BOARD_ACTIVITY',
  TRIP_PLANNING_ASSISTANCE = 'TRIP_PLANNING_ASSISTANCE'
}

export enum UniversalProfileCommunicationPreferencesFormType {
  COMMUNICATION_PREFERENCE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM = 'COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM',
  COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM = 'COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM'
}

export interface UniversalProfileContactInformationRequestInput {
  address: UniversalProfileAddressInput;
  emergencyContact: UniversalProfileEmergencyContactInput;
  phone: UniversalProfilePhoneInput;
}

export interface UniversalProfileContextInput {
  accountTakeOverWidgets?: InputMaybe<Array<UniversalProfileAccountTakeOverWidgetRequestInput>>;
  additionalTravelerIdentifier?: InputMaybe<Scalars['String']>;
  cmsToken?: InputMaybe<Scalars['String']>;
  communicationPreferencesCategoryType?: InputMaybe<UniversalProfileCommunicationPreferencesCategoryType>;
  communicationPreferencesFormType?: InputMaybe<UniversalProfileCommunicationPreferencesFormType>;
  communicationPreferencesUnsubscribeContext?: InputMaybe<UniversalProfileCommunicationPreferenceUnsubRequestInput>;
  experienceType?: InputMaybe<UniversalProfileExperienceType>;
  informationFormType?: InputMaybe<UniversalProfileInformationFormType>;
  settingsFormType?: InputMaybe<UniversalProfileSettingsFormType>;
  subExperienceType?: InputMaybe<UniversalProfileSubExperienceType>;
}

export enum UniversalProfileDashboardOptionType {
  COMMUNICATIONS = 'COMMUNICATIONS',
  COUPONS = 'COUPONS',
  CREDITS = 'CREDITS',
  HELP = 'HELP',
  PAYMENTS = 'PAYMENTS',
  PROFILE = 'PROFILE',
  REVIEWS = 'REVIEWS',
  SETTINGS = 'SETTINGS'
}

export enum UniversalProfileDependsOnFieldIdentificationCriteriaOperator {
  EXCLUDES = 'EXCLUDES',
  INCLUDES = 'INCLUDES'
}

export interface UniversalProfileEmailCommunicationPreferenceUpdateInput {
  category: UniversalProfileCommunicationPreferencesCategoryType;
  emailOptIn: Scalars['Boolean'];
}

export interface UniversalProfileEmergencyContactInput {
  contactName?: InputMaybe<Scalars['String']>;
  phone: UniversalProfilePhoneInput;
}

export enum UniversalProfileExperienceType {
  COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES',
  HELP = 'HELP',
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS'
}

export enum UniversalProfileInformationFormType {
  COMMUNICATION_PREFERENCE_UNSUB = 'COMMUNICATION_PREFERENCE_UNSUB',
  UPDATE_BASIC_INFORMATION = 'UPDATE_BASIC_INFORMATION',
  UPDATE_COMMUNICATION_PREFERENCE = 'UPDATE_COMMUNICATION_PREFERENCE',
  UPDATE_CONTACT_INFORMATION = 'UPDATE_CONTACT_INFORMATION',
  UPDATE_CONTACT_INFORMATION_EMAIL = 'UPDATE_CONTACT_INFORMATION_EMAIL',
  UPDATE_CONTACT_INFORMATION_PHONE_NUMBER = 'UPDATE_CONTACT_INFORMATION_PHONE_NUMBER'
}

export enum UniversalProfileLocationAndLanguageOptionType {
  COUNTY = 'COUNTY',
  CURRENCY = 'CURRENCY',
  LANGUAGE = 'LANGUAGE'
}

export enum UniversalProfileLoginInformationSettingsOptionType {
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CONNECTED_DEVICES = 'CONNECTED_DEVICES',
  EMAIL = 'EMAIL'
}

export enum UniversalProfileMoreDetailsOptionType {
  AIRPORT_SECURITY = 'AIRPORT_SECURITY',
  FLIGHT_PREFERENCES = 'FLIGHT_PREFERENCES',
  REWARD_PROGRAM = 'REWARD_PROGRAM',
  TRAVELER_DOCUMENTS = 'TRAVELER_DOCUMENTS'
}

export interface UniversalProfilePhoneInput {
  countryCode?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  smsInfo?: InputMaybe<Scalars['Boolean']>;
}

export enum UniversalProfilePreferencesOptionType {
  COUNTRY = 'COUNTRY',
  CURRENCY = 'CURRENCY',
  DISPLAY_APPEARANCE = 'DISPLAY_APPEARANCE',
  LANGUAGE = 'LANGUAGE'
}

export enum UniversalProfileSettingsFormType {
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  UPDATE_COUNTRY = 'UPDATE_COUNTRY',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  UPDATE_LANGUAGE = 'UPDATE_LANGUAGE',
  UPDATE_PASSWORD = 'UPDATE_PASSWORD'
}

export interface UniversalProfileSmsContactInformationRequestInput {
  phone: UniversalProfilePhoneInput;
}

export enum UniversalProfileSubExperienceType {
  COMMUNICATION_PREFERENCES_EXPEDIA = 'COMMUNICATION_PREFERENCES_EXPEDIA',
  COMMUNICATION_PREFERENCES_HOTELS = 'COMMUNICATION_PREFERENCES_HOTELS',
  COMMUNICATION_PREFERENCES_VRBO = 'COMMUNICATION_PREFERENCES_VRBO',
  VISIT_HELP_CENTER = 'VISIT_HELP_CENTER'
}

/** Enum for holding values with reference to page stack history */
export enum UpdateHistory {
  REMOVE = 'REMOVE'
}

export interface UpdateInsurtechOfferRequestInput {
  cartId: Scalars['String'];
  /** list of covered offer tokens to be added to the main offer */
  coveredOfferTokens?: InputMaybe<Array<OfferIdentityInput>>;
  /** The offer token of the offer to be updated */
  offersToAdd: Array<OfferIdentityInput>;
  /** list of Covered offer item ids to be removed from the main offer */
  offersToRemove: Array<OfferIdentityInput>;
  /** Session Id */
  sessionIdentifier?: InputMaybe<Scalars['String']>;
  targetOfferIdentity: OfferIdentityInput;
}

export enum UpdateTripType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export interface UriAttributesInput {
  /**
   * Used to specify the GAIA feature TYPE
   * Example Value: Multi-City
   */
  gaiaType?: InputMaybe<Scalars['String']>;
  lodgingUrlCode?: InputMaybe<Scalars['String']>;
}

export enum UriClassification {
  CLASSIFICATION_DEALS = 'CLASSIFICATION_DEALS',
  CLASSIFICATION_INVALID = 'CLASSIFICATION_INVALID'
}

export interface UriContextAttributesInput {
  affinity?: InputMaybe<Scalars['String']>;
  airCarrierCode?: InputMaybe<Scalars['String']>;
  carClass?: InputMaybe<Scalars['String']>;
  carSupplier?: InputMaybe<Scalars['String']>;
  gaiaType?: InputMaybe<Scalars['String']>;
  lodgingUrlCode?: InputMaybe<Scalars['String']>;
  starRating?: InputMaybe<Scalars['String']>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars['String'];
  /** Only for PDP pages */
  hotelId?: InputMaybe<Scalars['Int']>;
  origin?: InputMaybe<Scalars['String']>;
}

/**
 * A context that can be used to retrieve targeted flex content
 * with combination of attributes and identifiers that uniquely identify a URI.
 */
export interface UriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes?: InputMaybe<UriAttributesInput>;
  /**
   * Specifies the labelled category of a URL
   * Example Value: CLASSIFICATION_DEALS
   * Values align with the UriContext proto definitions
   */
  classification?: InputMaybe<UriClassification>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value: 178279
   */
  destination?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel.
   * Example Value: ENTRY
   * Values do NOT align with the UriContext proto definitions
   */
  funnelLocation?: InputMaybe<PageLocation>;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers?: InputMaybe<UriIdentifiersInput>;
}

/** A identifiers list that can be used to uniquely identify a URI. */
export interface UriIdentifiersInput {
  /**
   * Used to specify the accommodation type.
   * Example Value: Apartments
   */
  accommodationType?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify airports city GAIA feature ID
   * Example Value: 178279
   */
  airport?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the brand.
   * Example Value: Travelodge UK
   */
  brand?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the car class.
   * Example Value: Economy
   */
  carClass?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the car supplier location ID (aka CVL ID).
   * Example Value: 12245
   */
  carSupplierLocation?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the carrier code.
   * Example Value: BA
   */
  carrierCode?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify vendor ID
   * Example Value: ET
   */
  company?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the cruise line ID
   * Example Value: CV
   */
  cruiseLine?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of destination
   * Example Value:
   */
  destination?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the discriminator for hotel landing pages
   * Example Value: ho
   */
  discriminator?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify current screen feature displayed to user
   * Example Value: reviews, lodgingDiscovery, destinationDiscovery
   */
  feature?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the flight route type
   * Example Value: open / fixed
   */
  flightRoute?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify current location of user in the conversion funnel
   * Example Value: entry
   */
  funnelLocation?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the hotel ID
   * Example Value: 1
   */
  hotel?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify hotel PCS ID for HCOM pages
   * Example Value: 456469
   */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the line of business
   * Example Value: flight
   */
  lineOfBusiness?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the type of lodging
   * Example Value: alternative
   */
  lodgingType?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the GAIA feature ID of origin
   * Example Value: 178286
   */
  origin?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the ship code of the ship
   * Example Value: AVW
   */
  ship?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the hotel's star rating
   * Source of truth is flex-hotels-service
   * Example Value: 5
   */
  starRating?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the hotel's theme
   * Source of truth is affinity prime
   * Example Value: romantic
   */
  theme?: InputMaybe<Scalars['String']>;
  /**
   * Used to specify the url mapping path, without leading '/'
   * Example Value: lp/deals
   */
  url?: InputMaybe<Scalars['String']>;
}

export interface UserContextInput {
  siteId: Scalars['Int'];
  tuid: Scalars['Int'];
}

export interface UserLocationInput {
  userCountryCode?: InputMaybe<Scalars['String']>;
  userLatitude?: InputMaybe<Scalars['BigDecimal']>;
  userLongitude?: InputMaybe<Scalars['BigDecimal']>;
  userSelectedOrigin?: InputMaybe<Scalars['String']>;
}

/** Represents the status of response */
export enum VirtualAgentCheckoutStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

/** Represents the virtual agent context */
export interface VirtualAgentContextInput {
  /** Represents the intended itinerary number to change */
  itineraryNumber: Scalars['String'];
  /** Represents the token which is used in exchange of information */
  opaqueToken: Scalars['String'];
}

/** Represents a new input type, used by the new mutation to send event data */
export interface VirtualAgentControlConversationEventInput {
  /** Represents a typing indicator event's content */
  typingIndicator?: InputMaybe<TypingIndicatorEventContentInput>;
}

/** Represents VAC input message data */
export interface VirtualAgentControlMessageInput {
  /** Represents intent associated with a message */
  intent?: InputMaybe<Scalars['String']>;
  /** Represents message trigger location - outside or within the chat window */
  messageTriggerLocation?: InputMaybe<VirtualAgentControlMessageTriggerLocation>;
  /** Represents type of a message - text, intent, postback, etc.  */
  messageType?: InputMaybe<VirtualAgentControlMessageType>;
  /** Represents an optional payload of message input */
  payload?: InputMaybe<Scalars['String']>;
  /** Represents the text of message input */
  text?: InputMaybe<Scalars['String']>;
  /** Represents a unique identifier on the UI */
  umid: Scalars['String'];
}

export enum VirtualAgentControlMessageTriggerLocation {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

export enum VirtualAgentControlMessageType {
  INTENT = 'INTENT',
  POSTBACK = 'POSTBACK',
  TEXT = 'TEXT'
}

export type AddPropertyToCartMutationVariables = Exact<{
  id: Scalars['UUID'];
  context: ContextInput;
  propertyOffer: PropertyOfferInput;
  cartPropertySearchContextInput: CartPropertySearchContextInput;
}>;


export type AddPropertyToCartMutation = { __typename: 'Mutation', cartItems: { __typename: 'CartMutations', addProperty: { __typename: 'CartSummary', id: any, itemCount: number } } };

export type CreateMultiItemSessionMutationVariables = Exact<{
  context: ContextInput;
  multiItemSearchContext: MultiItemSearchContextInput;
}>;


export type CreateMultiItemSessionMutation = { __typename: 'Mutation', createMultiItemSession: { __typename: 'MultiItemSearchContextCreatedResponse', shoppingContext: { __typename: 'ShoppingContext', multiItem?: { __typename: 'MultiItemContext', id: string, packageType: PackageType } | null } } | { __typename: 'MultiItemSearchContextErrorResponse' } };

export type CreateSessionCartMutationVariables = Exact<{
  context: ContextInput;
  cartOptions: CartOptionsInput;
}>;


export type CreateSessionCartMutation = { __typename: 'Mutation', createSessionCart: { __typename: 'Cart', id: any } };

export type EmptyCartMutationVariables = Exact<{
  context: ContextInput;
  id: Scalars['UUID'];
}>;


export type EmptyCartMutation = { __typename: 'Mutation', cartItems: { __typename: 'CartMutations', emptyCart: { __typename: 'CartSummary', id: any, itemCount: number } } };

export type FederatedCartQueryVariables = Exact<{
  context: ContextInput;
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type FederatedCartQuery = { __typename: 'Query', cart: { __typename: 'Cart', itemCount: number, items: Array<{ __typename: 'PropertyCartItem', id: any, offers: Array<{ __typename: 'PropertyOffer', offerIndex: number, naturalKeys: Array<{ __typename: 'PropertyNaturalKey', id: string, roomTypeId: string, ratePlanId: string, inventoryType: InventoryType, checkIn: { __typename: 'Date', isoFormat: string }, checkOut: { __typename: 'Date', isoFormat: string }, rooms: Array<{ __typename: 'PropertyRoom', numberOfAdults: number, childAges: Array<number> }> }> }> }> } };

export type CartQueryVariables = Exact<{
  context: ContextInput;
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type CartQuery = { __typename: 'Query', cart: { __typename: 'Cart', itemCount: number, items: Array<{ __typename: 'PropertyCartItem', id: any, offers: Array<{ __typename: 'PropertyOffer', offerIndex: number, naturalKeys: Array<{ __typename: 'PropertyNaturalKey', id: string, roomTypeId: string, ratePlanId: string, ratePlanType?: string | null, inventoryType: InventoryType, checkIn: { __typename: 'Date', isoFormat: string }, checkOut: { __typename: 'Date', isoFormat: string }, rooms: Array<{ __typename: 'PropertyRoom', numberOfAdults: number, childAges: Array<number> }> }>, offer?: { __typename: 'OfferDetails', marketingChannelId: number, units: Array<{ __typename: 'PropertyUnit', name?: string | null, photos: Array<{ __typename: 'Image', description: string, url: any }>, ratePlans: Array<{ __typename: 'RatePlan', priceDetails: Array<{ __typename: 'Offer', availability?: { __typename: 'PropertyAvailability', available: boolean, minRoomsLeft?: number | null } | null, offerBookButton?: { __typename: 'LodgingForm', inputs?: Array<{ __typename: 'LodgingTextInput', name?: string | null, value?: string | null }> | null } | null, price?: { __typename: 'PropertyPrice', total?: { __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } } | null, lead?: { __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } } | null } | null, priceAfterLoyaltyPointsApplied?: { __typename: 'PropertyPrice', total?: { __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } } | null, lead?: { __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } } | null } | null, fees: Array<{ __typename: 'Fees', description?: string | null }> }> }> }> } | null }>, summary?: { __typename: 'PropertySummary', name: string, location?: { __typename: 'PropertyLocation', address?: { __typename: 'PropertyAddress', city?: string | null } | null } | null } | null, gallery?: { __typename: 'PropertyGallery', featured?: { __typename: 'Image', url: any } | null } | null }> } };

export type InitiateMultiItemSessionMutationVariables = Exact<{
  context: ContextInput;
  searchContext: MultiItemSearchContextInput;
}>;


export type InitiateMultiItemSessionMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', initiate: { __typename: 'MultiItemSearchContextCreatedResponse', redirectUrl?: any | null, shoppingContext: { __typename: 'ShoppingContext', multiItem?: { __typename: 'MultiItemContext', id: string, packageType: PackageType } | null } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: string | null } } };

export type LodgingPwaPropertySearchQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  shoppingContext?: InputMaybe<ShoppingContextInput>;
  criteria?: InputMaybe<PropertySearchCriteriaInput>;
  includePropertyListing?: InputMaybe<Scalars['Boolean']>;
  returnPropertyType?: InputMaybe<Scalars['Boolean']>;
}>;


export type LodgingPwaPropertySearchQuery = { __typename: 'Query', propertySearch: { __typename: 'PropertySearchResults', propertyListingAdaptexAnalyticsSuccessEvents?: Array<{ __typename: 'LodgingAdaptExAnalyticsEvent', campaignId: string, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, eventType?: EGReferrerEventType | null, linkName: string } | null, events: Array<{ __typename: 'LodgingAdaptExEvent', eventType: string, eventTarget: string, banditDisplayed: boolean, payloadId: string }> }>, pagination?: { __typename: 'LodgingPagination', paginationLabel?: string | null, trigger?: { __typename: 'LodgingPaginationNavigationButtons', previousButton: { __typename: 'UIPrimaryButton', disabled: boolean, primary?: string | null, accessibility?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null, icon?: { __typename: 'Icon', token: string } | null }, nextButton: { __typename: 'UIPrimaryButton', disabled: boolean, primary?: string | null, accessibility?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null, icon?: { __typename: 'Icon', token: string } | null } } | { __typename: 'LodgingScrollTrigger', triggerAfterPosition?: number | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null } | { __typename: 'UIPrimaryButton', accessibility?: string | null, disabled: boolean, egdsElementId?: string | null, primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null, icon?: { __typename: 'Icon', description: string, id: string, title?: string | null } | null } | null, subSets?: { __typename: 'LodgingPaginationSubSets', nextSubSet?: { __typename: 'LodgingPaginationSubSet', size: number, startingIndex: number } | null, previousSubset?: { __typename: 'LodgingPaginationSubSet', size: number, startingIndex: number } | null } | null } | null, criteria: { __typename: 'PropertySearchCriteria', primary: { __typename: 'PrimaryPropertyCriteria', dateRange?: { __typename: 'PropertyDateRange', checkInDate: { __typename: 'Date', year: number, month: number, day: number }, checkOutDate: { __typename: 'Date', year: number, month: number, day: number } } | null, destination: { __typename: 'Destination', regionId?: string | null, regionName?: string | null }, rooms: Array<{ __typename: 'Room', adults: number, children?: Array<{ __typename: 'Child', age: number }> | null }>, flexSearchCriteria?: { __typename: 'FlexibleSearchCriteria', flexibility?: Array<{ __typename: 'DatePeriod', bound?: ClosedPeriodBounding | null, unit: DatePeriodUnit, length: number }> | null } | null }, secondary?: { __typename: 'ShoppingSearchCriteria', booleans?: Array<{ __typename: 'BooleanValue', id: string, value: boolean }> | null, counts?: Array<{ __typename: 'NumberValue', id: string, value: number }> | null, dates?: Array<{ __typename: 'DateValue', id: string, value: { __typename: 'Date', year: number, month: number, day: number } }> | null, ranges?: Array<{ __typename: 'RangeValue', id: string, max: number, min: number }> | null, selections?: Array<{ __typename: 'SelectedValue', id: string, value: string }> | null } | null }, propertySearchListings?: Array<{ __typename: 'EGDSStandardMessagingCard', heading?: string | null, egdsElementId?: string | null, message: string, graphic?: { __typename: 'Icon' } | { __typename: 'Illustration', description: string, link: any } | { __typename: 'Mark' } | null, links?: Array<{ __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: string | null, useRelativePath: boolean, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } }> | null, impressionTracking?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null } | { __typename: 'FlexibleDateSearchCard' } | { __typename: 'LodgingCard', id: string, featuredHeader?: { __typename: 'LodgingCardFeaturedHeader', header: { __typename: 'EGDSHeading', text: string } } | null, cardLink?: { __typename: 'UILinkAction', accessibility?: string | null, useRelativePath: boolean, target: UILinkTarget, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } } | null, summarySections: Array<{ __typename: 'LodgingCardProductSummarySection', heading?: { __typename: 'EGDSHeading', text: string } | null, amenities: Array<{ __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } }>, messages: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, descriptionSection?: { __typename: 'LodgingCardPropertyDescriptionSection', heading?: { __typename: 'EGDSHeading', text: string } | null, description?: { __typename: 'EGDSParagraph', text: string } | null, link?: { __typename: 'EGDSStandardLink', action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | null } | null, changeActionDialog?: { __typename: 'LodgingCardChangeUnitDialogAction', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, changeActionSheet?: { __typename: 'LodgingCardChangeUnitSheetAction', sheet: { __typename: 'EGDSSheet', closeText?: string | null, closeAnalytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, detailsAction?: { __typename: 'LodgingCardPropertyDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | { __typename: 'LodgingCardUnitDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, guestRating?: { __typename: 'LodgingCardPhrase', accessibilityLabel: string, parts: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, phraseParts: Array<{ __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText' }> } | null, guestRatingSection?: { __typename: 'LodgingCardBadgedRating', badge: { __typename: 'EGDSBadgeNotification', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null }, phrases?: Array<{ __typename: 'LodgingCardPhrase', phraseParts: Array<{ __typename: 'EGDSIconRating' } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> }> | null } | { __typename: 'LodgingCardPhrase', accessibilityLabel: string, parts: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, phraseParts: Array<{ __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> } | null, footerMessages?: { __typename: 'EGDSBulletedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | { __typename: 'EGDSOrderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | { __typename: 'EGDSTextIconList', listItems: Array<{ __typename: 'EGDSTextIconListItem' }> } | { __typename: 'EGDSUnorderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | null }>, headingSection?: { __typename: 'LodgingCardHeadingSection', heading: string, productRating?: { __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', id: string } } | { __typename: 'PropertyRating', accessibility?: string | null, rating: number } | { __typename: 'PropertyStarRating', accessibility?: string | null, rating: number } | null, featuredMessages: Array<{ __typename: 'LodgingCardFeaturedMessage', text: string, icon?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | null }>, messages: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, amenities: Array<{ __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } }> } | null, footerActions: Array<{ __typename: 'LodgingCardLinkAction', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } }, icon?: { __typename: 'Icon', id: string } | null } }>, mediaSection: { __typename: 'LodgingCardMediaSection', gallery?: { __typename: 'LodgingGalleryCarousel', accessibilityHeadingText: string, nextButtonText?: string | null, previousButtonText?: string | null, navClickAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, intersectionAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, media: Array<{ __typename: 'LodgingMediaItem', id?: string | null, trackingId?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', description: string, url: any, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'Video' } }> } | null, badges?: { __typename: 'LodgingBadgesGroup', primaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, secondaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, tertiaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null } | null, saveItem?: { __typename: 'LodgingSaveItem', initialChecked: boolean, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, items: Array<{ __typename: 'LodgingSaveItemItem', itemId: string }>, labels?: { __typename: 'LodgingSaveItemLabels', removeLabel?: string | null, saveLabel?: string | null } | null, messages?: { __typename: 'LodgingSaveItemMessages', removeMessage?: string | null, saveMessage?: string | null } | null } | null, saveTripItem?: { __typename: 'TripsSaveItem', initialChecked: boolean, itemId: string, source: PageLocation, save: { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null }, remove: { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null }, attributes?: { __typename: 'TripsSaveActivityAttributes', regionId?: string | null, dateRange?: { __typename: 'DateRange', start: { __typename: 'Date', year: number, month: number, day: number }, end: { __typename: 'Date', year: number, month: number, day: number } } | null } | { __typename: 'TripsSaveFlightSearchAttributes' } | { __typename: 'TripsSaveStayAttributes', regionId?: string | null, roomConfiguration?: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> | null, checkInDate?: { __typename: 'Date', year: number, month: number, day: number } | null, checkoutDate?: { __typename: 'Date', year: number, month: number, day: number } | null } | null } | null }, dateSection?: { __typename: 'LodgingCardDateSection', date?: { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | null } | null, compareSection?: { __typename: 'LodgingCardCompareSection', compareAction: { __typename: 'EGDSBasicCheckBox', label: { __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSGraphicText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } } } | null, callOut?: { __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' } | null, priceSection?: { __typename: 'LodgingCardPriceSection', priceSummary?: { __typename: 'PropertyPrice', displayMessages?: Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<{ __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: string | null }, disclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: { __typename: 'UIPrimaryButton', accessibility?: string | null, primary?: string | null } | null } | null } | { __typename: 'LodgingEnrichedMessage', value: string, state?: string | null }> }> | null, options?: Array<{ __typename: 'PropertyPriceOption', leadingCaption?: string | null, accessibilityLabel?: string | null, displayPrice?: { __typename: 'Money', formatted: string } | null, disclaimer?: { __typename: 'LodgingPlainMessage', value: string } | null, priceDisclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryButton?: { __typename: 'LodgingButton', text: string } | null, trigger: { __typename: 'LodgingDialogTriggerMessage', icon?: { __typename: 'Icon', description: string } | null } } | null, strikeOut?: { __typename: 'Money', formatted: string } | null, loyaltyPrice?: { __typename: 'LoyaltyPrice', unit?: string | null, amount?: { __typename: 'FormattedNumber', formatted: string } | null, totalStrikeOutPoints?: { __typename: 'FormattedNumber', formatted: string } | null } | null }> | null, priceMessaging?: Array<{ __typename: 'LodgingEnrichedMessage', value: string, theme?: LodgingMessageTheme | null }> | null, marketingFeeDetails?: { __typename: 'MarketingFeeDetails', tierMessage: { __typename: 'LodgingEnrichedMessage', accessibilityLabel?: string | null, value: string, egdsMark?: { __typename: 'Mark', id: string } | null }, marketingFeeMessageDialog?: { __typename: 'LodgingBasicContentActionDialog', content: Array<string>, dialog: { __typename: 'EGDSActionDialog', footer: { __typename: 'EGDSInlineDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null } | { __typename: 'FlightsActionButton', primary?: string | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null } | { __typename: 'ServicingButton', primary?: string | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null } | { __typename: 'UIPrimaryButton', primary?: string | null } | { __typename: 'UISecondaryButton', primary?: string | null } | { __typename: 'UITertiaryButton', primary?: string | null }> } | { __typename: 'EGDSStackedDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null } | { __typename: 'FlightsActionButton', primary?: string | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null } | { __typename: 'ServicingButton', primary?: string | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null } | { __typename: 'UIPrimaryButton', primary?: string | null } | { __typename: 'UISecondaryButton', primary?: string | null } | { __typename: 'UITertiaryButton', primary?: string | null }> } } } | null } | null } | null, badge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, standardBadge?: { __typename: 'LodgingStandardBadge', standardBadge: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null }, impressionEventAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', referrerId: string, linkName?: string | null, event: string } | null } | null, button?: { __typename: 'LodgingPrimaryAltButton', accessibility?: string | null, disabled: boolean, primary?: string | null, action?: { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, icon?: { __typename: 'Icon', description: string, id: string } | null, attemptEvents: Array<{ __typename: 'LodgingAdaptExAnalyticsEvent', campaignId: string, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, eventType?: EGReferrerEventType | null, referrerId: string } | null, events: Array<{ __typename: 'LodgingAdaptExEvent', eventType: string, eventTarget: string, banditDisplayed: boolean, payloadId: string }> }>, successEvents: Array<{ __typename: 'LodgingAdaptExAnalyticsEvent', campaignId: string, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, eventType?: EGReferrerEventType | null, referrerId: string } | null, events: Array<{ __typename: 'LodgingAdaptExEvent', eventType: string, eventTarget: string, banditDisplayed: boolean, payloadId: string }> }>, adaptexSuccessActionTracking?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null } | null } | null, clickstreamEvents: { __typename: 'LodgingCardClickstreamEvents', productPresented?: { __typename: 'LodgingProductEvent', event: { __typename: 'EGClickstreamEvent', eventCategory: string, eventName: string, eventType: string, eventVersion: string }, product_list: Array<{ __typename: 'LodgingProduct', product_id: string }>, search_request: { __typename: 'LodgingSearchRequest', search_id: string } } | null, productSelected?: { __typename: 'LodgingProductEvent', event: { __typename: 'EGClickstreamEvent', eventCategory: string, eventName: string, eventType: string, eventVersion: string }, product_list: Array<{ __typename: 'LodgingProduct', product_id: string }>, search_request: { __typename: 'LodgingSearchRequest', search_id: string } } | null }, impressionAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', url?: any | null, referrerId: string, linkName?: string | null, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessActionTracking?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null } | { __typename: 'LodgingHeading', value: string } | { __typename: 'LodgingIntentCard', headingTitle: string, cardMessage?: string | null, gallery: { __typename: 'LodgingGalleryCarousel', media: Array<{ __typename: 'LodgingMediaItem', id?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', url: any, description: string, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null } | { __typename: 'Video' } }> }, primaryButton: { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'ActivityAddOfferToTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityCloseDialogAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityOpenDialogAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityOpenOffersModalAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityPaginationAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityRemoveOffersFromTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityUpdateOfferInTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'AgencyQuoteAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'AirCreditWebAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponAndCreditAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponAndCreditChatbotAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponsAndCreditsSimpleAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CrossSellButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CrossSellLinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CruiseAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenPreviousPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSOpenDatePickerAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSOpenTravelerSelectorAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSSubmitSearchFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsCreditSelectorOpenUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsDialogCloseUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsDialogTriggerUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersBookAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersDetailsOpenAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersDismissAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersLinkClickAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersSelectionClickAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MemberWalletBadge', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MemberWalletUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MishopDetailsUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUIButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'OpenTypeaheadAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentDialogElement', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PriceInsightsExistingDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAccountFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAddMembershipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAddPassportAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileLinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileReloadAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileRewardProgramFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileUpdateMembershipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileUpdatePassportAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'QuoteAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ShoppingSortAndFilterAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'SupplyNavigationHeaderSearchTrigger', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'TripsRetryOperationAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'UIFlightAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'WizardAdditionalUserInputRequiredAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'WizardSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | null }, impressionAnalyticsTracking: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string } } | { __typename: 'LodgingListingDivider', backgroundTheme?: string | null, title?: { __typename: 'EGDSHeading', headingType?: EGDSHeadingStyle | null, titleText: string } | null, subtitle?: { __typename: 'EGDSBasicLocalizedText', subtitleText: string } | { __typename: 'EGDSCardinalLocalizedText', subtitleText: string } | { __typename: 'EGDSCompositeLocalizedText', subtitleText: string } | { __typename: 'EGDSGraphicText', subtitleText: string } | { __typename: 'EGDSHeading', subtitleText: string } | { __typename: 'EGDSIconText', subtitleText: string } | { __typename: 'EGDSInlineLink', subtitleText: string } | { __typename: 'EGDSLocalizedTextTemplate', subtitleText: string } | { __typename: 'EGDSParagraph', subtitleText: string } | { __typename: 'EGDSPlainText', subtitleText: string } | { __typename: 'EGDSSpannableText', subtitleText: string } | { __typename: 'EGDSStandardLink', subtitleText: string } | { __typename: 'EGDSStylizedText', subtitleText: string } | { __typename: 'EGDSTextIconLinkListItem', subtitleText: string } | { __typename: 'EGDSTextIconListItem', subtitleText: string } | { __typename: 'EGDSTextStandardListItem', subtitleText: string } | { __typename: 'EGDSTextWithMarkListItem', subtitleText: string } | null, graphic?: { __typename: 'Icon', description: string, id: string, theme?: IconTheme | null, title?: string | null, withBackground?: boolean | null, iconSize?: IconSize | null } | { __typename: 'Illustration', description: string, url: any, id: string } | { __typename: 'Mark', description: string, size?: string | null, id: string, markUrl?: { __typename: 'HttpURI', relativePath: string, value: string } | null } | null, impressionAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string } | null } | { __typename: 'LodgingSurveyTrigger' } | { __typename: 'MessageResult', footerText?: string | null, type?: MessageType | null, title?: { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null } | null, subtitle?: { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null } | null, action?: { __typename: 'MessagingResultAction', primary?: { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null, secondary?: { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null } | null } | { __typename: 'Property' } | { __typename: 'PropertyListingsIconTextExpando', graphic?: { __typename: 'Icon' } | { __typename: 'Illustration', description: string, id: string, link: any } | { __typename: 'Mark' } | null, expandoCard?: { __typename: 'EGDSExpandoCard', collapsedLabel: string, expandedLabel: string, expanded: boolean, subtitle?: string | null, expandAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, collapseAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null } | null, expandedContent?: Array<{ __typename: 'EGDSGraphicText', text: string, graphic: { __typename: 'Icon', id: string, description: string, token: string, size?: IconSize | null, theme?: IconTheme | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } }> | null } | { __typename: 'PropertySearchListingPlaceholder', loadingComponent: string } | { __typename: 'PropertySearchListingsOverfilteredCard', cardContent?: { __typename: 'EGDSStandardMessagingCard', heading?: string | null, message: string, graphic?: { __typename: 'Icon', description: string, id: string, withBackground?: boolean | null, iconSize?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null } | null, action?: { __typename: 'LodgingLinkButton', button: { __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'FlightsActionButton' } | { __typename: 'FlightsDialogTrigger' } | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsSmartShoppingActionButton' } | { __typename: 'PackageUIActionDialogFooterButton' } | { __typename: 'PackageUIHideSearchFormAction' } | { __typename: 'PackageUITravelGuideButton' } | { __typename: 'ServicingButton' } | { __typename: 'SupplyCancelWaiverActionButton' } | { __typename: 'SupplyContentLinkStyleButton' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UISecondaryButton', accessibility?: string | null, disabled: boolean, primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UITertiaryButton' }, action?: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | null } | null, impressionAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string, linkName?: string | null } | null, filterPills?: Array<{ __typename: 'BasicShoppingAppliedFilter', filter?: { __typename: 'EGDSBasicPill' } | { __typename: 'EGDSBasicRemovablePill', primary?: string | null, accessibility?: string | null, name?: string | null, value?: string | null, remove?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null, removeAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'EGDSBasicTriggerPill' } | null, linkUrl?: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | null } | { __typename: 'ShoppingSelectedFilter' }> | null } | { __typename: 'PropertySearchListingsSoldOutCard', cardContent?: { __typename: 'EGDSStandardMessagingCard', heading?: string | null, graphic?: { __typename: 'Icon', description: string, id: string, theme?: IconTheme | null, title?: string | null, withBackground?: boolean | null, iconSize?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null } | null, actionButton?: { __typename: 'EGDSOverlayButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsActionButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'ServicingButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UISecondaryButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UITertiaryButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null, analytics?: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string, linkName?: string | null } | null } | { __typename: 'SponsoredContentPlacement', productType: SponsoredContentProductType, sponsoredContentContext: { __typename: 'SponsoredContentContext', pageName: string, variant?: string | null, sponsoredContentId: string, targeting?: { __typename: 'SponsoredContentTargeting', adults?: number | null, kids?: number | null, origin?: string | null, destination?: string | null, locationResolver?: SponsoredContentLocationResolver | null, dateStart?: { __typename: 'Date', day: number, month: number, year: number } | null, dateEnd?: { __typename: 'Date', day: number, month: number, year: number } | null } | null } } | { __typename: 'StaticLodgingMultiItemCrossSell', crossSellProductType: LodgingCrossSellProductType, multiItemSearchContext: { __typename: 'MultiItemSearchContext', properties?: Array<{ __typename: 'PropertySearchCriteria', primary: { __typename: 'PrimaryPropertyCriteria', dateRange?: { __typename: 'PropertyDateRange', checkInDate: { __typename: 'Date', year: number, month: number, day: number }, checkOutDate: { __typename: 'Date', year: number, month: number, day: number } } | null, destination: { __typename: 'Destination', pinnedPropertyId?: string | null, propertyIds?: Array<string> | null, regionId?: string | null, regionName?: string | null, coordinates?: { __typename: 'Coordinates', latitude: number, longitude: number } | null, mapBounds?: Array<{ __typename: 'Coordinates', latitude: number, longitude: number }> | null }, rooms: Array<{ __typename: 'Room', adults: number, children?: Array<{ __typename: 'Child', age: number }> | null }> }, secondary?: { __typename: 'ShoppingSearchCriteria', booleans?: Array<{ __typename: 'BooleanValue', id: string, value: boolean }> | null, counts?: Array<{ __typename: 'NumberValue', id: string, value: number }> | null, dates?: Array<{ __typename: 'DateValue', id: string, value: { __typename: 'Date', year: number, month: number, day: number } }> | null, ranges?: Array<{ __typename: 'RangeValue', id: string, max: number, min: number }> | null, selections?: Array<{ __typename: 'SelectedValue', id: string, value: string }> | null } | null }> | null }, fallbackListing?: { __typename: 'MessageResult', footerText?: string | null, type?: MessageType | null, title?: { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null } | null, subtitle?: { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null } | null, action?: { __typename: 'MessagingResultAction', primary?: { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null, secondary?: { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null } | null } | null }>, summary: { __typename: 'PropertyResultsSummary', matchedPropertiesSize: number, resultsHeading?: string | null, resultMessages: Array<{ __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink', text: string, egdsElementId?: string | null, disabled: boolean, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, title?: string | null, token: string, withBackground?: boolean | null } | null, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, useRelativePath: boolean, analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } }>, loyaltyInfo: { __typename: 'PropertyLoyaltyDiscount', pointsAppliedMessage?: string | null, saveWithPointsMessage?: string | null, saveWithPointsActionMessage?: string | null } }, shoppingContext?: { __typename: 'ShoppingContext', multiItem?: { __typename: 'MultiItemContext', id: string, packageType: PackageType } | null } | null, multiItemSearchContext?: { __typename: 'MultiItemSearchContext', cars?: Array<{ __typename: 'CarSearchCriteria', primary: { __typename: 'PrimaryCarCriteria', pickUpDateTime: { __typename: 'DateTime', year: number, month: number, day: number, hour: number, minute: number, second: number }, dropOffDateTime: { __typename: 'DateTime', year: number, month: number, day: number, hour: number, minute: number, second: number }, pickUpLocation: { __typename: 'CarRentalLocation', airportCode?: string | null }, dropOffLocation?: { __typename: 'CarRentalLocation', airportCode?: string | null } | null } }> | null, flights?: Array<{ __typename: 'FlightSearchCriteria', primary: { __typename: 'PrimaryFlightCriteria', tripType: FlightsTripType, travelers: Array<{ __typename: 'TravelerDetails', type: TravelerDetailsType, age?: number | null }>, journeyCriterias: Array<{ __typename: 'FlightsJourneyCriteria', destination: string, origin: string, departureDate: { __typename: 'Date', day: number, month: number, year: number } }>, searchPreferences?: { __typename: 'FlightsSearchPreferences', airline?: string | null, advancedFilters?: Array<FlightsAdvancedFilterType> | null, cabinClass: FlightsCabinClass } | null } }> | null, properties?: Array<{ __typename: 'PropertySearchCriteria', primary: { __typename: 'PrimaryPropertyCriteria', rooms: Array<{ __typename: 'Room', adults: number }>, destination: { __typename: 'Destination', regionId?: string | null, regionName?: string | null }, dateRange?: { __typename: 'PropertyDateRange', checkInDate: { __typename: 'Date', year: number, month: number, day: number }, checkOutDate: { __typename: 'Date', year: number, month: number, day: number } } | null } }> | null } | null, errorResponse?: { __typename: 'LodgingErrorResponse', header?: string | null, body?: string | null, icon?: { __typename: 'Icon', description: string, id: string } | null, button: { __typename: 'UIPrimaryButton', primary?: string | null, disabled: boolean, action?: { __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AgencyQuoteAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackOpenPreviousPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' } | { __typename: 'PriceInsightsExistingDialogButtonAction' } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileAddPassportAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileRewardProgramFormAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'ProfileUpdatePassportAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'SupplyNavigationHeaderSearchTrigger' } | { __typename: 'TripsRetryOperationAction' } | { __typename: 'UIFlightAction' } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' } | null }, errorRecoveryButtons?: Array<{ __typename: 'UITertiaryButton', primary?: string | null, disabled: boolean, action?: { __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AgencyQuoteAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackOpenPreviousPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' } | { __typename: 'PriceInsightsExistingDialogButtonAction' } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileAddPassportAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileRewardProgramFormAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'ProfileUpdatePassportAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'SupplyNavigationHeaderSearchTrigger' } | { __typename: 'TripsRetryOperationAction' } | { __typename: 'UIFlightAction' } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' } | null }> | null } | null, dialogErrorResponse?: { __typename: 'LodgingDialogErrorResponse', body: string, button: { __typename: 'UIPrimaryButton', primary?: string | null, disabled: boolean, action?: { __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AgencyQuoteAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackOpenPreviousPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction' } | { __typename: 'PriceInsightsExistingDialogButtonAction' } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileAddPassportAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileRewardProgramFormAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'ProfileUpdatePassportAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'SupplyNavigationHeaderSearchTrigger' } | { __typename: 'TripsRetryOperationAction' } | { __typename: 'UIFlightAction' } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' } | null } } | null, mapTrigger: { __typename: 'LodgingMapTrigger', label?: string | null, icon?: { __typename: 'Icon', id: string, title?: string | null, token: string } | null, small?: { __typename: 'Image', description: string, url: any } | null, medium?: { __typename: 'Image', description: string, url: any } | null, large?: { __typename: 'Image', description: string, url: any } | null, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null } } };

export type MapTriggerFragmentFragment = { __typename: 'LodgingMapTrigger', label?: string | null, icon?: { __typename: 'Icon', id: string, title?: string | null, token: string } | null, small?: { __typename: 'Image', description: string, url: any } | null, medium?: { __typename: 'Image', description: string, url: any } | null, large?: { __typename: 'Image', description: string, url: any } | null, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null };

export type MultiItemPropertySearchContextFieldsFragment = { __typename: 'MultiItemSearchContext', properties?: Array<{ __typename: 'PropertySearchCriteria', primary: { __typename: 'PrimaryPropertyCriteria', rooms: Array<{ __typename: 'Room', adults: number }>, destination: { __typename: 'Destination', regionId?: string | null, regionName?: string | null }, dateRange?: { __typename: 'PropertyDateRange', checkInDate: { __typename: 'Date', year: number, month: number, day: number }, checkOutDate: { __typename: 'Date', year: number, month: number, day: number } } | null } }> | null };

export type MessageFieldsFragment = { __typename: 'MessageResult', footerText?: string | null, type?: MessageType | null, title?: { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null } | null, subtitle?: { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null } | null, action?: { __typename: 'MessagingResultAction', primary?: { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null, secondary?: { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null } | null };

export type MessageTitleFieldsFragment = { __typename: 'MessagingResultTitle', text?: string | null, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, spotLight?: IconSpotLight | null } | null, egdsMark?: { __typename: 'Mark', id: string, description: string, url?: { __typename: 'HttpURI', value: string } | null } | null, illustration?: { __typename: 'LodgingIllustration', description?: string | null, assetUri?: { __typename: 'HttpURI', value: string } | null } | null };

export type MessagingActionFieldsFragment = { __typename: 'MessagingAction', linkUrl: string, referrerId?: string | null, text?: string | null, actionDetails?: { __typename: 'ActionDetails', action: string, details?: string | null, name: ActionDetailsType, title?: string | null, accessibilityLabel?: string | null } | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null };

export type LodgingIntentCardFieldsFragment = { __typename: 'LodgingIntentCard', headingTitle: string, cardMessage?: string | null, gallery: { __typename: 'LodgingGalleryCarousel', media: Array<{ __typename: 'LodgingMediaItem', id?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', url: any, description: string, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null } | { __typename: 'Video' } }> }, primaryButton: { __typename: 'UIPrimaryButton', primary?: string | null, action?: { __typename: 'ActivityAddOfferToTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityCloseDialogAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityOpenDialogAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityOpenOffersModalAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityPaginationAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityRemoveOffersFromTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityUpdateOfferInTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'AgencyQuoteAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'AirCreditWebAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponAndCreditAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponAndCreditChatbotAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponsAndCreditsSimpleAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CrossSellButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CrossSellLinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CruiseAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenPreviousPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSOpenDatePickerAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSOpenTravelerSelectorAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSSubmitSearchFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsCreditSelectorOpenUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsDialogCloseUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsDialogTriggerUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersBookAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersDetailsOpenAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersDismissAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersLinkClickAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersSelectionClickAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MemberWalletBadge', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MemberWalletUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MishopDetailsUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUIButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'OpenTypeaheadAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentDialogElement', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PriceInsightsCardDisclaimerToolTipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PriceInsightsExistingDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PriceInsightsRetryTrackingDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAccountFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAddMembershipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAddPassportAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileLinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileReloadAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileRewardProgramFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileUpdateMembershipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileUpdatePassportAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'QuoteAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ShoppingSortAndFilterAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'SupplyNavigationHeaderSearchTrigger', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'TripsRetryOperationAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'UIFlightAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'WizardAdditionalUserInputRequiredAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'WizardSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | null }, impressionAnalyticsTracking: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string } };

export type DisplayPriceFragmentFragment = { __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: string | null }, disclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: { __typename: 'UIPrimaryButton', accessibility?: string | null, primary?: string | null } | null } | null };

export type EnrichedMessageFragmentFragment = { __typename: 'LodgingEnrichedMessage', value: string, state?: string | null };

export type CommonPropertyCardFieldsFragment = { __typename: 'Property', id: string, name: string, vipMessaging?: string | null, propertyImage?: { __typename: 'PropertyImage', image: { __typename: 'Image', description: string, url: any }, fallbackImage?: { __typename: 'Image', description: string, url: any } | null } | null, offerBadge?: { __typename: 'OfferBadge', primary?: { __typename: 'Badge', text?: string | null, theme_temp?: Theme | null, icon_temp?: { __typename: 'Icon', id: string, description: string, title?: string | null } | null, mark?: { __typename: 'Mark', id: string, description: string } | null } | null, secondary?: { __typename: 'Badge', text?: string | null, theme_temp?: Theme | null, icon_temp?: { __typename: 'Icon', id: string, description: string, title?: string | null } | null, mark?: { __typename: 'Mark', id: string, description: string } | null } | null, tertiary?: { __typename: 'Badge', text?: string | null, theme_temp?: Theme | null, icon_temp?: { __typename: 'Icon', id: string, description: string, title?: string | null } | null, mark?: { __typename: 'Mark', id: string, description: string } | null } | null } | null, price?: { __typename: 'PropertyPrice', strikeOutType?: StrikeOutType | null, roomNightMessage?: string | null, displayMessages?: Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<{ __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: string | null }, disclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: { __typename: 'UIPrimaryButton', accessibility?: string | null, primary?: string | null } | null } | null } | { __typename: 'LodgingEnrichedMessage', value: string, state?: string | null }> }> | null, lead?: { __typename: 'Money', formatted: string } | null, strikeOut?: { __typename: 'Money', formatted: string } | null, disclaimer?: { __typename: 'LodgingPlainMessage', value: string } | null, priceMessages?: Array<{ __typename: 'LodgingPlainMessage', value: string }> | null, marketingFeeDetails?: { __typename: 'MarketingFeeDetails', tierName: string, tierIcon: string, marketingFeeMessage: { __typename: 'LodgingPlainMessage', value: string } } | null, options?: Array<{ __typename: 'PropertyPriceOption', leadingCaption?: string | null, displayPrice?: { __typename: 'Money', formatted: string } | null, strikeOut?: { __typename: 'Money', formatted: string } | null, loyaltyPrice?: { __typename: 'LoyaltyPrice', unit?: string | null, amount?: { __typename: 'FormattedNumber', formatted: string } | null, totalStrikeOutPoints?: { __typename: 'FormattedNumber', formatted: string } | null } | null, disclaimer?: { __typename: 'LodgingPlainMessage', value: string } | null }> | null } | null, reviews: { __typename: 'PropertyReviewsSummary', scoreDenominator: number, score?: number | null, localizedScore?: string | null, total?: number | null, localizedTotal?: string | null, superlative?: string | null, localizedSubtitle?: string | null, localizedSubtitleA11y?: { __typename: 'LodgingEnrichedMessage', accessibilityLabel?: string | null, value: string } | null, mark?: { __typename: 'LodgingMark', id: string, description: string } | null }, destinationInfo: { __typename: 'PropertyDestinationInfo', distanceFromMessaging?: string | null }, propertyDetailsLink?: { __typename: 'LodgingLink', uri: { __typename: 'HttpURI', value: string, relativePath: string }, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null, sponsoredListing?: { __typename: 'SponsoredListing', id?: string | null, clickRedirectTrackingUrl?: any | null, clickTrackingUrl?: any | null, details?: string | null, detailsHeadline?: string | null, hotelImage?: string | null, impressionTrackingUrl?: any | null, trackingData?: string | null, brand?: string | null, clickRedirectLinkoffTrackingUrl?: any | null, logo?: string | null, lotagline?: string | null, rating?: string | null, slots?: string | null, vanityUrl?: any | null, rank?: string | null, position?: string | null } | null };

export type CommonDateFieldsFragment = { __typename: 'Date', year: number, month: number, day: number };

export type CommonDateTimeFieldsFragment = { __typename: 'DateTime', year: number, month: number, day: number, hour: number, minute: number, second: number };

export type featuredMessageFragment = { __typename: 'LodgingEnrichedMessage', value: string, icon?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | null };

export type LodgingCardFieldsFragment = { __typename: 'LodgingCard', id: string, featuredHeader?: { __typename: 'LodgingCardFeaturedHeader', header: { __typename: 'EGDSHeading', text: string } } | null, cardLink?: { __typename: 'UILinkAction', accessibility?: string | null, useRelativePath: boolean, target: UILinkTarget, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } } | null, summarySections: Array<{ __typename: 'LodgingCardProductSummarySection', heading?: { __typename: 'EGDSHeading', text: string } | null, amenities: Array<{ __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } }>, messages: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, descriptionSection?: { __typename: 'LodgingCardPropertyDescriptionSection', heading?: { __typename: 'EGDSHeading', text: string } | null, description?: { __typename: 'EGDSParagraph', text: string } | null, link?: { __typename: 'EGDSStandardLink', action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | null } | null, changeActionDialog?: { __typename: 'LodgingCardChangeUnitDialogAction', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, changeActionSheet?: { __typename: 'LodgingCardChangeUnitSheetAction', sheet: { __typename: 'EGDSSheet', closeText?: string | null, closeAnalytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, detailsAction?: { __typename: 'LodgingCardPropertyDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | { __typename: 'LodgingCardUnitDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, guestRating?: { __typename: 'LodgingCardPhrase', accessibilityLabel: string, parts: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, phraseParts: Array<{ __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText' }> } | null, guestRatingSection?: { __typename: 'LodgingCardBadgedRating', badge: { __typename: 'EGDSBadgeNotification', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null }, phrases?: Array<{ __typename: 'LodgingCardPhrase', phraseParts: Array<{ __typename: 'EGDSIconRating' } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> }> | null } | { __typename: 'LodgingCardPhrase', accessibilityLabel: string, parts: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, phraseParts: Array<{ __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> } | null, footerMessages?: { __typename: 'EGDSBulletedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | { __typename: 'EGDSOrderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | { __typename: 'EGDSTextIconList', listItems: Array<{ __typename: 'EGDSTextIconListItem' }> } | { __typename: 'EGDSUnorderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | null }>, headingSection?: { __typename: 'LodgingCardHeadingSection', heading: string, productRating?: { __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', id: string } } | { __typename: 'PropertyRating', accessibility?: string | null, rating: number } | { __typename: 'PropertyStarRating', accessibility?: string | null, rating: number } | null, featuredMessages: Array<{ __typename: 'LodgingCardFeaturedMessage', text: string, icon?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | null }>, messages: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, amenities: Array<{ __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } }> } | null, footerActions: Array<{ __typename: 'LodgingCardLinkAction', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } }, icon?: { __typename: 'Icon', id: string } | null } }>, mediaSection: { __typename: 'LodgingCardMediaSection', gallery?: { __typename: 'LodgingGalleryCarousel', accessibilityHeadingText: string, nextButtonText?: string | null, previousButtonText?: string | null, navClickAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, intersectionAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, media: Array<{ __typename: 'LodgingMediaItem', id?: string | null, trackingId?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', description: string, url: any, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'Video' } }> } | null, badges?: { __typename: 'LodgingBadgesGroup', primaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, secondaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, tertiaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null } | null, saveItem?: { __typename: 'LodgingSaveItem', initialChecked: boolean, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, items: Array<{ __typename: 'LodgingSaveItemItem', itemId: string }>, labels?: { __typename: 'LodgingSaveItemLabels', removeLabel?: string | null, saveLabel?: string | null } | null, messages?: { __typename: 'LodgingSaveItemMessages', removeMessage?: string | null, saveMessage?: string | null } | null } | null, saveTripItem?: { __typename: 'TripsSaveItem', initialChecked: boolean, itemId: string, source: PageLocation, save: { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null }, remove: { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null }, attributes?: { __typename: 'TripsSaveActivityAttributes', regionId?: string | null, dateRange?: { __typename: 'DateRange', start: { __typename: 'Date', year: number, month: number, day: number }, end: { __typename: 'Date', year: number, month: number, day: number } } | null } | { __typename: 'TripsSaveFlightSearchAttributes' } | { __typename: 'TripsSaveStayAttributes', regionId?: string | null, roomConfiguration?: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> | null, checkInDate?: { __typename: 'Date', year: number, month: number, day: number } | null, checkoutDate?: { __typename: 'Date', year: number, month: number, day: number } | null } | null } | null }, dateSection?: { __typename: 'LodgingCardDateSection', date?: { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | null } | null, compareSection?: { __typename: 'LodgingCardCompareSection', compareAction: { __typename: 'EGDSBasicCheckBox', label: { __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSGraphicText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } } } | null, callOut?: { __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' } | null, priceSection?: { __typename: 'LodgingCardPriceSection', priceSummary?: { __typename: 'PropertyPrice', displayMessages?: Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<{ __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: string | null }, disclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: { __typename: 'UIPrimaryButton', accessibility?: string | null, primary?: string | null } | null } | null } | { __typename: 'LodgingEnrichedMessage', value: string, state?: string | null }> }> | null, options?: Array<{ __typename: 'PropertyPriceOption', leadingCaption?: string | null, accessibilityLabel?: string | null, displayPrice?: { __typename: 'Money', formatted: string } | null, disclaimer?: { __typename: 'LodgingPlainMessage', value: string } | null, priceDisclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryButton?: { __typename: 'LodgingButton', text: string } | null, trigger: { __typename: 'LodgingDialogTriggerMessage', icon?: { __typename: 'Icon', description: string } | null } } | null, strikeOut?: { __typename: 'Money', formatted: string } | null, loyaltyPrice?: { __typename: 'LoyaltyPrice', unit?: string | null, amount?: { __typename: 'FormattedNumber', formatted: string } | null, totalStrikeOutPoints?: { __typename: 'FormattedNumber', formatted: string } | null } | null }> | null, priceMessaging?: Array<{ __typename: 'LodgingEnrichedMessage', value: string, theme?: LodgingMessageTheme | null }> | null, marketingFeeDetails?: { __typename: 'MarketingFeeDetails', tierMessage: { __typename: 'LodgingEnrichedMessage', accessibilityLabel?: string | null, value: string, egdsMark?: { __typename: 'Mark', id: string } | null }, marketingFeeMessageDialog?: { __typename: 'LodgingBasicContentActionDialog', content: Array<string>, dialog: { __typename: 'EGDSActionDialog', footer: { __typename: 'EGDSInlineDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null } | { __typename: 'FlightsActionButton', primary?: string | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null } | { __typename: 'ServicingButton', primary?: string | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null } | { __typename: 'UIPrimaryButton', primary?: string | null } | { __typename: 'UISecondaryButton', primary?: string | null } | { __typename: 'UITertiaryButton', primary?: string | null }> } | { __typename: 'EGDSStackedDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null } | { __typename: 'FlightsActionButton', primary?: string | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null } | { __typename: 'ServicingButton', primary?: string | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null } | { __typename: 'UIPrimaryButton', primary?: string | null } | { __typename: 'UISecondaryButton', primary?: string | null } | { __typename: 'UITertiaryButton', primary?: string | null }> } } } | null } | null } | null, badge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, standardBadge?: { __typename: 'LodgingStandardBadge', standardBadge: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null }, impressionEventAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', referrerId: string, linkName?: string | null, event: string } | null } | null, button?: { __typename: 'LodgingPrimaryAltButton', accessibility?: string | null, disabled: boolean, primary?: string | null, action?: { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, icon?: { __typename: 'Icon', description: string, id: string } | null, attemptEvents: Array<{ __typename: 'LodgingAdaptExAnalyticsEvent', campaignId: string, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, eventType?: EGReferrerEventType | null, referrerId: string } | null, events: Array<{ __typename: 'LodgingAdaptExEvent', eventType: string, eventTarget: string, banditDisplayed: boolean, payloadId: string }> }>, successEvents: Array<{ __typename: 'LodgingAdaptExAnalyticsEvent', campaignId: string, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, eventType?: EGReferrerEventType | null, referrerId: string } | null, events: Array<{ __typename: 'LodgingAdaptExEvent', eventType: string, eventTarget: string, banditDisplayed: boolean, payloadId: string }> }>, adaptexSuccessActionTracking?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null } | null } | null, clickstreamEvents: { __typename: 'LodgingCardClickstreamEvents', productPresented?: { __typename: 'LodgingProductEvent', event: { __typename: 'EGClickstreamEvent', eventCategory: string, eventName: string, eventType: string, eventVersion: string }, product_list: Array<{ __typename: 'LodgingProduct', product_id: string }>, search_request: { __typename: 'LodgingSearchRequest', search_id: string } } | null, productSelected?: { __typename: 'LodgingProductEvent', event: { __typename: 'EGClickstreamEvent', eventCategory: string, eventName: string, eventType: string, eventVersion: string }, product_list: Array<{ __typename: 'LodgingProduct', product_id: string }>, search_request: { __typename: 'LodgingSearchRequest', search_id: string } } | null }, impressionAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', url?: any | null, referrerId: string, linkName?: string | null, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessActionTracking?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null };

export type AdaptexCampaignTrackingDetailFragmentFragment = { __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null };

export type ProductEventFragmentFragment = { __typename: 'LodgingProductEvent', event: { __typename: 'EGClickstreamEvent', eventCategory: string, eventName: string, eventType: string, eventVersion: string }, product_list: Array<{ __typename: 'LodgingProduct', product_id: string }>, search_request: { __typename: 'LodgingSearchRequest', search_id: string } };

export type ClickstreamEventFragmentFragment = { __typename: 'EGClickstreamEvent', eventCategory: string, eventName: string, eventType: string, eventVersion: string };

export type ProductListFragmentFragment = { __typename: 'LodgingProduct', product_id: string };

export type RequestFragmentFragment = { __typename: 'LodgingSearchRequest', search_id: string };

export type LodgingListingDividerFieldsFragment = { __typename: 'LodgingListingDivider', backgroundTheme?: string | null, title?: { __typename: 'EGDSHeading', headingType?: EGDSHeadingStyle | null, titleText: string } | null, subtitle?: { __typename: 'EGDSBasicLocalizedText', subtitleText: string } | { __typename: 'EGDSCardinalLocalizedText', subtitleText: string } | { __typename: 'EGDSCompositeLocalizedText', subtitleText: string } | { __typename: 'EGDSGraphicText', subtitleText: string } | { __typename: 'EGDSHeading', subtitleText: string } | { __typename: 'EGDSIconText', subtitleText: string } | { __typename: 'EGDSInlineLink', subtitleText: string } | { __typename: 'EGDSLocalizedTextTemplate', subtitleText: string } | { __typename: 'EGDSParagraph', subtitleText: string } | { __typename: 'EGDSPlainText', subtitleText: string } | { __typename: 'EGDSSpannableText', subtitleText: string } | { __typename: 'EGDSStandardLink', subtitleText: string } | { __typename: 'EGDSStylizedText', subtitleText: string } | { __typename: 'EGDSTextIconLinkListItem', subtitleText: string } | { __typename: 'EGDSTextIconListItem', subtitleText: string } | { __typename: 'EGDSTextStandardListItem', subtitleText: string } | { __typename: 'EGDSTextWithMarkListItem', subtitleText: string } | null, graphic?: { __typename: 'Icon', description: string, id: string, theme?: IconTheme | null, title?: string | null, withBackground?: boolean | null, iconSize?: IconSize | null } | { __typename: 'Illustration', description: string, url: any, id: string } | { __typename: 'Mark', description: string, size?: string | null, id: string, markUrl?: { __typename: 'HttpURI', relativePath: string, value: string } | null } | null, impressionAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string } | null };

export type PropertyListingStandardMessagingCardFragmentFragment = { __typename: 'EGDSStandardMessagingCard', heading?: string | null, egdsElementId?: string | null, message: string, graphic?: { __typename: 'Icon' } | { __typename: 'Illustration', description: string, link: any } | { __typename: 'Mark' } | null, links?: Array<{ __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', accessibility?: string | null, useRelativePath: boolean, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } }> | null, impressionTracking?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null };

export type PropertyListingExpandoCardFragmentFragment = { __typename: 'PropertyListingsIconTextExpando', graphic?: { __typename: 'Icon' } | { __typename: 'Illustration', description: string, id: string, link: any } | { __typename: 'Mark' } | null, expandoCard?: { __typename: 'EGDSExpandoCard', collapsedLabel: string, expandedLabel: string, expanded: boolean, subtitle?: string | null, expandAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, collapseAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null } | null, expandedContent?: Array<{ __typename: 'EGDSGraphicText', text: string, graphic: { __typename: 'Icon', id: string, description: string, token: string, size?: IconSize | null, theme?: IconTheme | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } }> | null };

export type LodgingCardHeadingSectionFragmentFragment = { __typename: 'LodgingCardHeadingSection', heading: string, productRating?: { __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', id: string } } | { __typename: 'PropertyRating', accessibility?: string | null, rating: number } | { __typename: 'PropertyStarRating', accessibility?: string | null, rating: number } | null, featuredMessages: Array<{ __typename: 'LodgingCardFeaturedMessage', text: string, icon?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | null }>, messages: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, amenities: Array<{ __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } }> };

export type LodgingCardFeaturedMessageFragmentFragment = { __typename: 'LodgingCardFeaturedMessage', text: string, icon?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | null };

type LodgingEGDSRatingFragment_EGDSIconRating_Fragment = { __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', id: string } };

type LodgingEGDSRatingFragment_PropertyRating_Fragment = { __typename: 'PropertyRating', accessibility?: string | null, rating: number };

type LodgingEGDSRatingFragment_PropertyStarRating_Fragment = { __typename: 'PropertyStarRating', accessibility?: string | null, rating: number };

export type LodgingEGDSRatingFragmentFragment = LodgingEGDSRatingFragment_EGDSIconRating_Fragment | LodgingEGDSRatingFragment_PropertyRating_Fragment | LodgingEGDSRatingFragment_PropertyStarRating_Fragment;

export type LodgingCardProductSummarySectionFragmentFragment = { __typename: 'LodgingCardProductSummarySection', heading?: { __typename: 'EGDSHeading', text: string } | null, amenities: Array<{ __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } }>, messages: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, descriptionSection?: { __typename: 'LodgingCardPropertyDescriptionSection', heading?: { __typename: 'EGDSHeading', text: string } | null, description?: { __typename: 'EGDSParagraph', text: string } | null, link?: { __typename: 'EGDSStandardLink', action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | null } | null, changeActionDialog?: { __typename: 'LodgingCardChangeUnitDialogAction', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, changeActionSheet?: { __typename: 'LodgingCardChangeUnitSheetAction', sheet: { __typename: 'EGDSSheet', closeText?: string | null, closeAnalytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, detailsAction?: { __typename: 'LodgingCardPropertyDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | { __typename: 'LodgingCardUnitDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } } | null, guestRating?: { __typename: 'LodgingCardPhrase', accessibilityLabel: string, parts: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, phraseParts: Array<{ __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText' }> } | null, guestRatingSection?: { __typename: 'LodgingCardBadgedRating', badge: { __typename: 'EGDSBadgeNotification', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null }, phrases?: Array<{ __typename: 'LodgingCardPhrase', phraseParts: Array<{ __typename: 'EGDSIconRating' } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> }> | null } | { __typename: 'LodgingCardPhrase', accessibilityLabel: string, parts: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, phraseParts: Array<{ __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> } | null, footerMessages?: { __typename: 'EGDSBulletedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | { __typename: 'EGDSOrderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | { __typename: 'EGDSTextIconList', listItems: Array<{ __typename: 'EGDSTextIconListItem' }> } | { __typename: 'EGDSUnorderedList', listItems: Array<{ __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null } | { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null } | { __typename: 'FlightsTextContainerListItem' } | { __typename: 'MishopUITextContainerListItem' }> } | null };

export type EGDSIconRatingFragmentFragment = { __typename: 'EGDSIconRating', accessibility?: string | null, rating: number, icon: { __typename: 'Icon', token: string, theme?: IconTheme | null, size?: IconSize | null } };

export type LodgingCardBadgedRatingFragmentFragment = { __typename: 'LodgingCardBadgedRating', badge: { __typename: 'EGDSBadgeNotification', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSLoyaltyBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSProgramBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null } | { __typename: 'EGDSStandardBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null }, phrases?: Array<{ __typename: 'LodgingCardPhrase', phraseParts: Array<{ __typename: 'EGDSIconRating' } | { __typename: 'EGDSPlainText' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null }> }> | null };

type EGDSBadgeFragment_EGDSBadgeNotification_Fragment = { __typename: 'EGDSBadgeNotification', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null };

type EGDSBadgeFragment_EGDSLoyaltyBadge_Fragment = { __typename: 'EGDSLoyaltyBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null };

type EGDSBadgeFragment_EGDSProgramBadge_Fragment = { __typename: 'EGDSProgramBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null };

type EGDSBadgeFragment_EGDSStandardBadge_Fragment = { __typename: 'EGDSStandardBadge', accessibility?: string | null, text?: string | null, size?: string | null, theme?: string | null };

export type EGDSBadgeFragmentFragment = EGDSBadgeFragment_EGDSBadgeNotification_Fragment | EGDSBadgeFragment_EGDSLoyaltyBadge_Fragment | EGDSBadgeFragment_EGDSProgramBadge_Fragment | EGDSBadgeFragment_EGDSStandardBadge_Fragment;

export type LodgingProductAmenityFragmentFragment = { __typename: 'EGDSIconText', text: string, icon: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } };

export type LodgingCardPropertyDescriptionSectionFragmentFragment = { __typename: 'LodgingCardPropertyDescriptionSection', heading?: { __typename: 'EGDSHeading', text: string } | null, description?: { __typename: 'EGDSParagraph', text: string } | null, link?: { __typename: 'EGDSStandardLink', action: { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } } | null };

export type LodgingCardChangeUnitDialogActionFragmentFragment = { __typename: 'LodgingCardChangeUnitDialogAction', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } };

export type EGDSDialogToolbarFragmentFragment = { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string };

export type LodgingCardChangeUnitSheetActionFragmentFragment = { __typename: 'LodgingCardChangeUnitSheetAction', sheet: { __typename: 'EGDSSheet', closeText?: string | null, closeAnalytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } };

export type LodgingCardMoreDetailsTriggerFragmentFragment = { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null };

export type LodgingEGDSIconFragmentFragment = { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null };

type LodgingCardPropertyDialogActionFragment_LodgingCardPropertyDetailsDialog_Fragment = { __typename: 'LodgingCardPropertyDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } };

type LodgingCardPropertyDialogActionFragment_LodgingCardUnitDetailsDialog_Fragment = { __typename: 'LodgingCardUnitDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } };

export type LodgingCardPropertyDialogActionFragmentFragment = LodgingCardPropertyDialogActionFragment_LodgingCardPropertyDetailsDialog_Fragment | LodgingCardPropertyDialogActionFragment_LodgingCardUnitDetailsDialog_Fragment;

export type LodgingCardPropertyDetailsDialogActionFragmentFragment = { __typename: 'LodgingCardPropertyDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } };

export type LodgingCardUnitDetailsDialogActionFragmentFragment = { __typename: 'LodgingCardUnitDetailsDialog', dialog: { __typename: 'EGDSFullScreenDialog', closeAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, toolbar: { __typename: 'EGDSDialogToolbar', closeText?: string | null, title: string } }, trigger: { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null } };

export type LodgingCardMoreDetailsLinkTriggerFragmentFragment = { __typename: 'LodgingCardMoreDetailsTrigger', accessibilityLabel: string, label: string, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null } | null };

export type LodgingCardLinkActionFragmentFragment = { __typename: 'LodgingCardLinkAction', link: { __typename: 'EGDSStandardLink', text: string, action: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' }, analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } }, icon?: { __typename: 'Icon', id: string } | null } };

export type LodgingCardMediaSectionFragmentFragment = { __typename: 'LodgingCardMediaSection', gallery?: { __typename: 'LodgingGalleryCarousel', accessibilityHeadingText: string, nextButtonText?: string | null, previousButtonText?: string | null, navClickAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, intersectionAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, media: Array<{ __typename: 'LodgingMediaItem', id?: string | null, trackingId?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', description: string, url: any, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'Video' } }> } | null, badges?: { __typename: 'LodgingBadgesGroup', primaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, secondaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null, tertiaryBadge?: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null } | null } | null, saveItem?: { __typename: 'LodgingSaveItem', initialChecked: boolean, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, items: Array<{ __typename: 'LodgingSaveItemItem', itemId: string }>, labels?: { __typename: 'LodgingSaveItemLabels', removeLabel?: string | null, saveLabel?: string | null } | null, messages?: { __typename: 'LodgingSaveItemMessages', removeMessage?: string | null, saveMessage?: string | null } | null } | null, saveTripItem?: { __typename: 'TripsSaveItem', initialChecked: boolean, itemId: string, source: PageLocation, save: { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null }, remove: { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null }, attributes?: { __typename: 'TripsSaveActivityAttributes', regionId?: string | null, dateRange?: { __typename: 'DateRange', start: { __typename: 'Date', year: number, month: number, day: number }, end: { __typename: 'Date', year: number, month: number, day: number } } | null } | { __typename: 'TripsSaveFlightSearchAttributes' } | { __typename: 'TripsSaveStayAttributes', regionId?: string | null, roomConfiguration?: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> | null, checkInDate?: { __typename: 'Date', year: number, month: number, day: number } | null, checkoutDate?: { __typename: 'Date', year: number, month: number, day: number } | null } | null } | null };

export type LodgingCardDateSectionFragmentFragment = { __typename: 'LodgingCardDateSection', date?: { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null } | null };

export type LodgingCardCompareSectionFragmentFragment = { __typename: 'LodgingCardCompareSection', compareAction: { __typename: 'EGDSBasicCheckBox', label: { __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSGraphicText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconLinkListItem', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } | { __typename: 'EGDSTextWithMarkListItem', text: string } } };

export type TripsSaveItemPropertiesFragmentFragment = { __typename: 'TripsSaveItemProperties', accessibility?: string | null, label?: string | null, analytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, adaptexSuccessCampaignIds?: Array<{ __typename: 'AdaptexCampaignTrackingDetail', campaignId: string, eventTarget?: string | null }> | null };

export type TripsSaveStayAttributesFragmentFragment = { __typename: 'TripsSaveStayAttributes', regionId?: string | null, roomConfiguration?: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> | null, checkInDate?: { __typename: 'Date', year: number, month: number, day: number } | null, checkoutDate?: { __typename: 'Date', year: number, month: number, day: number } | null };

export type TripsSaveActivityAttributesFragmentFragment = { __typename: 'TripsSaveActivityAttributes', regionId?: string | null, dateRange?: { __typename: 'DateRange', start: { __typename: 'Date', year: number, month: number, day: number }, end: { __typename: 'Date', year: number, month: number, day: number } } | null };

export type LodgingGalleryCarouselFragmentFragment = { __typename: 'LodgingGalleryCarousel', accessibilityHeadingText: string, nextButtonText?: string | null, previousButtonText?: string | null, navClickAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } | null, intersectionAnalytics?: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string, uisPrimeMessages: Array<{ __typename: 'EGUisMicroMessage', messageContent: string, schemaName: string }> } | null, media: Array<{ __typename: 'LodgingMediaItem', id?: string | null, trackingId?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', description: string, url: any, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'Video' } }> };

export type LodgingMediaItemFragmentFragment = { __typename: 'LodgingMediaItem', id?: string | null, trackingId?: string | null, media: { __typename: 'EGDSPhotosphereImage' } | { __typename: 'Image', description: string, url: any, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'Video' } };

export type LodgingEGDSImageFragmentFragment = { __typename: 'Image', description: string, url: any, thumbnailClickAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null };

export type LodgingEGDSStandardBadgeFragmentFragment = { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null };

export type LodgingstandardBadgeFragmentDocFragment = { __typename: 'LodgingStandardBadge', standardBadge: { __typename: 'EGDSStandardBadge', text?: string | null, theme?: string | null, size?: string | null, graphic?: { __typename: 'Icon', description: string, id: string } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string } | null }, impressionEventAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', referrerId: string, linkName?: string | null, event: string } | null };

type LodgingEGDSTextFragment_EGDSBasicLocalizedText_Fragment = { __typename: 'EGDSBasicLocalizedText' };

type LodgingEGDSTextFragment_EGDSCardinalLocalizedText_Fragment = { __typename: 'EGDSCardinalLocalizedText' };

type LodgingEGDSTextFragment_EGDSCompositeLocalizedText_Fragment = { __typename: 'EGDSCompositeLocalizedText' };

type LodgingEGDSTextFragment_EGDSGraphicText_Fragment = { __typename: 'EGDSGraphicText' };

type LodgingEGDSTextFragment_EGDSHeading_Fragment = { __typename: 'EGDSHeading' };

type LodgingEGDSTextFragment_EGDSIconText_Fragment = { __typename: 'EGDSIconText' };

type LodgingEGDSTextFragment_EGDSInlineLink_Fragment = { __typename: 'EGDSInlineLink', disabled: boolean, text: string, linkSize: EGDSLinkSize, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }, resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'SelfReferencedURI', value: string } | { __typename: 'TelURI', value: string } | { __typename: 'Uri', value: string } } };

type LodgingEGDSTextFragment_EGDSLocalizedTextTemplate_Fragment = { __typename: 'EGDSLocalizedTextTemplate' };

type LodgingEGDSTextFragment_EGDSParagraph_Fragment = { __typename: 'EGDSParagraph', text: string };

type LodgingEGDSTextFragment_EGDSPlainText_Fragment = { __typename: 'EGDSPlainText', text: string };

type LodgingEGDSTextFragment_EGDSSpannableText_Fragment = { __typename: 'EGDSSpannableText' };

type LodgingEGDSTextFragment_EGDSStandardLink_Fragment = { __typename: 'EGDSStandardLink' };

type LodgingEGDSTextFragment_EGDSStylizedText_Fragment = { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null };

type LodgingEGDSTextFragment_EGDSTextIconLinkListItem_Fragment = { __typename: 'EGDSTextIconLinkListItem' };

type LodgingEGDSTextFragment_EGDSTextIconListItem_Fragment = { __typename: 'EGDSTextIconListItem' };

type LodgingEGDSTextFragment_EGDSTextStandardListItem_Fragment = { __typename: 'EGDSTextStandardListItem' };

type LodgingEGDSTextFragment_EGDSTextWithMarkListItem_Fragment = { __typename: 'EGDSTextWithMarkListItem' };

export type LodgingEGDSTextFragmentFragment = LodgingEGDSTextFragment_EGDSBasicLocalizedText_Fragment | LodgingEGDSTextFragment_EGDSCardinalLocalizedText_Fragment | LodgingEGDSTextFragment_EGDSCompositeLocalizedText_Fragment | LodgingEGDSTextFragment_EGDSGraphicText_Fragment | LodgingEGDSTextFragment_EGDSHeading_Fragment | LodgingEGDSTextFragment_EGDSIconText_Fragment | LodgingEGDSTextFragment_EGDSInlineLink_Fragment | LodgingEGDSTextFragment_EGDSLocalizedTextTemplate_Fragment | LodgingEGDSTextFragment_EGDSParagraph_Fragment | LodgingEGDSTextFragment_EGDSPlainText_Fragment | LodgingEGDSTextFragment_EGDSSpannableText_Fragment | LodgingEGDSTextFragment_EGDSStandardLink_Fragment | LodgingEGDSTextFragment_EGDSStylizedText_Fragment | LodgingEGDSTextFragment_EGDSTextIconLinkListItem_Fragment | LodgingEGDSTextFragment_EGDSTextIconListItem_Fragment | LodgingEGDSTextFragment_EGDSTextStandardListItem_Fragment | LodgingEGDSTextFragment_EGDSTextWithMarkListItem_Fragment;

export type LodgingEGDSParagraphFragmentFragment = { __typename: 'EGDSParagraph', text: string };

export type EGDSStylizedTextFragmentFragment = { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null, accessibility?: string | null };

export type PriceSummaryFragmentFragment = { __typename: 'PropertyPrice', displayMessages?: Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<{ __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: string | null }, disclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: { __typename: 'UIPrimaryButton', accessibility?: string | null, primary?: string | null } | null } | null } | { __typename: 'LodgingEnrichedMessage', value: string, state?: string | null }> }> | null, options?: Array<{ __typename: 'PropertyPriceOption', leadingCaption?: string | null, accessibilityLabel?: string | null, displayPrice?: { __typename: 'Money', formatted: string } | null, disclaimer?: { __typename: 'LodgingPlainMessage', value: string } | null, priceDisclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryButton?: { __typename: 'LodgingButton', text: string } | null, trigger: { __typename: 'LodgingDialogTriggerMessage', icon?: { __typename: 'Icon', description: string } | null } } | null, strikeOut?: { __typename: 'Money', formatted: string } | null, loyaltyPrice?: { __typename: 'LoyaltyPrice', unit?: string | null, amount?: { __typename: 'FormattedNumber', formatted: string } | null, totalStrikeOutPoints?: { __typename: 'FormattedNumber', formatted: string } | null } | null }> | null, priceMessaging?: Array<{ __typename: 'LodgingEnrichedMessage', value: string, theme?: LodgingMessageTheme | null }> | null, marketingFeeDetails?: { __typename: 'MarketingFeeDetails', tierMessage: { __typename: 'LodgingEnrichedMessage', accessibilityLabel?: string | null, value: string, egdsMark?: { __typename: 'Mark', id: string } | null }, marketingFeeMessageDialog?: { __typename: 'LodgingBasicContentActionDialog', content: Array<string>, dialog: { __typename: 'EGDSActionDialog', footer: { __typename: 'EGDSInlineDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null } | { __typename: 'FlightsActionButton', primary?: string | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null } | { __typename: 'ServicingButton', primary?: string | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null } | { __typename: 'UIPrimaryButton', primary?: string | null } | { __typename: 'UISecondaryButton', primary?: string | null } | { __typename: 'UITertiaryButton', primary?: string | null }> } | { __typename: 'EGDSStackedDialogFooter', buttons: Array<{ __typename: 'EGDSOverlayButton', primary?: string | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null } | { __typename: 'FlightsActionButton', primary?: string | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null } | { __typename: 'ServicingButton', primary?: string | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null } | { __typename: 'UIPrimaryButton', primary?: string | null } | { __typename: 'UISecondaryButton', primary?: string | null } | { __typename: 'UITertiaryButton', primary?: string | null }> } } } | null } | null };

export type PriceMessageFragmentFragment = { __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: string | null }, disclaimer?: { __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: { __typename: 'UIPrimaryButton', accessibility?: string | null, primary?: string | null } | null } | null };

export type LodgingEGDSHeadingFragmentFragment = { __typename: 'EGDSHeading', text: string };

export type OfferBadgeFragmentFragment = { __typename: 'Badge', text?: string | null, theme_temp?: Theme | null, icon_temp?: { __typename: 'Icon', id: string, description: string, title?: string | null } | null, mark?: { __typename: 'Mark', id: string, description: string } | null };

export type LodgingProductFooterMessagesFragmentFragment = { __typename: 'EGDSTextWithMarkListItem', style?: EGDSTextListItemStyle | null, text: string, mark?: { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string } | null } | null };

export type LodgingProductSpannableFooterMessagesFragmentFragment = { __typename: 'EarnMessageContainerListItem', style?: EGDSTextListItemStyle | null, text: string, graphic: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, theme?: IconTheme | null, title?: string | null } | { __typename: 'Illustration', id: string, description: string } | { __typename: 'Mark', description: string, id: string, token: string, url?: { __typename: 'HttpURI', value: string, relativePath: string } | null }, stylizedText?: { __typename: 'EGDSSpannableText', text: string, contents: Array<{ __typename: 'EGDSBasicLocalizedText' } | { __typename: 'EGDSCardinalLocalizedText' } | { __typename: 'EGDSCompositeLocalizedText' } | { __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSIconText' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSLocalizedTextTemplate' } | { __typename: 'EGDSParagraph' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText' } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null } | { __typename: 'EGDSTextIconLinkListItem' } | { __typename: 'EGDSTextIconListItem' } | { __typename: 'EGDSTextStandardListItem' } | { __typename: 'EGDSTextWithMarkListItem' }>, inlineContent: Array<{ __typename: 'EGDSGraphicText' } | { __typename: 'EGDSHeading' } | { __typename: 'EGDSInlineLink' } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSStandardLink' } | { __typename: 'EGDSStylizedText', text: string, theme?: TextTheme | null, weight?: TextWeight | null, size?: string | null, decorative?: EGDSDecorativeText | null }> } | null };

export type LodgingEGDSPlainTextFragmentFragment = { __typename: 'EGDSPlainText', text: string };

export type LodgingMoreInfoTriggerFragmentFragment = { __typename: 'EGDSStandardLink', text: string, egdsElementId?: string | null, disabled: boolean, icon?: { __typename: 'Icon', description: string, id: string, size?: IconSize | null, title?: string | null, token: string, withBackground?: boolean | null } | null, action: { __typename: 'UILinkAction', accessibility?: string | null, target: UILinkTarget, useRelativePath: boolean, analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } };

export type SponsoredContentPlacementFieldsFragment = { __typename: 'SponsoredContentPlacement', productType: SponsoredContentProductType, sponsoredContentContext: { __typename: 'SponsoredContentContext', pageName: string, variant?: string | null, sponsoredContentId: string, targeting?: { __typename: 'SponsoredContentTargeting', adults?: number | null, kids?: number | null, origin?: string | null, destination?: string | null, locationResolver?: SponsoredContentLocationResolver | null, dateStart?: { __typename: 'Date', day: number, month: number, year: number } | null, dateEnd?: { __typename: 'Date', day: number, month: number, year: number } | null } | null } };

export type PropertySearchListingsSoldOutFieldsFragment = { __typename: 'PropertySearchListingsSoldOutCard', cardContent?: { __typename: 'EGDSStandardMessagingCard', heading?: string | null, graphic?: { __typename: 'Icon', description: string, id: string, theme?: IconTheme | null, title?: string | null, withBackground?: boolean | null, iconSize?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null } | null, actionButton?: { __typename: 'EGDSOverlayButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'EGDSSearchFormButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsActionButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsDialogTrigger', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsExperienceActionButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'FlightsSmartShoppingActionButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'PackageUIActionDialogFooterButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'PackageUIHideSearchFormAction', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'PackageUITravelGuideButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'ServicingButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'SupplyCancelWaiverActionButton', primary: string, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'SupplyContentLinkStyleButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UIPrimaryButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UISecondaryButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UITertiaryButton', primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | null, analytics?: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string, linkName?: string | null } | null };

export type PropertyListingOverfilteredFragmentFragment = { __typename: 'PropertySearchListingsOverfilteredCard', cardContent?: { __typename: 'EGDSStandardMessagingCard', heading?: string | null, message: string, graphic?: { __typename: 'Icon', description: string, id: string, withBackground?: boolean | null, iconSize?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null } | null, action?: { __typename: 'LodgingLinkButton', button: { __typename: 'EGDSOverlayButton' } | { __typename: 'EGDSSearchFormButton' } | { __typename: 'FlightsActionButton' } | { __typename: 'FlightsDialogTrigger' } | { __typename: 'FlightsExperienceActionButton' } | { __typename: 'FlightsSmartShoppingActionButton' } | { __typename: 'PackageUIActionDialogFooterButton' } | { __typename: 'PackageUIHideSearchFormAction' } | { __typename: 'PackageUITravelGuideButton' } | { __typename: 'ServicingButton' } | { __typename: 'SupplyCancelWaiverActionButton' } | { __typename: 'SupplyContentLinkStyleButton' } | { __typename: 'UIPrimaryButton' } | { __typename: 'UISecondaryButton', accessibility?: string | null, disabled: boolean, primary?: string | null, analytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'UITertiaryButton' }, action?: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | null } | null, impressionAnalytics?: { __typename: 'ClientSideImpressionEventAnalytics', event: string, referrerId: string, linkName?: string | null } | null, filterPills?: Array<{ __typename: 'BasicShoppingAppliedFilter', filter?: { __typename: 'EGDSBasicPill' } | { __typename: 'EGDSBasicRemovablePill', primary?: string | null, accessibility?: string | null, name?: string | null, value?: string | null, remove?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null, removeAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'EGDSBasicTriggerPill' } | null, linkUrl?: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | null } | { __typename: 'ShoppingSelectedFilter' }> | null };

export type SearchFilterPillsFragmentFragment = { __typename: 'PropertySearchListingsOverfilteredCard', filterPills?: Array<{ __typename: 'BasicShoppingAppliedFilter', filter?: { __typename: 'EGDSBasicPill' } | { __typename: 'EGDSBasicRemovablePill', primary?: string | null, accessibility?: string | null, name?: string | null, value?: string | null, remove?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null, removeAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null } | { __typename: 'EGDSBasicTriggerPill' } | null, linkUrl?: { __typename: 'UILinkAction', target: UILinkTarget, useRelativePath: boolean, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', value: string, relativePath: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'SelfReferencedURI' } | { __typename: 'TelURI' } | { __typename: 'Uri' } } | null } | { __typename: 'ShoppingSelectedFilter' }> | null };

export type LodgingEGDSRemovablePillFragmentFragment = { __typename: 'EGDSBasicRemovablePill', primary?: string | null, accessibility?: string | null, name?: string | null, value?: string | null, remove?: { __typename: 'Icon', id: string, description: string, size?: IconSize | null } | { __typename: 'Illustration' } | { __typename: 'Mark' } | null, removeAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } | null };

export type LodgingAdaptExAnalyticsEventFragmentFragment = { __typename: 'LodgingAdaptExAnalyticsEvent', campaignId: string, clientSideAnalytics?: { __typename: 'ClientSideAnalytics', referrerId: string, eventType?: EGReferrerEventType | null, linkName: string } | null, events: Array<{ __typename: 'LodgingAdaptExEvent', eventType: string, eventTarget: string, banditDisplayed: boolean, payloadId: string }> };

export type PrepareCheckoutByCartIdMutationVariables = Exact<{
  context: ContextInput;
  id: Scalars['UUID'];
  totalPrice: MoneyInput;
  marketingChannelId?: InputMaybe<Scalars['Int']>;
  checkoutOptions?: InputMaybe<Array<CheckoutOptionInput> | CheckoutOptionInput>;
}>;


export type PrepareCheckoutByCartIdMutation = { __typename: 'Mutation', prepareCheckoutByCartId: { __typename: 'PrepareCheckoutResponse', tripId?: any | null, checkoutUrl?: any | null, failureReason?: { __typename: 'CheckoutFailureReason' } | { __typename: 'MaxRoomsFailure', groupLinkMessage?: string | null, message: string } | null } };

export type PrepareCheckoutMutationVariables = Exact<{
  context: ContextInput;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput> | PropertyNaturalKeyInput>;
  cookies: Scalars['String'];
}>;


export type PrepareCheckoutMutation = { __typename: 'Mutation', prepareCheckout: { __typename: 'PrepareCheckoutResponse', tripId?: any | null, checkoutUrl?: any | null } };

export type PropertyInfoPageLayoutQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars['String'];
  shoppingContext?: InputMaybe<ShoppingContextInput>;
}>;


export type PropertyInfoPageLayoutQuery = { __typename: 'Query', propertyInfo: { __typename: 'PropertyInfo', experimental: { __typename: 'PropertyDetailsExperimentalSection', pageLayoutExperimentalFeature: { __typename: 'PageLayoutExperimentalFeature', templateName?: string | null } } } };

export type RemoveItemFromCartMutationVariables = Exact<{
  cartId: Scalars['UUID'];
  context: ContextInput;
  itemId: Scalars['UUID'];
}>;


export type RemoveItemFromCartMutation = { __typename: 'Mutation', cartItems: { __typename: 'CartMutations', remove: { __typename: 'CartSummary', id: any, itemCount: number } } };

export type SearchResultsPageLayoutQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
}>;


export type SearchResultsPageLayoutQuery = { __typename: 'Query', propertySearch: { __typename: 'PropertySearchResults', experimental: { __typename: 'PropertySearchExperimentalSection', pageLayoutFeatureExperiment: { __typename: 'PageLayoutExperimentalFeature', templateName?: string | null } } } };

export type SelectProductsMutationVariables = Exact<{
  context: ContextInput;
  sessionId: Scalars['String'];
  priceToken?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Array<PropertyNaturalKeyInput> | PropertyNaturalKeyInput>;
  flights?: InputMaybe<Array<FlightNaturalKeyInput> | FlightNaturalKeyInput>;
  cars?: InputMaybe<Array<CarNaturalKeyInput> | CarNaturalKeyInput>;
  dealMarker?: InputMaybe<Scalars['String']>;
}>;


export type SelectProductsMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', selectProducts: { __typename: 'MultiItemSearchContextCreatedResponse', redirectUrl?: any | null, shoppingContext: { __typename: 'ShoppingContext', multiItem?: { __typename: 'MultiItemContext', id: string, packageType: PackageType } | null } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: string | null } } };

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace AddPropertyToCart {
  export type Variables = AddPropertyToCartMutationVariables;
  export type mutation = AddPropertyToCartMutation;
  export type cartItems = (NonNullable<AddPropertyToCartMutation['cartItems']>);
  export type addProperty = (NonNullable<(NonNullable<AddPropertyToCartMutation['cartItems']>)['addProperty']>);
}

export namespace CreateMultiItemSession {
  export type Variables = CreateMultiItemSessionMutationVariables;
  export type mutation = CreateMultiItemSessionMutation;
  export type createMultiItemSession = (NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type shoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type multiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
}

export namespace CreateSessionCart {
  export type Variables = CreateSessionCartMutationVariables;
  export type mutation = CreateSessionCartMutation;
  export type createSessionCart = (NonNullable<CreateSessionCartMutation['createSessionCart']>);
}

export namespace EmptyCart {
  export type Variables = EmptyCartMutationVariables;
  export type mutation = EmptyCartMutation;
  export type cartItems = (NonNullable<EmptyCartMutation['cartItems']>);
  export type emptyCart = (NonNullable<(NonNullable<EmptyCartMutation['cartItems']>)['emptyCart']>);
}

export namespace FederatedCart {
  export type Variables = FederatedCartQueryVariables;
  export type query = FederatedCartQuery;
  export type cart = (NonNullable<FederatedCartQuery['cart']>);
  export type items = NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>;
  export type PropertyCartItemInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>);
  export type offers = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>;
  export type naturalKeys = NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>;
  export type checkIn = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkIn']>);
  export type checkOut = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkOut']>);
  export type rooms = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['rooms']>)[number]>;
}

export namespace Cart {
  export type Variables = CartQueryVariables;
  export type query = CartQuery;
  export type cart = (NonNullable<CartQuery['cart']>);
  export type items = NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>;
  export type PropertyCartItemInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>);
  export type offers = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>;
  export type naturalKeys = NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>;
  export type checkIn = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkIn']>);
  export type checkOut = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkOut']>);
  export type rooms = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['rooms']>)[number]>;
  export type offer = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>);
  export type units = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>;
  export type photos = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['photos']>)[number]>;
  export type ratePlans = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>;
  export type priceDetails = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>;
  export type availability = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['availability']>);
  export type offerBookButton = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['offerBookButton']>);
  export type inputs = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['offerBookButton']>)['inputs']>)[number]>;
  export type LodgingTextInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['offerBookButton']>)['inputs']>)[number]>, { __typename: 'LodgingTextInput' }>);
  export type price = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>);
  export type total = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['total']>);
  export type currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['total']>)['currency']>);
  export type lead = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['lead']>);
  export type _currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['lead']>)['currency']>);
  export type priceAfterLoyaltyPointsApplied = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>);
  export type _total = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['total']>);
  export type __currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['total']>)['currency']>);
  export type _lead = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['lead']>);
  export type ___currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['lead']>)['currency']>);
  export type fees = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['fees']>)[number]>;
  export type summary = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['summary']>);
  export type location = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['summary']>)['location']>);
  export type address = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['summary']>)['location']>)['address']>);
  export type gallery = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['gallery']>);
  export type featured = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['gallery']>)['featured']>);
}

export namespace InitiateMultiItemSession {
  export type Variables = InitiateMultiItemSessionMutationVariables;
  export type mutation = InitiateMultiItemSessionMutation;
  export type multiItemShopping = (NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>);
  export type initiate = (NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type shoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type multiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}

export namespace LodgingPwaPropertySearch {
  export type Variables = LodgingPwaPropertySearchQueryVariables;
  export type query = LodgingPwaPropertySearchQuery;
  export type propertySearch = (NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>);
  export type propertyListingAdaptexAnalyticsSuccessEvents = NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertyListingAdaptexAnalyticsSuccessEvents']>)[number]>;
  export type pagination = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>);
  export type trigger = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>);
  export type LodgingPaginationNavigationButtonsInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>);
  export type previousButton = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>)['previousButton']>);
  export type analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>)['previousButton']>)['analytics']>);
  export type icon = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>)['previousButton']>)['icon']>);
  export type nextButton = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>)['nextButton']>);
  export type _analytics = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>)['nextButton']>)['analytics']>);
  export type _icon = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingPaginationNavigationButtons' }>)['nextButton']>)['icon']>);
  export type UIPrimaryButtonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'UIPrimaryButton' }>);
  export type __analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'UIPrimaryButton' }>)['analytics']>);
  export type __icon = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'UIPrimaryButton' }>)['icon']>);
  export type LodgingScrollTriggerInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingScrollTrigger' }>);
  export type ___analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['trigger']>), { __typename: 'LodgingScrollTrigger' }>)['analytics']>);
  export type subSets = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['subSets']>);
  export type nextSubSet = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['subSets']>)['nextSubSet']>);
  export type previousSubset = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['pagination']>)['subSets']>)['previousSubset']>);
  export type criteria = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>);
  export type primary = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>);
  export type dateRange = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['dateRange']>);
  export type checkInDate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['dateRange']>)['checkInDate']>);
  export type checkOutDate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['dateRange']>)['checkOutDate']>);
  export type destination = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['destination']>);
  export type rooms = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['rooms']>)[number]>;
  export type children = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['rooms']>)[number]>['children']>)[number]>;
  export type flexSearchCriteria = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['flexSearchCriteria']>);
  export type flexibility = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['primary']>)['flexSearchCriteria']>)['flexibility']>)[number]>;
  export type secondary = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>);
  export type booleans = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>)['booleans']>)[number]>;
  export type counts = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>)['counts']>)[number]>;
  export type dates = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>)['dates']>)[number]>;
  export type value = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>)['dates']>)[number]>['value']>);
  export type ranges = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>)['ranges']>)[number]>;
  export type selections = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['criteria']>)['secondary']>)['selections']>)[number]>;
  export type propertySearchListings = NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>;
  export type LodgingCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'LodgingCard' }>);
  export type PropertySearchListingPlaceholderInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'PropertySearchListingPlaceholder' }>);
  export type MessageResultInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'MessageResult' }>);
  export type LodgingHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'LodgingHeading' }>);
  export type StaticLodgingMultiItemCrossSellInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>);
  export type multiItemSearchContext = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>);
  export type properties = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>;
  export type _primary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>);
  export type _dateRange = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['dateRange']>);
  export type _checkInDate = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['dateRange']>)['checkInDate']>);
  export type _checkOutDate = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['dateRange']>)['checkOutDate']>);
  export type _destination = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['destination']>);
  export type coordinates = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['destination']>)['coordinates']>);
  export type mapBounds = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['destination']>)['mapBounds']>)[number]>;
  export type _rooms = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['rooms']>)[number]>;
  export type _children = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['primary']>)['rooms']>)[number]>['children']>)[number]>;
  export type _secondary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>);
  export type _booleans = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>)['booleans']>)[number]>;
  export type _counts = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>)['counts']>)[number]>;
  export type _dates = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>)['dates']>)[number]>;
  export type _value = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>)['dates']>)[number]>['value']>);
  export type _ranges = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>)['ranges']>)[number]>;
  export type _selections = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['multiItemSearchContext']>)['properties']>)[number]>['secondary']>)['selections']>)[number]>;
  export type fallbackListing = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['fallbackListing']>);
  export type _MessageResultInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['fallbackListing']>), { __typename: 'MessageResult' }>);
  export type LodgingIntentCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'LodgingIntentCard' }>);
  export type LodgingListingDividerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'LodgingListingDivider' }>);
  export type SponsoredContentPlacementInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'SponsoredContentPlacement' }>);
  export type PropertySearchListingsSoldOutCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'PropertySearchListingsSoldOutCard' }>);
  export type PropertySearchListingsOverfilteredCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'PropertySearchListingsOverfilteredCard' }>);
  export type EGDSStandardMessagingCardInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'EGDSStandardMessagingCard' }>);
  export type PropertyListingsIconTextExpandoInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'PropertyListingsIconTextExpando' }>);
  export type summary = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>);
  export type resultMessages = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultMessages']>)[number]>;
  export type EGDSPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultMessages']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type EGDSStandardLinkInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultMessages']>)[number]>, { __typename: 'EGDSStandardLink' }>);
  export type loyaltyInfo = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['loyaltyInfo']>);
  export type shoppingContext = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['shoppingContext']>);
  export type multiItem = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['shoppingContext']>)['multiItem']>);
  export type _multiItemSearchContext = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>);
  export type cars = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>;
  export type __primary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>);
  export type pickUpDateTime = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['pickUpDateTime']>);
  export type dropOffDateTime = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['dropOffDateTime']>);
  export type pickUpLocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['pickUpLocation']>);
  export type dropOffLocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['dropOffLocation']>);
  export type flights = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>;
  export type ___primary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>);
  export type travelers = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['travelers']>)[number]>;
  export type journeyCriterias = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>;
  export type departureDate = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>['departureDate']>);
  export type searchPreferences = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['searchPreferences']>);
  export type errorResponse = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>);
  export type ___icon = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['icon']>);
  export type button = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>);
  export type action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>);
  export type UILinkActionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>);
  export type ____analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['analytics']>);
  export type resource = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type errorRecoveryButtons = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>;
  export type _action = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>);
  export type _UILinkActionInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>);
  export type _____analytics = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>)['analytics']>);
  export type _resource = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>)['resource']>);
  export type _HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type dialogErrorResponse = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>);
  export type _button = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>);
  export type __action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>);
  export type __UILinkActionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>);
  export type ______analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['analytics']>);
  export type __resource = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>);
  export type __HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type mapTrigger = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['mapTrigger']>);
}

export namespace MapTriggerFragment {
  export type fragment = MapTriggerFragmentFragment;
  export type icon = (NonNullable<MapTriggerFragmentFragment['icon']>);
  export type small = (NonNullable<MapTriggerFragmentFragment['small']>);
  export type medium = (NonNullable<MapTriggerFragmentFragment['medium']>);
  export type large = (NonNullable<MapTriggerFragmentFragment['large']>);
  export type clientSideAnalytics = (NonNullable<MapTriggerFragmentFragment['clientSideAnalytics']>);
}

export namespace MultiItemPropertySearchContextFields {
  export type fragment = MultiItemPropertySearchContextFieldsFragment;
  export type properties = NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>;
  export type primary = (NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>);
  export type rooms = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['rooms']>)[number]>;
  export type destination = (NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['destination']>);
  export type dateRange = (NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['dateRange']>);
  export type checkInDate = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['dateRange']>)['checkInDate']>);
  export type checkOutDate = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['dateRange']>)['checkOutDate']>);
}

export namespace MessageFields {
  export type fragment = MessageFieldsFragment;
  export type title = (NonNullable<MessageFieldsFragment['title']>);
  export type subtitle = (NonNullable<MessageFieldsFragment['subtitle']>);
  export type action = (NonNullable<MessageFieldsFragment['action']>);
  export type primary = (NonNullable<(NonNullable<MessageFieldsFragment['action']>)['primary']>);
  export type secondary = (NonNullable<(NonNullable<MessageFieldsFragment['action']>)['secondary']>);
}

export namespace MessageTitleFields {
  export type fragment = MessageTitleFieldsFragment;
  export type icon = (NonNullable<MessageTitleFieldsFragment['icon']>);
  export type egdsMark = (NonNullable<MessageTitleFieldsFragment['egdsMark']>);
  export type url = (NonNullable<(NonNullable<MessageTitleFieldsFragment['egdsMark']>)['url']>);
  export type illustration = (NonNullable<MessageTitleFieldsFragment['illustration']>);
  export type assetUri = (NonNullable<(NonNullable<MessageTitleFieldsFragment['illustration']>)['assetUri']>);
}

export namespace MessagingActionFields {
  export type fragment = MessagingActionFieldsFragment;
  export type actionDetails = (NonNullable<MessagingActionFieldsFragment['actionDetails']>);
  export type analytics = (NonNullable<MessagingActionFieldsFragment['analytics']>);
}

export namespace LodgingIntentCardFields {
  export type fragment = LodgingIntentCardFieldsFragment;
  export type gallery = (NonNullable<LodgingIntentCardFieldsFragment['gallery']>);
  export type media = NonNullable<(NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['gallery']>)['media']>)[number]>;
  export type _media = (NonNullable<NonNullable<(NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['gallery']>)['media']>)[number]>['media']>);
  export type ImageInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['gallery']>)['media']>)[number]>['media']>), { __typename: 'Image' }>);
  export type thumbnailClickAnalytics = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['gallery']>)['media']>)[number]>['media']>), { __typename: 'Image' }>)['thumbnailClickAnalytics']>);
  export type uisPrimeMessages = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['gallery']>)['media']>)[number]>['media']>), { __typename: 'Image' }>)['thumbnailClickAnalytics']>)['uisPrimeMessages']>)[number]>;
  export type primaryButton = (NonNullable<LodgingIntentCardFieldsFragment['primaryButton']>);
  export type action = (NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['primaryButton']>)['action']>);
  export type analytics = (NonNullable<(NonNullable<(NonNullable<LodgingIntentCardFieldsFragment['primaryButton']>)['action']>)['analytics']>);
  export type impressionAnalyticsTracking = (NonNullable<LodgingIntentCardFieldsFragment['impressionAnalyticsTracking']>);
}

export namespace DisplayPriceFragment {
  export type fragment = DisplayPriceFragmentFragment;
  export type price = (NonNullable<DisplayPriceFragmentFragment['price']>);
  export type disclaimer = (NonNullable<DisplayPriceFragmentFragment['disclaimer']>);
  export type primaryUIButton = (NonNullable<(NonNullable<DisplayPriceFragmentFragment['disclaimer']>)['primaryUIButton']>);
}

export namespace EnrichedMessageFragment {
  export type fragment = EnrichedMessageFragmentFragment;
}

export namespace CommonPropertyCardFields {
  export type fragment = CommonPropertyCardFieldsFragment;
  export type propertyImage = (NonNullable<CommonPropertyCardFieldsFragment['propertyImage']>);
  export type image = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyImage']>)['image']>);
  export type fallbackImage = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyImage']>)['fallbackImage']>);
  export type offerBadge = (NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>);
  export type primary = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['primary']>);
  export type secondary = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['secondary']>);
  export type tertiary = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['tertiary']>);
  export type price = (NonNullable<CommonPropertyCardFieldsFragment['price']>);
  export type displayMessages = NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['displayMessages']>)[number]>;
  export type lineItems = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>;
  export type lead = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['lead']>);
  export type strikeOut = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['strikeOut']>);
  export type disclaimer = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['disclaimer']>);
  export type priceMessages = NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['priceMessages']>)[number]>;
  export type marketingFeeDetails = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['marketingFeeDetails']>);
  export type marketingFeeMessage = (NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['marketingFeeDetails']>)['marketingFeeMessage']>);
  export type options = NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>;
  export type displayPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['displayPrice']>);
  export type _strikeOut = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['strikeOut']>);
  export type loyaltyPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['loyaltyPrice']>);
  export type amount = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['loyaltyPrice']>)['amount']>);
  export type totalStrikeOutPoints = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['loyaltyPrice']>)['totalStrikeOutPoints']>);
  export type _disclaimer = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['disclaimer']>);
  export type reviews = (NonNullable<CommonPropertyCardFieldsFragment['reviews']>);
  export type localizedSubtitleA11y = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['reviews']>)['localizedSubtitleA11y']>);
  export type mark = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['reviews']>)['mark']>);
  export type destinationInfo = (NonNullable<CommonPropertyCardFieldsFragment['destinationInfo']>);
  export type propertyDetailsLink = (NonNullable<CommonPropertyCardFieldsFragment['propertyDetailsLink']>);
  export type uri = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyDetailsLink']>)['uri']>);
  export type clientSideAnalytics = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyDetailsLink']>)['clientSideAnalytics']>);
  export type sponsoredListing = (NonNullable<CommonPropertyCardFieldsFragment['sponsoredListing']>);
}

export namespace CommonDateFields {
  export type fragment = CommonDateFieldsFragment;
}

export namespace CommonDateTimeFields {
  export type fragment = CommonDateTimeFieldsFragment;
}

export namespace featuredMessage {
  export type fragment = featuredMessageFragment;
  export type icon = (NonNullable<featuredMessageFragment['icon']>);
}

export namespace LodgingCardFields {
  export type fragment = LodgingCardFieldsFragment;
  export type featuredHeader = (NonNullable<LodgingCardFieldsFragment['featuredHeader']>);
  export type header = (NonNullable<(NonNullable<LodgingCardFieldsFragment['featuredHeader']>)['header']>);
  export type cardLink = (NonNullable<LodgingCardFieldsFragment['cardLink']>);
  export type resource = (NonNullable<(NonNullable<LodgingCardFieldsFragment['cardLink']>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<LodgingCardFieldsFragment['cardLink']>)['resource']>), { __typename: 'HttpURI' }>);
  export type analytics = (NonNullable<(NonNullable<LodgingCardFieldsFragment['cardLink']>)['analytics']>);
  export type uisPrimeMessages = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['cardLink']>)['analytics']>)['uisPrimeMessages']>)[number]>;
  export type summarySections = NonNullable<(NonNullable<LodgingCardFieldsFragment['summarySections']>)[number]>;
  export type headingSection = (NonNullable<LodgingCardFieldsFragment['headingSection']>);
  export type footerActions = NonNullable<(NonNullable<LodgingCardFieldsFragment['footerActions']>)[number]>;
  export type mediaSection = (NonNullable<LodgingCardFieldsFragment['mediaSection']>);
  export type dateSection = (NonNullable<LodgingCardFieldsFragment['dateSection']>);
  export type compareSection = (NonNullable<LodgingCardFieldsFragment['compareSection']>);
  export type callOut = (NonNullable<LodgingCardFieldsFragment['callOut']>);
  export type priceSection = (NonNullable<LodgingCardFieldsFragment['priceSection']>);
  export type priceSummary = (NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['priceSummary']>);
  export type badge = (NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['badge']>);
  export type standardBadge = (NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['standardBadge']>);
  export type button = (NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>);
  export type action = (NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['action']>);
  export type _analytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['action']>)['analytics']>);
  export type _resource = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['action']>)['resource']>);
  export type __analytics = (NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['analytics']>);
  export type icon = (NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['icon']>);
  export type attemptEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['attemptEvents']>)[number]>;
  export type clientSideAnalytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['attemptEvents']>)[number]>['clientSideAnalytics']>);
  export type events = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['attemptEvents']>)[number]>['events']>)[number]>;
  export type successEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['successEvents']>)[number]>;
  export type _clientSideAnalytics = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['successEvents']>)[number]>['clientSideAnalytics']>);
  export type _events = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['successEvents']>)[number]>['events']>)[number]>;
  export type adaptexSuccessActionTracking = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['priceSection']>)['button']>)['adaptexSuccessActionTracking']>)[number]>;
  export type clickstreamEvents = (NonNullable<LodgingCardFieldsFragment['clickstreamEvents']>);
  export type productPresented = (NonNullable<(NonNullable<LodgingCardFieldsFragment['clickstreamEvents']>)['productPresented']>);
  export type productSelected = (NonNullable<(NonNullable<LodgingCardFieldsFragment['clickstreamEvents']>)['productSelected']>);
  export type impressionAnalytics = (NonNullable<LodgingCardFieldsFragment['impressionAnalytics']>);
  export type _uisPrimeMessages = NonNullable<(NonNullable<(NonNullable<LodgingCardFieldsFragment['impressionAnalytics']>)['uisPrimeMessages']>)[number]>;
  export type _adaptexSuccessActionTracking = NonNullable<(NonNullable<LodgingCardFieldsFragment['adaptexSuccessActionTracking']>)[number]>;
}

export namespace AdaptexCampaignTrackingDetailFragment {
  export type fragment = AdaptexCampaignTrackingDetailFragmentFragment;
}

export namespace ProductEventFragment {
  export type fragment = ProductEventFragmentFragment;
  export type event = (NonNullable<ProductEventFragmentFragment['event']>);
  export type product_list = NonNullable<(NonNullable<ProductEventFragmentFragment['product_list']>)[number]>;
  export type search_request = (NonNullable<ProductEventFragmentFragment['search_request']>);
}

export namespace ClickstreamEventFragment {
  export type fragment = ClickstreamEventFragmentFragment;
}

export namespace ProductListFragment {
  export type fragment = ProductListFragmentFragment;
}

export namespace RequestFragment {
  export type fragment = RequestFragmentFragment;
}

export namespace LodgingListingDividerFields {
  export type fragment = LodgingListingDividerFieldsFragment;
  export type title = (NonNullable<LodgingListingDividerFieldsFragment['title']>);
  export type subtitle = (NonNullable<LodgingListingDividerFieldsFragment['subtitle']>);
  export type graphic = (NonNullable<LodgingListingDividerFieldsFragment['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<LodgingListingDividerFieldsFragment['graphic']>), { __typename: 'Icon' }>);
  export type IllustrationInlineFragment = (DiscriminateUnion<(NonNullable<LodgingListingDividerFieldsFragment['graphic']>), { __typename: 'Illustration' }>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<LodgingListingDividerFieldsFragment['graphic']>), { __typename: 'Mark' }>);
  export type markUrl = (NonNullable<(DiscriminateUnion<(NonNullable<LodgingListingDividerFieldsFragment['graphic']>), { __typename: 'Mark' }>)['markUrl']>);
  export type impressionAnalytics = (NonNullable<LodgingListingDividerFieldsFragment['impressionAnalytics']>);
}

export namespace PropertyListingStandardMessagingCardFragment {
  export type fragment = PropertyListingStandardMessagingCardFragmentFragment;
  export type graphic = (NonNullable<PropertyListingStandardMessagingCardFragmentFragment['graphic']>);
  export type IllustrationInlineFragment = (DiscriminateUnion<(NonNullable<PropertyListingStandardMessagingCardFragmentFragment['graphic']>), { __typename: 'Illustration' }>);
  export type links = NonNullable<(NonNullable<PropertyListingStandardMessagingCardFragmentFragment['links']>)[number]>;
  export type action = (NonNullable<NonNullable<(NonNullable<PropertyListingStandardMessagingCardFragmentFragment['links']>)[number]>['action']>);
  export type analytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<PropertyListingStandardMessagingCardFragmentFragment['links']>)[number]>['action']>)['analytics']>);
  export type resource = (NonNullable<(NonNullable<NonNullable<(NonNullable<PropertyListingStandardMessagingCardFragmentFragment['links']>)[number]>['action']>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<NonNullable<(NonNullable<PropertyListingStandardMessagingCardFragmentFragment['links']>)[number]>['action']>)['resource']>), { __typename: 'HttpURI' }>);
  export type impressionTracking = (NonNullable<PropertyListingStandardMessagingCardFragmentFragment['impressionTracking']>);
}

export namespace PropertyListingExpandoCardFragment {
  export type fragment = PropertyListingExpandoCardFragmentFragment;
  export type graphic = (NonNullable<PropertyListingExpandoCardFragmentFragment['graphic']>);
  export type IllustrationInlineFragment = (DiscriminateUnion<(NonNullable<PropertyListingExpandoCardFragmentFragment['graphic']>), { __typename: 'Illustration' }>);
  export type expandoCard = (NonNullable<PropertyListingExpandoCardFragmentFragment['expandoCard']>);
  export type expandAnalytics = (NonNullable<(NonNullable<PropertyListingExpandoCardFragmentFragment['expandoCard']>)['expandAnalytics']>);
  export type collapseAnalytics = (NonNullable<(NonNullable<PropertyListingExpandoCardFragmentFragment['expandoCard']>)['collapseAnalytics']>);
  export type expandedContent = NonNullable<(NonNullable<PropertyListingExpandoCardFragmentFragment['expandedContent']>)[number]>;
  export type _graphic = (NonNullable<NonNullable<(NonNullable<PropertyListingExpandoCardFragmentFragment['expandedContent']>)[number]>['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<PropertyListingExpandoCardFragmentFragment['expandedContent']>)[number]>['graphic']>), { __typename: 'Icon' }>);
}

export namespace LodgingCardHeadingSectionFragment {
  export type fragment = LodgingCardHeadingSectionFragmentFragment;
  export type productRating = (NonNullable<LodgingCardHeadingSectionFragmentFragment['productRating']>);
  export type featuredMessages = NonNullable<(NonNullable<LodgingCardHeadingSectionFragmentFragment['featuredMessages']>)[number]>;
  export type messages = NonNullable<(NonNullable<LodgingCardHeadingSectionFragmentFragment['messages']>)[number]>;
  export type amenities = NonNullable<(NonNullable<LodgingCardHeadingSectionFragmentFragment['amenities']>)[number]>;
}

export namespace LodgingCardFeaturedMessageFragment {
  export type fragment = LodgingCardFeaturedMessageFragmentFragment;
  export type icon = (NonNullable<LodgingCardFeaturedMessageFragmentFragment['icon']>);
}

export namespace LodgingEGDSRatingFragment {
  export type fragment = LodgingEGDSRatingFragmentFragment;
  export type EGDSIconRatingInlineFragment = (DiscriminateUnion<LodgingEGDSRatingFragmentFragment, { __typename: 'EGDSIconRating' }>);
  export type icon = (NonNullable<(DiscriminateUnion<LodgingEGDSRatingFragmentFragment, { __typename: 'EGDSIconRating' }>)['icon']>);
}

export namespace LodgingCardProductSummarySectionFragment {
  export type fragment = LodgingCardProductSummarySectionFragmentFragment;
  export type heading = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['heading']>);
  export type amenities = NonNullable<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['amenities']>)[number]>;
  export type messages = NonNullable<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['messages']>)[number]>;
  export type descriptionSection = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['descriptionSection']>);
  export type changeActionDialog = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['changeActionDialog']>);
  export type changeActionSheet = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['changeActionSheet']>);
  export type detailsAction = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['detailsAction']>);
  export type guestRating = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRating']>);
  export type parts = NonNullable<(NonNullable<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRating']>)['parts']>)[number]>;
  export type phraseParts = NonNullable<(NonNullable<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRating']>)['phraseParts']>)[number]>;
  export type guestRatingSection = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRatingSection']>);
  export type LodgingCardPhraseInlineFragment = (DiscriminateUnion<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRatingSection']>), { __typename: 'LodgingCardPhrase' }>);
  export type _parts = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRatingSection']>), { __typename: 'LodgingCardPhrase' }>)['parts']>)[number]>;
  export type _phraseParts = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRatingSection']>), { __typename: 'LodgingCardPhrase' }>)['phraseParts']>)[number]>;
  export type LodgingCardBadgedRatingInlineFragment = (DiscriminateUnion<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['guestRatingSection']>), { __typename: 'LodgingCardBadgedRating' }>);
  export type footerMessages = (NonNullable<LodgingCardProductSummarySectionFragmentFragment['footerMessages']>);
  export type listItems = NonNullable<(NonNullable<(NonNullable<LodgingCardProductSummarySectionFragmentFragment['footerMessages']>)['listItems']>)[number]>;
}

export namespace EGDSIconRatingFragment {
  export type fragment = EGDSIconRatingFragmentFragment;
  export type icon = (NonNullable<EGDSIconRatingFragmentFragment['icon']>);
}

export namespace LodgingCardBadgedRatingFragment {
  export type fragment = LodgingCardBadgedRatingFragmentFragment;
  export type badge = (NonNullable<LodgingCardBadgedRatingFragmentFragment['badge']>);
  export type phrases = NonNullable<(NonNullable<LodgingCardBadgedRatingFragmentFragment['phrases']>)[number]>;
  export type phraseParts = NonNullable<(NonNullable<NonNullable<(NonNullable<LodgingCardBadgedRatingFragmentFragment['phrases']>)[number]>['phraseParts']>)[number]>;
}

export namespace EGDSBadgeFragment {
  export type fragment = EGDSBadgeFragmentFragment;
}

export namespace LodgingProductAmenityFragment {
  export type fragment = LodgingProductAmenityFragmentFragment;
  export type icon = (NonNullable<LodgingProductAmenityFragmentFragment['icon']>);
}

export namespace LodgingCardPropertyDescriptionSectionFragment {
  export type fragment = LodgingCardPropertyDescriptionSectionFragmentFragment;
  export type heading = (NonNullable<LodgingCardPropertyDescriptionSectionFragmentFragment['heading']>);
  export type description = (NonNullable<LodgingCardPropertyDescriptionSectionFragmentFragment['description']>);
  export type link = (NonNullable<LodgingCardPropertyDescriptionSectionFragmentFragment['link']>);
  export type action = (NonNullable<(NonNullable<LodgingCardPropertyDescriptionSectionFragmentFragment['link']>)['action']>);
  export type resource = (NonNullable<(NonNullable<(NonNullable<LodgingCardPropertyDescriptionSectionFragmentFragment['link']>)['action']>)['resource']>);
}

export namespace LodgingCardChangeUnitDialogActionFragment {
  export type fragment = LodgingCardChangeUnitDialogActionFragmentFragment;
  export type dialog = (NonNullable<LodgingCardChangeUnitDialogActionFragmentFragment['dialog']>);
  export type closeAnalytics = (NonNullable<(NonNullable<LodgingCardChangeUnitDialogActionFragmentFragment['dialog']>)['closeAnalytics']>);
  export type toolbar = (NonNullable<(NonNullable<LodgingCardChangeUnitDialogActionFragmentFragment['dialog']>)['toolbar']>);
  export type trigger = (NonNullable<LodgingCardChangeUnitDialogActionFragmentFragment['trigger']>);
}

export namespace EGDSDialogToolbarFragment {
  export type fragment = EGDSDialogToolbarFragmentFragment;
}

export namespace LodgingCardChangeUnitSheetActionFragment {
  export type fragment = LodgingCardChangeUnitSheetActionFragmentFragment;
  export type sheet = (NonNullable<LodgingCardChangeUnitSheetActionFragmentFragment['sheet']>);
  export type closeAnalytics = (NonNullable<(NonNullable<LodgingCardChangeUnitSheetActionFragmentFragment['sheet']>)['closeAnalytics']>);
  export type trigger = (NonNullable<LodgingCardChangeUnitSheetActionFragmentFragment['trigger']>);
}

export namespace LodgingCardMoreDetailsTriggerFragment {
  export type fragment = LodgingCardMoreDetailsTriggerFragmentFragment;
  export type analytics = (NonNullable<LodgingCardMoreDetailsTriggerFragmentFragment['analytics']>);
  export type icon = (NonNullable<LodgingCardMoreDetailsTriggerFragmentFragment['icon']>);
}

export namespace LodgingEGDSIconFragment {
  export type fragment = LodgingEGDSIconFragmentFragment;
}

export namespace LodgingCardPropertyDialogActionFragment {
  export type fragment = LodgingCardPropertyDialogActionFragmentFragment;
  export type LodgingCardUnitDetailsDialogInlineFragment = (DiscriminateUnion<LodgingCardPropertyDialogActionFragmentFragment, { __typename: 'LodgingCardUnitDetailsDialog' }>);
  export type LodgingCardPropertyDetailsDialogInlineFragment = (DiscriminateUnion<LodgingCardPropertyDialogActionFragmentFragment, { __typename: 'LodgingCardPropertyDetailsDialog' }>);
}

export namespace LodgingCardPropertyDetailsDialogActionFragment {
  export type fragment = LodgingCardPropertyDetailsDialogActionFragmentFragment;
  export type dialog = (NonNullable<LodgingCardPropertyDetailsDialogActionFragmentFragment['dialog']>);
  export type closeAnalytics = (NonNullable<(NonNullable<LodgingCardPropertyDetailsDialogActionFragmentFragment['dialog']>)['closeAnalytics']>);
  export type toolbar = (NonNullable<(NonNullable<LodgingCardPropertyDetailsDialogActionFragmentFragment['dialog']>)['toolbar']>);
  export type trigger = (NonNullable<LodgingCardPropertyDetailsDialogActionFragmentFragment['trigger']>);
}

export namespace LodgingCardUnitDetailsDialogActionFragment {
  export type fragment = LodgingCardUnitDetailsDialogActionFragmentFragment;
  export type dialog = (NonNullable<LodgingCardUnitDetailsDialogActionFragmentFragment['dialog']>);
  export type closeAnalytics = (NonNullable<(NonNullable<LodgingCardUnitDetailsDialogActionFragmentFragment['dialog']>)['closeAnalytics']>);
  export type toolbar = (NonNullable<(NonNullable<LodgingCardUnitDetailsDialogActionFragmentFragment['dialog']>)['toolbar']>);
  export type trigger = (NonNullable<LodgingCardUnitDetailsDialogActionFragmentFragment['trigger']>);
}

export namespace LodgingCardMoreDetailsLinkTriggerFragment {
  export type fragment = LodgingCardMoreDetailsLinkTriggerFragmentFragment;
  export type analytics = (NonNullable<LodgingCardMoreDetailsLinkTriggerFragmentFragment['analytics']>);
  export type icon = (NonNullable<LodgingCardMoreDetailsLinkTriggerFragmentFragment['icon']>);
}

export namespace LodgingCardLinkActionFragment {
  export type fragment = LodgingCardLinkActionFragmentFragment;
  export type link = (NonNullable<LodgingCardLinkActionFragmentFragment['link']>);
  export type action = (NonNullable<(NonNullable<LodgingCardLinkActionFragmentFragment['link']>)['action']>);
  export type resource = (NonNullable<(NonNullable<(NonNullable<LodgingCardLinkActionFragmentFragment['link']>)['action']>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<LodgingCardLinkActionFragmentFragment['link']>)['action']>)['resource']>), { __typename: 'HttpURI' }>);
  export type analytics = (NonNullable<(NonNullable<(NonNullable<LodgingCardLinkActionFragmentFragment['link']>)['action']>)['analytics']>);
  export type icon = (NonNullable<(NonNullable<LodgingCardLinkActionFragmentFragment['link']>)['icon']>);
}

export namespace LodgingCardMediaSectionFragment {
  export type fragment = LodgingCardMediaSectionFragmentFragment;
  export type gallery = (NonNullable<LodgingCardMediaSectionFragmentFragment['gallery']>);
  export type badges = (NonNullable<LodgingCardMediaSectionFragmentFragment['badges']>);
  export type primaryBadge = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['badges']>)['primaryBadge']>);
  export type secondaryBadge = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['badges']>)['secondaryBadge']>);
  export type tertiaryBadge = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['badges']>)['tertiaryBadge']>);
  export type saveItem = (NonNullable<LodgingCardMediaSectionFragmentFragment['saveItem']>);
  export type analytics = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveItem']>)['analytics']>);
  export type items = NonNullable<(NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveItem']>)['items']>)[number]>;
  export type labels = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveItem']>)['labels']>);
  export type messages = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveItem']>)['messages']>);
  export type saveTripItem = (NonNullable<LodgingCardMediaSectionFragmentFragment['saveTripItem']>);
  export type save = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveTripItem']>)['save']>);
  export type remove = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveTripItem']>)['remove']>);
  export type attributes = (NonNullable<(NonNullable<LodgingCardMediaSectionFragmentFragment['saveTripItem']>)['attributes']>);
}

export namespace LodgingCardDateSectionFragment {
  export type fragment = LodgingCardDateSectionFragmentFragment;
  export type date = (NonNullable<LodgingCardDateSectionFragmentFragment['date']>);
  export type EGDSStylizedTextInlineFragment = (DiscriminateUnion<(NonNullable<LodgingCardDateSectionFragmentFragment['date']>), { __typename: 'EGDSStylizedText' }>);
}

export namespace LodgingCardCompareSectionFragment {
  export type fragment = LodgingCardCompareSectionFragmentFragment;
  export type compareAction = (NonNullable<LodgingCardCompareSectionFragmentFragment['compareAction']>);
  export type EGDSBasicCheckBoxInlineFragment = (DiscriminateUnion<(NonNullable<LodgingCardCompareSectionFragmentFragment['compareAction']>), { __typename: 'EGDSBasicCheckBox' }>);
  export type label = (NonNullable<(DiscriminateUnion<(NonNullable<LodgingCardCompareSectionFragmentFragment['compareAction']>), { __typename: 'EGDSBasicCheckBox' }>)['label']>);
}

export namespace TripsSaveItemPropertiesFragment {
  export type fragment = TripsSaveItemPropertiesFragmentFragment;
  export type analytics = (NonNullable<TripsSaveItemPropertiesFragmentFragment['analytics']>);
  export type uisPrimeMessages = NonNullable<(NonNullable<(NonNullable<TripsSaveItemPropertiesFragmentFragment['analytics']>)['uisPrimeMessages']>)[number]>;
  export type adaptexSuccessCampaignIds = NonNullable<(NonNullable<TripsSaveItemPropertiesFragmentFragment['adaptexSuccessCampaignIds']>)[number]>;
}

export namespace TripsSaveStayAttributesFragment {
  export type fragment = TripsSaveStayAttributesFragmentFragment;
  export type roomConfiguration = NonNullable<(NonNullable<TripsSaveStayAttributesFragmentFragment['roomConfiguration']>)[number]>;
  export type checkInDate = (NonNullable<TripsSaveStayAttributesFragmentFragment['checkInDate']>);
  export type checkoutDate = (NonNullable<TripsSaveStayAttributesFragmentFragment['checkoutDate']>);
}

export namespace TripsSaveActivityAttributesFragment {
  export type fragment = TripsSaveActivityAttributesFragmentFragment;
  export type dateRange = (NonNullable<TripsSaveActivityAttributesFragmentFragment['dateRange']>);
  export type start = (NonNullable<(NonNullable<TripsSaveActivityAttributesFragmentFragment['dateRange']>)['start']>);
  export type end = (NonNullable<(NonNullable<TripsSaveActivityAttributesFragmentFragment['dateRange']>)['end']>);
}

export namespace LodgingGalleryCarouselFragment {
  export type fragment = LodgingGalleryCarouselFragmentFragment;
  export type navClickAnalytics = (NonNullable<LodgingGalleryCarouselFragmentFragment['navClickAnalytics']>);
  export type intersectionAnalytics = (NonNullable<LodgingGalleryCarouselFragmentFragment['intersectionAnalytics']>);
  export type uisPrimeMessages = NonNullable<(NonNullable<(NonNullable<LodgingGalleryCarouselFragmentFragment['intersectionAnalytics']>)['uisPrimeMessages']>)[number]>;
  export type media = NonNullable<(NonNullable<LodgingGalleryCarouselFragmentFragment['media']>)[number]>;
}

export namespace LodgingMediaItemFragment {
  export type fragment = LodgingMediaItemFragmentFragment;
  export type media = (NonNullable<LodgingMediaItemFragmentFragment['media']>);
  export type ImageInlineFragment = (DiscriminateUnion<(NonNullable<LodgingMediaItemFragmentFragment['media']>), { __typename: 'Image' }>);
}

export namespace LodgingEGDSImageFragment {
  export type fragment = LodgingEGDSImageFragmentFragment;
  export type thumbnailClickAnalytics = (NonNullable<LodgingEGDSImageFragmentFragment['thumbnailClickAnalytics']>);
}

export namespace LodgingEGDSStandardBadgeFragment {
  export type fragment = LodgingEGDSStandardBadgeFragmentFragment;
  export type graphic = (NonNullable<LodgingEGDSStandardBadgeFragmentFragment['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<LodgingEGDSStandardBadgeFragmentFragment['graphic']>), { __typename: 'Icon' }>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<LodgingEGDSStandardBadgeFragmentFragment['graphic']>), { __typename: 'Mark' }>);
}

export namespace LodgingstandardBadgeFragmentDoc {
  export type fragment = LodgingstandardBadgeFragmentDocFragment;
  export type standardBadge = (NonNullable<LodgingstandardBadgeFragmentDocFragment['standardBadge']>);
  export type graphic = (NonNullable<(NonNullable<LodgingstandardBadgeFragmentDocFragment['standardBadge']>)['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<LodgingstandardBadgeFragmentDocFragment['standardBadge']>)['graphic']>), { __typename: 'Icon' }>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<LodgingstandardBadgeFragmentDocFragment['standardBadge']>)['graphic']>), { __typename: 'Mark' }>);
  export type impressionEventAnalytics = (NonNullable<LodgingstandardBadgeFragmentDocFragment['impressionEventAnalytics']>);
}

export namespace LodgingEGDSTextFragment {
  export type fragment = LodgingEGDSTextFragmentFragment;
  export type EGDSPlainTextInlineFragment = (DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSPlainText' }>);
  export type EGDSParagraphInlineFragment = (DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSParagraph' }>);
  export type EGDSStylizedTextInlineFragment = (DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSStylizedText' }>);
  export type EGDSInlineLinkInlineFragment = (DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSInlineLink' }>);
  export type action = (NonNullable<(DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSInlineLink' }>)['action']>);
  export type analytics = (NonNullable<(NonNullable<(DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSInlineLink' }>)['action']>)['analytics']>);
  export type resource = (NonNullable<(NonNullable<(DiscriminateUnion<LodgingEGDSTextFragmentFragment, { __typename: 'EGDSInlineLink' }>)['action']>)['resource']>);
}

export namespace LodgingEGDSParagraphFragment {
  export type fragment = LodgingEGDSParagraphFragmentFragment;
}

export namespace EGDSStylizedTextFragment {
  export type fragment = EGDSStylizedTextFragmentFragment;
}

export namespace PriceSummaryFragment {
  export type fragment = PriceSummaryFragmentFragment;
  export type displayMessages = NonNullable<(NonNullable<PriceSummaryFragmentFragment['displayMessages']>)[number]>;
  export type lineItems = NonNullable<(NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['displayMessages']>)[number]>['lineItems']>)[number]>;
  export type options = NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>;
  export type displayPrice = (NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['displayPrice']>);
  export type disclaimer = (NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['disclaimer']>);
  export type priceDisclaimer = (NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['priceDisclaimer']>);
  export type primaryButton = (NonNullable<(NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['priceDisclaimer']>)['primaryButton']>);
  export type trigger = (NonNullable<(NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['priceDisclaimer']>)['trigger']>);
  export type icon = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['priceDisclaimer']>)['trigger']>)['icon']>);
  export type strikeOut = (NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['strikeOut']>);
  export type loyaltyPrice = (NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['loyaltyPrice']>);
  export type amount = (NonNullable<(NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['loyaltyPrice']>)['amount']>);
  export type totalStrikeOutPoints = (NonNullable<(NonNullable<NonNullable<(NonNullable<PriceSummaryFragmentFragment['options']>)[number]>['loyaltyPrice']>)['totalStrikeOutPoints']>);
  export type priceMessaging = NonNullable<(NonNullable<PriceSummaryFragmentFragment['priceMessaging']>)[number]>;
  export type marketingFeeDetails = (NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>);
  export type tierMessage = (NonNullable<(NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>)['tierMessage']>);
  export type egdsMark = (NonNullable<(NonNullable<(NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>)['tierMessage']>)['egdsMark']>);
  export type marketingFeeMessageDialog = (NonNullable<(NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>)['marketingFeeMessageDialog']>);
  export type dialog = (NonNullable<(NonNullable<(NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>)['marketingFeeMessageDialog']>)['dialog']>);
  export type footer = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>)['marketingFeeMessageDialog']>)['dialog']>)['footer']>);
  export type buttons = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PriceSummaryFragmentFragment['marketingFeeDetails']>)['marketingFeeMessageDialog']>)['dialog']>)['footer']>)['buttons']>)[number]>;
}

export namespace PriceMessageFragment {
  export type fragment = PriceMessageFragmentFragment;
  export type price = (NonNullable<PriceMessageFragmentFragment['price']>);
  export type disclaimer = (NonNullable<PriceMessageFragmentFragment['disclaimer']>);
  export type primaryUIButton = (NonNullable<(NonNullable<PriceMessageFragmentFragment['disclaimer']>)['primaryUIButton']>);
}

export namespace LodgingEGDSHeadingFragment {
  export type fragment = LodgingEGDSHeadingFragmentFragment;
}

export namespace OfferBadgeFragment {
  export type fragment = OfferBadgeFragmentFragment;
  export type icon_temp = (NonNullable<OfferBadgeFragmentFragment['icon_temp']>);
  export type mark = (NonNullable<OfferBadgeFragmentFragment['mark']>);
}

export namespace LodgingProductFooterMessagesFragment {
  export type fragment = LodgingProductFooterMessagesFragmentFragment;
  export type mark = (NonNullable<LodgingProductFooterMessagesFragmentFragment['mark']>);
  export type url = (NonNullable<(NonNullable<LodgingProductFooterMessagesFragmentFragment['mark']>)['url']>);
}

export namespace LodgingProductSpannableFooterMessagesFragment {
  export type fragment = LodgingProductSpannableFooterMessagesFragmentFragment;
  export type graphic = (NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['graphic']>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['graphic']>), { __typename: 'Mark' }>);
  export type url = (NonNullable<(DiscriminateUnion<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['graphic']>), { __typename: 'Mark' }>)['url']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['graphic']>), { __typename: 'Icon' }>);
  export type IllustrationInlineFragment = (DiscriminateUnion<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['graphic']>), { __typename: 'Illustration' }>);
  export type stylizedText = (NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>);
  export type EGDSSpannableTextInlineFragment = ({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>);
  export type contents = NonNullable<(NonNullable<({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>)['contents']>)[number]>;
  export type EGDSPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>)['contents']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type EGDSStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>)['contents']>)[number]>, { __typename: 'EGDSStylizedText' }>);
  export type inlineContent = NonNullable<(NonNullable<({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>)['inlineContent']>)[number]>;
  export type _EGDSPlainTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>)['inlineContent']>)[number]>, { __typename: 'EGDSPlainText' }>);
  export type _EGDSStylizedTextInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<({ __typename: 'EGDSSpannableText' } & Pick<(NonNullable<LodgingProductSpannableFooterMessagesFragmentFragment['stylizedText']>), '__typename' | 'text' | 'contents' | 'inlineContent'>)['inlineContent']>)[number]>, { __typename: 'EGDSStylizedText' }>);
}

export namespace LodgingEGDSPlainTextFragment {
  export type fragment = LodgingEGDSPlainTextFragmentFragment;
}

export namespace LodgingMoreInfoTriggerFragment {
  export type fragment = LodgingMoreInfoTriggerFragmentFragment;
  export type icon = (NonNullable<LodgingMoreInfoTriggerFragmentFragment['icon']>);
  export type action = (NonNullable<LodgingMoreInfoTriggerFragmentFragment['action']>);
  export type analytics = (NonNullable<(NonNullable<LodgingMoreInfoTriggerFragmentFragment['action']>)['analytics']>);
  export type resource = (NonNullable<(NonNullable<LodgingMoreInfoTriggerFragmentFragment['action']>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<LodgingMoreInfoTriggerFragmentFragment['action']>)['resource']>), { __typename: 'HttpURI' }>);
}

export namespace SponsoredContentPlacementFields {
  export type fragment = SponsoredContentPlacementFieldsFragment;
  export type sponsoredContentContext = (NonNullable<SponsoredContentPlacementFieldsFragment['sponsoredContentContext']>);
  export type targeting = (NonNullable<(NonNullable<SponsoredContentPlacementFieldsFragment['sponsoredContentContext']>)['targeting']>);
  export type dateStart = (NonNullable<(NonNullable<(NonNullable<SponsoredContentPlacementFieldsFragment['sponsoredContentContext']>)['targeting']>)['dateStart']>);
  export type dateEnd = (NonNullable<(NonNullable<(NonNullable<SponsoredContentPlacementFieldsFragment['sponsoredContentContext']>)['targeting']>)['dateEnd']>);
}

export namespace PropertySearchListingsSoldOutFields {
  export type fragment = PropertySearchListingsSoldOutFieldsFragment;
  export type cardContent = (NonNullable<PropertySearchListingsSoldOutFieldsFragment['cardContent']>);
  export type EGDSStandardMessagingCardInlineFragment = ({ __typename: 'EGDSStandardMessagingCard' } & Pick<(NonNullable<PropertySearchListingsSoldOutFieldsFragment['cardContent']>), '__typename' | 'heading' | 'graphic'>);
  export type graphic = (NonNullable<({ __typename: 'EGDSStandardMessagingCard' } & Pick<(NonNullable<PropertySearchListingsSoldOutFieldsFragment['cardContent']>), '__typename' | 'heading' | 'graphic'>)['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<({ __typename: 'EGDSStandardMessagingCard' } & Pick<(NonNullable<PropertySearchListingsSoldOutFieldsFragment['cardContent']>), '__typename' | 'heading' | 'graphic'>)['graphic']>), { __typename: 'Icon' }>);
  export type actionButton = (NonNullable<PropertySearchListingsSoldOutFieldsFragment['actionButton']>);
  export type EGDSButtonInlineFragment = (DiscriminateUnion<(NonNullable<PropertySearchListingsSoldOutFieldsFragment['actionButton']>), { __typename: 'EGDSButton' }>);
  export type analytics = (NonNullable<(DiscriminateUnion<(NonNullable<PropertySearchListingsSoldOutFieldsFragment['actionButton']>), { __typename: 'EGDSButton' }>)['analytics']>);
  export type _analytics = (NonNullable<PropertySearchListingsSoldOutFieldsFragment['analytics']>);
}

export namespace PropertyListingOverfilteredFragment {
  export type fragment = PropertyListingOverfilteredFragmentFragment;
  export type cardContent = (NonNullable<PropertyListingOverfilteredFragmentFragment['cardContent']>);
  export type EGDSStandardMessagingCardInlineFragment = ({ __typename: 'EGDSStandardMessagingCard' } & Pick<(NonNullable<PropertyListingOverfilteredFragmentFragment['cardContent']>), 'heading' | 'message' | 'graphic'>);
  export type graphic = (NonNullable<({ __typename: 'EGDSStandardMessagingCard' } & Pick<(NonNullable<PropertyListingOverfilteredFragmentFragment['cardContent']>), 'heading' | 'message' | 'graphic'>)['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<({ __typename: 'EGDSStandardMessagingCard' } & Pick<(NonNullable<PropertyListingOverfilteredFragmentFragment['cardContent']>), 'heading' | 'message' | 'graphic'>)['graphic']>), { __typename: 'Icon' }>);
  export type action = (NonNullable<PropertyListingOverfilteredFragmentFragment['action']>);
  export type button = (NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['button']>);
  export type UISecondaryButtonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['button']>), { __typename: 'UISecondaryButton' }>);
  export type analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['button']>), { __typename: 'UISecondaryButton' }>)['analytics']>);
  export type ClientSideAnalyticsInlineFragment = ({ __typename: 'ClientSideAnalytics' } & Pick<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['button']>), { __typename: 'UISecondaryButton' }>)['analytics']>), 'referrerId' | 'linkName'>);
  export type _action = (NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['action']>);
  export type UILinkActionInlineFragment = ({ __typename: 'UILinkAction' } & Pick<(NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['action']>), 'resource' | 'target' | 'useRelativePath'>);
  export type resource = (NonNullable<({ __typename: 'UILinkAction' } & Pick<(NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['action']>), 'resource' | 'target' | 'useRelativePath'>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<({ __typename: 'UILinkAction' } & Pick<(NonNullable<(NonNullable<PropertyListingOverfilteredFragmentFragment['action']>)['action']>), 'resource' | 'target' | 'useRelativePath'>)['resource']>), { __typename: 'HttpURI' }>);
  export type impressionAnalytics = (NonNullable<PropertyListingOverfilteredFragmentFragment['impressionAnalytics']>);
  export type ClientSideImpressionEventAnalyticsInlineFragment = ({ __typename: 'ClientSideImpressionEventAnalytics' } & Pick<(NonNullable<PropertyListingOverfilteredFragmentFragment['impressionAnalytics']>), 'event' | 'referrerId' | 'linkName'>);
}

export namespace SearchFilterPillsFragment {
  export type fragment = SearchFilterPillsFragmentFragment;
  export type filterPills = NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>;
  export type BasicShoppingAppliedFilterInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>, { __typename: 'BasicShoppingAppliedFilter' }>);
  export type filter = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>, { __typename: 'BasicShoppingAppliedFilter' }>)['filter']>);
  export type linkUrl = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>, { __typename: 'BasicShoppingAppliedFilter' }>)['linkUrl']>);
  export type UILinkActionInlineFragment = ({ __typename: 'UILinkAction' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>, { __typename: 'BasicShoppingAppliedFilter' }>)['linkUrl']>), 'resource' | 'target' | 'useRelativePath'>);
  export type resource = (NonNullable<({ __typename: 'UILinkAction' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>, { __typename: 'BasicShoppingAppliedFilter' }>)['linkUrl']>), 'resource' | 'target' | 'useRelativePath'>)['resource']>);
  export type HttpURIInlineFragment = (DiscriminateUnion<(NonNullable<({ __typename: 'UILinkAction' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<SearchFilterPillsFragmentFragment['filterPills']>)[number]>, { __typename: 'BasicShoppingAppliedFilter' }>)['linkUrl']>), 'resource' | 'target' | 'useRelativePath'>)['resource']>), { __typename: 'HttpURI' }>);
}

export namespace LodgingEGDSRemovablePillFragment {
  export type fragment = LodgingEGDSRemovablePillFragmentFragment;
  export type remove = (NonNullable<LodgingEGDSRemovablePillFragmentFragment['remove']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<LodgingEGDSRemovablePillFragmentFragment['remove']>), { __typename: 'Icon' }>);
  export type removeAnalytics = (NonNullable<LodgingEGDSRemovablePillFragmentFragment['removeAnalytics']>);
}

export namespace LodgingAdaptExAnalyticsEventFragment {
  export type fragment = LodgingAdaptExAnalyticsEventFragmentFragment;
  export type clientSideAnalytics = (NonNullable<LodgingAdaptExAnalyticsEventFragmentFragment['clientSideAnalytics']>);
  export type events = NonNullable<(NonNullable<LodgingAdaptExAnalyticsEventFragmentFragment['events']>)[number]>;
}

export namespace PrepareCheckoutByCartId {
  export type Variables = PrepareCheckoutByCartIdMutationVariables;
  export type mutation = PrepareCheckoutByCartIdMutation;
  export type prepareCheckoutByCartId = (NonNullable<PrepareCheckoutByCartIdMutation['prepareCheckoutByCartId']>);
  export type failureReason = (NonNullable<(NonNullable<PrepareCheckoutByCartIdMutation['prepareCheckoutByCartId']>)['failureReason']>);
  export type MaxRoomsFailureInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<PrepareCheckoutByCartIdMutation['prepareCheckoutByCartId']>)['failureReason']>), { __typename: 'MaxRoomsFailure' }>);
}

export namespace PrepareCheckout {
  export type Variables = PrepareCheckoutMutationVariables;
  export type mutation = PrepareCheckoutMutation;
  export type prepareCheckout = (NonNullable<PrepareCheckoutMutation['prepareCheckout']>);
}

export namespace PropertyInfoPageLayout {
  export type Variables = PropertyInfoPageLayoutQueryVariables;
  export type query = PropertyInfoPageLayoutQuery;
  export type propertyInfo = (NonNullable<PropertyInfoPageLayoutQuery['propertyInfo']>);
  export type experimental = (NonNullable<(NonNullable<PropertyInfoPageLayoutQuery['propertyInfo']>)['experimental']>);
  export type pageLayoutExperimentalFeature = (NonNullable<(NonNullable<(NonNullable<PropertyInfoPageLayoutQuery['propertyInfo']>)['experimental']>)['pageLayoutExperimentalFeature']>);
}

export namespace RemoveItemFromCart {
  export type Variables = RemoveItemFromCartMutationVariables;
  export type mutation = RemoveItemFromCartMutation;
  export type cartItems = (NonNullable<RemoveItemFromCartMutation['cartItems']>);
  export type remove = (NonNullable<(NonNullable<RemoveItemFromCartMutation['cartItems']>)['remove']>);
}

export namespace SearchResultsPageLayout {
  export type Variables = SearchResultsPageLayoutQueryVariables;
  export type query = SearchResultsPageLayoutQuery;
  export type propertySearch = (NonNullable<SearchResultsPageLayoutQuery['propertySearch']>);
  export type experimental = (NonNullable<(NonNullable<SearchResultsPageLayoutQuery['propertySearch']>)['experimental']>);
  export type pageLayoutFeatureExperiment = (NonNullable<(NonNullable<(NonNullable<SearchResultsPageLayoutQuery['propertySearch']>)['experimental']>)['pageLayoutFeatureExperiment']>);
}

export namespace SelectProducts {
  export type Variables = SelectProductsMutationVariables;
  export type mutation = SelectProductsMutation;
  export type multiItemShopping = (NonNullable<SelectProductsMutation['multiItemShopping']>);
  export type selectProducts = (NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type shoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type multiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}

export const MapTriggerFragmentFragmentDoc = gql`
    fragment MapTriggerFragment on LodgingMapTrigger {
  icon {
    id
    title
    token
  }
  label
  small {
    description
    url
  }
  medium {
    description
    url
  }
  large {
    description
    url
  }
  clientSideAnalytics {
    linkName
    referrerId
  }
}
    `;
export const CommonDateFieldsFragmentDoc = gql`
    fragment CommonDateFields on Date {
  year
  month
  day
}
    `;
export const MultiItemPropertySearchContextFieldsFragmentDoc = gql`
    fragment MultiItemPropertySearchContextFields on MultiItemSearchContext {
  properties {
    primary {
      rooms {
        adults
      }
      destination {
        regionId
        regionName
      }
      dateRange {
        checkInDate {
          ...CommonDateFields
        }
        checkOutDate {
          ...CommonDateFields
        }
      }
    }
  }
}
    ${CommonDateFieldsFragmentDoc}`;
export const MessageTitleFieldsFragmentDoc = gql`
    fragment MessageTitleFields on MessagingResultTitle {
  text
  icon {
    description
    id
    size
    spotLight
  }
  egdsMark {
    id
    description
    url {
      value
    }
  }
  illustration {
    assetUri {
      value
    }
    description
  }
}
    `;
export const MessagingActionFieldsFragmentDoc = gql`
    fragment MessagingActionFields on MessagingAction {
  actionDetails {
    action
    details
    name
    title
    accessibilityLabel
  }
  analytics {
    referrerId
    linkName
  }
  linkUrl
  referrerId
  text
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on MessageResult {
  __typename
  title {
    ...MessageTitleFields
  }
  subtitle {
    ...MessageTitleFields
  }
  action {
    primary {
      ...MessagingActionFields
    }
    secondary {
      ...MessagingActionFields
    }
  }
  footerText
  type
}
    ${MessageTitleFieldsFragmentDoc}
${MessagingActionFieldsFragmentDoc}`;
export const LodgingIntentCardFieldsFragmentDoc = gql`
    fragment LodgingIntentCardFields on LodgingIntentCard {
  __typename
  headingTitle
  cardMessage: message
  gallery {
    media {
      id
      media {
        ... on Image {
          thumbnailClickAnalytics {
            linkName
            referrerId
            uisPrimeMessages {
              messageContent
              schemaName
            }
          }
          url
          description
        }
      }
    }
  }
  primaryButton {
    primary
    action {
      analytics {
        __typename
        linkName
        referrerId
      }
    }
  }
  impressionAnalyticsTracking: impressionTracking {
    __typename
    event
    referrerId
  }
}
    `;
export const OfferBadgeFragmentFragmentDoc = gql`
    fragment OfferBadgeFragment on Badge {
  text
  theme_temp
  icon_temp {
    id
    description
    title
  }
  mark {
    id
    description
  }
}
    `;
export const DisplayPriceFragmentFragmentDoc = gql`
    fragment DisplayPriceFragment on DisplayPrice {
  __typename
  role
  price {
    formatted
    accessibilityLabel
  }
  disclaimer {
    content
    primaryUIButton {
      accessibility
      primary
    }
  }
}
    `;
export const EnrichedMessageFragmentFragmentDoc = gql`
    fragment EnrichedMessageFragment on LodgingEnrichedMessage {
  __typename
  value
  state
}
    `;
export const CommonPropertyCardFieldsFragmentDoc = gql`
    fragment CommonPropertyCardFields on Property {
  id
  name
  propertyImage {
    image {
      description
      url
    }
    fallbackImage {
      description
      url
    }
  }
  offerBadge {
    primary {
      ...OfferBadgeFragment
    }
    secondary {
      ...OfferBadgeFragment
    }
    tertiary {
      ...OfferBadgeFragment
    }
  }
  price {
    displayMessages {
      lineItems {
        ...DisplayPriceFragment
        ...EnrichedMessageFragment
      }
    }
    lead {
      formatted
    }
    strikeOutType
    strikeOut {
      formatted
    }
    disclaimer {
      value
    }
    roomNightMessage
    priceMessages {
      value
    }
    marketingFeeDetails {
      tierName
      tierIcon
      marketingFeeMessage {
        value
      }
    }
    options {
      leadingCaption
      displayPrice {
        formatted
      }
      strikeOut {
        formatted
      }
      loyaltyPrice {
        amount {
          formatted
        }
        totalStrikeOutPoints {
          formatted
        }
        unit
      }
      disclaimer {
        value
      }
    }
  }
  reviews {
    scoreDenominator
    score
    localizedScore
    total
    localizedTotal
    superlative
    localizedSubtitle
    localizedSubtitleA11y {
      accessibilityLabel
      value
    }
    mark {
      id
      description
    }
  }
  destinationInfo {
    distanceFromMessaging
  }
  vipMessaging
  propertyDetailsLink {
    uri {
      value
      relativePath
    }
    clientSideAnalytics {
      referrerId
      linkName
    }
  }
  sponsoredListing {
    id
    clickRedirectTrackingUrl
    clickTrackingUrl
    details
    detailsHeadline
    hotelImage
    impressionTrackingUrl
    trackingData
    brand
    clickRedirectLinkoffTrackingUrl
    logo
    lotagline
    rating
    slots
    vanityUrl
    rank
    position
  }
}
    ${OfferBadgeFragmentFragmentDoc}
${DisplayPriceFragmentFragmentDoc}
${EnrichedMessageFragmentFragmentDoc}`;
export const CommonDateTimeFieldsFragmentDoc = gql`
    fragment CommonDateTimeFields on DateTime {
  year
  month
  day
  hour
  minute
  second
}
    `;
export const featuredMessageFragmentDoc = gql`
    fragment featuredMessage on LodgingEnrichedMessage {
  icon {
    id
    description
    size
  }
  value
}
    `;
export const LodgingEGDSHeadingFragmentFragmentDoc = gql`
    fragment LodgingEGDSHeadingFragment on EGDSHeading {
  __typename
  text
}
    `;
export const LodgingEGDSIconFragmentFragmentDoc = gql`
    fragment LodgingEGDSIconFragment on Icon {
  __typename
  description
  id
  size
  theme
}
    `;
export const LodgingProductAmenityFragmentFragmentDoc = gql`
    fragment LodgingProductAmenityFragment on EGDSIconText {
  icon {
    ...LodgingEGDSIconFragment
  }
  text
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingEGDSParagraphFragmentFragmentDoc = gql`
    fragment LodgingEGDSParagraphFragment on EGDSParagraph {
  __typename
  text
}
    `;
export const EGDSStylizedTextFragmentFragmentDoc = gql`
    fragment EGDSStylizedTextFragment on EGDSStylizedText {
  __typename
  text
  theme
  weight
  size
  decorative
  accessibility
}
    `;
export const LodgingEGDSTextFragmentFragmentDoc = gql`
    fragment LodgingEGDSTextFragment on EGDSText {
  ... on EGDSPlainText {
    __typename
    text
  }
  ... on EGDSParagraph {
    ...LodgingEGDSParagraphFragment
  }
  ... on EGDSStylizedText {
    ...EGDSStylizedTextFragment
  }
  ... on EGDSInlineLink {
    __typename
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
      }
      target
    }
    disabled
    linkSize: size
    text
  }
}
    ${LodgingEGDSParagraphFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}`;
export const LodgingCardPropertyDescriptionSectionFragmentFragmentDoc = gql`
    fragment LodgingCardPropertyDescriptionSectionFragment on LodgingCardPropertyDescriptionSection {
  heading {
    text
  }
  description {
    text
  }
  link {
    action {
      resource {
        value
      }
    }
  }
}
    `;
export const EGDSDialogToolbarFragmentFragmentDoc = gql`
    fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {
  closeText
  title
}
    `;
export const LodgingCardMoreDetailsTriggerFragmentFragmentDoc = gql`
    fragment LodgingCardMoreDetailsTriggerFragment on LodgingCardMoreDetailsTrigger {
  accessibilityLabel
  analytics {
    linkName
    referrerId
  }
  icon {
    ...LodgingEGDSIconFragment
  }
  label
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingCardChangeUnitDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardChangeUnitDialogActionFragment on LodgingCardChangeUnitDialogAction {
  dialog {
    closeAnalytics {
      linkName
      referrerId
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
  trigger {
    ...LodgingCardMoreDetailsTriggerFragment
  }
}
    ${EGDSDialogToolbarFragmentFragmentDoc}
${LodgingCardMoreDetailsTriggerFragmentFragmentDoc}`;
export const LodgingCardChangeUnitSheetActionFragmentFragmentDoc = gql`
    fragment LodgingCardChangeUnitSheetActionFragment on LodgingCardChangeUnitSheetAction {
  sheet {
    closeAnalytics {
      linkName
      referrerId
    }
    closeText
  }
  trigger {
    ...LodgingCardMoreDetailsTriggerFragment
  }
}
    ${LodgingCardMoreDetailsTriggerFragmentFragmentDoc}`;
export const LodgingCardMoreDetailsLinkTriggerFragmentFragmentDoc = gql`
    fragment LodgingCardMoreDetailsLinkTriggerFragment on LodgingCardMoreDetailsTrigger {
  accessibilityLabel
  analytics {
    linkName
    referrerId
  }
  icon {
    ...LodgingEGDSIconFragment
  }
  label
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingCardUnitDetailsDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardUnitDetailsDialogActionFragment on LodgingCardUnitDetailsDialog {
  dialog {
    closeAnalytics {
      linkName
      referrerId
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
  trigger {
    ...LodgingCardMoreDetailsLinkTriggerFragment
  }
}
    ${EGDSDialogToolbarFragmentFragmentDoc}
${LodgingCardMoreDetailsLinkTriggerFragmentFragmentDoc}`;
export const LodgingCardPropertyDetailsDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardPropertyDetailsDialogActionFragment on LodgingCardPropertyDetailsDialog {
  dialog {
    closeAnalytics {
      linkName
      referrerId
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
  trigger {
    ...LodgingCardMoreDetailsLinkTriggerFragment
  }
}
    ${EGDSDialogToolbarFragmentFragmentDoc}
${LodgingCardMoreDetailsLinkTriggerFragmentFragmentDoc}`;
export const LodgingCardPropertyDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardPropertyDialogActionFragment on LodgingCardDetailsAction {
  __typename
  ... on LodgingCardUnitDetailsDialog {
    ...LodgingCardUnitDetailsDialogActionFragment
  }
  ... on LodgingCardPropertyDetailsDialog {
    ...LodgingCardPropertyDetailsDialogActionFragment
  }
}
    ${LodgingCardUnitDetailsDialogActionFragmentFragmentDoc}
${LodgingCardPropertyDetailsDialogActionFragmentFragmentDoc}`;
export const EGDSIconRatingFragmentFragmentDoc = gql`
    fragment EGDSIconRatingFragment on EGDSIconRating {
  __typename
  accessibility
  icon {
    token
    theme
    size
  }
  rating
}
    `;
export const EGDSBadgeFragmentFragmentDoc = gql`
    fragment EGDSBadgeFragment on EGDSBadge {
  accessibility
  text
  size
  theme
}
    `;
export const LodgingCardBadgedRatingFragmentFragmentDoc = gql`
    fragment LodgingCardBadgedRatingFragment on LodgingCardBadgedRating {
  badge {
    ...EGDSBadgeFragment
  }
  phrases {
    phraseParts {
      ...EGDSStylizedTextFragment
    }
  }
}
    ${EGDSBadgeFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}`;
export const LodgingProductFooterMessagesFragmentFragmentDoc = gql`
    fragment LodgingProductFooterMessagesFragment on EGDSTextWithMarkListItem {
  __typename
  mark {
    description
    id
    token
    url {
      value
    }
  }
  style
  text
}
    `;
export const LodgingProductSpannableFooterMessagesFragmentFragmentDoc = gql`
    fragment LodgingProductSpannableFooterMessagesFragment on EarnMessageContainerListItem {
  __typename
  graphic {
    ... on Mark {
      __typename
      description
      id
      token
      url {
        value
        relativePath
      }
    }
    ... on Icon {
      __typename
      description
      id
      size
      theme
      title
    }
    ... on Illustration {
      __typename
      id
      description
    }
  }
  style
  text
  stylizedText {
    ... on EGDSSpannableText {
      __typename
      text
      contents {
        ... on EGDSPlainText {
          __typename
          text
        }
        ... on EGDSStylizedText {
          __typename
          text
          theme
          weight
          size
          decorative
        }
      }
      inlineContent {
        ... on EGDSPlainText {
          __typename
          text
        }
        ... on EGDSStylizedText {
          __typename
          text
          theme
          weight
          size
          decorative
        }
      }
    }
  }
}
    `;
export const LodgingCardProductSummarySectionFragmentFragmentDoc = gql`
    fragment LodgingCardProductSummarySectionFragment on LodgingCardProductSummarySection {
  heading {
    ...LodgingEGDSHeadingFragment
  }
  amenities {
    ...LodgingProductAmenityFragment
  }
  messages {
    ...LodgingEGDSTextFragment
  }
  descriptionSection {
    ...LodgingCardPropertyDescriptionSectionFragment
  }
  changeActionDialog {
    ...LodgingCardChangeUnitDialogActionFragment
  }
  changeActionSheet {
    ...LodgingCardChangeUnitSheetActionFragment
  }
  detailsAction {
    ...LodgingCardPropertyDialogActionFragment
  }
  guestRating {
    accessibilityLabel
    parts {
      ...LodgingEGDSTextFragment
    }
    phraseParts {
      ...EGDSIconRatingFragment
    }
  }
  guestRatingSection {
    __typename
    ... on LodgingCardPhrase {
      accessibilityLabel
      parts {
        ...LodgingEGDSTextFragment
      }
      phraseParts {
        ...EGDSStylizedTextFragment
        ...EGDSIconRatingFragment
      }
    }
    ... on LodgingCardBadgedRating {
      ...LodgingCardBadgedRatingFragment
    }
  }
  footerMessages {
    listItems {
      ...LodgingProductFooterMessagesFragment
      ...LodgingProductSpannableFooterMessagesFragment
    }
  }
}
    ${LodgingEGDSHeadingFragmentFragmentDoc}
${LodgingProductAmenityFragmentFragmentDoc}
${LodgingEGDSTextFragmentFragmentDoc}
${LodgingCardPropertyDescriptionSectionFragmentFragmentDoc}
${LodgingCardChangeUnitDialogActionFragmentFragmentDoc}
${LodgingCardChangeUnitSheetActionFragmentFragmentDoc}
${LodgingCardPropertyDialogActionFragmentFragmentDoc}
${EGDSIconRatingFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}
${LodgingCardBadgedRatingFragmentFragmentDoc}
${LodgingProductFooterMessagesFragmentFragmentDoc}
${LodgingProductSpannableFooterMessagesFragmentFragmentDoc}`;
export const LodgingEGDSRatingFragmentFragmentDoc = gql`
    fragment LodgingEGDSRatingFragment on EGDSRating {
  accessibility
  rating
  ... on EGDSIconRating {
    icon {
      id
    }
  }
}
    `;
export const LodgingCardFeaturedMessageFragmentFragmentDoc = gql`
    fragment LodgingCardFeaturedMessageFragment on LodgingCardFeaturedMessage {
  icon {
    id
    description
    size
  }
  text
}
    `;
export const LodgingCardHeadingSectionFragmentFragmentDoc = gql`
    fragment LodgingCardHeadingSectionFragment on LodgingCardHeadingSection {
  heading
  productRating {
    ...LodgingEGDSRatingFragment
  }
  featuredMessages {
    ...LodgingCardFeaturedMessageFragment
  }
  messages {
    ...LodgingEGDSTextFragment
  }
  amenities {
    ...LodgingProductAmenityFragment
  }
}
    ${LodgingEGDSRatingFragmentFragmentDoc}
${LodgingCardFeaturedMessageFragmentFragmentDoc}
${LodgingEGDSTextFragmentFragmentDoc}
${LodgingProductAmenityFragmentFragmentDoc}`;
export const LodgingCardLinkActionFragmentFragmentDoc = gql`
    fragment LodgingCardLinkActionFragment on LodgingCardLinkAction {
  link {
    text
    action {
      target
      resource {
        __typename
        ... on HttpURI {
          value
          relativePath
        }
      }
      useRelativePath
      analytics {
        referrerId
        linkName
      }
    }
    icon {
      id
    }
  }
}
    `;
export const LodgingEGDSImageFragmentFragmentDoc = gql`
    fragment LodgingEGDSImageFragment on Image {
  description
  url
  __typename
  thumbnailClickAnalytics {
    referrerId
    linkName
    __typename
  }
}
    `;
export const LodgingMediaItemFragmentFragmentDoc = gql`
    fragment LodgingMediaItemFragment on LodgingMediaItem {
  id
  media {
    __typename
    ... on Image {
      ...LodgingEGDSImageFragment
      __typename
    }
  }
  trackingId
  __typename
}
    ${LodgingEGDSImageFragmentFragmentDoc}`;
export const LodgingGalleryCarouselFragmentFragmentDoc = gql`
    fragment LodgingGalleryCarouselFragment on LodgingGalleryCarousel {
  accessibilityHeadingText
  navClickAnalytics {
    linkName
    referrerId
  }
  intersectionAnalytics {
    linkName
    referrerId
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
  media {
    ...LodgingMediaItemFragment
    __typename
  }
  nextButtonText
  previousButtonText
}
    ${LodgingMediaItemFragmentFragmentDoc}`;
export const LodgingEGDSStandardBadgeFragmentFragmentDoc = gql`
    fragment LodgingEGDSStandardBadgeFragment on EGDSStandardBadge {
  __typename
  graphic {
    ... on Icon {
      __typename
      description
      id
    }
    ... on Mark {
      __typename
      description
      id
    }
  }
  text
  theme
  size
}
    `;
export const AdaptexCampaignTrackingDetailFragmentFragmentDoc = gql`
    fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {
  campaignId
  eventTarget
}
    `;
export const TripsSaveItemPropertiesFragmentFragmentDoc = gql`
    fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {
  accessibility
  analytics {
    linkName
    referrerId
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
  adaptexSuccessCampaignIds {
    ...AdaptexCampaignTrackingDetailFragment
  }
  label
}
    ${AdaptexCampaignTrackingDetailFragmentFragmentDoc}`;
export const TripsSaveStayAttributesFragmentFragmentDoc = gql`
    fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {
  regionId
  roomConfiguration {
    childAges
    numberOfAdults
  }
  checkInDate {
    ...CommonDateFields
  }
  checkoutDate {
    ...CommonDateFields
  }
}
    ${CommonDateFieldsFragmentDoc}`;
export const TripsSaveActivityAttributesFragmentFragmentDoc = gql`
    fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {
  regionId
  dateRange {
    start {
      ...CommonDateFields
    }
    end {
      ...CommonDateFields
    }
  }
}
    ${CommonDateFieldsFragmentDoc}`;
export const LodgingCardMediaSectionFragmentFragmentDoc = gql`
    fragment LodgingCardMediaSectionFragment on LodgingCardMediaSection {
  gallery {
    ...LodgingGalleryCarouselFragment
  }
  badges {
    primaryBadge {
      ...LodgingEGDSStandardBadgeFragment
    }
    secondaryBadge {
      ...LodgingEGDSStandardBadgeFragment
    }
    tertiaryBadge {
      ...LodgingEGDSStandardBadgeFragment
    }
  }
  saveItem {
    analytics {
      linkName
      referrerId
    }
    initialChecked
    items {
      itemId
    }
    labels {
      removeLabel
      saveLabel
    }
    messages {
      removeMessage
      saveMessage
    }
  }
  saveTripItem {
    initialChecked
    itemId
    source
    save {
      ...TripsSaveItemPropertiesFragment
    }
    remove {
      ...TripsSaveItemPropertiesFragment
    }
    attributes {
      __typename
      ...TripsSaveStayAttributesFragment
      ...TripsSaveActivityAttributesFragment
    }
  }
}
    ${LodgingGalleryCarouselFragmentFragmentDoc}
${LodgingEGDSStandardBadgeFragmentFragmentDoc}
${TripsSaveItemPropertiesFragmentFragmentDoc}
${TripsSaveStayAttributesFragmentFragmentDoc}
${TripsSaveActivityAttributesFragmentFragmentDoc}`;
export const LodgingCardDateSectionFragmentFragmentDoc = gql`
    fragment LodgingCardDateSectionFragment on LodgingCardDateSection {
  __typename
  date {
    ... on EGDSStylizedText {
      ...EGDSStylizedTextFragment
    }
  }
}
    ${EGDSStylizedTextFragmentFragmentDoc}`;
export const LodgingCardCompareSectionFragmentFragmentDoc = gql`
    fragment LodgingCardCompareSectionFragment on LodgingCardCompareSection {
  __typename
  compareAction {
    ... on EGDSBasicCheckBox {
      __typename
      label {
        text
      }
    }
  }
}
    `;
export const PriceMessageFragmentFragmentDoc = gql`
    fragment PriceMessageFragment on DisplayPrice {
  __typename
  role
  price {
    formatted
    accessibilityLabel
  }
  disclaimer {
    content
    primaryUIButton {
      accessibility
      primary
    }
  }
}
    `;
export const PriceSummaryFragmentFragmentDoc = gql`
    fragment PriceSummaryFragment on PropertyPrice {
  displayMessages {
    lineItems {
      ...PriceMessageFragment
      ...EnrichedMessageFragment
    }
  }
  options {
    leadingCaption
    displayPrice {
      formatted
    }
    disclaimer {
      value
    }
    priceDisclaimer {
      content
      primaryButton {
        text
      }
      trigger {
        icon {
          description
        }
      }
    }
    accessibilityLabel
    strikeOut {
      formatted
    }
    loyaltyPrice {
      unit
      amount {
        formatted
      }
      totalStrikeOutPoints {
        formatted
      }
    }
  }
  priceMessaging {
    value
    theme
  }
  marketingFeeDetails {
    tierMessage {
      accessibilityLabel
      value
      egdsMark {
        id
      }
    }
    marketingFeeMessageDialog {
      content
      dialog {
        footer {
          buttons {
            primary
          }
        }
      }
    }
  }
}
    ${PriceMessageFragmentFragmentDoc}
${EnrichedMessageFragmentFragmentDoc}`;
export const LodgingstandardBadgeFragmentDocFragmentDoc = gql`
    fragment LodgingstandardBadgeFragmentDoc on LodgingStandardBadge {
  __typename
  standardBadge {
    __typename
    graphic {
      ... on Icon {
        __typename
        description
        id
      }
      ... on Mark {
        __typename
        description
        id
      }
    }
    text
    theme
    size
  }
  impressionEventAnalytics {
    __typename
    referrerId
    linkName
    event
  }
}
    `;
export const ClickstreamEventFragmentFragmentDoc = gql`
    fragment ClickstreamEventFragment on EGClickstreamEvent {
  eventCategory
  eventName
  eventType
  eventVersion
}
    `;
export const ProductListFragmentFragmentDoc = gql`
    fragment ProductListFragment on LodgingProduct {
  product_id
}
    `;
export const RequestFragmentFragmentDoc = gql`
    fragment RequestFragment on LodgingSearchRequest {
  search_id
}
    `;
export const ProductEventFragmentFragmentDoc = gql`
    fragment ProductEventFragment on LodgingProductEvent {
  event {
    ...ClickstreamEventFragment
  }
  product_list {
    ...ProductListFragment
  }
  search_request {
    ...RequestFragment
  }
}
    ${ClickstreamEventFragmentFragmentDoc}
${ProductListFragmentFragmentDoc}
${RequestFragmentFragmentDoc}`;
export const LodgingCardFieldsFragmentDoc = gql`
    fragment LodgingCardFields on LodgingCard {
  __typename
  id
  featuredHeader {
    header {
      text
    }
  }
  cardLink {
    accessibility
    resource {
      __typename
      ... on HttpURI {
        relativePath
        value
      }
    }
    analytics {
      linkName
      referrerId
      uisPrimeMessages {
        messageContent
        schemaName
      }
    }
    useRelativePath
    target
  }
  summarySections {
    ...LodgingCardProductSummarySectionFragment
  }
  headingSection {
    ...LodgingCardHeadingSectionFragment
  }
  footerActions {
    ...LodgingCardLinkActionFragment
  }
  mediaSection {
    ...LodgingCardMediaSectionFragment
  }
  dateSection {
    ...LodgingCardDateSectionFragment
  }
  compareSection {
    ...LodgingCardCompareSectionFragment
  }
  callOut {
    ...LodgingEGDSTextFragment
  }
  priceSection {
    priceSummary {
      ...PriceSummaryFragment
    }
    badge {
      ...LodgingEGDSStandardBadgeFragment
    }
    standardBadge {
      ...LodgingstandardBadgeFragmentDoc
    }
    button {
      accessibility
      action {
        analytics {
          linkName
          referrerId
        }
        resource {
          value
        }
      }
      analytics {
        linkName
        referrerId
      }
      disabled
      icon {
        description
        id
      }
      primary
      attemptEvents {
        campaignId
        clientSideAnalytics {
          linkName
          eventType
          referrerId
        }
        events {
          eventType
          eventTarget
          banditDisplayed
          payloadId
        }
      }
      successEvents {
        campaignId
        clientSideAnalytics {
          linkName
          eventType
          referrerId
        }
        events {
          eventType
          eventTarget
          banditDisplayed
          payloadId
        }
      }
      adaptexSuccessActionTracking {
        ...AdaptexCampaignTrackingDetailFragment
      }
    }
  }
  clickstreamEvents {
    productPresented {
      ...ProductEventFragment
    }
    productSelected {
      ...ProductEventFragment
    }
  }
  impressionAnalytics {
    url
    referrerId
    linkName
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
  adaptexSuccessActionTracking {
    ...AdaptexCampaignTrackingDetailFragment
  }
}
    ${LodgingCardProductSummarySectionFragmentFragmentDoc}
${LodgingCardHeadingSectionFragmentFragmentDoc}
${LodgingCardLinkActionFragmentFragmentDoc}
${LodgingCardMediaSectionFragmentFragmentDoc}
${LodgingCardDateSectionFragmentFragmentDoc}
${LodgingCardCompareSectionFragmentFragmentDoc}
${LodgingEGDSTextFragmentFragmentDoc}
${PriceSummaryFragmentFragmentDoc}
${LodgingEGDSStandardBadgeFragmentFragmentDoc}
${LodgingstandardBadgeFragmentDocFragmentDoc}
${AdaptexCampaignTrackingDetailFragmentFragmentDoc}
${ProductEventFragmentFragmentDoc}`;
export const LodgingListingDividerFieldsFragmentDoc = gql`
    fragment LodgingListingDividerFields on LodgingListingDivider {
  __typename
  title {
    titleText: text
    headingType
  }
  subtitle {
    subtitleText: text
  }
  graphic {
    ... on Icon {
      __typename
      description
      id
      iconSize: size
      theme
      title
      withBackground
    }
    ... on Illustration {
      __typename
      description
      url
      id
    }
    ... on Mark {
      __typename
      description
      markUrl: url {
        relativePath
        value
      }
      size
      id
    }
  }
  impressionAnalytics {
    event
    referrerId
  }
  backgroundTheme
}
    `;
export const PropertyListingStandardMessagingCardFragmentFragmentDoc = gql`
    fragment PropertyListingStandardMessagingCardFragment on EGDSStandardMessagingCard {
  __typename
  graphic {
    __typename
    ... on Illustration {
      description
      link: url
    }
  }
  heading
  egdsElementId
  message
  links {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        __typename
        ... on HttpURI {
          relativePath
        }
      }
      useRelativePath
    }
    text
  }
  impressionTracking {
    linkName
    referrerId
  }
}
    `;
export const PropertyListingExpandoCardFragmentFragmentDoc = gql`
    fragment PropertyListingExpandoCardFragment on PropertyListingsIconTextExpando {
  __typename
  graphic {
    __typename
    ... on Illustration {
      link: url
      description
      id
    }
  }
  expandoCard {
    collapsedLabel
    expandedLabel
    expanded
    subtitle
    expandAnalytics {
      linkName
      referrerId
    }
    collapseAnalytics {
      linkName
      referrerId
    }
  }
  expandedContent {
    text
    graphic {
      __typename
      ... on Icon {
        id
        description
        token
        size
        theme
      }
    }
  }
}
    `;
export const LodgingEGDSPlainTextFragmentFragmentDoc = gql`
    fragment LodgingEGDSPlainTextFragment on EGDSPlainText {
  __typename
  text
}
    `;
export const LodgingMoreInfoTriggerFragmentFragmentDoc = gql`
    fragment LodgingMoreInfoTriggerFragment on EGDSStandardLink {
  __typename
  text
  icon {
    description
    id
    size
    title
    token
    withBackground
  }
  action {
    accessibility
    analytics {
      referrerId
      linkName
    }
    resource {
      __typename
      ... on HttpURI {
        relativePath
        value
      }
    }
    target
    useRelativePath
  }
  egdsElementId
  disabled
}
    `;
export const SponsoredContentPlacementFieldsFragmentDoc = gql`
    fragment SponsoredContentPlacementFields on SponsoredContentPlacement {
  __typename
  productType
  sponsoredContentContext {
    pageName
    variant
    sponsoredContentId
    targeting {
      adults
      kids
      origin
      destination
      locationResolver
      dateStart {
        day
        month
        year
      }
      dateEnd {
        day
        month
        year
      }
    }
  }
}
    `;
export const PropertySearchListingsSoldOutFieldsFragmentDoc = gql`
    fragment PropertySearchListingsSoldOutFields on PropertySearchListingsSoldOutCard {
  __typename
  cardContent: content {
    ... on EGDSStandardMessagingCard {
      __typename
      heading
      graphic {
        __typename
        ... on Icon {
          description
          id
          iconSize: size
          theme
          title
          withBackground
        }
      }
    }
  }
  actionButton {
    __typename
    ... on EGDSButton {
      primary
      analytics {
        __typename
        referrerId
        linkName
      }
    }
  }
  analytics {
    __typename
    event
    referrerId
    linkName
  }
}
    `;
export const LodgingEGDSRemovablePillFragmentFragmentDoc = gql`
    fragment LodgingEGDSRemovablePillFragment on EGDSBasicRemovablePill {
  __typename
  primary
  accessibility
  name
  value
  remove {
    __typename
    ... on Icon {
      id
      description
      size
    }
  }
  removeAnalytics {
    __typename
    referrerId
    linkName
  }
}
    `;
export const SearchFilterPillsFragmentFragmentDoc = gql`
    fragment SearchFilterPillsFragment on PropertySearchListingsOverfilteredCard {
  __typename
  filterPills {
    __typename
    ... on BasicShoppingAppliedFilter {
      filter {
        __typename
        ...LodgingEGDSRemovablePillFragment
      }
      linkUrl {
        __typename
        ... on UILinkAction {
          resource {
            __typename
            ... on HttpURI {
              value
              relativePath
            }
          }
          target
          useRelativePath
        }
      }
    }
  }
}
    ${LodgingEGDSRemovablePillFragmentFragmentDoc}`;
export const PropertyListingOverfilteredFragmentFragmentDoc = gql`
    fragment PropertyListingOverfilteredFragment on PropertySearchListingsOverfilteredCard {
  __typename
  cardContent: content {
    __typename
    ... on EGDSStandardMessagingCard {
      heading
      message
      graphic {
        __typename
        ... on Icon {
          description
          id
          iconSize: size
          withBackground
        }
      }
    }
  }
  ...SearchFilterPillsFragment
  action {
    button {
      __typename
      ... on UISecondaryButton {
        accessibility
        disabled
        primary
        analytics {
          __typename
          ... on ClientSideAnalytics {
            referrerId
            linkName
          }
        }
      }
    }
    action {
      __typename
      ... on UILinkAction {
        resource {
          __typename
          ... on HttpURI {
            value
            relativePath
          }
        }
        target
        useRelativePath
      }
    }
  }
  impressionAnalytics {
    __typename
    ... on ClientSideImpressionEventAnalytics {
      event
      referrerId
      linkName
    }
  }
}
    ${SearchFilterPillsFragmentFragmentDoc}`;
export const LodgingAdaptExAnalyticsEventFragmentFragmentDoc = gql`
    fragment LodgingAdaptExAnalyticsEventFragment on LodgingAdaptExAnalyticsEvent {
  __typename
  campaignId
  clientSideAnalytics {
    __typename
    referrerId
    eventType
    linkName
  }
  events {
    __typename
    eventType
    eventTarget
    banditDisplayed
    payloadId
  }
}
    `;
export const AddPropertyToCartDocument = gql`
    mutation AddPropertyToCart($id: UUID!, $context: ContextInput!, $propertyOffer: PropertyOfferInput!, $cartPropertySearchContextInput: CartPropertySearchContextInput!) {
  cartItems(id: $id, context: $context) {
    addProperty(key: $propertyOffer, searchContext: $cartPropertySearchContextInput) {
      id
      itemCount
    }
  }
}
    `;
export const CreateMultiItemSessionDocument = gql`
    mutation CreateMultiItemSession($context: ContextInput!, $multiItemSearchContext: MultiItemSearchContextInput!) {
  createMultiItemSession(
    context: $context
    searchContext: $multiItemSearchContext
  ) {
    __typename
    ... on MultiItemSearchContextCreatedResponse {
      shoppingContext {
        multiItem {
          id
          packageType
        }
      }
    }
  }
}
    `;
export const CreateSessionCartDocument = gql`
    mutation CreateSessionCart($context: ContextInput!, $cartOptions: CartOptionsInput!) {
  createSessionCart(context: $context, cartOptions: $cartOptions) {
    id
  }
}
    `;
export const EmptyCartDocument = gql`
    mutation EmptyCart($context: ContextInput!, $id: UUID!) {
  cartItems(id: $id, context: $context) {
    emptyCart {
      id
      itemCount
    }
  }
}
    `;
export const FederatedCartDocument = gql`
    query FederatedCart($context: ContextInput!, $id: UUID) {
  cart(id: $id, context: $context) {
    itemCount
    items {
      id
      ... on PropertyCartItem {
        offers {
          offerIndex
          naturalKeys {
            id
            roomTypeId
            ratePlanId
            checkIn {
              isoFormat
            }
            checkOut {
              isoFormat
            }
            inventoryType
            rooms {
              numberOfAdults
              childAges
            }
          }
        }
      }
    }
  }
}
    `;
export const CartDocument = gql`
    query Cart($context: ContextInput!, $id: UUID) {
  cart(id: $id, context: $context) {
    itemCount
    items {
      id
      ... on PropertyCartItem {
        offers {
          offerIndex
          naturalKeys {
            id
            roomTypeId
            ratePlanId
            ratePlanType
            checkIn {
              isoFormat
            }
            checkOut {
              isoFormat
            }
            inventoryType
            rooms {
              numberOfAdults
              childAges
            }
          }
          offer {
            marketingChannelId
            units {
              name
              photos {
                description
                url
              }
              ratePlans {
                priceDetails {
                  availability {
                    available
                    minRoomsLeft
                  }
                  offerBookButton {
                    inputs {
                      ... on LodgingTextInput {
                        name
                        value
                      }
                    }
                  }
                  price {
                    total {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                    lead {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                  }
                  priceAfterLoyaltyPointsApplied {
                    total {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                    lead {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                  }
                  fees {
                    description
                  }
                }
              }
            }
          }
        }
        summary {
          name
          location {
            address {
              city
            }
          }
        }
        gallery {
          featured {
            url
          }
        }
      }
    }
  }
}
    `;
export const InitiateMultiItemSessionDocument = gql`
    mutation InitiateMultiItemSession($context: ContextInput!, $searchContext: MultiItemSearchContextInput!) {
  multiItemShopping(context: $context) {
    initiate(searchContext: $searchContext) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        shoppingContext {
          multiItem {
            id
            packageType
          }
        }
        redirectUrl
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}
    `;
export const LodgingPwaPropertySearchDocument = gql`
    query LodgingPwaPropertySearch($context: ContextInput!, $destination: DestinationInput!, $shoppingContext: ShoppingContextInput, $criteria: PropertySearchCriteriaInput, $includePropertyListing: Boolean = true, $returnPropertyType: Boolean = false) {
  propertySearch(
    context: $context
    destination: $destination
    shoppingContext: $shoppingContext
    criteria: $criteria
    returnPropertyType: $returnPropertyType
  ) {
    propertyListingAdaptexAnalyticsSuccessEvents @include(if: $includePropertyListing) {
      ...LodgingAdaptExAnalyticsEventFragment
    }
    pagination @include(if: $includePropertyListing) {
      paginationLabel
      trigger {
        __typename
        ... on LodgingPaginationNavigationButtons {
          previousButton {
            analytics {
              referrerId
              linkName
            }
            disabled
            primary
            accessibility
            icon {
              token
            }
          }
          nextButton {
            analytics {
              referrerId
              linkName
            }
            disabled
            primary
            accessibility
            icon {
              token
            }
          }
        }
        ... on UIPrimaryButton {
          analytics {
            referrerId
            linkName
          }
          accessibility
          disabled
          egdsElementId
          icon {
            description
            id
            title
          }
          primary
        }
        ... on LodgingScrollTrigger {
          triggerAfterPosition
          analytics {
            linkName
            referrerId
          }
        }
      }
      subSets {
        nextSubSet {
          size
          startingIndex
        }
        previousSubset {
          size
          startingIndex
        }
      }
    }
    criteria {
      primary {
        dateRange {
          checkInDate {
            ...CommonDateFields
          }
          checkOutDate {
            ...CommonDateFields
          }
        }
        destination {
          regionId
          regionName
        }
        rooms {
          adults
          children {
            age
          }
        }
        flexSearchCriteria {
          flexibility {
            bound
            unit
            length
          }
        }
      }
      secondary {
        booleans {
          id
          value
        }
        counts {
          id
          value
        }
        dates {
          id
          value {
            ...CommonDateFields
          }
        }
        ranges {
          id
          max
          min
        }
        selections {
          id
          value
        }
      }
    }
    propertySearchListings @include(if: $includePropertyListing) {
      ... on LodgingCard {
        ...LodgingCardFields
      }
      ... on PropertySearchListingPlaceholder {
        __typename
        loadingComponent
      }
      ... on MessageResult {
        ...MessageFields
      }
      ... on LodgingHeading {
        __typename
        value
      }
      ... on StaticLodgingMultiItemCrossSell {
        __typename
        multiItemSearchContext {
          properties {
            primary {
              dateRange {
                checkInDate {
                  ...CommonDateFields
                }
                checkOutDate {
                  ...CommonDateFields
                }
              }
              destination {
                coordinates {
                  latitude
                  longitude
                }
                mapBounds {
                  latitude
                  longitude
                }
                pinnedPropertyId
                propertyIds
                regionId
                regionName
              }
              rooms {
                adults
                children {
                  age
                }
              }
            }
            secondary {
              booleans {
                id
                value
              }
              counts {
                id
                value
              }
              dates {
                id
                value {
                  ...CommonDateFields
                }
              }
              ranges {
                id
                max
                min
              }
              selections {
                id
                value
              }
            }
          }
        }
        crossSellProductType
        fallbackListing {
          __typename
          ... on MessageResult {
            ...MessageFields
          }
        }
      }
      ... on LodgingIntentCard {
        ...LodgingIntentCardFields
      }
      ... on LodgingListingDivider {
        ...LodgingListingDividerFields
      }
      ... on SponsoredContentPlacement {
        ...SponsoredContentPlacementFields
      }
      ... on PropertySearchListingsSoldOutCard {
        ...PropertySearchListingsSoldOutFields
      }
      ... on PropertySearchListingsOverfilteredCard {
        ...PropertyListingOverfilteredFragment
      }
      ... on EGDSStandardMessagingCard {
        ...PropertyListingStandardMessagingCardFragment
      }
      ... on PropertyListingsIconTextExpando {
        ...PropertyListingExpandoCardFragment
      }
    }
    summary {
      resultMessages {
        __typename
        ... on EGDSPlainText {
          ...LodgingEGDSPlainTextFragment
        }
        ... on EGDSStandardLink {
          ...LodgingMoreInfoTriggerFragment
        }
      }
      loyaltyInfo {
        pointsAppliedMessage
        saveWithPointsMessage
        saveWithPointsActionMessage
      }
      matchedPropertiesSize
      resultsHeading
    }
    shoppingContext {
      multiItem {
        id
        packageType
      }
    }
    multiItemSearchContext {
      ...MultiItemPropertySearchContextFields
      cars {
        primary {
          pickUpDateTime {
            ...CommonDateTimeFields
          }
          dropOffDateTime {
            ...CommonDateTimeFields
          }
          pickUpLocation {
            airportCode
          }
          dropOffLocation {
            airportCode
          }
        }
      }
      flights {
        primary {
          travelers {
            type
            age
          }
          tripType
          journeyCriterias {
            destination
            origin
            departureDate {
              day
              month
              year
            }
          }
          searchPreferences {
            airline
            advancedFilters
            cabinClass
          }
        }
      }
    }
    errorResponse {
      header
      body
      icon {
        description
        id
      }
      button {
        primary
        action {
          ... on UILinkAction {
            analytics {
              referrerId
              linkName
            }
            resource {
              ... on HttpURI {
                relativePath
                value
              }
            }
          }
        }
        disabled
      }
      errorRecoveryButtons {
        primary
        action {
          ... on UILinkAction {
            analytics {
              referrerId
              linkName
            }
            resource {
              ... on HttpURI {
                relativePath
                value
              }
            }
          }
        }
        disabled
      }
    }
    dialogErrorResponse {
      body
      button {
        primary
        action {
          ... on UILinkAction {
            analytics {
              referrerId
              linkName
            }
            resource {
              ... on HttpURI {
                relativePath
                value
              }
            }
          }
        }
        disabled
      }
    }
    mapTrigger {
      ...MapTriggerFragment
    }
  }
}
    ${LodgingAdaptExAnalyticsEventFragmentFragmentDoc}
${CommonDateFieldsFragmentDoc}
${LodgingCardFieldsFragmentDoc}
${MessageFieldsFragmentDoc}
${LodgingIntentCardFieldsFragmentDoc}
${LodgingListingDividerFieldsFragmentDoc}
${SponsoredContentPlacementFieldsFragmentDoc}
${PropertySearchListingsSoldOutFieldsFragmentDoc}
${PropertyListingOverfilteredFragmentFragmentDoc}
${PropertyListingStandardMessagingCardFragmentFragmentDoc}
${PropertyListingExpandoCardFragmentFragmentDoc}
${LodgingEGDSPlainTextFragmentFragmentDoc}
${LodgingMoreInfoTriggerFragmentFragmentDoc}
${MultiItemPropertySearchContextFieldsFragmentDoc}
${CommonDateTimeFieldsFragmentDoc}
${MapTriggerFragmentFragmentDoc}`;
export const PrepareCheckoutByCartIdDocument = gql`
    mutation PrepareCheckoutByCartId($context: ContextInput!, $id: UUID!, $totalPrice: MoneyInput!, $marketingChannelId: Int, $checkoutOptions: [CheckoutOptionInput!]) {
  prepareCheckoutByCartId(
    context: $context
    cartId: $id
    totalPrice: $totalPrice
    marketingChannelId: $marketingChannelId
    checkoutOptions: $checkoutOptions
  ) {
    tripId
    checkoutUrl
    failureReason {
      ... on MaxRoomsFailure {
        groupLinkMessage
        message
      }
    }
  }
}
    `;
export const PrepareCheckoutDocument = gql`
    mutation PrepareCheckout($context: ContextInput!, $properties: [PropertyNaturalKeyInput!], $cookies: String!) {
  prepareCheckout(context: $context, properties: $properties, cookies: $cookies) {
    tripId
    checkoutUrl
  }
}
    `;
export const PropertyInfoPageLayoutDocument = gql`
    query PropertyInfoPageLayout($context: ContextInput!, $propertyId: String!, $shoppingContext: ShoppingContextInput) {
  propertyInfo(
    context: $context
    propertyId: $propertyId
    shoppingContext: $shoppingContext
  ) {
    experimental {
      pageLayoutExperimentalFeature {
        templateName
      }
    }
  }
}
    `;
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($cartId: UUID!, $context: ContextInput!, $itemId: UUID!) {
  cartItems(id: $cartId, context: $context) {
    remove(id: $itemId) {
      id
      itemCount
    }
  }
}
    `;
export const SearchResultsPageLayoutDocument = gql`
    query SearchResultsPageLayout($context: ContextInput!, $destination: DestinationInput!) {
  propertySearch(context: $context, destination: $destination) {
    experimental {
      pageLayoutFeatureExperiment {
        templateName
      }
    }
  }
}
    `;
export const SelectProductsDocument = gql`
    mutation SelectProducts($context: ContextInput!, $sessionId: String!, $priceToken: String, $properties: [PropertyNaturalKeyInput!], $flights: [FlightNaturalKeyInput!], $cars: [CarNaturalKeyInput!], $dealMarker: String) {
  multiItemShopping(context: $context) {
    selectProducts(
      sessionId: $sessionId
      priceToken: $priceToken
      properties: $properties
      flights: $flights
      cars: $cars
      dealMarker: $dealMarker
    ) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        shoppingContext {
          multiItem {
            id
            packageType
          }
        }
        redirectUrl
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();
const AddPropertyToCartDocumentString = print(AddPropertyToCartDocument);
const CreateMultiItemSessionDocumentString = print(CreateMultiItemSessionDocument);
const CreateSessionCartDocumentString = print(CreateSessionCartDocument);
const EmptyCartDocumentString = print(EmptyCartDocument);
const FederatedCartDocumentString = print(FederatedCartDocument);
const CartDocumentString = print(CartDocument);
const InitiateMultiItemSessionDocumentString = print(InitiateMultiItemSessionDocument);
const LodgingPwaPropertySearchDocumentString = print(LodgingPwaPropertySearchDocument);
const PrepareCheckoutByCartIdDocumentString = print(PrepareCheckoutByCartIdDocument);
const PrepareCheckoutDocumentString = print(PrepareCheckoutDocument);
const PropertyInfoPageLayoutDocumentString = print(PropertyInfoPageLayoutDocument);
const RemoveItemFromCartDocumentString = print(RemoveItemFromCartDocument);
const SearchResultsPageLayoutDocumentString = print(SearchResultsPageLayoutDocument);
const SelectProductsDocumentString = print(SelectProductsDocument);
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AddPropertyToCart(variables: AddPropertyToCartMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: AddPropertyToCartMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<AddPropertyToCartMutation>(AddPropertyToCartDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddPropertyToCart', 'mutation');
    },
    CreateMultiItemSession(variables: CreateMultiItemSessionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: CreateMultiItemSessionMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<CreateMultiItemSessionMutation>(CreateMultiItemSessionDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateMultiItemSession', 'mutation');
    },
    CreateSessionCart(variables: CreateSessionCartMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: CreateSessionCartMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<CreateSessionCartMutation>(CreateSessionCartDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateSessionCart', 'mutation');
    },
    EmptyCart(variables: EmptyCartMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: EmptyCartMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<EmptyCartMutation>(EmptyCartDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EmptyCart', 'mutation');
    },
    FederatedCart(variables: FederatedCartQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: FederatedCartQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<FederatedCartQuery>(FederatedCartDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FederatedCart', 'query');
    },
    Cart(variables: CartQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: CartQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<CartQuery>(CartDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Cart', 'query');
    },
    InitiateMultiItemSession(variables: InitiateMultiItemSessionMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: InitiateMultiItemSessionMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<InitiateMultiItemSessionMutation>(InitiateMultiItemSessionDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InitiateMultiItemSession', 'mutation');
    },
    LodgingPwaPropertySearch(variables: LodgingPwaPropertySearchQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: LodgingPwaPropertySearchQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<LodgingPwaPropertySearchQuery>(LodgingPwaPropertySearchDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LodgingPwaPropertySearch', 'query');
    },
    PrepareCheckoutByCartId(variables: PrepareCheckoutByCartIdMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PrepareCheckoutByCartIdMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PrepareCheckoutByCartIdMutation>(PrepareCheckoutByCartIdDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrepareCheckoutByCartId', 'mutation');
    },
    PrepareCheckout(variables: PrepareCheckoutMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PrepareCheckoutMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PrepareCheckoutMutation>(PrepareCheckoutDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PrepareCheckout', 'mutation');
    },
    PropertyInfoPageLayout(variables: PropertyInfoPageLayoutQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: PropertyInfoPageLayoutQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<PropertyInfoPageLayoutQuery>(PropertyInfoPageLayoutDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PropertyInfoPageLayout', 'query');
    },
    RemoveItemFromCart(variables: RemoveItemFromCartMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: RemoveItemFromCartMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<RemoveItemFromCartMutation>(RemoveItemFromCartDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveItemFromCart', 'mutation');
    },
    SearchResultsPageLayout(variables: SearchResultsPageLayoutQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: SearchResultsPageLayoutQuery; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SearchResultsPageLayoutQuery>(SearchResultsPageLayoutDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SearchResultsPageLayout', 'query');
    },
    SelectProducts(variables: SelectProductsMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<{ data: SelectProductsMutation; extensions?: any; headers: Dom.Headers; status: number; }> {
        return withWrapper((wrappedRequestHeaders) => client.rawRequest<SelectProductsMutation>(SelectProductsDocumentString, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SelectProducts', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;